export const defaultDictOfParts = {
    "TPS61033": {
        "Description": "5-V 5-A boost converter with PG and PFM/PWM control",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "3 mm2: 1.2 x 2.1 (SOT-5X3|8)",
        "Package Group": "SOT-5X3|8",
        "\"Approx. price\n(USD)\"": "$0.600 | 1ku",
        "Status": "PREVIEW"
    },
    "TPS568231": {
        "Description": "3.8-V to 17-V 8-A synchronous buck converter with D-CAP3 control",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "12 mm2: 3.5 x 3.5 (VQFN-HR|18)",
        "Package Group": "VQFN-HR|18",
        "\"Approx. price\n(USD)\"": "$1.400 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62992-Q1": {
        "Description": "Automotive 3-V to 10-V 2-A low-IQ synchronous buck converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": "Functional Safety-Capable",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "4 mm2: 2 x 2.2 (VQFN-HR|9)",
        "Package Group": "VQFN-HR|9",
        "\"Approx. price\n(USD)\"": "$0.540 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62993-Q1": {
        "Description": "Automotive 3-V to 10-V 3-A low-IQ synchronous buck converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": "Functional Safety-Capable",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "4 mm2: 2 x 2.2 (VQFN-HR|9)",
        "Package Group": "VQFN-HR|9",
        "\"Approx. price\n(USD)\"": "$0.610 | 1ku",
        "Status": "ACTIVE"
    },
    "LM5149-Q1": {
        "Description": "80-V automotive synchronous buck DC/DC controller with ultra-low IQ and integrated active EMI filter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck controllers (external switch)",
        "Rating": "Automotive",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 150",
        "Package size: mm2:W x L (PKG)": "19 mm2: 3.5 x 5.5 (VQFN|24)",
        "Package Group": "VQFN|24",
        "\"Approx. price\n(USD)\"": "$2.189 | 1ku",
        "Status": "PREVIEW"
    },
    "TPSM365R6": {
        "Description": "3-V to 65-V input 1-V to 13-V output 0.6-A synchronous buck converter power module",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck modules (integrated inductor)",
        "Rating": "Catalog",
        "TI functional safety category": "Functional Safety-Capable",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "See datasheet",
        "Package Group": " --- ",
        "\"Approx. price\n(USD)\"": "$2.600 | 1ku",
        "Status": "PREVIEW"
    },
    "LM5012": {
        "Description": "6-V to 100-V input 2.5-A non-synchronous buck DC/DC converter with ultra-low IQ",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": "Functional Safety-Capable",
        "\"Operating temperature range\n(C)\"": "-40 to 150",
        "Package size: mm2:W x L (PKG)": "19 mm2: 3.9 x 4.89 (SO PowerPAD|8)",
        "Package Group": "SO PowerPAD|8",
        "\"Approx. price\n(USD)\"": "$1.080 | 1ku",
        "Status": "ACTIVE"
    },
    "LM5012-Q1": {
        "Description": "Automotive 6-V to 100-V input 2.5-A non-synchronous buck DC/DC converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": "Functional Safety-Capable",
        "\"Operating temperature range\n(C)\"": "-40 to 150",
        "Package size: mm2:W x L (PKG)": "19 mm2: 3.9 x 4.89 (SO PowerPAD|8)",
        "Package Group": "SO PowerPAD|8",
        "\"Approx. price\n(USD)\"": "$1.500 | 1ku",
        "Status": "ACTIVE"
    },
    "LM5013": {
        "Description": "6-V to 100-V input 3.5-A non-synchronous buck DC/DC converter with ultra-low quiescent current (IQ)",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": "Functional Safety-Capable",
        "\"Operating temperature range\n(C)\"": "-40 to 150",
        "Package size: mm2:W x L (PKG)": "19 mm2: 3.9 x 4.89 (SO PowerPAD|8)",
        "Package Group": "SO PowerPAD|8",
        "\"Approx. price\n(USD)\"": "$1.543 | 1ku",
        "Status": "ACTIVE"
    },
    "LM5169": {
        "Description": "6-V to 120-V Wide VIN 650-mA DC/DC converter with Fly-Buck™ capability",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 150",
        "Package size: mm2:W x L (PKG)": "19 mm2: 3.9 x 4.89 (SO PowerPAD|8)",
        "Package Group": "SO PowerPAD|8",
        "\"Approx. price\n(USD)\"": "$1.500 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS51383": {
        "Description": "4.5-V to 24-V input 8-A synchronous buck converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "6 mm2: 2 x 3 (VQFN-HR|12)",
        "Package Group": "VQFN-HR|12",
        "\"Approx. price\n(USD)\"": "$1.320 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS61376": {
        "Description": "25-V 4.5-A boost converter with 2.5% accuracy input average current limit & true disconnection",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "5 mm2: 2 x 2.5 (VQFN-HR|13)",
        "Package Group": "VQFN-HR|13",
        "\"Approx. price\n(USD)\"": "$1.200 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS563252": {
        "Description": "3-V to 16-V input voltage 3-A 1.4-Mhz synchronous buck converter in SOT563",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "2 mm2: 1.2 x 1.6 (SOT-5X3|6)",
        "Package Group": "SOT-5X3|6",
        "\"Approx. price\n(USD)\"": "$0.350 | 1ku",
        "Status": "PREVIEW"
    },
    "TPS563257": {
        "Description": "3-V to 16-V input voltage 3-A 1.4-Mhz synchronous buck converter in SOT563",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "2 mm2: 1.2 x 1.6 (SOT-5X3|6)",
        "Package Group": "SOT-5X3|6",
        "\"Approx. price\n(USD)\"": "$0.350 | 1ku",
        "Status": "PREVIEW"
    },
    "TLV61070A": {
        "Description": "5-V 2-A boost converter with 0.5-V minimum input voltage",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "5 mm2: 1.6 x 2.9 (SOT-23|6)",
        "Package Group": "SOT-23|6",
        "\"Approx. price\n(USD)\"": "$0.200 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62873-Q1": {
        "Description": "Automotive 2.7-V to 6-V input 15-A stackable synchronous buck converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": "Functional Safety-Capable",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3.55 x 2.55 (VQFN-FCRLF|16)",
        "Package Group": "VQFN-FCRLF|16",
        "\"Approx. price\n(USD)\"": "$1.852 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS544C26": {
        "Description": "4-V to 16-V 35-A SVID and I&sup2;C&nbsp;synchronous step-down converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "30 mm2: 5 x 6 (WQFN-FCRLF|37)",
        "Package Group": "WQFN-FCRLF|37",
        "\"Approx. price\n(USD)\"": "$4.150 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS55289": {
        "Description": "30-V 8-A buck-boost converter with I²C interface",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck-boost inverting & split-rail converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "15 mm2: 3 x 5 (VQFN-HR|21)",
        "Package Group": "VQFN-HR|21",
        "\"Approx. price\n(USD)\"": "$3.350 | 1ku",
        "Status": "ACTIVE"
    },
    "LM5168-Q1": {
        "Description": "Automotive 6-V to 120-V Wide VIN 300-mA DC-DC converter with Fly-Buck™ capability",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 150",
        "Package size: mm2:W x L (PKG)": "19 mm2: 3.9 x 4.89 (SO PowerPAD|8)",
        "Package Group": "SO PowerPAD|8",
        "\"Approx. price\n(USD)\"": "$1.250 | 1ku",
        "Status": "ACTIVE"
    },
    "LM5169-Q1": {
        "Description": "Automotive 6-V to 120-V Wide VIN 650-mA DC-DC converter with Fly-Buck™ capability",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 150",
        "Package size: mm2:W x L (PKG)": "19 mm2: 3.9 x 4.89 (SO PowerPAD|8)",
        "Package Group": "SO PowerPAD|8",
        "\"Approx. price\n(USD)\"": "$1.764 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS543B22": {
        "Description": "4-V to 18-V input advanced current mode 20-A synchronous SWIFT&trade; step-down converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 150",
        "Package size: mm2:W x L (PKG)": "11 mm2: 2.5 x 4.5 (WQFN-FCRLF|17)",
        "Package Group": "WQFN-FCRLF|17",
        "\"Approx. price\n(USD)\"": "$2.950 | 1ku",
        "Status": "PREVIEW"
    },
    "TPSM8D6B24": {
        "Description": "4-V to 16-V input dual 25-A single 50-A PMBus&reg; power module",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck modules (integrated inductor)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "320 mm2: 20 x 16 (QFM|59)",
        "Package Group": "QFM|59",
        "\"Approx. price\n(USD)\"": "$20.000 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS56C231": {
        "Description": "3.8-V to 17-V 12-A synchronous buck converter with D-CAP3 control",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "12 mm2: 3.5 x 3.5 (VQFN-HR|18)",
        "Package Group": "VQFN-HR|18",
        "\"Approx. price\n(USD)\"": "$1.500 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62872-Q1": {
        "Description": "Automotive 2.7-V to 6-V input 12-A stackable synchronous buck converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": "Functional Safety-Capable",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3.55 x 2.55 (VQFN-FCRLF|16)",
        "Package Group": "VQFN-FCRLF|16",
        "\"Approx. price\n(USD)\"": "$1.770 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62933O": {
        "Description": "3.8-V to 30-V 3-A 200-kHz to 2.2-MHz synchronous buck converter with out-of-audio mode in SOT583",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 150",
        "Package size: mm2:W x L (PKG)": "3 mm2: 1.2 x 2.1 (SOT-5X3|8)",
        "Package Group": "SOT-5X3|8",
        "\"Approx. price\n(USD)\"": "$0.670 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62A02A": {
        "Description": "2.5-V to 5.5-V input 2-A high-efficiency step-down converter with forced PWM in SOT-563 package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "2 mm2: 1.2 x 1.6 (SOT-5X3|6)",
        "Package Group": "SOT-5X3|6",
        "\"Approx. price\n(USD)\"": "$0.195 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS628513": {
        "Description": "2.7-V to 6-V 3-A fixed-frequency step-down converter in SOT-583 package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": "Functional Safety-Capable",
        "\"Operating temperature range\n(C)\"": "-40 to 150",
        "Package size: mm2:W x L (PKG)": "3 mm2: 1.2 x 2.1 (SOT-5X3|8)",
        "Package Group": "SOT-5X3|8",
        "\"Approx. price\n(USD)\"": "$0.536 | 1ku",
        "Status": "ACTIVE"
    },
    "LMR51420": {
        "Description": "SIMPLE SWITCHER® power converter 4.5-V to 36-V 2-A synchronous buck with 40-µA IQ",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "\"-40 to 150\n-40 to 125\"",
        "Package size: mm2:W x L (PKG)": "5 mm2: 1.6 x 2.9 (SOT-23-THIN|6)",
        "Package Group": "SOT-23-THIN|6",
        "\"Approx. price\n(USD)\"": "$0.500 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62A02": {
        "Description": "2.5-V to 5.5-V input 2-A high-efficiency step-down converter in SOT-563 package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "2 mm2: 1.2 x 1.6 (SOT-5X3|6)",
        "Package Group": "SOT-5X3|6",
        "\"Approx. price\n(USD)\"": "$0.195 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62870-Q1": {
        "Description": "Automotive 2.7-V to 6-V input 6-A stackable synchronous buck converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": "Functional Safety-Capable",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3.55 x 2.55 (VQFN-FCRLF|16)",
        "Package Group": "VQFN-FCRLF|16",
        "\"Approx. price\n(USD)\"": "$1.498 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS563300": {
        "Description": "3.8-V to 28-V Input 3-A synchronous buck converter in SOT-583 package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 150",
        "Package size: mm2:W x L (PKG)": "3 mm2: 1.2 x 2.1 (SOT-5X3|8)",
        "Package Group": "SOT-5X3|8",
        "\"Approx. price\n(USD)\"": "$0.490 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62933F": {
        "Description": "3.8-V to 30-V input 3-A 200-kHz to 2.2-MHz synchronous buck converter in SOT-583 package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 150",
        "Package size: mm2:W x L (PKG)": "3 mm2: 1.2 x 2.1 (SOT-5X3|8)",
        "Package Group": "SOT-5X3|8",
        "\"Approx. price\n(USD)\"": "$0.670 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62933P": {
        "Description": "3.8-V to 30-V 3-A 200-kHz to 2.2-MHz low-IQ synchronous buck converter in SOT-583",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 150",
        "Package size: mm2:W x L (PKG)": "3 mm2: 1.2 x 2.1 (SOT-5X3|8)",
        "Package Group": "SOT-5X3|8",
        "\"Approx. price\n(USD)\"": "$0.670 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS63901": {
        "Description": "5.5-V buck-boost converter with 75-nA operating IQ in WCSP package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck-boost inverting & split-rail converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "1 mm2: 1.016 x 1.448 (DSBGA|12)",
        "Package Group": "DSBGA|12",
        "\"Approx. price\n(USD)\"": "$0.800 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62441-Q1": {
        "Description": "Automotive 2.75-V to 6-V dual 1-A output step-down converter with adjustable frequency",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": "Functional Safety-Capable",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "6 mm2: 2.3 x 2.7 (VQFN-HR|14)",
        "Package Group": "VQFN-HR|14",
        "\"Approx. price\n(USD)\"": "$0.920 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62442-Q1": {
        "Description": "Automotive 2.75-V to 6-V dual 2-A or 3-A and 1-A output adjustable frequency step-down converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": "Functional Safety-Capable",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "6 mm2: 2.3 x 2.7 (VQFN-HR|14)",
        "Package Group": "VQFN-HR|14",
        "\"Approx. price\n(USD)\"": "$1.003 | 1ku",
        "Status": "ACTIVE"
    },
    "LMR51430": {
        "Description": "SIMPLE SWITCHER&reg; 4.5-V to 36-V 3-A synchronous buck converter with 40-&micro;A IQ",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 150",
        "Package size: mm2:W x L (PKG)": "5 mm2: 1.6 x 2.9 (SOT-23-THIN|6)",
        "Package Group": "SOT-23-THIN|6",
        "\"Approx. price\n(USD)\"": "$0.650 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS628503": {
        "Description": "2.7-V to 6-V 3-A adjustable-frequency step-down converter in SOT-583 package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": "Functional Safety-Capable",
        "\"Operating temperature range\n(C)\"": "-40 to 150",
        "Package size: mm2:W x L (PKG)": "3 mm2: 1.2 x 2.1 (SOT-5X3|8)",
        "Package Group": "SOT-5X3|8",
        "\"Approx. price\n(USD)\"": "$0.536 | 1ku",
        "Status": "ACTIVE"
    },
    "LM25143-Q1": {
        "Description": "Automotive 3.5-V to 42-V low-Iq dual output stackable synchronous buck DC-DC controller",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck controllers (external switch)",
        "Rating": "Automotive",
        "TI functional safety category": "Functional Safety-Capable",
        "\"Operating temperature range\n(C)\"": "-40 to 150",
        "Package size: mm2:W x L (PKG)": "36 mm2: 6 x 6 (VQFN|40)",
        "Package Group": "VQFN|40",
        "\"Approx. price\n(USD)\"": "$1.562 | 1ku",
        "Status": "ACTIVE"
    },
    "LM5143A-Q1": {
        "Description": "Automotive 3.5-V to 65-V low-IQ dual output stackable synchronous buck DC-DC controller",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck controllers (external switch)",
        "Rating": "Automotive",
        "TI functional safety category": "Functional Safety-Capable",
        "\"Operating temperature range\n(C)\"": "-40 to 150",
        "Package size: mm2:W x L (PKG)": "36 mm2: 6 x 6 (VQFN|40)",
        "Package Group": "VQFN|40",
        "\"Approx. price\n(USD)\"": "$1.953 | 1ku",
        "Status": "ACTIVE"
    },
    "LM5177": {
        "Description": "78-V wide VIN synchronous 4-switch buck-boost controller with bidirectional operation",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck-boost & inverting controllers (external switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "43 mm2: 4.4 x 9.7 (HTSSOP|38)",
        "Package Group": "HTSSOP|38",
        "\"Approx. price\n(USD)\"": "$3.490 | 1ku",
        "Status": "PREVIEW"
    },
    "TLVM13620": {
        "Description": "3.6-V to 36-V input 1-V to 6-V output 2-A step-down module in 4-mm x 6-mm x 1.8-mm package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck modules (integrated inductor)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "24 mm2: 4 x 6 (B0QFN|30)",
        "Package Group": "B0QFN|30",
        "\"Approx. price\n(USD)\"": "$1.650 | 1ku",
        "Status": "ACTIVE"
    },
    "TPSM63602": {
        "Description": "3.6-V to 36-V input 1-V to 12-V output 2-A step-down module in 4-mm x 6-mm x 1.8-mm package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck modules (integrated inductor)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "24 mm2: 4 x 6 (B0QFN|30)",
        "Package Group": "B0QFN|30",
        "\"Approx. price\n(USD)\"": "$3.280 | 1ku",
        "Status": "ACTIVE"
    },
    "TPSM63603E": {
        "Description": "36-V 3-A step-down power module in small 4-mm x 6-mm x 1.8-mm with -55°C extended temperature range",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck modules (integrated inductor)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-55 to 125",
        "Package size: mm2:W x L (PKG)": "24 mm2: 4 x 6 (B0QFN|30)",
        "Package Group": "B0QFN|30",
        "\"Approx. price\n(USD)\"": "$5.480 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62A01A": {
        "Description": "2.5-V to 5.5-V input 1-A high-efficiency step-down converter with forced PWM in SOT-563 package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "2 mm2: 1.2 x 1.6 (SOT-5X3|6)",
        "Package Group": "SOT-5X3|6",
        "\"Approx. price\n(USD)\"": "$0.148 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS564242": {
        "Description": "3-V to 16-V input voltage 4-A ECO mode synchronous buck converter in SOT-563 package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "2 mm2: 1.2 x 1.6 (SOT-5X3|6)",
        "Package Group": "SOT-5X3|6",
        "\"Approx. price\n(USD)\"": "$0.370 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS565242": {
        "Description": "3-V to 16-V input voltage 5-A ECO mode synchronous buck converter in SOT-563 package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "2 mm2: 1.2 x 1.6 (SOT-5X3|6)",
        "Package Group": "SOT-5X3|6",
        "\"Approx. price\n(USD)\"": "$0.494 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS565247": {
        "Description": "3-V to 16-V input voltage 5-A FCCM mode synchronous buck converter in SOT-563 package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "2 mm2: 1.2 x 1.6 (SOT-5X3|6)",
        "Package Group": "SOT-5X3|6",
        "\"Approx. price\n(USD)\"": "$0.494 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS566242": {
        "Description": "3-V to 16-V input voltage 6-A ECO mode synchronous buck converter in SOT-563 package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "2 mm2: 1.2 x 1.6 (SOT-5X3|6)",
        "Package Group": "SOT-5X3|6",
        "\"Approx. price\n(USD)\"": "$0.638 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS566247": {
        "Description": "3-V to 16-V input voltage 6-A FCCM mode synchronous buck converter in SOT-563 package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "2 mm2: 1.2 x 1.6 (SOT-5X3|6)",
        "Package Group": "SOT-5X3|6",
        "\"Approx. price\n(USD)\"": "$0.638 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62903-Q1": {
        "Description": "Automotive 3-V to 18-V 3-A low-IQ synchronous buck converter with +165°C TJ",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": "Functional Safety-Capable",
        "\"Operating temperature range\n(C)\"": "-40 to 165",
        "Package size: mm2:W x L (PKG)": "4 mm2: 2 x 2.2 (VQFN-HR|9)",
        "Package Group": "VQFN-HR|9",
        "\"Approx. price\n(USD)\"": "$0.740 | 1ku",
        "Status": "PREVIEW"
    },
    "TPS62871-Q1": {
        "Description": "Automotive 2.7-V to 6-V input 9-A stackable synchronous buck converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": "Functional Safety-Capable",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3.55 x 2.55 (VQFN-FCRLF|16)",
        "Package Group": "VQFN-FCRLF|16",
        "\"Approx. price\n(USD)\"": "$1.600 | 1ku",
        "Status": "PREVIEW"
    },
    "TLVM13640": {
        "Description": "36-V input 1-V to 6-V output 4-A buck power module in 5-mm x 5.5-mm enhanced HotRod™ QFN",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck modules (integrated inductor)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "28 mm2: 5 x 5.5 (B3QFN|20)",
        "Package Group": "B3QFN|20",
        "\"Approx. price\n(USD)\"": "$2.950 | 1ku",
        "Status": "ACTIVE"
    },
    "TLVM13660": {
        "Description": "36-V input 1-V to 6-V output 6-A buck power module in 5-mm x 5.5-mm enhanced HotRod™ QFN",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck modules (integrated inductor)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "28 mm2: 5 x 5.5 (B3QFN|20)",
        "Package Group": "B3QFN|20",
        "\"Approx. price\n(USD)\"": "$3.550 | 1ku",
        "Status": "ACTIVE"
    },
    "TPSM63604": {
        "Description": "36-V input 16-V output 4-A synchronous step-down DC-DC power module",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck modules (integrated inductor)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "28 mm2: 5 x 5.5 (B3QFN|20)",
        "Package Group": "B3QFN|20",
        "\"Approx. price\n(USD)\"": "$5.550 | 1ku",
        "Status": "ACTIVE"
    },
    "TPSM63606E": {
        "Description": "High-density 36-V input 1-V to 16-V output 6-A power module with -55°C enhanced temperature range",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck modules (integrated inductor)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-55 to 125",
        "Package size: mm2:W x L (PKG)": "28 mm2: 5 x 5.5 (B3QFN|20)",
        "Package Group": "B3QFN|20",
        "\"Approx. price\n(USD)\"": "$9.750 | 1ku",
        "Status": "ACTIVE"
    },
    "LM5152-Q1": {
        "Description": "Automotive 2.2 MHz wide VIN low IQ synchronous boost controller",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost controllers (external switch)",
        "Rating": "Automotive",
        "TI functional safety category": "Functional Safety-Capable",
        "\"Operating temperature range\n(C)\"": "-40 to 150",
        "Package size: mm2:W x L (PKG)": "12 mm2: 3.5 x 3.5 (VQFN|20)",
        "Package Group": "VQFN|20",
        "\"Approx. price\n(USD)\"": "$1.280 | 1ku",
        "Status": "ACTIVE"
    },
    "LM51521-Q1": {
        "Description": "Automotive 2.2-MHz wide V<sub>IN</sub> low IQ synchronous boost controller with disabled bypass mode",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost controllers (external switch)",
        "Rating": "Automotive",
        "TI functional safety category": "Functional Safety-Capable",
        "\"Operating temperature range\n(C)\"": "-40 to 150",
        "Package size: mm2:W x L (PKG)": "12 mm2: 3.5 x 3.5 (VQFN|20)",
        "Package Group": "VQFN|20",
        "\"Approx. price\n(USD)\"": "$1.180 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS629203-Q1": {
        "Description": "Automotive 3-V to 17-V 0.3-A low-IQ synchronous buck converter in SOT-583 package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": "Functional Safety-Capable",
        "\"Operating temperature range\n(C)\"": "-40 to 150",
        "Package size: mm2:W x L (PKG)": "3 mm2: 1.2 x 2.1 (SOT-5X3|8)",
        "Package Group": "SOT-5X3|8",
        "\"Approx. price\n(USD)\"": "$0.470 | 1ku",
        "Status": "ACTIVE"
    },
    "LM5013-Q1": {
        "Description": "6-V to 100-V input 3.5-A non-synchronous buck DC/DC converter with ultra-low quiescent current (IQ)",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": "Functional Safety-Capable",
        "\"Operating temperature range\n(C)\"": "-40 to 150",
        "Package size: mm2:W x L (PKG)": "19 mm2: 3.9 x 4.89 (SO PowerPAD|8)",
        "Package Group": "SO PowerPAD|8",
        "\"Approx. price\n(USD)\"": "$2.142 | 1ku",
        "Status": "ACTIVE"
    },
    "LMR43610-Q1": {
        "Description": "Automotive 3-V to 36-V 1-A low-EMI synchronous buck regulator with low IQ",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": "Functional Safety-Capable",
        "\"Operating temperature range\n(C)\"": "-40 to 150",
        "Package size: mm2:W x L (PKG)": "4 mm2: 2 x 2 (VQFN-HR|9)",
        "Package Group": "VQFN-HR|9",
        "\"Approx. price\n(USD)\"": "$1.180 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62A01": {
        "Description": "2.5-V to 5.5-V input 1-A high-efficiency step-down converter in SOT-563 package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "2 mm2: 1.2 x 1.6 (SOT-5X3|6)",
        "Package Group": "SOT-5X3|6",
        "\"Approx. price\n(USD)\"": "$0.148 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS629203": {
        "Description": "3-V to 17-V 0.3-A low-IQ synchronous buck converter in SOT-583 package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 150",
        "Package size: mm2:W x L (PKG)": "3 mm2: 1.2 x 2.1 (SOT-5X3|8)",
        "Package Group": "SOT-5X3|8",
        "\"Approx. price\n(USD)\"": "$0.330 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS629206": {
        "Description": "3-V to 17-V 0.6-A low-IQ synchronous buck converter in SOT-583 package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 150",
        "Package size: mm2:W x L (PKG)": "3 mm2: 1.2 x 2.1 (SOT-5X3|8)",
        "Package Group": "SOT-5X3|8",
        "\"Approx. price\n(USD)\"": "$0.360 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS629206-Q1": {
        "Description": "Automotive 3-V to 17-V 0.6-A low-IQ synchronous buck converter in SOT-583 package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": "Functional Safety-Capable",
        "\"Operating temperature range\n(C)\"": "-40 to 150",
        "Package size: mm2:W x L (PKG)": "3 mm2: 1.2 x 2.1 (SOT-5X3|8)",
        "Package Group": "SOT-5X3|8",
        "\"Approx. price\n(USD)\"": "$0.490 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS629210E": {
        "Description": "3-V to 17-V 1-A high-efficiency synchronous buck converter with -55°C to 150°C temperature range",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": "Functional Safety-Capable",
        "\"Operating temperature range\n(C)\"": "-55 to 150",
        "Package size: mm2:W x L (PKG)": "3 mm2: 1.2 x 2.1 (SOT-5X3|8)",
        "Package Group": "SOT-5X3|8",
        "\"Approx. price\n(USD)\"": "$1.080 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS629211-Q1": {
        "Description": "Automotive 3-V to 10-V 1-A high-efficiency low-IQ synchronous buck converter in SOT-583 package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": "Functional Safety-Capable",
        "\"Operating temperature range\n(C)\"": "-40 to 150",
        "Package size: mm2:W x L (PKG)": "3 mm2: 1.2 x 2.1 (SOT-5X3|8)",
        "Package Group": "SOT-5X3|8",
        "\"Approx. price\n(USD)\"": "$0.525 | 1ku",
        "Status": "ACTIVE"
    },
    "LM25143": {
        "Description": "3.5-V to 42-V dual-output stackable synchronous buck DC/DC controller with ultra-low IQ",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck controllers (external switch)",
        "Rating": "Catalog",
        "TI functional safety category": "Functional Safety-Capable",
        "\"Operating temperature range\n(C)\"": "-40 to 150",
        "Package size: mm2:W x L (PKG)": "36 mm2: 6 x 6 (VQFN|40)",
        "Package Group": "VQFN|40",
        "\"Approx. price\n(USD)\"": "$1.324 | 1ku",
        "Status": "ACTIVE"
    },
    "LM5143": {
        "Description": "3.5-V to 65-V dual-output stackable synchronous buck DC/DC controller with ultra-low IQ",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck controllers (external switch)",
        "Rating": "Catalog",
        "TI functional safety category": "Functional Safety-Capable",
        "\"Operating temperature range\n(C)\"": "-40 to 150",
        "Package size: mm2:W x L (PKG)": "36 mm2: 6 x 6 (VQFN|40)",
        "Package Group": "VQFN|40",
        "\"Approx. price\n(USD)\"": "$1.655 | 1ku",
        "Status": "ACTIVE"
    },
    "TPSM82903": {
        "Description": "3-V to 17-V 3-A high-efficiency low-IQ synchronous buck converter module with integrated inductor",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck modules (integrated inductor)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "8 mm2: 2.8 x 3 (uSiP|11)",
        "Package Group": "uSiP|11",
        "\"Approx. price\n(USD)\"": "$1.710 | 1ku",
        "Status": "PREVIEW"
    },
    "TPS62442": {
        "Description": "2.75-V to 6-V dual 2-A or 3-A and 1-A step-down converter in QFN package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": "Functional Safety-Capable",
        "\"Operating temperature range\n(C)\"": "-40 to 150",
        "Package size: mm2:W x L (PKG)": "6 mm2: 2.3 x 2.7 (VQFN-HR|14)",
        "Package Group": "VQFN-HR|14",
        "\"Approx. price\n(USD)\"": "$0.740 | 1ku",
        "Status": "PREVIEW"
    },
    "TPS62932": {
        "Description": "3.8-V to 30-V input 2-A 200-kHz to 2.2-MHz low-IQ synchronous buck converter in SOT-583 package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 150",
        "Package size: mm2:W x L (PKG)": "3 mm2: 1.2 x 2.1 (SOT-5X3|8)",
        "Package Group": "SOT-5X3|8",
        "\"Approx. price\n(USD)\"": "$0.637 | 1ku",
        "Status": "ACTIVE"
    },
    "LMQ66430": {
        "Description": "36-V 3-A low EMI synchronous step-down converter with 1.5-µA IQ",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 150",
        "Package size: mm2:W x L (PKG)": "7 mm2: 2.6 x 2.6 (VQFN-FCRLF|14)",
        "Package Group": "VQFN-FCRLF|14",
        "\"Approx. price\n(USD)\"": "$1.290 | 1ku",
        "Status": "PREVIEW"
    },
    "LMQ66430-Q1": {
        "Description": "Automotive 36-V 3-A low EMI synchronous step-down converter with 1.5-µA IQ",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 150",
        "Package size: mm2:W x L (PKG)": "7 mm2: 2.6 x 2.6 (VQFN-FCRLF|14)",
        "Package Group": "VQFN-FCRLF|14",
        "\"Approx. price\n(USD)\"": "$1.550 | 1ku",
        "Status": "PREVIEW"
    },
    "TPS62824": {
        "Description": "2.4-V to 5.5-V input 1-A step-down converter with 1% accuracy in 1.5-mm x 1.5-mm QFN",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "2 mm2: 1.5 x 1.5 (VSON-HR|6)",
        "Package Group": "VSON-HR|6",
        "\"Approx. price\n(USD)\"": "$0.399 | 1ku",
        "Status": "ACTIVE"
    },
    "TLVM13630": {
        "Description": "High-density 3-V to 36-V input 1-V to 6-V output 3-A step-down power module",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck modules (integrated inductor)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "24 mm2: 4 x 6 (B0QFN|30)",
        "Package Group": "B0QFN|30",
        "\"Approx. price\n(USD)\"": "$1.750 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS7H4003-SEP": {
        "Description": "Radiation-tolerant 3-V to 7-V 18-A synchronous step-down converter in space-enhanced plastic",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Space",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-55 to 125",
        "Package size: mm2:W x L (PKG)": "85 mm2: 6.1 x 14 (HTSSOP|44)",
        "Package Group": "HTSSOP|44",
        "\"Approx. price\n(USD)\"": "$1528.385 | 1ku",
        "Status": "ACTIVE"
    },
    "LMR38010": {
        "Description": "SIMPLE SWITCHER® 80-V 1.0-A 2.2-MHz step-down converter with 40-µA IQ",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": "Functional Safety-Capable",
        "\"Operating temperature range\n(C)\"": "-40 to 150",
        "Package size: mm2:W x L (PKG)": "19 mm2: 3.9 x 4.89 (SO PowerPAD|8)",
        "Package Group": "SO PowerPAD|8",
        "\"Approx. price\n(USD)\"": "$1.136 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS629210": {
        "Description": "3-V to 17-V 1-A high-efficiency low-IQ synchronous buck converter in SOT-583 package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 150",
        "Package size: mm2:W x L (PKG)": "3 mm2: 1.2 x 2.1 (SOT-5X3|8)",
        "Package Group": "SOT-5X3|8",
        "\"Approx. price\n(USD)\"": "$0.450 | 1ku",
        "Status": "ACTIVE"
    },
    "TPSM5D1806E": {
        "Description": "4.5-V to 15-V input dual 6-A single 12-A output power module with -55°C operating temperature",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck modules (integrated inductor)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-55 to 125",
        "Package size: mm2:W x L (PKG)": "44 mm2: 5.5 x 8 (B0QFN|51)",
        "Package Group": "B0QFN|51",
        "\"Approx. price\n(USD)\"": "$26.000 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62843": {
        "Description": "1.8-V to 5.5-V input 600-mA ultra-low IQ step-down converter in WCSP package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "1 mm2: .7 x 1.05 (DSBGA|6)",
        "Package Group": "DSBGA|6",
        "\"Approx. price\n(USD)\"": "$0.478 | 1ku",
        "Status": "PREVIEW"
    },
    "TPS631000": {
        "Description": "1.5-A output current high-power-density buck-boost converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck-boost inverting & split-rail converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "3 mm2: 1.2 x 2.1 (SOT-5X3|8)",
        "Package Group": "SOT-5X3|8",
        "\"Approx. price\n(USD)\"": "$0.630 | 1ku",
        "Status": "ACTIVE"
    },
    "LMR54406": {
        "Description": "SIMPLE SWITCHER® power converter with 4-V to 36-V input 0.6-A synchronous buck and 80-µA IQ",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "5 mm2: 1.6 x 2.9 (SOT-23|6)",
        "Package Group": "SOT-23|6",
        "\"Approx. price\n(USD)\"": "$0.378 | 1ku",
        "Status": "ACTIVE"
    },
    "LM63460-Q1": {
        "Description": "Automotive 3-V to 36-V 6-A low EMI synchronous step-down converter in enhanced QFN package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 150",
        "Package size: mm2:W x L (PKG)": "14 mm2: 3.5 x 4 (VQFN-FCRLF|22)",
        "Package Group": "VQFN-FCRLF|22",
        "\"Approx. price\n(USD)\"": "$2.138 | 1ku",
        "Status": "PREVIEW"
    },
    "TPS62810M": {
        "Description": "2.75-V to 6-V 4-A step-down converter in a 2-mm x 3-mm QFN package with -55C extended temperature",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-55 to 125",
        "Package size: mm2:W x L (PKG)": "6 mm2: 2 x 3 (VQFN-HR|9)",
        "Package Group": "VQFN-HR|9",
        "\"Approx. price\n(USD)\"": "$1.784 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62812M": {
        "Description": "2.75-V to 6-V 2-A step-down converter in a 2-mm x 3-mm QFN package with -55C extended temperature",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-55 to 125",
        "Package size: mm2:W x L (PKG)": "6 mm2: 2 x 3 (VQFN-HR|9)",
        "Package Group": "VQFN-HR|9",
        "\"Approx. price\n(USD)\"": "$1.428 | 1ku",
        "Status": "ACTIVE"
    },
    "TPSM8D6C24": {
        "Description": "4-V to 16-V input dual 35-A PMBus® power module",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck modules (integrated inductor)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "320 mm2: 20 x 16 (QFM|59)",
        "Package Group": "QFM|59",
        "\"Approx. price\n(USD)\"": "$30.000 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62816-Q1": {
        "Description": "Automotive 2.75-V to 6-V 6-A step-down converter in 2-mm x 3-mm wettable-flanks QFN package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": "Functional Safety-Capable",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "6 mm2: 2 x 3 (VQFN-HR|9)",
        "Package Group": "VQFN-HR|9",
        "\"Approx. price\n(USD)\"": "$1.239 | 1ku",
        "Status": "ACTIVE"
    },
    "LM5123-Q1": {
        "Description": "2.2MHz wide VIN low IQ synchronous boost controller",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost controllers (external switch)",
        "Rating": "Automotive",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 150",
        "Package size: mm2:W x L (PKG)": "12 mm2: 3.5 x 3.5 (VQFN|20)",
        "Package Group": "VQFN|20",
        "\"Approx. price\n(USD)\"": "$1.593 | 1ku",
        "Status": "ACTIVE"
    },
    "TPSM82864A": {
        "Description": "2.4-V to 5.5-V Input 4-A thin step-down power module with integrated inductor in 3.5-mm x 4-mm QFN",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck modules (integrated inductor)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "14 mm2: 4 x 3.5 (B0QFN|23)",
        "Package Group": "B0QFN|23",
        "\"Approx. price\n(USD)\"": "$1.860 | 1ku",
        "Status": "ACTIVE"
    },
    "TPSM82866A": {
        "Description": "2.4-V to 5.5-V Input 6-A thin step-down power module with integrated inductor in 3.5-mm x 4-mm QFN",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck modules (integrated inductor)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "14 mm2: 4 x 3.5 (B0QFN|23)",
        "Package Group": "B0QFN|23",
        "\"Approx. price\n(USD)\"": "$2.200 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS536C9": {
        "Description": "Dual-channel 12 phase step-down digital multiphase D-CAP+™ controller with VR14 SVID and PMBus",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck controllers (external switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "36 mm2: 6 x 6 (VQFN|48)",
        "Package Group": "VQFN|48",
        "\"Approx. price\n(USD)\"": "$7.700 | 1ku",
        "Status": "ACTIVE"
    },
    "LM25148": {
        "Description": "42-V synchronous buck DC/DC controller with ultra-low IQ",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck controllers (external switch)",
        "Rating": "Catalog",
        "TI functional safety category": "Functional Safety-Capable",
        "\"Operating temperature range\n(C)\"": "-40 to 150",
        "Package size: mm2:W x L (PKG)": "19 mm2: 3.5 x 5.5 (VQFN|24)",
        "Package Group": "VQFN|24",
        "\"Approx. price\n(USD)\"": "$1.096 | 1ku",
        "Status": "ACTIVE"
    },
    "LM25149": {
        "Description": "42-V synchronous buck DC/DC controller with ultra-low IQ & integrated active EMI filter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck controllers (external switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 150",
        "Package size: mm2:W x L (PKG)": "19 mm2: 3.5 x 5.5 (VQFN|24)",
        "Package Group": "VQFN|24",
        "\"Approx. price\n(USD)\"": "$1.324 | 1ku",
        "Status": "ACTIVE"
    },
    "LMR43620-Q1": {
        "Description": "Automotive 3-V to 36-V 2-A low-IQ synchronous buck regulator",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": "Functional Safety-Capable",
        "\"Operating temperature range\n(C)\"": "-40 to 150",
        "Package size: mm2:W x L (PKG)": "4 mm2: 2 x 2 (VQFN-HR|9)",
        "Package Group": "VQFN-HR|9",
        "\"Approx. price\n(USD)\"": "$1.210 | 1ku",
        "Status": "ACTIVE"
    },
    "TPSM63606": {
        "Description": "High-density 36-V input 1-V to 16-V output 6-A power module in 5-mm x 5.5-mm enhanced HotRod™ QFN",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck modules (integrated inductor)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "28 mm2: 5 x 5.5 (B3QFN|20)",
        "Package Group": "B3QFN|20",
        "\"Approx. price\n(USD)\"": "$6.550 | 1ku",
        "Status": "ACTIVE"
    },
    "TPSM8A28": {
        "Description": "2.7-V to 16-V input 12-A buck power module with differential remote sense",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck modules (integrated inductor)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "49 mm2: 6.5 x 7.5 (B3QFN|25)",
        "Package Group": "B3QFN|25",
        "\"Approx. price\n(USD)\"": "$9.500 | 1ku",
        "Status": "ACTIVE"
    },
    "TPSM8A29": {
        "Description": "2.7-V to 16-V input 15-A buck power module with differential remote sense",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck modules (integrated inductor)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "49 mm2: 6.5 x 7.5 (B3QFN|25)",
        "Package Group": "B3QFN|25",
        "\"Approx. price\n(USD)\"": "$11.500 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62933": {
        "Description": "3.8-V to 30-V 3-A 200-kHz to 2.2-MHz low-IQ synchronous buck converter in SOT-583 package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 150",
        "Package size: mm2:W x L (PKG)": "3 mm2: 1.2 x 2.1 (SOT-5X3|8)",
        "Package Group": "SOT-5X3|8",
        "\"Approx. price\n(USD)\"": "$0.670 | 1ku",
        "Status": "ACTIVE"
    },
    "LM5168": {
        "Description": "6-V to 120-V wide VIN 300-mA DC-DC converter with Fly-Buck™ capability",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 150",
        "Package size: mm2:W x L (PKG)": "19 mm2: 3.9 x 4.89 (SO PowerPAD|8)",
        "Package Group": "SO PowerPAD|8",
        "\"Approx. price\n(USD)\"": "$1.060 | 1ku",
        "Status": "ACTIVE"
    },
    "LM61480": {
        "Description": "8-A buck converter optimized for power density and low EMI",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": "Functional Safety-Capable",
        "\"Operating temperature range\n(C)\"": "-40 to 150",
        "Package size: mm2:W x L (PKG)": "16 mm2: 3.5 x 4.5 (VQFN-HR|16)",
        "Package Group": "VQFN-HR|16",
        "\"Approx. price\n(USD)\"": "$1.911 | 1ku",
        "Status": "ACTIVE"
    },
    "LM61495": {
        "Description": "10-A buck converter optimized for power density and low EMI",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": "Functional Safety-Capable",
        "\"Operating temperature range\n(C)\"": "-40 to 150",
        "Package size: mm2:W x L (PKG)": "16 mm2: 3.5 x 4.5 (VQFN-HR|16)",
        "Package Group": "VQFN-HR|16",
        "\"Approx. price\n(USD)\"": "$2.376 | 1ku",
        "Status": "ACTIVE"
    },
    "LM62460": {
        "Description": "6-A buck converter optimized for power density and low EMI",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": "Functional Safety-Capable",
        "\"Operating temperature range\n(C)\"": "-40 to 150",
        "Package size: mm2:W x L (PKG)": "16 mm2: 3.5 x 4.5 (VQFN-HR|16)",
        "Package Group": "VQFN-HR|16",
        "\"Approx. price\n(USD)\"": "$1.705 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62089A": {
        "Description": "2.4-V to 5.5-V input 2-A step-down converter in 1.2-mm x 0.8-mm WCS package with forced-PWM",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "1 mm2: 1.4 x 1 (DSBGA|6)",
        "Package Group": "DSBGA|6",
        "\"Approx. price\n(USD)\"": "$0.460 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS629210-Q1": {
        "Description": "Automotive 3-V to 17-V 1-A high-efficiency and low-IQ synchronous buck converter in SOT-583",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": "Functional Safety-Capable",
        "\"Operating temperature range\n(C)\"": "-40 to 150",
        "Package size: mm2:W x L (PKG)": "3 mm2: 1.2 x 2.1 (SOT-5X3|8)",
        "Package Group": "SOT-5X3|8",
        "\"Approx. price\n(USD)\"": "$0.540 | 1ku",
        "Status": "ACTIVE"
    },
    "TPSM63603": {
        "Description": "High-density 3-V to 36-V input 1-V to 16-V output 3-A power module",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck modules (integrated inductor)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "24 mm2: 4 x 6 (B0QFN|30)",
        "Package Group": "B0QFN|30",
        "\"Approx. price\n(USD)\"": "$3.650 | 1ku",
        "Status": "ACTIVE"
    },
    "LMR54410": {
        "Description": "SIMPLE SWITCHER® power converter 4.5-V to 36-V 1-A synchronous buck with 80-µA IQ",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "5 mm2: 1.6 x 2.9 (SOT-23|6)",
        "Package Group": "SOT-23|6",
        "\"Approx. price\n(USD)\"": "$0.420 | 1ku",
        "Status": "ACTIVE"
    },
    "TPSM82821A": {
        "Description": "5.5-V input 1-A step-down converter with integrated inductor and forced PWM mode in µSiP package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck modules (integrated inductor)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "See datasheet",
        "Package Group": " --- ",
        "\"Approx. price\n(USD)\"": "$0.945 | 1ku",
        "Status": "ACTIVE"
    },
    "TPSM82822A": {
        "Description": "5.5-V input 2-A step-down converter with integrated inductor and forced PWM mode in µSiP package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck modules (integrated inductor)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "See datasheet",
        "Package Group": " --- ",
        "\"Approx. price\n(USD)\"": "$1.050 | 1ku",
        "Status": "ACTIVE"
    },
    "TPSM82823A": {
        "Description": "5.5-V input 3-A step-down converter with integrated inductor and forced PWM mode in µSiP package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck modules (integrated inductor)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "See datasheet",
        "Package Group": " --- ",
        "\"Approx. price\n(USD)\"": "$1.208 | 1ku",
        "Status": "ACTIVE"
    },
    "LMR38020": {
        "Description": "SIMPLE SWITCHER® power converter 4.2-V to 80-V 2-A synchronous buck with 40-µA IQ",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": "Functional Safety-Capable",
        "\"Operating temperature range\n(C)\"": "-40 to 150",
        "Package size: mm2:W x L (PKG)": "19 mm2: 3.9 x 4.89 (SO PowerPAD|8)",
        "Package Group": "SO PowerPAD|8",
        "\"Approx. price\n(USD)\"": "$1.250 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62088A": {
        "Description": "2.4-V to 5.5-V input 3-A step-down converter in 1.2-mm x 0.8-mm WCS package with forced-PWM",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "1 mm2: 1.4 x 1 (DSBGA|6)",
        "Package Group": "DSBGA|6",
        "\"Approx. price\n(USD)\"": "$0.561 | 1ku",
        "Status": "ACTIVE"
    },
    "LM61430-Q1": {
        "Description": "Automotive 3-V to 36-V 3-A low-noise synchronous step-down converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": "Functional Safety-Capable",
        "\"Operating temperature range\n(C)\"": "-40 to 150",
        "Package size: mm2:W x L (PKG)": "14 mm2: 3.5 x 4 (VQFN-HR|14)",
        "Package Group": "VQFN-HR|14",
        "\"Approx. price\n(USD)\"": "$1.652 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS562212": {
        "Description": "4.2-V to 18-V 2-A 1.2-MHz synchronous buck converter with eco-mode and selectable FCCM",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 150",
        "Package size: mm2:W x L (PKG)": "3 mm2: 1.2 x 2.1 (SOT-5X3|8)",
        "Package Group": "SOT-5X3|8",
        "\"Approx. price\n(USD)\"": "$0.400 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS61094": {
        "Description": "60-nA quiescent current bi-directional buck/boost converter with bypass mode",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "6 mm2: 3 x 2 (WSON|12)",
        "Package Group": "WSON|12",
        "\"Approx. price\n(USD)\"": "$1.200 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS563212": {
        "Description": "4.2-V to 18-V 3-A 1.2-MHz synchronous buck converter with eco-mode and selectable FCCM",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 150",
        "Package size: mm2:W x L (PKG)": "3 mm2: 1.2 x 2.1 (SOT-5X3|8)",
        "Package Group": "SOT-5X3|8",
        "\"Approx. price\n(USD)\"": "$0.500 | 1ku",
        "Status": "ACTIVE"
    },
    "LM5158": {
        "Description": "3-A 85-V  2.2-MHz wide VIN boost flyback & SEPIC converter with dual random spread spectrum",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (WQFN|16)",
        "Package Group": "WQFN|16",
        "\"Approx. price\n(USD)\"": "$1.595 | 1ku",
        "Status": "ACTIVE"
    },
    "LM5158-Q1": {
        "Description": "3-A 85-V 2.2-MHz wide VIN boost flyback & SEPIC converter with dual random spread spectrum",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": "Functional Safety-Capable",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (WQFN|16)",
        "Package Group": "WQFN|16",
        "\"Approx. price\n(USD)\"": "$1.856 | 1ku",
        "Status": "ACTIVE"
    },
    "LM51581": {
        "Description": "1.5-A 85-V 2.2-MHz wide VIN boost flyback & SEPIC converter with dual random spread spectrum",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (WQFN|16)",
        "Package Group": "WQFN|16",
        "\"Approx. price\n(USD)\"": "$1.595 | 1ku",
        "Status": "ACTIVE"
    },
    "LM51581-Q1": {
        "Description": "1.5-A 85-V 2.2-MHz wide VIN boost flyback & SEPIC converter with dual random spread spectrum",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": "Functional Safety-Capable",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (WQFN|16)",
        "Package Group": "WQFN|16",
        "\"Approx. price\n(USD)\"": "$1.711 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS63807": {
        "Description": "2A11-uA quiescent current buck-boost converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck-boost inverting & split-rail converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "See datasheet (DSBGA)",
        "Package Group": "DSBGA|15",
        "\"Approx. price\n(USD)\"": "$0.905 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS628503-Q1": {
        "Description": "2.7-V to 6-V 3-A automotive step-down converter in SOT583 package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": "Functional Safety-Capable",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "3 mm2: 1.2 x 2.1 (SOT-5X3|8)",
        "Package Group": "SOT-5X3|8",
        "\"Approx. price\n(USD)\"": "$0.696 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS53689": {
        "Description": "Dual-channel 8 phase step-down digital multiphase D-CAP+™ controller with VR14 SVID and PMBus",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck controllers (external switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "25 mm2: 5 x 5 (WQFN|40)",
        "Package Group": "WQFN|40",
        "\"Approx. price\n(USD)\"": "$4.787 | 1ku",
        "Status": "ACTIVE"
    },
    "TPSM5601R5": {
        "Description": "4.2-V to 60-V input 1-V to 6-V output 1.5-A step-down module in 5-mm x 5.5-mm x 4-mm QFN",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck modules (integrated inductor)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "28 mm2: 5 x 5.5 (B3QFN|15)",
        "Package Group": "B3QFN|15",
        "\"Approx. price\n(USD)\"": "$2.800 | 1ku",
        "Status": "ACTIVE"
    },
    "TPSM560R6": {
        "Description": "4.2-V to 60-V input 1-V to 6-V output 0.6-A step-down module in 5-mm x 5.5-mm x 4-mm QFN",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck modules (integrated inductor)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "28 mm2: 5 x 5.5 (B3QFN|15)",
        "Package Group": "B3QFN|15",
        "\"Approx. price\n(USD)\"": "$2.800 | 1ku",
        "Status": "ACTIVE"
    },
    "TPSM560R6H": {
        "Description": "4.2-V to 60-V input 1-V to 16-V output 0.6-A step-down module in 5-mm x 5.5-mm x 4-mm QFN",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck modules (integrated inductor)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "28 mm2: 5 x 5.5 (B3QFN|15)",
        "Package Group": "B3QFN|15",
        "\"Approx. price\n(USD)\"": "$2.800 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62811M": {
        "Description": "2.75-V to 6-V 1-A step-down converter in a 2-mm x 3-mm QFN package with -55C extended temperature",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-55 to 125",
        "Package size: mm2:W x L (PKG)": "6 mm2: 2 x 3 (VQFN-HR|9)",
        "Package Group": "VQFN-HR|9",
        "\"Approx. price\n(USD)\"": "$1.260 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62813M": {
        "Description": "2.75-V to 6-V 3-A step-down converter in a 2-mm x 3-mm QFN package with -55C extended temperature",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-55 to 125",
        "Package size: mm2:W x L (PKG)": "6 mm2: 2 x 3 (VQFN-HR|9)",
        "Package Group": "VQFN-HR|9",
        "\"Approx. price\n(USD)\"": "$1.602 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS562211": {
        "Description": "4.2-V to 18-V 2-A synchronous buck converter with 1% accuracy PG/SS and PFM/forced-PWM in SOT583",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "3 mm2: 1.2 x 2.1 (SOT-5X3|8)",
        "Package Group": "SOT-5X3|8",
        "\"Approx. price\n(USD)\"": "$0.250 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS563211": {
        "Description": "4.2-V to 18-V 3-A synchronous buck converter with 1% accuracy PG/SS and PFM/forced-PWM in SOT583",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "3 mm2: 1.2 x 2.1 (SOT-5X3|8)",
        "Package Group": "SOT-5X3|8",
        "\"Approx. price\n(USD)\"": "$0.300 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS7H4002-SP": {
        "Description": "Radiation-hardened QMLV 3-V to 5.5-V input 3-A synchronous step-down converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Space",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "\"-55 to 125\n25 to 25\"",
        "Package size: mm2:W x L (PKG)": "94 mm2: 7.38 x 12.7 (CFP|20)",
        "Package Group": "CFP|20",
        "\"Approx. price\n(USD)\"": "$1675.800 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS628510": {
        "Description": "2.7-V to 6-V 0.5-A fixed-frequency step-down converter in SOT583 package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": "Functional Safety-Capable",
        "\"Operating temperature range\n(C)\"": "-40 to 150",
        "Package size: mm2:W x L (PKG)": "3 mm2: 1.2 x 2.1 (SOT-5X3|8)",
        "Package Group": "SOT-5X3|8",
        "\"Approx. price\n(USD)\"": "$0.360 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS628511": {
        "Description": "2.7-V to 6-V 1-A fixed-frequency step-down converter in SOT583 package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": "Functional Safety-Capable",
        "\"Operating temperature range\n(C)\"": "-40 to 150",
        "Package size: mm2:W x L (PKG)": "3 mm2: 1.2 x 2.1 (SOT-5X3|8)",
        "Package Group": "SOT-5X3|8",
        "\"Approx. price\n(USD)\"": "$0.399 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS628512": {
        "Description": "2.7-V to 6-V 2-A fixed-frequency step-down converter in SOT583 package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": "Functional Safety-Capable",
        "\"Operating temperature range\n(C)\"": "-40 to 150",
        "Package size: mm2:W x L (PKG)": "3 mm2: 1.2 x 2.1 (SOT-5X3|8)",
        "Package Group": "SOT-5X3|8",
        "\"Approx. price\n(USD)\"": "$0.431 | 1ku",
        "Status": "ACTIVE"
    },
    "LM61480-Q1": {
        "Description": "8-A automotive buck converter optimized for power density and low EMI",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": "Functional Safety-Capable",
        "\"Operating temperature range\n(C)\"": "-40 to 150",
        "Package size: mm2:W x L (PKG)": "16 mm2: 3.5 x 4.5 (VQFN-HR|16)",
        "Package Group": "VQFN-HR|16",
        "\"Approx. price\n(USD)\"": "$2.454 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS628501": {
        "Description": "2.7-V to 6-V 1-A adjustable-frequency step-down converter in SOT583 package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": "Functional Safety-Capable",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "3 mm2: 1.2 x 2.1 (SOT-5X3|8)",
        "Package Group": "SOT-5X3|8",
        "\"Approx. price\n(USD)\"": "$0.399 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS628502": {
        "Description": "2.7-V to 6-V 2-A adjustable-frequency step-down converter in SOT583 package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": "Functional Safety-Capable",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "3 mm2: 1.2 x 2.1 (SOT-5X3|8)",
        "Package Group": "SOT-5X3|8",
        "\"Approx. price\n(USD)\"": "$0.431 | 1ku",
        "Status": "ACTIVE"
    },
    "TPSM831D31": {
        "Description": "8V-14V input 120A + 40A dual output PMBus module with AVS and monitoring",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck modules (integrated inductor)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 105",
        "Package size: mm2:W x L (PKG)": "720 mm2: 15 x 48 (QFM|28)",
        "Package Group": "QFM|28",
        "\"Approx. price\n(USD)\"": "$113.520 | 100u",
        "Status": "ACTIVE"
    },
    "TPS548B27": {
        "Description": "2.7-V to 16-V 20-A synchronous step-down converter with differential remote sense",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "12 mm2: 3 x 4 (VQFN-FCRLF|19)",
        "Package Group": "VQFN-FCRLF|19",
        "\"Approx. price\n(USD)\"": "$2.600 | 1ku",
        "Status": "ACTIVE"
    },
    "LM5157": {
        "Description": "6A/4A 50-V 2.2-MHz wide VIN boost flyback & SEPIC converter with dual random spread spectrum",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": "Functional Safety-Capable",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (WQFN|16)",
        "Package Group": "WQFN|16",
        "\"Approx. price\n(USD)\"": "$1.300 | 1ku",
        "Status": "ACTIVE"
    },
    "LMR33620AP-Q1": {
        "Description": "Automotive 3.8-V to 36-V 2-A synchronous step-down voltage converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": "Functional Safety-Capable",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "6 mm2: 3 x 2 (VQFN-HR|12)",
        "Package Group": "VQFN-HR|12",
        "\"Approx. price\n(USD)\"": "$0.801 | 1ku",
        "Status": "ACTIVE"
    },
    "LMR33630AP-Q1": {
        "Description": "Automotive 3.8-V to 36-V 3-A synchronous step-down voltage converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": "Functional Safety-Capable",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "6 mm2: 3 x 2 (VQFN-HR|12)",
        "Package Group": "VQFN-HR|12",
        "\"Approx. price\n(USD)\"": "$0.925 | 1ku",
        "Status": "ACTIVE"
    },
    "LM25148-Q1": {
        "Description": "Automotive 42-V synchronous buck DC/DC controller with ultra-low IQ",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck controllers (external switch)",
        "Rating": "Automotive",
        "TI functional safety category": "Functional Safety-Capable",
        "\"Operating temperature range\n(C)\"": "-40 to 150",
        "Package size: mm2:W x L (PKG)": "19 mm2: 3.5 x 5.5 (VQFN|24)",
        "Package Group": "VQFN|24",
        "\"Approx. price\n(USD)\"": "$1.359 | 1ku",
        "Status": "PREVIEW"
    },
    "LM5157-Q1": {
        "Description": "6-A 50-V 2.2-MHz wide VIN boost flyback & SEPIC converter with dual random spread spectrum",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": "Functional Safety-Capable",
        "\"Operating temperature range\n(C)\"": "-40 to 150",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (WQFN|16)",
        "Package Group": "WQFN|16",
        "\"Approx. price\n(USD)\"": "$1.664 | 1ku",
        "Status": "ACTIVE"
    },
    "LM5145-Q1": {
        "Description": "Automotive 75-V synchronous buck DC/DC controller with wide duty-cycle range",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck controllers (external switch)",
        "Rating": "Automotive",
        "TI functional safety category": "Functional Safety-Capable",
        "\"Operating temperature range\n(C)\"": "-40 to 150",
        "Package size: mm2:W x L (PKG)": "16 mm2: 3.5 x 4.5 (VQFN|20)",
        "Package Group": "VQFN|20",
        "\"Approx. price\n(USD)\"": "$1.333 | 1ku",
        "Status": "ACTIVE"
    },
    "LM5146": {
        "Description": "100-V synchronous buck DC/DC controller with wide duty-cycle range",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck controllers (external switch)",
        "Rating": "Catalog",
        "TI functional safety category": "Functional Safety-Capable",
        "\"Operating temperature range\n(C)\"": "-40 to 150",
        "Package size: mm2:W x L (PKG)": "16 mm2: 3.5 x 4.5 (VQFN|20)",
        "Package Group": "VQFN|20",
        "\"Approx. price\n(USD)\"": "$1.294 | 1ku",
        "Status": "ACTIVE"
    },
    "LM62460-Q1": {
        "Description": "6-A automotive buck converter optimized for power density and low EMI",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": "Functional Safety-Capable",
        "\"Operating temperature range\n(C)\"": "-40 to 150",
        "Package size: mm2:W x L (PKG)": "16 mm2: 3.5 x 4.5 (VQFN-HR|16)",
        "Package Group": "VQFN-HR|16",
        "\"Approx. price\n(USD)\"": "$2.231 | 1ku",
        "Status": "ACTIVE"
    },
    "TPSM82823": {
        "Description": "5.5-V input 3-A step-down module with integrated inductor in 2.0-mm × 2.5-mm × 1.1-mm uSiP package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck modules (integrated inductor)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "See datasheet",
        "Package Group": " --- ",
        "\"Approx. price\n(USD)\"": "$1.208 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS61379-Q1": {
        "Description": "25&micro;A quiescent current synchronous boost converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (WQFN|16)",
        "Package Group": "WQFN|16",
        "\"Approx. price\n(USD)\"": "$1.001 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62865": {
        "Description": "2.4-V to 5.5-V input 4-A synchronous step-down converter in 1.5-mm x 2.5-mm QFN package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "4 mm2: 1.5 x 2.5 (VQFN-HR|9)",
        "Package Group": "VQFN-HR|9",
        "\"Approx. price\n(USD)\"": "$0.704 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62867": {
        "Description": "2.4-V to 5.5-V input 6-A synchronous step-down converter in 1.5-mm x 2.5-mm QFN package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "4 mm2: 1.5 x 2.5 (VQFN-HR|9)",
        "Package Group": "VQFN-HR|9",
        "\"Approx. price\n(USD)\"": "$0.903 | 1ku",
        "Status": "ACTIVE"
    },
    "LM61495-Q1": {
        "Description": "10-A automotive buck converter optimized for power density and low EMI",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": "Functional Safety-Capable",
        "\"Operating temperature range\n(C)\"": "-40 to 150",
        "Package size: mm2:W x L (PKG)": "16 mm2: 3.5 x 4.5 (VQFN-HR|16)",
        "Package Group": "VQFN-HR|16",
        "\"Approx. price\n(USD)\"": "$2.699 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS541620": {
        "Description": "4.5-V to 15-V advanced current mode dual 6-A synchronous SWIFT™ step-down converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 150",
        "Package size: mm2:W x L (PKG)": "15 mm2: 3 x 5 (VQFN-HR|25)",
        "Package Group": "VQFN-HR|25",
        "\"Approx. price\n(USD)\"": "$2.625 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62901": {
        "Description": "3-V to 17-V 1-A high-efficiency and low IQ buck converter 1.5-mm × 2-mm QFN package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 150",
        "Package size: mm2:W x L (PKG)": "3 mm2: 1.5 x 2 (VQFN-HR|9)",
        "Package Group": "VQFN-HR|9",
        "\"Approx. price\n(USD)\"": "$0.536 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62902": {
        "Description": "3-V to 17-V 2-A high-efficiency and low IQ buck converter 1.5-mm × 2-mm QFN package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 150",
        "Package size: mm2:W x L (PKG)": "3 mm2: 1.5 x 2 (VQFN-HR|9)",
        "Package Group": "VQFN-HR|9",
        "\"Approx. price\n(USD)\"": "$0.578 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62903": {
        "Description": "3-V to 17-V 3-A high-efficiency and low IQ buck converter 1.5-mm × 2-mm QFN package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 150",
        "Package size: mm2:W x L (PKG)": "3 mm2: 1.5 x 2 (VQFN-HR|9)",
        "Package Group": "VQFN-HR|9",
        "\"Approx. price\n(USD)\"": "$0.651 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62912": {
        "Description": "17-VIN 2-A low-noise and low-ripple buck converter with integrated ferrite bead filter compensation",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 150",
        "Package size: mm2:W x L (PKG)": "4 mm2: 2 x 2 (VQFN-HR|10)",
        "Package Group": "VQFN-HR|10",
        "\"Approx. price\n(USD)\"": "$1.111 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62913": {
        "Description": "17-VIN 3-A low-noise and low-ripple buck converter with integrated ferrite bead filter compensation",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 150",
        "Package size: mm2:W x L (PKG)": "4 mm2: 2 x 2 (VQFN-HR|10)",
        "Package Group": "VQFN-HR|10",
        "\"Approx. price\n(USD)\"": "$1.222 | 1ku",
        "Status": "ACTIVE"
    },
    "TPSM5D1806": {
        "Description": "4.5-V to 15-V input dual 6-A single 12-A output power module",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck modules (integrated inductor)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "44 mm2: 5.5 x 8 (B0QFN|51)",
        "Package Group": "B0QFN|51",
        "\"Approx. price\n(USD)\"": "$13.650 | 1ku",
        "Status": "ACTIVE"
    },
    "TPSM13604H": {
        "Description": "SIMPLE SWITCHER® 5-V to 36-V 4-A high-output voltage power module",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck modules (integrated inductor)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "140 mm2: 13.77 x 10.16 (TO-PMOD|7)",
        "Package Group": "TO-PMOD|7",
        "\"Approx. price\n(USD)\"": "$8.393 | 1ku",
        "Status": "ACTIVE"
    },
    "TPSM5601R5H": {
        "Description": "60-V input 1-V to 16-V output 1.5-A power module in enhanced HotRod™ QFN package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck modules (integrated inductor)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "28 mm2: 5 x 5.5 (B3QFN|15)",
        "Package Group": "B3QFN|15",
        "\"Approx. price\n(USD)\"": "$2.940 | 1ku",
        "Status": "ACTIVE"
    },
    "TPSM5601R5HE": {
        "Description": "-55°C junction 60-V input 1-V to 16-V output 1.5-A power module in enhanced HotRod™ QFN package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck modules (integrated inductor)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-55 to 125",
        "Package size: mm2:W x L (PKG)": "28 mm2: 5 x 5.5 (B3QFN|15)",
        "Package Group": "B3QFN|15",
        "\"Approx. price\n(USD)\"": "$4.290 | 1ku",
        "Status": "ACTIVE"
    },
    "LM51571-Q1": {
        "Description": "4-A 50-V 2.2-MHz wide VIN boost flyback & SEPIC converter with dual random spread spectrum",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": "Functional Safety-Capable",
        "\"Operating temperature range\n(C)\"": "-40 to 150",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (WQFN|16)",
        "Package Group": "WQFN|16",
        "\"Approx. price\n(USD)\"": "$1.612 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62824A": {
        "Description": "2.4-V to 5.5-V input 1-A step-down converter with forced PWM in 1.5-mm×1.5-mm QFN package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "2 mm2: 1.5 x 1.5 (VSON-HR|6)",
        "Package Group": "VSON-HR|6",
        "\"Approx. price\n(USD)\"": "$0.399 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62827A": {
        "Description": "2.4-V to 5.5-V input 4-A step-down converter with forced PWM in 1.5-mm × 1.5-mm VSON-HR package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "2 mm2: 1.5 x 1.5 (VSON-HR|6)",
        "Package Group": "VSON-HR|6",
        "\"Approx. price\n(USD)\"": "$0.647 | 1ku",
        "Status": "ACTIVE"
    },
    "LM5156": {
        "Description": "2.2-MHz wide VIN nonsynchronous boost flyback & SEPIC controller with dual random spread spectrum",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "\"Boost controllers (external switch)\nBuck-boost & inverting controllers (external switch)\"",
        "Rating": "Catalog",
        "TI functional safety category": "Functional Safety-Capable",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "6 mm2: 3 x 2 (WSON|12)",
        "Package Group": "WSON|12",
        "\"Approx. price\n(USD)\"": "$0.729 | 1ku",
        "Status": "ACTIVE"
    },
    "LM51561": {
        "Description": "2.2MHz Wide Input Nonsynchronous BoostSEPICFlyback Controller with Spread Spectrum",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost controllers (external switch)",
        "Rating": "Catalog",
        "TI functional safety category": "Functional Safety-Capable",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "6 mm2: 3 x 2 (WSON|12)",
        "Package Group": "WSON|12",
        "\"Approx. price\n(USD)\"": "$0.729 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS566231": {
        "Description": "3-V to 18-V input 6-A synchronous step-down voltage regulator with pulse skip mode",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "1 mm2: .5 x 1 (VQFN-HR|9)",
        "Package Group": "VQFN-HR|9",
        "\"Approx. price\n(USD)\"": "$1.040 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS566238": {
        "Description": "3-V to 18-V input 6-A synchronous step-down regulator with forced continuous conduction mode",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "1 mm2: .5 x 1 (VQFN-HR|9)",
        "Package Group": "VQFN-HR|9",
        "\"Approx. price\n(USD)\"": "$1.040 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62868": {
        "Description": "5.5-V 4-A synchronous step-down converter with I²C interface in 1.5-mm x 2.5-mm QFN package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "4 mm2: 1.5 x 2.5 (VQFN-HR|9)",
        "Package Group": "VQFN-HR|9",
        "\"Approx. price\n(USD)\"": "$0.700 | 1ku",
        "Status": "ACTIVE"
    },
    "LMR36015S": {
        "Description": "4.2-V to 60-V 1.5-A ultra-small synchronous step-down converter with extended temperature",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-55 to 150",
        "Package size: mm2:W x L (PKG)": "6 mm2: 3 x 2 (VQFN-HR|12)",
        "Package Group": "VQFN-HR|12",
        "\"Approx. price\n(USD)\"": "$1.298 | 1ku",
        "Status": "ACTIVE"
    },
    "LMR36503": {
        "Description": "3-V to 65-V 0.3-A ultra-small synchronous buck converter with 6 μA IQ",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 150",
        "Package size: mm2:W x L (PKG)": "4 mm2: 2 x 2 (VQFN-HR|9)",
        "Package Group": "VQFN-HR|9",
        "\"Approx. price\n(USD)\"": "$1.450 | 1ku",
        "Status": "ACTIVE"
    },
    "LMR36506": {
        "Description": "3-V to 65-V 0.6-A ultra-small synchronous buck converter with 4 μA IQ",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 150",
        "Package size: mm2:W x L (PKG)": "4 mm2: 2 x 2 (VQFN-HR|9)",
        "Package Group": "VQFN-HR|9",
        "\"Approx. price\n(USD)\"": "$1.550 | 1ku",
        "Status": "ACTIVE"
    },
    "TLV62595": {
        "Description": "2.5-V to 5.5-V input 4-A step-down converter with 1% output accuracy in 1.5-mm x 1.5-mm QFN package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "2 mm2: 1.5 x 1.5 (VSON-HR|6)",
        "Package Group": "VSON-HR|6",
        "\"Approx. price\n(USD)\"": "$0.410 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS543820E": {
        "Description": "4-V to 18-V 8-A synchronous step-down converter extended temperature",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-55 to 150",
        "Package size: mm2:W x L (PKG)": "8 mm2: 2.5 x 3 (VQFN-HR|14)",
        "Package Group": "VQFN-HR|14",
        "\"Approx. price\n(USD)\"": "$4.148 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS53676": {
        "Description": "Dual-channel D-CAP+ dual-channel (N+M&lt;= 7 phases) step-down multiphase controller with AVSBus",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck controllers (external switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "36 mm2: 6 x 6 (VQFN|48)",
        "Package Group": "VQFN|48",
        "\"Approx. price\n(USD)\"": "$2.800 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS543820": {
        "Description": "4-V to 18-V 8-A synchronous SWIFT™ step-down converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 150",
        "Package size: mm2:W x L (PKG)": "8 mm2: 2.5 x 3 (VQFN-HR|14)",
        "Package Group": "VQFN-HR|14",
        "\"Approx. price\n(USD)\"": "$1.470 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS628501-Q1": {
        "Description": "2.7-V to 6-V 1-A automotive step-down converter in SOT583 package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": "Functional Safety-Capable",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "3 mm2: 1.2 x 2.1 (SOT-5X3|8)",
        "Package Group": "SOT-5X3|8",
        "\"Approx. price\n(USD)\"": "$0.525 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS55288-Q1": {
        "Description": "36-V 16-A buck-boost converter with I2C control AEC-Q100 qualified",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck-boost inverting & split-rail converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 150",
        "Package size: mm2:W x L (PKG)": "14 mm2: 3.5 x 4 (VQFN-HR|26)",
        "Package Group": "VQFN-HR|26",
        "\"Approx. price\n(USD)\"": "$2.974 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS552882-Q1": {
        "Description": "36-V 16-A buck-boost converter AEC-Q100 qualified",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck-boost inverting & split-rail converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 150",
        "Package size: mm2:W x L (PKG)": "14 mm2: 3.5 x 4 (VQFN-HR|26)",
        "Package Group": "VQFN-HR|26",
        "\"Approx. price\n(USD)\"": "$2.974 | 1ku",
        "Status": "ACTIVE"
    },
    "LM25149-Q1": {
        "Description": "42-V automotive synchronous buck DC/DC controller with ultra-low IQ & integrated active EMI filter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck controllers (external switch)",
        "Rating": "Automotive",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 150",
        "Package size: mm2:W x L (PKG)": "19 mm2: 3.5 x 5.5 (VQFN|24)",
        "Package Group": "VQFN|24",
        "\"Approx. price\n(USD)\"": "$1.562 | 1ku",
        "Status": "PREVIEW"
    },
    "TPS536C7": {
        "Description": "Dual-channel D-CAP+&trade; PMBus (N+M &le; 12 phases) step-down multiphase PWM controller",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck controllers (external switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "36 mm2: 6 x 6 (VQFN|48)",
        "Package Group": "VQFN|48",
        "\"Approx. price\n(USD)\"": "$4.950 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS543320": {
        "Description": "4-V to 18-V 3-A synchronous SWIFT™ step-down converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 150",
        "Package size: mm2:W x L (PKG)": "8 mm2: 2.5 x 3 (VQFN-HR|14)",
        "Package Group": "VQFN-HR|14",
        "\"Approx. price\n(USD)\"": "$0.872 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS61288": {
        "Description": "18-V 15-A synchronous boost converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "8 mm2: 2.5 x 3 (VQFN-HR|11)",
        "Package Group": "VQFN-HR|11",
        "\"Approx. price\n(USD)\"": "$1.390 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS54622-EP": {
        "Description": "Enhanced product 17-V 6-A synchronous step-down switcher",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "HiRel Enhanced Product",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-55 to 125",
        "Package size: mm2:W x L (PKG)": "12 mm2: 3.5 x 3.5 (VQFN|14)",
        "Package Group": "VQFN|14",
        "\"Approx. price\n(USD)\"": "$9.900 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS548B28": {
        "Description": "2.7-V to 16-V input 20-A synchronous step-down converter with remote sense and hiccup current limit",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "12 mm2: 3 x 4 (VQFN-HR|21)",
        "Package Group": "VQFN-HR|21",
        "\"Approx. price\n(USD)\"": "$2.600 | 1ku",
        "Status": "ACTIVE"
    },
    "LMQ62440-Q1": {
        "Description": "Automotive 3-V to 36-V 4-A low-noise fixed frequency synchronous step-down converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": "Functional Safety-Capable",
        "\"Operating temperature range\n(C)\"": "-40 to 150",
        "Package size: mm2:W x L (PKG)": "14 mm2: 3.5 x 4 (VQFN-HR|14)",
        "Package Group": "VQFN-HR|14",
        "\"Approx. price\n(USD)\"": "$1.841 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62869": {
        "Description": "5.5-V 6-A synchronous step-down converter with I²C interface in 1.5-mm x 2.5-mm QFN package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "4 mm2: 1.5 x 2.5 (VQFN-HR|9)",
        "Package Group": "VQFN-HR|9",
        "\"Approx. price\n(USD)\"": "$0.900 | 1ku",
        "Status": "ACTIVE"
    },
    "TPSM265R1": {
        "Description": "3-V to 65-V input 100-mA step-down power module in 2.8 x 3.7 mm package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck modules (integrated inductor)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "See datasheet",
        "Package Group": " --- ",
        "\"Approx. price\n(USD)\"": "$1.586 | 1ku",
        "Status": "ACTIVE"
    },
    "TPSM41615": {
        "Description": "4-V to 16-V 15-A stackable power module",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck modules (integrated inductor)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "176 mm2: 11 x 16 (QFM|69)",
        "Package Group": "QFM|69",
        "\"Approx. price\n(USD)\"": "$11.550 | 1ku",
        "Status": "ACTIVE"
    },
    "TPSM41625": {
        "Description": "4-V to 16-V 25-A stackable power module",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck modules (integrated inductor)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "176 mm2: 11 x 16 (QFM|69)",
        "Package Group": "QFM|69",
        "\"Approx. price\n(USD)\"": "$13.650 | 1ku",
        "Status": "ACTIVE"
    },
    "TPSM82810": {
        "Description": "2.75-V to 6-V 4-A step-down module with adjustable-frequency & tracking in 3 x 4-mm μSIP package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck modules (integrated inductor)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "12 mm2: 3 x 4 (uSiP|14)",
        "Package Group": "uSiP|14",
        "\"Approx. price\n(USD)\"": "$1.733 | 1ku",
        "Status": "ACTIVE"
    },
    "TPSM82813": {
        "Description": "2.75-V to 6-V 3-A step-down module with adjustable-frequency & tracking in 3 x 4-mm μSIP package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck modules (integrated inductor)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "12 mm2: 3 x 4 (uSiP|14)",
        "Package Group": "uSiP|14",
        "\"Approx. price\n(USD)\"": "$1.575 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62825A": {
        "Description": "2.4-V to 5.5-V input 2-A step-down converter with forced PWM in 1.5-mm × 1.5-mm VSON-HR package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "2 mm2: 1.5 x 1.5 (VSON-HR|6)",
        "Package Group": "VSON-HR|6",
        "\"Approx. price\n(USD)\"": "$0.431 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62826A": {
        "Description": "2.4-V to 5.5-V input 3-A step-down converter with forced PWM in 1.5-mm×1.5-mm VSON-HR package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "2 mm2: 1.5 x 1.5 (VSON-HR|6)",
        "Package Group": "VSON-HR|6",
        "\"Approx. price\n(USD)\"": "$0.536 | 1ku",
        "Status": "ACTIVE"
    },
    "LMQ61460": {
        "Description": "Industrial 3-V to 36-V 6-A low-noise synchronous step-down converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 150",
        "Package size: mm2:W x L (PKG)": "14 mm2: 3.5 x 4 (VQFN-HR|14)",
        "Package Group": "VQFN-HR|14",
        "\"Approx. price\n(USD)\"": "$1.610 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS552882": {
        "Description": "36-V 16-A buck-boost converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck-boost inverting & split-rail converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "14 mm2: 3.5 x 4 (VQFN-HR|26)",
        "Package Group": "VQFN-HR|26",
        "\"Approx. price\n(USD)\"": "$2.520 | 1ku",
        "Status": "ACTIVE"
    },
    "TPSM82821": {
        "Description": "5.5-V input 1-A step-down module with integrated inductor in 2 x 2.5 x 1.1-mm μSIP package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck modules (integrated inductor)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "See datasheet",
        "Package Group": " --- ",
        "\"Approx. price\n(USD)\"": "$0.945 | 1ku",
        "Status": "ACTIVE"
    },
    "TPSM82822": {
        "Description": "5.5-V input 2-A step-down module with integrated inductor in 2 x 2.5 x 1.1-mm μSIP package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck modules (integrated inductor)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "See datasheet",
        "Package Group": " --- ",
        "\"Approx. price\n(USD)\"": "$1.050 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS7H4010-SEP": {
        "Description": "Radiation-tolerant 3.5-V to 32-V input 6-A synchronous step-down converter in a plastic package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Space",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-55 to 125",
        "Package size: mm2:W x L (PKG)": "24 mm2: 4 x 6 (WQFN|30)",
        "Package Group": "WQFN|30",
        "\"Approx. price\n(USD)\"": "$435.960 | 100u",
        "Status": "ACTIVE"
    },
    "TPS542A52": {
        "Description": "4-V to 18-V input voltage mode 15-A synchronous SWIFT™ step-down converter with remote sense",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 150",
        "Package size: mm2:W x L (PKG)": "18 mm2: 4 x 4.5 (VQFN-HR|33)",
        "Package Group": "VQFN-HR|33",
        "\"Approx. price\n(USD)\"": "$2.585 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS543620": {
        "Description": "4-V to 18-V input advanced current mode 6-A synchronous SWIFT™ step-down converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 150",
        "Package size: mm2:W x L (PKG)": "8 mm2: 2.5 x 3 (VQFN-HR|14)",
        "Package Group": "VQFN-HR|14",
        "\"Approx. price\n(USD)\"": "$1.313 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS628502-Q1": {
        "Description": "2.7-V to 6-V 2-A automotive step-down converter in SOT583 package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": "Functional Safety-Capable",
        "\"Operating temperature range\n(C)\"": "\"-40 to 125\n-40 to 150\"",
        "Package size: mm2:W x L (PKG)": "3 mm2: 1.2 x 2.1 (SOT-5X3|8)",
        "Package Group": "SOT-5X3|8",
        "\"Approx. price\n(USD)\"": "$0.578 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS562207S": {
        "Description": "4.3-V to 17-V input 2-A FCCM mode synchronous buck converter in SOT563 package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "2 mm2: 1.2 x 1.6 (SOT-5X3|6)",
        "Package Group": "SOT-5X3|6",
        "\"Approx. price\n(USD)\"": "$0.156 | 1ku",
        "Status": "ACTIVE"
    },
    "LMR50410": {
        "Description": "SIMPLE SWITCHER 4-V to 36-V 1-A synchronous step-down converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": "Functional Safety-Capable",
        "\"Operating temperature range\n(C)\"": "-40 to 150",
        "Package size: mm2:W x L (PKG)": "5 mm2: 1.6 x 2.9 (SOT-23|6)",
        "Package Group": "SOT-23|6",
        "\"Approx. price\n(USD)\"": "$0.420 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS542A50": {
        "Description": "4-V to 18-V input voltage mode 15-A synchronous SWIFT™ step-down converter with I2C interface",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 150",
        "Package size: mm2:W x L (PKG)": "18 mm2: 4 x 4.5 (VQFN-HR|33)",
        "Package Group": "VQFN-HR|33",
        "\"Approx. price\n(USD)\"": "$2.970 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS546A24A": {
        "Description": "2.95-V to 18-V stackable 10-A synchronous SWIFT™ buck converter with pin-strapping and PMBus",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 150",
        "Package size: mm2:W x L (PKG)": "35 mm2: 5 x 7 (LQFN-CLIP|40)",
        "Package Group": "LQFN-CLIP|40",
        "\"Approx. price\n(USD)\"": "$2.739 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS54J061": {
        "Description": "4-V to 16-V input 6-A synchronous buck converter 600-mV reference voltage and hiccup current limit",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "6 mm2: 2 x 3 (VQFN-HR|14)",
        "Package Group": "VQFN-HR|14",
        "\"Approx. price\n(USD)\"": "$1.250 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS562202S": {
        "Description": "4.3-V to 17-V input 2-A ECO mode synchronous buck converter in SOT563 package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 150",
        "Package size: mm2:W x L (PKG)": "2 mm2: 1.2 x 1.6 (SOT-5X3|6)",
        "Package Group": "SOT-5X3|6",
        "\"Approx. price\n(USD)\"": "$0.156 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS563202S": {
        "Description": "4.3-V to 17-V input 3-A ECO mode synchronous buck converter in SOT563 package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "2 mm2: 1.2 x 1.6 (SOT-5X3|6)",
        "Package Group": "SOT-5X3|6",
        "\"Approx. price\n(USD)\"": "$0.208 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS563207S": {
        "Description": "4.3-V to 17-V input 3-A FCCM mode synchronous buck converter in SOT563 package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "2 mm2: 1.2 x 1.6 (SOT-5X3|6)",
        "Package Group": "SOT-5X3|6",
        "\"Approx. price\n(USD)\"": "$0.208 | 1ku",
        "Status": "ACTIVE"
    },
    "LMQ61460-Q1": {
        "Description": "Automotive 3-V to 36-V 6-A low EMI synchronous step-down quiet converter with integrated capacitors",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": "Functional Safety-Capable",
        "\"Operating temperature range\n(C)\"": "-40 to 150",
        "Package size: mm2:W x L (PKG)": "14 mm2: 3.5 x 4 (VQFN-HR|14)",
        "Package Group": "VQFN-HR|14",
        "\"Approx. price\n(USD)\"": "$2.045 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS63900": {
        "Description": "1.8-V to 5.5-V 75-nA IQ buck-boost converter with input current limit and Dynamic Voltage Scaling",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck-boost inverting & split-rail converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "6 mm2: 2.5 x 2.5 (SON|10)",
        "Package Group": "SON|10",
        "\"Approx. price\n(USD)\"": "$0.800 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS51397A": {
        "Description": "4.5-V to 24-V input 10-A synchronous step-down regulator",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (VQFN-HR|20)",
        "Package Group": "VQFN-HR|20",
        "\"Approx. price\n(USD)\"": "$1.450 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS562202": {
        "Description": "4.3-V to 17-V input 2-A output synchronous step-down voltage converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 150",
        "Package size: mm2:W x L (PKG)": "2 mm2: 1.2 x 1.6 (SOT-5X3|6)",
        "Package Group": "SOT-5X3|6",
        "\"Approx. price\n(USD)\"": "$0.155 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS563207": {
        "Description": "4.3-V to 17-V input 3-A synchronous buck converter in SOT563",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 150",
        "Package size: mm2:W x L (PKG)": "2 mm2: 1.2 x 1.6 (SOT-5X3|6)",
        "Package Group": "SOT-5X3|6",
        "\"Approx. price\n(USD)\"": "$0.208 | 1ku",
        "Status": "ACTIVE"
    },
    "LM34966-Q1": {
        "Description": "500-kHz wide VIN nonsynchronous boost flyback & SEPIC controller",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost controllers (external switch)",
        "Rating": "Automotive",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 150",
        "Package size: mm2:W x L (PKG)": "22 mm2: 4.4 x 5 (HTSSOP|14)",
        "Package Group": "HTSSOP|14",
        "\"Approx. price\n(USD)\"": "$0.831 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS61378-Q1": {
        "Description": "18.5-V output 4.8-A synchronous boost converter with load disconnect",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (WQFN|16)",
        "Package Group": "WQFN|16",
        "\"Approx. price\n(USD)\"": "$1.260 | 1ku",
        "Status": "ACTIVE"
    },
    "LM51561H": {
        "Description": "2.2-MHz wide VIN nonsynchronous boost flyback & SEPIC controller with spread spectrum and hiccup",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost controllers (external switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 150",
        "Package size: mm2:W x L (PKG)": "22 mm2: 4.4 x 5 (HTSSOP|14)",
        "Package Group": "HTSSOP|14",
        "\"Approx. price\n(USD)\"": "$0.729 | 1ku",
        "Status": "ACTIVE"
    },
    "LM51561H-Q1": {
        "Description": "2.2-MHz wide VIN nonsynchronous boost flyback & SEPIC controller with spread spectrum and hiccup",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost controllers (external switch)",
        "Rating": "Automotive",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 150",
        "Package size: mm2:W x L (PKG)": "22 mm2: 4.4 x 5 (HTSSOP|14)",
        "Package Group": "HTSSOP|14",
        "\"Approx. price\n(USD)\"": "$0.860 | 1ku",
        "Status": "ACTIVE"
    },
    "LM5156H": {
        "Description": "2.2-MHz wide VIN nonsynchronous boost flyback & SEPIC controller with dual random spread spectrum",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "\"Boost controllers (external switch)\nBuck-boost & inverting controllers (external switch)\"",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 150",
        "Package size: mm2:W x L (PKG)": "22 mm2: 4.4 x 5 (HTSSOP|14)",
        "Package Group": "HTSSOP|14",
        "\"Approx. price\n(USD)\"": "$0.729 | 1ku",
        "Status": "ACTIVE"
    },
    "LM5156H-Q1": {
        "Description": "2.2-MHz wide VIN nonsynchronous boost flyback & SEPIC controller with dual random spread spectrum",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "\"Boost controllers (external switch)\nBuck-boost & inverting controllers (external switch)\"",
        "Rating": "Automotive",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 150",
        "Package size: mm2:W x L (PKG)": "22 mm2: 4.4 x 5 (HTSSOP|14)",
        "Package Group": "HTSSOP|14",
        "\"Approx. price\n(USD)\"": "$0.860 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62860": {
        "Description": "1.8-V to 5.5-V input tiny 0.6-A ultra-low Iq step-down buck converter with I2C/VSEL interface",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "1 mm2: .7 x 1.4 (DSBGA|8)",
        "Package Group": "DSBGA|8",
        "\"Approx. price\n(USD)\"": "$0.399 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS53688": {
        "Description": "Dual-channel 8 phase step-down digital multiphase D-CAP+™ controller with VR13.HC SVID and PMBus",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck controllers (external switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "25 mm2: 5 x 5 (WQFN|40)",
        "Package Group": "WQFN|40",
        "\"Approx. price\n(USD)\"": "$4.787 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS546B24A": {
        "Description": "2.95-V to 18-V stackable 20-A synchronous SWIFT™ buck converter with pin-strapping and PMBus",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 150",
        "Package size: mm2:W x L (PKG)": "35 mm2: 5 x 7 (LQFN-CLIP|40)",
        "Package Group": "LQFN-CLIP|40",
        "\"Approx. price\n(USD)\"": "$3.575 | 1ku",
        "Status": "ACTIVE"
    },
    "LMR36503-Q1": {
        "Description": "Automotive 3-V to 65-V 0.3-A buck converter optimized for size and light load efficiency",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 150",
        "Package size: mm2:W x L (PKG)": "4 mm2: 2 x 2 (VQFN-HR|9)",
        "Package Group": "VQFN-HR|9",
        "\"Approx. price\n(USD)\"": "$1.711 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS562207": {
        "Description": "4.3-V to 17-V input 2-A synchronous buck converter in SOT563",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "2 mm2: 1.2 x 1.6 (SOT-5X3|6)",
        "Package Group": "SOT-5X3|6",
        "\"Approx. price\n(USD)\"": "$0.155 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS54618C-Q1": {
        "Description": "Automotive 2.95-V to 6-V 6-A 2-MHz synchronous buck converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": "Functional Safety-Capable",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (WQFN|16)",
        "Package Group": "WQFN|16",
        "\"Approx. price\n(USD)\"": "$1.299 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS55288": {
        "Description": "36V 16A buck-boost converter with PPS control",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck-boost inverting & split-rail converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 150",
        "Package size: mm2:W x L (PKG)": "14 mm2: 3.5 x 4 (VQFN-HR|26)",
        "Package Group": "VQFN-HR|26",
        "\"Approx. price\n(USD)\"": "$2.520 | 1ku",
        "Status": "ACTIVE"
    },
    "LM60430": {
        "Description": "3.8-V to 36-V 3-A ultra-small synchronous step-down converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 150",
        "Package size: mm2:W x L (PKG)": "6 mm2: 2 x 3 (WQFN-HR|13)",
        "Package Group": "WQFN-HR|13",
        "\"Approx. price\n(USD)\"": "$0.836 | 1ku",
        "Status": "ACTIVE"
    },
    "LM60440": {
        "Description": "36-V 4-A synchronous converter in an enhanced EMI QFN package with wettable flank and external pad",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 150",
        "Package size: mm2:W x L (PKG)": "6 mm2: 2 x 3 (WQFN-HR|13)",
        "Package Group": "WQFN-HR|13",
        "\"Approx. price\n(USD)\"": "$0.903 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS563202": {
        "Description": "4.5-V to 17-V input 3-A synchronous buck converter in SOT563",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "2 mm2: 1.2 x 1.6 (SOT-5X3|6)",
        "Package Group": "SOT-5X3|6",
        "\"Approx. price\n(USD)\"": "$0.208 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62861": {
        "Description": "1.8-V to 5.5-V input tiny 1-A ultra-low Iq step-down converter with I2C/VSEL interface",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "1 mm2: .7 x 1.4 (DSBGA|8)",
        "Package Group": "DSBGA|8",
        "\"Approx. price\n(USD)\"": "$0.529 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS54JB20": {
        "Description": "2.7-V to 16-V input 20-A synchronous buck converter with remote sense and latch-off current limit",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "12 mm2: 3 x 4 (VQFN-HR|21)",
        "Package Group": "VQFN-HR|21",
        "\"Approx. price\n(USD)\"": "$2.730 | 1ku",
        "Status": "ACTIVE"
    },
    "LMR50410-Q1": {
        "Description": "Automotive qualified SIMPLE SWITCHER 4-V to 36-V 1-A synchronous step-down converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": "Functional Safety-Capable",
        "\"Operating temperature range\n(C)\"": "-40 to 150",
        "Package size: mm2:W x L (PKG)": "5 mm2: 1.6 x 2.9 (SOT-23|6)",
        "Package Group": "SOT-23|6",
        "\"Approx. price\n(USD)\"": "$0.496 | 1ku",
        "Status": "ACTIVE"
    },
    "LM76005": {
        "Description": "3.5-V to 60-V 5-A synchronous step-down voltage converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": "Functional Safety-Capable",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "24 mm2: 4 x 6 (WQFN|30)",
        "Package Group": "WQFN|30",
        "\"Approx. price\n(USD)\"": "$1.995 | 1ku",
        "Status": "ACTIVE"
    },
    "LM76005-Q1": {
        "Description": "3.5-V to 60-V 5-A synchronous voltage regulator",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": "Functional Safety-Capable",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "24 mm2: 4 x 6 (WQFN|30)",
        "Package Group": "WQFN|30",
        "\"Approx. price\n(USD)\"": "$2.354 | 1ku",
        "Status": "ACTIVE"
    },
    "LM63610-Q1": {
        "Description": "3.5-V to 36-V 1.0-A step-down voltage converter with spread spectrum",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "32 mm2: 6.4 x 5 (HTSSOP|16) 9 mm2: 3 x 3 (WSON|12)",
        "Package Group": "HTSSOP|16 WSON|12",
        "\"Approx. price\n(USD)\"": "$1.100 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS53820": {
        "Description": "Integrated step-down converter with SVID for Intel CPU power",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "25 mm2: 5 x 5 (VQFN-HR|35)",
        "Package Group": "VQFN-HR|35",
        "\"Approx. price\n(USD)\"": "$4.200 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS548A28": {
        "Description": "2.7-V to 16-V 15-A synchronous buck converter with remote sense and 3-V LDO",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "12 mm2: 3 x 4 (VQFN-HR|21)",
        "Package Group": "VQFN-HR|21",
        "\"Approx. price\n(USD)\"": "$1.943 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS548A29": {
        "Description": "2.7-V to 16-V 15-A synchronous buck converter with remote sense and 4.5-V LDO",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "12 mm2: 3 x 4 (VQFN-HR|21)",
        "Package Group": "VQFN-HR|21",
        "\"Approx. price\n(USD)\"": "$1.943 | 1ku",
        "Status": "ACTIVE"
    },
    "LMR36506-Q1": {
        "Description": "3-V to 65-V 0.6-A buck converter optimized for size and light load efficiency",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 150",
        "Package size: mm2:W x L (PKG)": "4 mm2: 2 x 2 (VQFN-HR|9)",
        "Package Group": "VQFN-HR|9",
        "\"Approx. price\n(USD)\"": "$1.829 | 1ku",
        "Status": "ACTIVE"
    },
    "LM60430-Q1": {
        "Description": "Automotive 36-V 3-A synchronous converter in a QFN package with wettable flank and external pad",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 150",
        "Package size: mm2:W x L (PKG)": "6 mm2: 2 x 3 (WQFN-HR|13)",
        "Package Group": "WQFN-HR|13",
        "\"Approx. price\n(USD)\"": "$0.986 | 1ku",
        "Status": "ACTIVE"
    },
    "LM60440-Q1": {
        "Description": "Automotive 36-V 4-A synchronous converter in an enhanced EMI QFN package with wettable flank",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 150",
        "Package size: mm2:W x L (PKG)": "6 mm2: 2 x 3 (WQFN-HR|13)",
        "Package Group": "WQFN-HR|13",
        "\"Approx. price\n(USD)\"": "$1.066 | 1ku",
        "Status": "ACTIVE"
    },
    "LM5156-Q1": {
        "Description": "2.2-MHz wide VIN nonsynchronous boost flyback & SEPIC controller with dual random spread spectrum",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "\"Boost controllers (external switch)\nBuck-boost & inverting controllers (external switch)\"",
        "Rating": "Automotive",
        "TI functional safety category": "Functional Safety-Capable",
        "\"Operating temperature range\n(C)\"": "-40 to 150",
        "Package size: mm2:W x L (PKG)": "6 mm2: 3 x 2 (WSON|12)",
        "Package Group": "WSON|12",
        "\"Approx. price\n(USD)\"": "$0.860 | 1ku",
        "Status": "ACTIVE"
    },
    "LM51561-Q1": {
        "Description": "2.2-MHz wide VIN nonsynchronous boost flyback & SEPIC controller with spread spectrum and hiccup",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost controllers (external switch)",
        "Rating": "Automotive",
        "TI functional safety category": "Functional Safety-Capable",
        "\"Operating temperature range\n(C)\"": "-40 to 150",
        "Package size: mm2:W x L (PKG)": "6 mm2: 3 x 2 (WSON|12)",
        "Package Group": "WSON|12",
        "\"Approx. price\n(USD)\"": "$0.860 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS51215A": {
        "Description": "3-V to 28-V input single phase D-CAP2 controller with 2-bit VID",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck controllers (external switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (WQFN|20)",
        "Package Group": "WQFN|20",
        "\"Approx. price\n(USD)\"": "$0.450 | 1ku",
        "Status": "ACTIVE"
    },
    "LM62435-Q1": {
        "Description": "Automotive 3-V to 36-V 3.5-A low EMI synchronous step-down converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": "Functional Safety-Capable",
        "\"Operating temperature range\n(C)\"": "-40 to 150",
        "Package size: mm2:W x L (PKG)": "14 mm2: 3.5 x 4 (VQFN-HR|14)",
        "Package Group": "VQFN-HR|14",
        "\"Approx. price\n(USD)\"": "$1.947 | 1ku",
        "Status": "ACTIVE"
    },
    "LM62440-Q1": {
        "Description": "Automotive 3-V to 36-V 4-A low-noise synchronous step-down converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": "Functional Safety-Capable",
        "\"Operating temperature range\n(C)\"": "-40 to 150",
        "Package size: mm2:W x L (PKG)": "14 mm2: 3.5 x 4 (VQFN-HR|14)",
        "Package Group": "VQFN-HR|14",
        "\"Approx. price\n(USD)\"": "$1.735 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62864": {
        "Description": "4-A synchronous step-down converter with I2C interface in 1.05-mm x 1.78-mm WCSP package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "2 mm2: 1.05 x 1.75 (DSBGA|15)",
        "Package Group": "DSBGA|15",
        "\"Approx. price\n(USD)\"": "$0.684 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62866": {
        "Description": "5.5-V 6-A synchronous step-down converter with I2C interface in 1.05-mm × 1.78-mm WCSP package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "2 mm2: 1.05 x 1.75 (DSBGA|15)",
        "Package Group": "DSBGA|15",
        "\"Approx. price\n(USD)\"": "$0.878 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS7H4001-SP": {
        "Description": "Radiation-hardened QMLV 3-V to 7-V input 18-A synchronous step-down converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Space",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "\"-55 to 125\n25 to 25\"",
        "Package size: mm2:W x L (PKG)": "164 mm2: 7.62 x 21.49 (CFP|34) 85 mm2: 6.1 x 14 (HTSSOP|44)",
        "Package Group": "CFP|34 HTSSOP|44",
        "\"Approx. price\n(USD)\"": "$4725.000 | 100u",
        "Status": "ACTIVE"
    },
    "TPS54J060": {
        "Description": "4-V to 16-V input 6-A synchronous buck converter 900-mV reference voltage latch-off current limit",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "6 mm2: 2 x 3 (VQFN-HR|14)",
        "Package Group": "VQFN-HR|14",
        "\"Approx. price\n(USD)\"": "$1.250 | 1ku",
        "Status": "ACTIVE"
    },
    "LM61440": {
        "Description": "3-V to 36-V 4-A low-noise synchronous step-down converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": "Functional Safety-Capable",
        "\"Operating temperature range\n(C)\"": "-40 to 150",
        "Package size: mm2:W x L (PKG)": "14 mm2: 3.5 x 4 (VQFN-HR|14)",
        "Package Group": "VQFN-HR|14",
        "\"Approx. price\n(USD)\"": "$1.418 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS54JA20": {
        "Description": "2.7-V to 16-V input 12-A synchronous buck converter with remote sense and latch-off current limit",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "12 mm2: 3 x 4 (VQFN-HR|21)",
        "Package Group": "VQFN-HR|21",
        "\"Approx. price\n(USD)\"": "$1.943 | 1ku",
        "Status": "ACTIVE"
    },
    "LM61440-Q1": {
        "Description": "Automotive 3-V to 36-V 4-A low-noise synchronous step-down converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": "Functional Safety-Capable",
        "\"Operating temperature range\n(C)\"": "-40 to 150",
        "Package size: mm2:W x L (PKG)": "14 mm2: 3.5 x 4 (VQFN-HR|14)",
        "Package Group": "VQFN-HR|14",
        "\"Approx. price\n(USD)\"": "$1.673 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS59632-Q1": {
        "Description": "2.5-V to 24-V 3- 2- and 1-phase step-down driverless controller",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck controllers (external switch)",
        "Rating": "Automotive",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "25 mm2: 5 x 5 (VQFN|32)",
        "Package Group": "VQFN|32",
        "\"Approx. price\n(USD)\"": "$2.772 | 1ku",
        "Status": "ACTIVE"
    },
    "LM61435-Q1": {
        "Description": "Automotive 3-V to 36-V 3.5-A synchronous step-down converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": "Functional Safety-Capable",
        "\"Operating temperature range\n(C)\"": "-40 to 150",
        "Package size: mm2:W x L (PKG)": "14 mm2: 3.5 x 4 (VQFN-HR|14)",
        "Package Group": "VQFN-HR|14",
        "\"Approx. price\n(USD)\"": "$1.761 | 1ku",
        "Status": "ACTIVE"
    },
    "LM61460": {
        "Description": "3-V to 36-V 6-A Low-EMI synchronous step-down converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 150",
        "Package size: mm2:W x L (PKG)": "14 mm2: 3.5 x 4 (VQFN-HR|14)",
        "Package Group": "VQFN-HR|14",
        "\"Approx. price\n(USD)\"": "$1.523 | 1ku",
        "Status": "ACTIVE"
    },
    "LMR36510": {
        "Description": "SIMPLE SWITCHER&reg; 4.2-V to 65-V 1-A synchronous step-down converter with 26-uA IQ",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "19 mm2: 3.9 x 4.89 (SO PowerPAD|8)",
        "Package Group": "SO PowerPAD|8",
        "\"Approx. price\n(USD)\"": "$0.788 | 1ku",
        "Status": "ACTIVE"
    },
    "LMR36520": {
        "Description": "SIMPLE SWITCHER&reg; 4.2-V to 65-V 2-A synchronous step-down converter with 26-uA IQ",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "19 mm2: 3.9 x 4.89 (SO PowerPAD|8)",
        "Package Group": "SO PowerPAD|8",
        "\"Approx. price\n(USD)\"": "$0.893 | 1ku",
        "Status": "ACTIVE"
    },
    "LM63635-Q1": {
        "Description": "3.5-V to 32-V 3.25-A step-down voltage converter with spread spectrum",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": "Functional Safety-Capable",
        "\"Operating temperature range\n(C)\"": "-40 to 150",
        "Package size: mm2:W x L (PKG)": "32 mm2: 6.4 x 5 (HTSSOP|16) 9 mm2: 3 x 3 (WSON|12)",
        "Package Group": "HTSSOP|16 WSON|12",
        "\"Approx. price\n(USD)\"": "$1.400 | 1ku",
        "Status": "ACTIVE"
    },
    "LM5163H-Q1": {
        "Description": "Automotive 6V-100-V input 0.5-A synchronous high-temperature buck DC/DC converter with ultra-low IQ",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 165",
        "Package size: mm2:W x L (PKG)": "19 mm2: 3.9 x 4.89 (SO PowerPAD|8)",
        "Package Group": "SO PowerPAD|8",
        "\"Approx. price\n(USD)\"": "$1.680 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS652353": {
        "Description": "LNB voltage regulator with I2C interface",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (WQFN|20)",
        "Package Group": "WQFN|20",
        "\"Approx. price\n(USD)\"": "$0.968 | 1ku",
        "Status": "ACTIVE"
    },
    "LM61460-Q1": {
        "Description": "Automotive 3-V to 36-V 6-A low-noise synchronous step-down converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": "Functional Safety-Capable",
        "\"Operating temperature range\n(C)\"": "-40 to 150",
        "Package size: mm2:W x L (PKG)": "14 mm2: 3.5 x 4 (VQFN-HR|14)",
        "Package Group": "VQFN-HR|14",
        "\"Approx. price\n(USD)\"": "$1.859 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS546D24A": {
        "Description": "2.95-V to 16-V stackable 40-A synchronous SWIFT™ buck converter with pin-strapping and PMBus",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 150",
        "Package size: mm2:W x L (PKG)": "35 mm2: 5 x 7 (LQFN-CLIP|40)",
        "Package Group": "LQFN-CLIP|40",
        "\"Approx. price\n(USD)\"": "$4.695 | 1ku",
        "Status": "ACTIVE"
    },
    "LM5170": {
        "Description": "Multiphase bidirectional current controller",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck-boost & inverting controllers (external switch)",
        "Rating": "Catalog",
        "TI functional safety category": "Functional Safety-Capable",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "49 mm2: 7 x 7 (HTQFP|48)",
        "Package Group": "HTQFP|48",
        "\"Approx. price\n(USD)\"": "$4.356 | 1ku",
        "Status": "ACTIVE"
    },
    "TPSM53602": {
        "Description": "36-V 2-A step-down power module in small 5.5 x 5 x 4-mm Enhanced HotRod™ QFN with simple footprint",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck modules (integrated inductor)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "28 mm2: 5 x 5.5 (B3QFN|15)",
        "Package Group": "B3QFN|15",
        "\"Approx. price\n(USD)\"": "$3.550 | 1ku",
        "Status": "ACTIVE"
    },
    "TPSM53603": {
        "Description": "36-V 3-A step-down power module in small 5.5 x 5 x 4-mm Enhanced HotRod™ QFN with simple footprint",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck modules (integrated inductor)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "28 mm2: 5 x 5.5 (B3QFN|15)",
        "Package Group": "B3QFN|15",
        "\"Approx. price\n(USD)\"": "$3.950 | 1ku",
        "Status": "ACTIVE"
    },
    "TPSM53604": {
        "Description": "36-V 4-A step-down power module in small 5.5 x 5 x 4-mm Enhanced HotRod™ QFN with simple footprint",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck modules (integrated inductor)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "28 mm2: 5 x 5.5 (B3QFN|15)",
        "Package Group": "B3QFN|15",
        "\"Approx. price\n(USD)\"": "$4.950 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS61023": {
        "Description": "3.7-A boost converter with 0.5-V ultra-low input voltage",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "2 mm2: 1.2 x 1.6 (SOT-5X3|6)",
        "Package Group": "SOT-5X3|6",
        "\"Approx. price\n(USD)\"": "$0.294 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS61391": {
        "Description": "85-VOUT Boost converter with current mirror",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (WQFN|16)",
        "Package Group": "WQFN|16",
        "\"Approx. price\n(USD)\"": "$1.320 | 1ku",
        "Status": "ACTIVE"
    },
    "LMR33640": {
        "Description": "SIMPLE SWITCHER® 3.8-V to 36-V 4-A step-down converter in SOIC-8 package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": "Functional Safety-Capable",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "19 mm2: 3.9 x 4.89 (SO PowerPAD|8)",
        "Package Group": "SO PowerPAD|8",
        "\"Approx. price\n(USD)\"": "$0.893 | 1ku",
        "Status": "ACTIVE"
    },
    "LMR33610": {
        "Description": "SIMPLE SWITCHER® 3.8-V to 36-V 1-A synchronous step-down converter in SOIC-8 package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": "Functional Safety-Capable",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "19 mm2: 3.9 x 4.89 (SO PowerPAD|8)",
        "Package Group": "SO PowerPAD|8",
        "\"Approx. price\n(USD)\"": "$0.630 | 1ku",
        "Status": "ACTIVE"
    },
    "LM5163": {
        "Description": "100-V input 0.5-A synchronous buck DC/DC converter with ultra-low IQ",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 150",
        "Package size: mm2:W x L (PKG)": "19 mm2: 3.9 x 4.89 (SO PowerPAD|8)",
        "Package Group": "SO PowerPAD|8",
        "\"Approx. price\n(USD)\"": "$0.945 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS63810": {
        "Description": "2.5-A high-efficient buck-boost converter with I²C interface for dynamic voltage scaling",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck-boost inverting & split-rail converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "See datasheet (DSBGA)",
        "Package Group": "DSBGA|15",
        "\"Approx. price\n(USD)\"": "$1.082 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS63811": {
        "Description": "2.5-A high-efficient buck-boost converter with I²C interface for dynamic voltage scaling",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck-boost inverting & split-rail converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "See datasheet (DSBGA)",
        "Package Group": "DSBGA|15",
        "\"Approx. price\n(USD)\"": "$1.082 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS543C20A": {
        "Description": "4-V to 16-V 40-A synchronous SWIFT™ buck converter with adaptive internal compensation",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "35 mm2: 5 x 7 (LQFN-CLIP|40)",
        "Package Group": "LQFN-CLIP|40",
        "\"Approx. price\n(USD)\"": "$3.948 | 1ku",
        "Status": "ACTIVE"
    },
    "LM63615-Q1": {
        "Description": "3.5-V to 36-V 1.5-A step-down voltage converter with spread spectrum",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": "Functional Safety-Capable",
        "\"Operating temperature range\n(C)\"": "-40 to 150",
        "Package size: mm2:W x L (PKG)": "32 mm2: 6.4 x 5 (HTSSOP|16) 9 mm2: 3 x 3 (WSON|12)",
        "Package Group": "HTSSOP|16 WSON|12",
        "\"Approx. price\n(USD)\"": "$1.200 | 1ku",
        "Status": "ACTIVE"
    },
    "LM63625-Q1": {
        "Description": "3.5-V to 36-V 2.5-A step-down voltage converter with spread spectrum",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": "Functional Safety-Capable",
        "\"Operating temperature range\n(C)\"": "-40 to 150",
        "Package size: mm2:W x L (PKG)": "32 mm2: 6.4 x 5 (HTSSOP|16) 9 mm2: 3 x 3 (WSON|12)",
        "Package Group": "HTSSOP|16 WSON|12",
        "\"Approx. price\n(USD)\"": "$1.300 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS63802": {
        "Description": "2-A high-efficient 11-µA quiescent current buck-boost converter in QFN/DFN package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck-boost inverting & split-rail converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "6 mm2: 2 x 3 (VSON-HR|10)",
        "Package Group": "VSON-HR|10",
        "\"Approx. price\n(USD)\"": "$0.800 | 1ku",
        "Status": "ACTIVE"
    },
    "LM5143-Q1": {
        "Description": "3.5-V to 65-V low Iq dual 2-phase synchronous buck DC-DC controller",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck controllers (external switch)",
        "Rating": "Automotive",
        "TI functional safety category": "Functional Safety-Capable",
        "\"Operating temperature range\n(C)\"": "-40 to 150",
        "Package size: mm2:W x L (PKG)": "36 mm2: 6 x 6 (VQFNP|40)",
        "Package Group": "VQFNP|40",
        "\"Approx. price\n(USD)\"": "$6.000 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS56C230": {
        "Description": "4.5-V to 18-V 12-A synchronous SWIFT™ buck converter optimized for solution cost",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (VQFN-HR|20)",
        "Package Group": "VQFN-HR|20",
        "\"Approx. price\n(USD)\"": "$1.365 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS56637": {
        "Description": "4.5-V to 28-V 6-A synchronous buck converter with ULQ-Mode",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 150",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (VQFN-HR|10)",
        "Package Group": "VQFN-HR|10",
        "\"Approx. price\n(USD)\"": "$1.386 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS560430-Q1": {
        "Description": "Automotive qualified SIMPLE SWITCHER® 4-V to 36-V 600-mA synchronous step-down converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "5 mm2: 1.6 x 2.9 (SOT-23|6)",
        "Package Group": "SOT-23|6",
        "\"Approx. price\n(USD)\"": "$0.446 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS63806": {
        "Description": "2.5-A high-efficient buck-boost converter with optimized load step response in tiny WCSP",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck-boost inverting & split-rail converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "See datasheet (DSBGA)",
        "Package Group": "DSBGA|15",
        "\"Approx. price\n(USD)\"": "$1.061 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62811-Q1": {
        "Description": "Automotive 2.75-V to 6-V 1-A step-down converter in a 2mm x 3mm wettable-flanks QFN package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": "Functional Safety-Capable",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "6 mm2: 2 x 3 (VQFN-HR|9)",
        "Package Group": "VQFN-HR|9",
        "\"Approx. price\n(USD)\"": "$0.743 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62812-Q1": {
        "Description": "Automotive 2.75-V to 6-V 2-A step-down converter in a 2mm x 3mm wettable-flanks QFN package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": "Functional Safety-Capable",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "6 mm2: 2 x 3 (VQFN-HR|9)",
        "Package Group": "VQFN-HR|9",
        "\"Approx. price\n(USD)\"": "$0.843 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62840": {
        "Description": "60-nA quiescent current (IQ) 1.8-V to 6.5-VIN high-efficiency 750-mA step-down converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "1 mm2: 1.4 x 1 (DSBGA|6) 9 mm2: 3 x 3 (HVSSOP|8) 3 mm2: 1.5 x 2 (VSON-HR|8)",
        "Package Group": "DSBGA|6 HVSSOP|8 VSON-HR|8",
        "\"Approx. price\n(USD)\"": "$0.651 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62152A-Q1": {
        "Description": "3-V to 17-V 1-A step-down converter with DCS-Control™",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": "Functional Safety-Capable",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (VQFN|16)",
        "Package Group": "VQFN|16",
        "\"Approx. price\n(USD)\"": "$0.620 | 1ku",
        "Status": "ACTIVE"
    },
    "LM51551-Q1": {
        "Description": "2.2-MHz wide VIN 1.5-A MOSFET driver non-synchronous boost controller hiccup mode protection",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost controllers (external switch)",
        "Rating": "Automotive",
        "TI functional safety category": "Functional Safety-Capable",
        "\"Operating temperature range\n(C)\"": "-40 to 150",
        "Package size: mm2:W x L (PKG)": "6 mm2: 3 x 2 (WSON|12)",
        "Package Group": "WSON|12",
        "\"Approx. price\n(USD)\"": "$0.818 | 1ku",
        "Status": "ACTIVE"
    },
    "LM5155-Q1": {
        "Description": "2.2-MHz wide VIN 1.5-A MOSFET driver non-synchronous boost controller AEC-Q100 qualified",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "\"Boost controllers (external switch)\nBuck-boost & inverting controllers (external switch)\"",
        "Rating": "Automotive",
        "TI functional safety category": "Functional Safety-Capable",
        "\"Operating temperature range\n(C)\"": "-40 to 150",
        "Package size: mm2:W x L (PKG)": "6 mm2: 3 x 2 (WSON|12)",
        "Package Group": "WSON|12",
        "\"Approx. price\n(USD)\"": "$0.818 | 1ku",
        "Status": "ACTIVE"
    },
    "TLV61048": {
        "Description": "14-V output voltage non-synchronous boost converter in SOT-23 package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "5 mm2: 1.6 x 2.9 (SOT-23|6)",
        "Package Group": "SOT-23|6",
        "\"Approx. price\n(USD)\"": "$0.355 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS61390": {
        "Description": "85-VOUT boost converter with current mirror and sample and hold",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (WQFN|16)",
        "Package Group": "WQFN|16",
        "\"Approx. price\n(USD)\"": "$1.320 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62810-Q1": {
        "Description": "Automotive 2.75-V to 6-V 4-A step-down converter in a 2mm x 3mm wettable-flanks QFN package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": "Functional Safety-Capable",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "6 mm2: 2 x 3 (VQFN-HR|9)",
        "Package Group": "VQFN-HR|9",
        "\"Approx. price\n(USD)\"": "$1.053 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62813-Q1": {
        "Description": "Automotive 2.75-V to 6-V 3-A step-down converter with fixed Fsw and SYNC in 2x3mm wettable-flanks",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": "Functional Safety-Capable",
        "\"Operating temperature range\n(C)\"": "\"-40 to 120\n-40 to 125\"",
        "Package size: mm2:W x L (PKG)": "6 mm2: 2 x 3 (VQFN-HR|9)",
        "Package Group": "VQFN-HR|9",
        "\"Approx. price\n(USD)\"": "$0.945 | 1ku",
        "Status": "ACTIVE"
    },
    "LM5163-Q1": {
        "Description": "Automotive 6-V to 100-V input 0.5-A synchronous buck DC/DC converter with ultra-low IQ",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 150",
        "Package size: mm2:W x L (PKG)": "19 mm2: 3.9 x 4.89 (SO PowerPAD|8)",
        "Package Group": "SO PowerPAD|8",
        "\"Approx. price\n(USD)\"": "$1.115 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS54A24": {
        "Description": "4.5-V to 17-V 10-A synchronous SWIFT™ buck converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 150",
        "Package size: mm2:W x L (PKG)": "16 mm2: 4 x 4 (WQFN|24)",
        "Package Group": "WQFN|24",
        "\"Approx. price\n(USD)\"": "$1.596 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS56339": {
        "Description": "4.5-V to 24-V input 3-A output synchronous buck converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "5 mm2: 1.6 x 2.9 (SOT-23-THIN|6)",
        "Package Group": "SOT-23-THIN|6",
        "\"Approx. price\n(USD)\"": "$0.397 | 1ku",
        "Status": "ACTIVE"
    },
    "LMR34215-Q1": {
        "Description": "4.2-V to 42-V 1.5-A ultra-small synchronous step-down converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "6 mm2: 3 x 2 (VQFN-HR|12)",
        "Package Group": "VQFN-HR|12",
        "\"Approx. price\n(USD)\"": "$0.935 | 1ku",
        "Status": "ACTIVE"
    },
    "LMR34206-Q1": {
        "Description": "4.2-V to 42-V 0.6-A ultra-small synchronous step-down converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "6 mm2: 3 x 2 (VQFN-HR|12)",
        "Package Group": "VQFN-HR|12",
        "\"Approx. price\n(USD)\"": "$0.819 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS566235": {
        "Description": "4.5-V to 18-V 6-A synchronous buck converter in 2-mm x 3-mm QFN",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "6 mm2: 2 x 3 (VQFN-HR|13)",
        "Package Group": "VQFN-HR|13",
        "\"Approx. price\n(USD)\"": "$1.103 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS562231": {
        "Description": "4.5-V to 17-V input 2-A output synchronous step-down converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "2 mm2: 1.2 x 1.6 (SOT-5X3|6)",
        "Package Group": "SOT-5X3|6",
        "\"Approx. price\n(USD)\"": "$0.174 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS568230": {
        "Description": "4.5-V to 18-V 8-A synchronous SWIFT™ buck converter optimized for solution cost",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (VQFN-HR|20)",
        "Package Group": "VQFN-HR|20",
        "\"Approx. price\n(USD)\"": "$1.197 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS61022": {
        "Description": "8-A boost converter with 0.5-V ultra-low input voltage",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "4 mm2: 2 x 2 (VQFN-HR|7)",
        "Package Group": "VQFN-HR|7",
        "\"Approx. price\n(USD)\"": "$0.601 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62827": {
        "Description": "2.5-V to 5.5-V input 4-A step-down converter with 1% accuracy in 1.5-mm x 1.5-mm VSON-HR package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "2 mm2: 1.5 x 1.5 (VSON-HR|6)",
        "Package Group": "VSON-HR|6",
        "\"Approx. price\n(USD)\"": "$0.647 | 1ku",
        "Status": "ACTIVE"
    },
    "LM5164-Q1": {
        "Description": "6-V to 100-V input 1-A synchronous DC-DC buck converter with ultra-low IQ",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": "Functional Safety-Capable",
        "\"Operating temperature range\n(C)\"": "-40 to 150",
        "Package size: mm2:W x L (PKG)": "19 mm2: 3.9 x 4.89 (SO PowerPAD|8)",
        "Package Group": "SO PowerPAD|8",
        "\"Approx. price\n(USD)\"": "$1.667 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS51396A": {
        "Description": "4.5-V to 24-V 8-A synchronous step-down voltage regulator",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (VQFN-HR|20)",
        "Package Group": "VQFN-HR|20",
        "\"Approx. price\n(USD)\"": "$1.386 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS563231": {
        "Description": "4.5-V to 17-V input 3-A synchronous step-down voltage regulator",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "2 mm2: 1.2 x 1.6 (SOT-5X3|6)",
        "Package Group": "SOT-5X3|6",
        "\"Approx. price\n(USD)\"": "$0.231 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62807": {
        "Description": "1.8V-5.5V input 600-mA ultra-low IQ step-down converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "1 mm2: .7 x 1.05 (DSBGA|6)",
        "Package Group": "DSBGA|6",
        "\"Approx. price\n(USD)\"": "$0.378 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62808": {
        "Description": "1.8V-5.5V input 600-mA ultra-low IQ step-down converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "1 mm2: .7 x 1.05 (DSBGA|6)",
        "Package Group": "DSBGA|6",
        "\"Approx. price\n(USD)\"": "$0.378 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS54340B": {
        "Description": "42-V input 3.5-A step-down DC/DC converter with Eco-mode™",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 150",
        "Package size: mm2:W x L (PKG)": "19 mm2: 3.9 x 4.89 (SO PowerPAD|8)",
        "Package Group": "SO PowerPAD|8",
        "\"Approx. price\n(USD)\"": "$1.452 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS54540B": {
        "Description": "4.5-V to 42-V input 5-A step-down converter with Eco-mode™",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 150",
        "Package size: mm2:W x L (PKG)": "19 mm2: 3.9 x 4.89 (SO PowerPAD|8)",
        "Package Group": "SO PowerPAD|8",
        "\"Approx. price\n(USD)\"": "$1.694 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS54560B": {
        "Description": "4.5-V to 60-V input 5-A step-down DC-DC converter with Eco-mode™",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 150",
        "Package size: mm2:W x L (PKG)": "19 mm2: 3.9 x 4.89 (SO PowerPAD|8)",
        "Package Group": "SO PowerPAD|8",
        "\"Approx. price\n(USD)\"": "$2.033 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS563249": {
        "Description": "17-V 3-A constant 1.4-MHz synchronous step-down voltage regulator",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "5 mm2: 1.6 x 2.9 (SOT-23-THIN|6)",
        "Package Group": "SOT-23-THIN|6",
        "\"Approx. price\n(USD)\"": "$0.526 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS563240": {
        "Description": "17-V 3-A 1.4-MHz synchronous step-down voltage regulator",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "5 mm2: 1.6 x 2.9 (SOT-23-THIN|6)",
        "Package Group": "SOT-23-THIN|6",
        "\"Approx. price\n(USD)\"": "$0.525 | 1ku",
        "Status": "ACTIVE"
    },
    "LM5164": {
        "Description": "6-V to 100-V input 1-A synchronous buck DC-DC converter with ultra-low IQ",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 150",
        "Package size: mm2:W x L (PKG)": "19 mm2: 3.9 x 4.89 (SO PowerPAD|8)",
        "Package Group": "SO PowerPAD|8",
        "\"Approx. price\n(USD)\"": "$1.413 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS6283810": {
        "Description": "2.4V-5.5V input tiny 6-pin 3-A step-down converter in 1.2-mm x 0.8-mm WCSP",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "1 mm2: 1.4 x 1 (DSBGA|6)",
        "Package Group": "DSBGA|6",
        "\"Approx. price\n(USD)\"": "$0.561 | 1ku",
        "Status": "ACTIVE"
    },
    "LM51551": {
        "Description": "2.2-MHz wide VIN nonsynchronous boost flyback & SEPIC controller with hiccup",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost controllers (external switch)",
        "Rating": "Catalog",
        "TI functional safety category": "Functional Safety-Capable",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "6 mm2: 3 x 2 (WSON|12)",
        "Package Group": "WSON|12",
        "\"Approx. price\n(USD)\"": "$0.693 | 1ku",
        "Status": "ACTIVE"
    },
    "LM34936-Q1": {
        "Description": "Automotive 30-V wide VIN synchronous 4-switch buck-boost controller",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck-boost & inverting controllers (external switch)",
        "Rating": "Automotive",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "43 mm2: 4.4 x 9.7 (HTSSOP|28)",
        "Package Group": "HTSSOP|28",
        "\"Approx. price\n(USD)\"": "$2.726 | 1ku",
        "Status": "ACTIVE"
    },
    "LM5155": {
        "Description": "2.2-MHz wide VIN 1.5-A MOSFET driver non-synchronous boost controller",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "\"Boost controllers (external switch)\nBuck-boost & inverting controllers (external switch)\"",
        "Rating": "Catalog",
        "TI functional safety category": "Functional Safety-Capable",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "6 mm2: 3 x 2 (WSON|12)",
        "Package Group": "WSON|12",
        "\"Approx. price\n(USD)\"": "$0.693 | 1ku",
        "Status": "ACTIVE"
    },
    "LMR36006": {
        "Description": "4.2-V to 60-V 0.6-A ultra-small synchronous step-down converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 150",
        "Package size: mm2:W x L (PKG)": "6 mm2: 3 x 2 (VQFN-HR|12)",
        "Package Group": "VQFN-HR|12",
        "\"Approx. price\n(USD)\"": "$0.735 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS54360B": {
        "Description": "60-V input 3.5-A step-down DC/DC converter with Eco-Mode™",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 150",
        "Package size: mm2:W x L (PKG)": "19 mm2: 3.9 x 4.89 (SO PowerPAD|8)",
        "Package Group": "SO PowerPAD|8",
        "\"Approx. price\n(USD)\"": "$1.742 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS61372": {
        "Description": "16V/3.6A sync boost with load disconnect",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "2 mm2: 1.4 x 1.4 (DSBGA|16)",
        "Package Group": "DSBGA|16",
        "\"Approx. price\n(USD)\"": "$1.663 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS61088-Q1": {
        "Description": "10-A fully-integrated synchronous boost converter AEC-Q100 qualified",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": "Functional Safety-Capable",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "16 mm2: 3.5 x 4.5 (VQFN|20)",
        "Package Group": "VQFN|20",
        "\"Approx. price\n(USD)\"": "$1.828 | 1ku",
        "Status": "ACTIVE"
    },
    "LM5146-Q1": {
        "Description": "Automotive 100-V synchronous buck DC/DC controller with wide duty-cycle range",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck controllers (external switch)",
        "Rating": "Automotive",
        "TI functional safety category": "Functional Safety-Capable",
        "\"Operating temperature range\n(C)\"": "-40 to 150",
        "Package size: mm2:W x L (PKG)": "16 mm2: 3.5 x 4.5 (VQFN|20)",
        "Package Group": "VQFN|20",
        "\"Approx. price\n(USD)\"": "$1.425 | 1ku",
        "Status": "ACTIVE"
    },
    "LMR36015": {
        "Description": "4.2-V to 60-V 1.5-A ultra-small synchronous step-down converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 150",
        "Package size: mm2:W x L (PKG)": "6 mm2: 3 x 2 (VQFN-HR|12)",
        "Package Group": "VQFN-HR|12",
        "\"Approx. price\n(USD)\"": "$0.840 | 1ku",
        "Status": "ACTIVE"
    },
    "LMR36015-Q1": {
        "Description": "4.2-V to 60-V 1.5-A ultra-small synchronous step-down converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 150",
        "Package size: mm2:W x L (PKG)": "6 mm2: 3 x 2 (VQFN-HR|12)",
        "Package Group": "VQFN-HR|12",
        "\"Approx. price\n(USD)\"": "$0.991 | 1ku",
        "Status": "ACTIVE"
    },
    "LM5122ZA": {
        "Description": "3-V to 65-V wide VIN current mode synchronous boost controller with multiphase capability",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost controllers (external switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "34 mm2: 4.4 x 7.8 (HTSSOP|24)",
        "Package Group": "HTSSOP|24",
        "\"Approx. price\n(USD)\"": "$1.742 | 1ku",
        "Status": "ACTIVE"
    },
    "LMR33620-Q1": {
        "Description": "3.8-V to 36-V 2-A synchronous step-down voltage converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": "Functional Safety-Capable",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "6 mm2: 3 x 2 (VQFN-HR|12)",
        "Package Group": "VQFN-HR|12",
        "\"Approx. price\n(USD)\"": "$0.781 | 1ku",
        "Status": "ACTIVE"
    },
    "LMR33630-Q1": {
        "Description": "3.8-V to 36-V 3-A synchronous step-down voltage converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": "Functional Safety-Capable",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "6 mm2: 3 x 2 (VQFN-HR|12)",
        "Package Group": "VQFN-HR|12",
        "\"Approx. price\n(USD)\"": "$0.930 | 1ku",
        "Status": "ACTIVE"
    },
    "LMR36006-Q1": {
        "Description": "4.2-V to 60-V 0.6-A ultra-small synchronous step-down converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 150",
        "Package size: mm2:W x L (PKG)": "6 mm2: 3 x 2 (VQFN-HR|12)",
        "Package Group": "VQFN-HR|12",
        "\"Approx. price\n(USD)\"": "$0.867 | 1ku",
        "Status": "ACTIVE"
    },
    "LMZM33604": {
        "Description": "3.5-V to 36-V input 1-V to 20-V output 4-A power module",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck modules (integrated inductor)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 105",
        "Package size: mm2:W x L (PKG)": "160 mm2: 10 x 16 (B3QFN|41)",
        "Package Group": "B3QFN|41",
        "\"Approx. price\n(USD)\"": "$6.840 | 1ku",
        "Status": "ACTIVE"
    },
    "LMZM33606": {
        "Description": "3.5-V to 36-V input 1-V to 20-V output 6-A power module",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck modules (integrated inductor)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 105",
        "Package size: mm2:W x L (PKG)": "160 mm2: 10 x 16 (B3QFN|41)",
        "Package Group": "B3QFN|41",
        "\"Approx. price\n(USD)\"": "$7.200 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS63805": {
        "Description": "2-A high-efficient 11-µA quiescent current buck-boost converter with tiny solution size",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck-boost inverting & split-rail converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "See datasheet (DSBGA)",
        "Package Group": "DSBGA|15",
        "\"Approx. price\n(USD)\"": "$0.905 | 1ku",
        "Status": "ACTIVE"
    },
    "LM2775-Q1": {
        "Description": "Automotive 2.7-V to 5.5-VIN 200-mA output current 5-V fixed output voltage doubler",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Charge pumps (inductorless)",
        "Rating": "Automotive",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "4 mm2: 2 x 2 (WSON|8)",
        "Package Group": "WSON|8",
        "\"Approx. price\n(USD)\"": "$0.591 | 1ku",
        "Status": "ACTIVE"
    },
    "LM5176-Q1": {
        "Description": "55-V wide VIN synchronous 4-switch buck-boost controller AEC-Q100 qualified",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck-boost & inverting controllers (external switch)",
        "Rating": "Automotive",
        "TI functional safety category": "Functional Safety-Capable",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "43 mm2: 4.4 x 9.7 (HTSSOP|28)",
        "Package Group": "HTSSOP|28",
        "\"Approx. price\n(USD)\"": "$3.427 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS61281D": {
        "Description": "2.3MHz 3A synchronous boost converter with pass-through mode",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "See datasheet (DSBGA)",
        "Package Group": "DSBGA|16",
        "\"Approx. price\n(USD)\"": "$0.462 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS61282D": {
        "Description": "2.3MHz 4A synchronous boost converter with pass-through mode",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "See datasheet (DSBGA)",
        "Package Group": "DSBGA|16",
        "\"Approx. price\n(USD)\"": "$0.462 | 1ku",
        "Status": "ACTIVE"
    },
    "LM34936": {
        "Description": "30-V Wide VIN Synchronous 4-Switch Buck-Boost Controller",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck-boost & inverting controllers (external switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "20 mm2: 4 x 5 (VQFN|28)",
        "Package Group": "VQFN|28",
        "\"Approx. price\n(USD)\"": "$2.420 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62422-Q1": {
        "Description": "Automotive 2.25-MHz Fixed VOUT Dual 1000mA/600mA Step-Down Converter for ADAS Camera applications",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (VSON|10)",
        "Package Group": "VSON|10",
        "\"Approx. price\n(USD)\"": "$0.776 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62423-Q1": {
        "Description": "Automotive 2.25-MHz Fixed VOUT Dual 800mA Step-Down Converter for ADAS Camera applications",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (VSON|10)",
        "Package Group": "VSON|10",
        "\"Approx. price\n(USD)\"": "$0.776 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62424-Q1": {
        "Description": "Automotive 2.25-MHz Fixed VOUT Dual 800mA Step-Down Converter for ADAS Camera applications",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (VSON|10)",
        "Package Group": "VSON|10",
        "\"Approx. price\n(USD)\"": "$0.776 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62800": {
        "Description": "1.8V-5.5V input tiny 1A ultra-low Iq step-down converter in 1.05 x 0.70mm chip scale package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "1 mm2: .7 x 1.05 (DSBGA|6)",
        "Package Group": "DSBGA|6",
        "\"Approx. price\n(USD)\"": "$0.494 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62802": {
        "Description": "1.8V-5.5V input 1-A ultra-low Iq step-down converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "1 mm2: .7 x 1.05 (DSBGA|6)",
        "Package Group": "DSBGA|6",
        "\"Approx. price\n(USD)\"": "$0.494 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62823": {
        "Description": "2.4-V to 5.5-V input 3-A step-down converter with 1% accuracy in 1.5-mm x 2-mm VSON-HR package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "3 mm2: 1.5 x 2 (VSON-HR|8)",
        "Package Group": "VSON-HR|8",
        "\"Approx. price\n(USD)\"": "$0.536 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62825": {
        "Description": "2.4-V to 5.5-V input 2-A step-down converter with 1% accuracy in 1.5-mm x 1.5-mm VSON-HR package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "2 mm2: 1.5 x 1.5 (VSON-HR|6)",
        "Package Group": "VSON-HR|6",
        "\"Approx. price\n(USD)\"": "$0.431 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62826": {
        "Description": "2.4-V-5.5-V input 3-A step-down converter with 1% accuracy in 1.5-mm x 1.5-mm VSON-HR package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "2 mm2: 1.5 x 1.5 (VSON-HR|6)",
        "Package Group": "VSON-HR|6",
        "\"Approx. price\n(USD)\"": "$0.536 | 1ku",
        "Status": "ACTIVE"
    },
    "LM51501-Q1": {
        "Description": "Automotive 1.5-V to 42-V VIN low IQ boost controller with 6V 6.5V 9.5V 11.5V output options",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost controllers (external switch)",
        "Rating": "Automotive",
        "TI functional safety category": "Functional Safety-Capable",
        "\"Operating temperature range\n(C)\"": "\"-40 to 125\n-40 to 150\"",
        "Package size: mm2:W x L (PKG)": "16 mm2: 4 x 4 (WQFN|16)",
        "Package Group": "WQFN|16",
        "\"Approx. price\n(USD)\"": "$0.786 | 1ku",
        "Status": "ACTIVE"
    },
    "TLV62568A": {
        "Description": "2.5V-5.5V input 1A high efficiency step-down buck converter with forced PWM in small SOT563 package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "2 mm2: 1.2 x 1.6 (SOT-5X3|6)",
        "Package Group": "SOT-5X3|6",
        "\"Approx. price\n(USD)\"": "$0.096 | 1ku",
        "Status": "ACTIVE"
    },
    "TLV62569A": {
        "Description": "2A High Efficiency Step-down Buck Converter with forced PWM in SOT Package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "2 mm2: 1.2 x 1.6 (SOT-5X3|6)",
        "Package Group": "SOT-5X3|6",
        "\"Approx. price\n(USD)\"": "$0.150 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS560430": {
        "Description": "SIMPLE SWITCHER® 36-V 600-mA Buck Regulator With High-Efficiency Sleep Mode",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "5 mm2: 1.6 x 2.9 (SOT-23|6)",
        "Package Group": "SOT-23|6",
        "\"Approx. price\n(USD)\"": "$0.378 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62806": {
        "Description": "1.8V-5.5V input tiny 600mA ultra-low Iq step-down converter in 1.05 x 0.70mm chip scale package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "1 mm2: .7 x 1.05 (DSBGA|6)",
        "Package Group": "DSBGA|6",
        "\"Approx. price\n(USD)\"": "$0.378 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62822": {
        "Description": "2.4-V to 5.5-V input 2-A step-down converter with 1% accuracy in 1.5-mm x 2-mm VSON-HR package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "3 mm2: 1.5 x 2 (VSON-HR|8)",
        "Package Group": "VSON-HR|8",
        "\"Approx. price\n(USD)\"": "$0.431 | 1ku",
        "Status": "ACTIVE"
    },
    "TPSM84209": {
        "Description": "4.5-V to 28-V input 1.2-V to 6-V output 2.5-A power module",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck modules (integrated inductor)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "18 mm2: 4 x 4.5 (QFN-FCMOD|9)",
        "Package Group": "QFN-FCMOD|9",
        "\"Approx. price\n(USD)\"": "$1.554 | 1ku",
        "Status": "ACTIVE"
    },
    "LMZM23600": {
        "Description": "36-V 0.5-A Step-Down DC/DC Power Module in 3.8-mm × 3-mm Package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck modules (integrated inductor)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "See datasheet",
        "Package Group": " --- ",
        "\"Approx. price\n(USD)\"": "$1.756 | 1ku",
        "Status": "ACTIVE"
    },
    "LMZM23601": {
        "Description": "36-V 1-A Step-Down DC-DC Power Module in 3.8-mm × 3-mm Package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck modules (integrated inductor)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "See datasheet",
        "Package Group": " --- ",
        "\"Approx. price\n(USD)\"": "$2.125 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62147": {
        "Description": "3-17V 2.0A Step-Down Converter with 1% accuracy and PFM/Forced-PWM in 2x3QFN",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "6 mm2: 2 x 3 (VQFN-HR|11)",
        "Package Group": "VQFN-HR|11",
        "\"Approx. price\n(USD)\"": "$0.570 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62148": {
        "Description": "3-17V 2.0A Step-Down Converter with 1% accuracy and PFM/Forced-PWM in 2x3QFN",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "6 mm2: 2 x 3 (VQFN-HR|11)",
        "Package Group": "VQFN-HR|11",
        "\"Approx. price\n(USD)\"": "$0.570 | 1ku",
        "Status": "ACTIVE"
    },
    "TPSM84624": {
        "Description": "4.5V to 17V Input 0.6V-10V Output 6A Power Module in Compact 7.5x7.5mm Footprint",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck modules (integrated inductor)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 105",
        "Package size: mm2:W x L (PKG)": "56 mm2: 7.5 x 7.5 (QFM|24)",
        "Package Group": "QFM|24",
        "\"Approx. price\n(USD)\"": "$4.200 | 1ku",
        "Status": "ACTIVE"
    },
    "LMR14010A": {
        "Description": "SIMPLE SWITCHER® 4-V to 40-V 1-A step-down converter With high efficiency eco-mode",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "5 mm2: 1.6 x 2.9 (SOT-23-THIN|6)",
        "Package Group": "SOT-23-THIN|6",
        "\"Approx. price\n(USD)\"": "$0.420 | 1ku",
        "Status": "ACTIVE"
    },
    "TPSM82480": {
        "Description": "6-A 5.5-V Input step-down power module with PG MODE and VSEL options",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck modules (integrated inductor)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "28 mm2: 3.6 x 7.9 (QFM|24)",
        "Package Group": "QFM|24",
        "\"Approx. price\n(USD)\"": "$2.363 | 1ku",
        "Status": "ACTIVE"
    },
    "LMR23615": {
        "Description": "SIMPLE SWITCHER® 36-V 1.5-A Synchronous Step-Down Converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (WSON|12)",
        "Package Group": "WSON|12",
        "\"Approx. price\n(USD)\"": "$1.201 | 1ku",
        "Status": "ACTIVE"
    },
    "LMR23615-Q1": {
        "Description": "SIMPLE SWITCHER® 36-V 1.5-A Synchronous Step-Down Converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (WSON|12)",
        "Package Group": "WSON|12",
        "\"Approx. price\n(USD)\"": "$1.417 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62243-Q1": {
        "Description": "2.25-MHz 300-mA Step-Down Converter in DDC/TSOT23 Package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "8 mm2: 2.8 x 2.9 (SOT-23-THIN|5)",
        "Package Group": "SOT-23-THIN|5",
        "\"Approx. price\n(USD)\"": "$0.467 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62244-Q1": {
        "Description": "2.25-MHz 300-mA Step-Down Converter in TSOT23 Package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "8 mm2: 2.8 x 2.9 (SOT-23-THIN|5)",
        "Package Group": "SOT-23-THIN|5",
        "\"Approx. price\n(USD)\"": "$0.467 | 1ku",
        "Status": "ACTIVE"
    },
    "LMZM33602": {
        "Description": "4V to 36V 2A Step-Down DC/DC Power Module in Compact 7x9x4mm QFN Package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck modules (integrated inductor)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 105",
        "Package size: mm2:W x L (PKG)": "63 mm2: 7 x 9 (B3QFN|18)",
        "Package Group": "B3QFN|18",
        "\"Approx. price\n(USD)\"": "$3.800 | 1ku",
        "Status": "ACTIVE"
    },
    "LMZM33603": {
        "Description": "4V to 36V 3A Step-Down DC/DC Power Module in Compact 7x9x4mm QFN Package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck modules (integrated inductor)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 105",
        "Package size: mm2:W x L (PKG)": "63 mm2: 7 x 9 (B3QFN|18)",
        "Package Group": "B3QFN|18",
        "\"Approx. price\n(USD)\"": "$4.000 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62801": {
        "Description": "1.8V-5.5V input tiny 1A ultra-low Iq step-down converter in 1.05 x 0.70mm chip scale package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "1 mm2: .7 x 1.05 (DSBGA|6)",
        "Package Group": "DSBGA|6",
        "\"Approx. price\n(USD)\"": "$0.494 | 1ku",
        "Status": "ACTIVE"
    },
    "LMR33620": {
        "Description": "SIMPLE SWITCHER® 3.8V to 36V 2A Synchronous Buck Converter With Ultra-Low EMI",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": "Functional Safety-Capable",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "19 mm2: 3.9 x 4.89 (SO PowerPAD|8) 6 mm2: 3 x 2 (VQFN-HR|12)",
        "Package Group": "SO PowerPAD|8 VQFN-HR|12",
        "\"Approx. price\n(USD)\"": "$0.688 | 1ku",
        "Status": "ACTIVE"
    },
    "LMR33630": {
        "Description": "SIMPLE SWITCHER® 3.8V to 36V 3A Synchronous Buck Converter With Ultra-Low EMI",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": "Functional Safety-Capable",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "19 mm2: 3.9 x 4.89 (SO PowerPAD|8) 6 mm2: 3 x 2 (VQFN-HR|12)",
        "Package Group": "SO PowerPAD|8 VQFN-HR|12",
        "\"Approx. price\n(USD)\"": "$0.791 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62821": {
        "Description": "2.4-V to 5.5-V input 1-A step-down converter with 1% accuracy in 1.5-mm x 2-mm VSON-HR package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "3 mm2: 1.5 x 2 (VSON-HR|8)",
        "Package Group": "VSON-HR|8",
        "\"Approx. price\n(USD)\"": "$0.399 | 1ku",
        "Status": "ACTIVE"
    },
    "TPSM84424": {
        "Description": "4.5V to 17V Input 0.6V-10V Output 4A Power Module in Compact 7.5x7.5mm Footprint",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck modules (integrated inductor)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 105",
        "Package size: mm2:W x L (PKG)": "56 mm2: 7.5 x 7.5 (QFM|24)",
        "Package Group": "QFM|24",
        "\"Approx. price\n(USD)\"": "$3.800 | 1ku",
        "Status": "ACTIVE"
    },
    "TPSM84824": {
        "Description": "4.5V to 17V Input 0.6V-10V Output 8A Power Module in Compact 7.5x7.5mm Footprint",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck modules (integrated inductor)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 105",
        "Package size: mm2:W x L (PKG)": "56 mm2: 7.5 x 7.5 (QFM|24)",
        "Package Group": "QFM|24",
        "\"Approx. price\n(USD)\"": "$5.250 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS65268-Q1": {
        "Description": "4-V to 8-V 3-A 2-A Triple Synchronous Step-Down Converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "25 mm2: 5 x 5 (VQFN|32)",
        "Package Group": "VQFN|32",
        "\"Approx. price\n(USD)\"": "$1.723 | 1ku",
        "Status": "ACTIVE"
    },
    "TPSM846C24": {
        "Description": "4.5-V to 15-V Input 0.5-V to 2.0-V output 35-A power module",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck modules (integrated inductor)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 105",
        "Package size: mm2:W x L (PKG)": "240 mm2: 15 x 16 (QFM|59)",
        "Package Group": "QFM|59",
        "\"Approx. price\n(USD)\"": "$12.075 | 1ku",
        "Status": "ACTIVE"
    },
    "TPSM846C23": {
        "Description": "4.5V to 15V Input 0.35V to 2.0V Output 35A PMBus Power Module",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck modules (integrated inductor)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 105",
        "Package size: mm2:W x L (PKG)": "240 mm2: 15 x 16 (QFM|59)",
        "Package Group": "QFM|59",
        "\"Approx. price\n(USD)\"": "$14.028 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS61322": {
        "Description": "6-uA Quiescent Current 1.8-A Switch Current Boost Converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "5 mm2: 1.6 x 2.9 (SOT-23|5) 7 mm2: 2.37 x 2.92 (SOT-23|3)",
        "Package Group": "SOT-23|3 SOT-23|5",
        "\"Approx. price\n(USD)\"": "$0.132 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS61280D": {
        "Description": "2.3MHz 3A synchronous boost converter with pass-through mode and I2C control interface",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "See datasheet (DSBGA)",
        "Package Group": "DSBGA|16",
        "\"Approx. price\n(USD)\"": "$0.462 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62097-Q1": {
        "Description": "2A Automotive Step-Down Converter in 3x3 QFN With Wettable Flanks",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (VQFN|16)",
        "Package Group": "VQFN|16",
        "\"Approx. price\n(USD)\"": "$0.714 | 1ku",
        "Status": "ACTIVE"
    },
    "LM73605-Q1": {
        "Description": "Automotive qualified 3.5-V to 36-V 5-A synchronous step-down voltage converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "24 mm2: 4 x 6 (WQFN|30)",
        "Package Group": "WQFN|30",
        "\"Approx. price\n(USD)\"": "$2.466 | 1ku",
        "Status": "ACTIVE"
    },
    "LM73606-Q1": {
        "Description": "Automotive qualified 3.5-V to 36-V 6-A synchronous step-down voltage converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "24 mm2: 4 x 6 (WQFN|30)",
        "Package Group": "WQFN|30",
        "\"Approx. price\n(USD)\"": "$2.970 | 1ku",
        "Status": "ACTIVE"
    },
    "LM76002-Q1": {
        "Description": "3.5V to 60V 3.5A/2.5A Synchronous Voltage Regulator",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "24 mm2: 4 x 6 (WQFN|30)",
        "Package Group": "WQFN|30",
        "\"Approx. price\n(USD)\"": "$1.947 | 1ku",
        "Status": "ACTIVE"
    },
    "LM76003-Q1": {
        "Description": "3.5V to 60V 3.5A/2.5A Synchronous Voltage Regulator",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "24 mm2: 4 x 6 (WQFN|30)",
        "Package Group": "WQFN|30",
        "\"Approx. price\n(USD)\"": "$2.272 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS40345": {
        "Description": "3-V to 20-V 25-A synchronous buck controller for cost-optimized applications",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck controllers (external switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-20 to 85",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (VSON|10)",
        "Package Group": "VSON|10",
        "\"Approx. price\n(USD)\"": "$0.726 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS53119": {
        "Description": "3-V to 26-V 20-A synchronous D-CAP buck controller with eco-mode",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck controllers (external switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-20 to 85",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (VQFN|16)",
        "Package Group": "VQFN|16",
        "\"Approx. price\n(USD)\"": "$0.726 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62088": {
        "Description": "2.4-V to 5.5-V input tiny 6-pin 3-A step-down converter in 1.2-mm x 0.8-mm WCSP",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "1 mm2: .8 x 1.2 (DSBGA|6) 1 mm2: 1.4 x 1 (DSBGA|6)",
        "Package Group": "DSBGA|6 DSBGA|6",
        "\"Approx. price\n(USD)\"": "$0.561 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS55160-Q1": {
        "Description": "3.6-V to 36-V 1-A output 2-MHz synchronous step-up and step-down converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck-boost inverting & split-rail converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": "Functional Safety-Capable",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "42 mm2: 6.4 x 6.5 (HTSSOP|20)",
        "Package Group": "HTSSOP|20",
        "\"Approx. price\n(USD)\"": "$1.889 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS55162-Q1": {
        "Description": "3.6-V to 36-V 1-A output 2-MHz synchronous step-up and step-down converter AEC-Q100 qualified",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck-boost inverting & split-rail converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": "Functional Safety-Capable",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "42 mm2: 6.4 x 6.5 (HTSSOP|20)",
        "Package Group": "HTSSOP|20",
        "\"Approx. price\n(USD)\"": "$1.889 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS55165-Q1": {
        "Description": "2-V to 36-V 1-A output 2-MHz 5-V or 12-V fixed output voltage step-up and step-down converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck-boost inverting & split-rail converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": "Functional Safety-Capable",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "42 mm2: 6.4 x 6.5 (HTSSOP|20)",
        "Package Group": "HTSSOP|20",
        "\"Approx. price\n(USD)\"": "$1.889 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS61085A-Q1": {
        "Description": "650-kHz and 1.2-MHz 18.5-V step-up DC/DC converter AEC-Q100 qualified",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "15 mm2: 4.9 x 3 (VSSOP|8)",
        "Package Group": "VSSOP|8",
        "\"Approx. price\n(USD)\"": "$0.948 | 1ku",
        "Status": "ACTIVE"
    },
    "LM2623-Q1": {
        "Description": "0.8-V to 14-V input voltage 2-A load current step-up DC/DC AEC-Q100 qualified",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "16 mm2: 4 x 4 (WSON|14)",
        "Package Group": "WSON|14",
        "\"Approx. price\n(USD)\"": "$0.628 | 1ku",
        "Status": "ACTIVE"
    },
    "LM76002": {
        "Description": "3.5V to 60V 2.5A Synchronous Step-Down Voltage Converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "24 mm2: 4 x 6 (WQFN|30)",
        "Package Group": "WQFN|30",
        "\"Approx. price\n(USD)\"": "$1.650 | 1ku",
        "Status": "ACTIVE"
    },
    "LM76003": {
        "Description": "3.5V to 60V 3.5A Synchronous Step-Down Voltage Converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "24 mm2: 4 x 6 (WQFN|30)",
        "Package Group": "WQFN|30",
        "\"Approx. price\n(USD)\"": "$1.925 | 1ku",
        "Status": "ACTIVE"
    },
    "LM5150-Q1": {
        "Description": "Automotive 1.5-V to 42-V VIN low IQ boost controller with 6.8V 7.5V 8.5V 10.5V output options",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost controllers (external switch)",
        "Rating": "Automotive",
        "TI functional safety category": "Functional Safety-Capable",
        "\"Operating temperature range\n(C)\"": "-40 to 150",
        "Package size: mm2:W x L (PKG)": "16 mm2: 4 x 4 (WQFN|16)",
        "Package Group": "WQFN|16",
        "\"Approx. price\n(USD)\"": "$0.786 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS63710": {
        "Description": "Low Noise 1A Synchronous Inverting Buck Converter in 3x3 WSON Package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck-boost inverting & split-rail converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (WSON|12)",
        "Package Group": "WSON|12",
        "\"Approx. price\n(USD)\"": "$0.967 | 1ku",
        "Status": "ACTIVE"
    },
    "LM73605": {
        "Description": "3.5V to 36V 5A Synchronous Step-Down Voltage Converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "24 mm2: 4 x 6 (WQFN|30)",
        "Package Group": "WQFN|30",
        "\"Approx. price\n(USD)\"": "$2.090 | 1ku",
        "Status": "ACTIVE"
    },
    "LM73606": {
        "Description": "3.5V to 36V 6A Synchronous Step-Down Voltage Converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "24 mm2: 4 x 6 (WQFN|30)",
        "Package Group": "WQFN|30",
        "\"Approx. price\n(USD)\"": "$2.517 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS565208": {
        "Description": "4.5V to 17V 5A Synchronous Step-Down Voltage Regulator in SOT23",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "5 mm2: 1.6 x 2.9 (SOT-23-THIN|6)",
        "Package Group": "SOT-23-THIN|6",
        "\"Approx. price\n(USD)\"": "$0.537 | 1ku",
        "Status": "ACTIVE"
    },
    "LMS3655-Q1": {
        "Description": "5.5-A 36-V synchronous 400-kHz step-down converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 150",
        "Package size: mm2:W x L (PKG)": "20 mm2: 4 x 5 (VQFN-HR|22)",
        "Package Group": "VQFN-HR|22",
        "\"Approx. price\n(USD)\"": "$2.726 | 1ku",
        "Status": "ACTIVE"
    },
    "LMS3635-Q1": {
        "Description": "3.5-A 36-V synchronous 400-kHz step-down converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 150",
        "Package size: mm2:W x L (PKG)": "20 mm2: 4 x 5 (VQFN-HR|22)",
        "Package Group": "VQFN-HR|22",
        "\"Approx. price\n(USD)\"": "$2.207 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS565201": {
        "Description": "4.5V to 17V 5A Synchronous Step-Down Voltage Regulator in SOT23",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "5 mm2: 1.6 x 2.9 (SOT-23-THIN|6)",
        "Package Group": "SOT-23-THIN|6",
        "\"Approx. price\n(USD)\"": "$0.537 | 1ku",
        "Status": "ACTIVE"
    },
    "TLV62585": {
        "Description": "2.5V-5.5V input 3-A high efficiency step-down converter in 2x2 QFN or SOT563 package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "2 mm2: 1.2 x 1.6 (SOT-5X3|6) 4 mm2: 2 x 2 (VQFN-HR|12)",
        "Package Group": "SOT-5X3|6 VQFN-HR|12",
        "\"Approx. price\n(USD)\"": "$0.176 | 1ku",
        "Status": "ACTIVE"
    },
    "LV14360": {
        "Description": "4.3-V to 60-V 3-A step down converter with 300-µA standby IQ and +/-0.53% Vref accuracy",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 150",
        "Package size: mm2:W x L (PKG)": "19 mm2: 3.9 x 4.89 (SO PowerPAD|8)",
        "Package Group": "SO PowerPAD|8",
        "\"Approx. price\n(USD)\"": "$1.100 | 1ku",
        "Status": "ACTIVE"
    },
    "LMS3655": {
        "Description": "5.5A 36V Synchronous 400kHz Step-Down Converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "20 mm2: 4 x 5 (VQFN-HR|22)",
        "Package Group": "VQFN-HR|22",
        "\"Approx. price\n(USD)\"": "$2.310 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS54424": {
        "Description": "4.5V to 17V Input Current Mode 4A Synchronous SWIFT™ Step-Down Converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 150",
        "Package size: mm2:W x L (PKG)": "12 mm2: 3.5 x 3.5 (VQFN-HR|18)",
        "Package Group": "VQFN-HR|18",
        "\"Approx. price\n(USD)\"": "$0.968 | 1ku",
        "Status": "ACTIVE"
    },
    "TPSM84203": {
        "Description": "1.5A 28V Input 3.3V Output TO-220 Power Module",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck modules (integrated inductor)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "110 mm2: 10 x 11 (SIP MODULE|3)",
        "Package Group": "SIP MODULE|3",
        "\"Approx. price\n(USD)\"": "$3.190 | 1ku",
        "Status": "ACTIVE"
    },
    "TPSM84205": {
        "Description": "1.5A 28V Input 5V Output TO-220 Power Module",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck modules (integrated inductor)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "110 mm2: 10 x 11 (SIP MODULE|3)",
        "Package Group": "SIP MODULE|3",
        "\"Approx. price\n(USD)\"": "$2.930 | 1ku",
        "Status": "ACTIVE"
    },
    "TPSM84212": {
        "Description": "1.5A 28V Input 12V Output TO-220 Power Module",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck modules (integrated inductor)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "110 mm2: 10 x 11 (SIP MODULE|3)",
        "Package Group": "SIP MODULE|3",
        "\"Approx. price\n(USD)\"": "$2.959 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS543B20": {
        "Description": "4-V to 19-V 25-A synchronous SWIFT™ buck converter with adaptive internal compensation",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "35 mm2: 5 x 7 (LQFN-CLIP|40)",
        "Package Group": "LQFN-CLIP|40",
        "\"Approx. price\n(USD)\"": "$3.480 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS82140": {
        "Description": "17V Input 2A Synchronous Step-Down Converter MicroSiP™ Module With Integrated Inductor",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck modules (integrated inductor)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "See datasheet",
        "Package Group": " --- ",
        "\"Approx. price\n(USD)\"": "$1.530 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS82150": {
        "Description": "17V Input 1A Synchronous Step-Down Converter MicroSiP™ Module With Integrated Inductor",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck modules (integrated inductor)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "See datasheet",
        "Package Group": " --- ",
        "\"Approx. price\n(USD)\"": "$1.465 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS53681": {
        "Description": "Dual-Channel 6+2/5+3 D-CAP+TM Multiphase Step-Down Controller with PMBus and NVM",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck controllers (external switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "25 mm2: 5 x 5 (WQFN|40)",
        "Package Group": "WQFN|40",
        "\"Approx. price\n(USD)\"": "$4.501 | 1ku",
        "Status": "ACTIVE"
    },
    "LM25145": {
        "Description": "6V to 42V Synchronous Buck DC-DC Controller With Wide Duty Cycle Range",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck controllers (external switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "16 mm2: 3.5 x 4.5 (VQFN|20)",
        "Package Group": "VQFN|20",
        "\"Approx. price\n(USD)\"": "$0.765 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS549B22": {
        "Description": "1.5-V to 18-V 25-A synchronous SWIFT™ buck converter with differential remote sense and PMBus",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "35 mm2: 5 x 7 (LQFN-CLIP|40)",
        "Package Group": "LQFN-CLIP|40",
        "\"Approx. price\n(USD)\"": "$4.030 | 1ku",
        "Status": "ACTIVE"
    },
    "LM5176": {
        "Description": "55V wide VIN synchronous 4-switch buck-boost controller",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck-boost & inverting controllers (external switch)",
        "Rating": "Catalog",
        "TI functional safety category": "Functional Safety-Capable",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "43 mm2: 4.4 x 9.7 (HTSSOP|28) 20 mm2: 4 x 5 (VQFN|28)",
        "Package Group": "HTSSOP|28 VQFN|28",
        "\"Approx. price\n(USD)\"": "$2.904 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS54308": {
        "Description": "4.5-V to 28-V Input 3-A output synchronous 350-kHz FCCM step-down converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "5 mm2: 1.6 x 2.9 (SOT-23-THIN|6)",
        "Package Group": "SOT-23-THIN|6",
        "\"Approx. price\n(USD)\"": "$0.591 | 1ku",
        "Status": "ACTIVE"
    },
    "LM5145": {
        "Description": "75V Synchronous Buck Controller With Wide Input Voltage and Duty Cycle Ranges",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck controllers (external switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "16 mm2: 3.5 x 4.5 (VQFN|20)",
        "Package Group": "VQFN|20",
        "\"Approx. price\n(USD)\"": "$1.155 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS65263-1Q1": {
        "Description": "4.0-V to 18-V input triple 3-A/2-A/2-A synchronous buck converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "25 mm2: 5 x 5 (VQFN|32)",
        "Package Group": "VQFN|32",
        "\"Approx. price\n(USD)\"": "$1.748 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS561201": {
        "Description": "4.5V to 17V Input 1A Synchronous Step-Down Voltage Regulator in 6-pin SOT-23",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "5 mm2: 1.6 x 2.9 (SOT-23-THIN|6)",
        "Package Group": "SOT-23-THIN|6",
        "\"Approx. price\n(USD)\"": "$0.158 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS561208": {
        "Description": "4.5V to 17V Input 1A Output Synchronous Step-Down Converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "5 mm2: 1.6 x 2.9 (SOT-23-THIN|6)",
        "Package Group": "SOT-23-THIN|6",
        "\"Approx. price\n(USD)\"": "$0.193 | 1ku",
        "Status": "ACTIVE"
    },
    "TLV61046A": {
        "Description": "28-V Output Voltage Boost Converter with Power Diode and Isolation Switch",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "5 mm2: 1.6 x 2.9 (SOT-23|6)",
        "Package Group": "SOT-23|6",
        "\"Approx. price\n(USD)\"": "$0.372 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS61096A": {
        "Description": "28-V Output Voltage Boost Converter with 1-µA Quiescent Current",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "6 mm2: 3 x 2 (WSON|12)",
        "Package Group": "WSON|12",
        "\"Approx. price\n(USD)\"": "$0.464 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS57112C-Q1": {
        "Description": "Automotive 2.95-V to 6-V 2-A 2-MHz synchronous buck converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": "Functional Safety-Capable",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (WQFN|16)",
        "Package Group": "WQFN|16",
        "\"Approx. price\n(USD)\"": "$0.726 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS61253A": {
        "Description": "3.8-MHz 5-V / 4-A Boost in 1.2-mm x 1.3-mm WCSP",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "\"-40 to 125\n-40 to 85\"",
        "Package size: mm2:W x L (PKG)": "2 mm2: 1.4 x 1.4 (DSBGA|9)",
        "Package Group": "DSBGA|9",
        "\"Approx. price\n(USD)\"": "$0.393 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62136": {
        "Description": "3-17V 4.0A Step-Down Converter with 1% accuracy and PFM/Forced-PWM in 2x3QFN",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "6 mm2: 2 x 3 (VQFN-HR|11)",
        "Package Group": "VQFN-HR|11",
        "\"Approx. price\n(USD)\"": "$0.644 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS53627": {
        "Description": "2-Phase D-CAP+&trade; Step-Down Controller for Intel VR13 CPU VCORE and DDR Memory",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck controllers (external switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 105",
        "Package size: mm2:W x L (PKG)": "16 mm2: 4 x 4 (VQFN|32)",
        "Package Group": "VQFN|32",
        "\"Approx. price\n(USD)\"": "$2.081 | 1ku",
        "Status": "ACTIVE"
    },
    "LM25141": {
        "Description": "Low Iq Wide Input Range Synchronous Buck Controller",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck controllers (external switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "16 mm2: 4 x 4 (VQFN|24)",
        "Package Group": "VQFN|24",
        "\"Approx. price\n(USD)\"": "$1.151 | 1ku",
        "Status": "ACTIVE"
    },
    "LM5141": {
        "Description": "Low Iq Wide Input Range Synchronous Buck Controller",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck controllers (external switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "16 mm2: 4 x 4 (VQFN|24)",
        "Package Group": "VQFN|24",
        "\"Approx. price\n(USD)\"": "$1.839 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS54560B-Q1": {
        "Description": "4.5V to 60V Input 5A Step-Down DC-DC Converter with Eco-mode&trade;",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "19 mm2: 3.9 x 4.89 (SO PowerPAD|8)",
        "Package Group": "SO PowerPAD|8",
        "\"Approx. price\n(USD)\"": "$2.399 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS61178": {
        "Description": "20-V 10-A fully integrated sync boost with load disconnect",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "11 mm2: 3 x 3.5 (VQFN-HR|13)",
        "Package Group": "VQFN-HR|13",
        "\"Approx. price\n(USD)\"": "$1.742 | 1ku",
        "Status": "ACTIVE"
    },
    "LM25141-Q1": {
        "Description": "Automotive 2.2-MHz low-IQ synchronous buck controller with frequency spread spectrum",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck controllers (external switch)",
        "Rating": "Automotive",
        "TI functional safety category": "Functional Safety-Capable",
        "\"Operating temperature range\n(C)\"": "-40 to 150",
        "Package size: mm2:W x L (PKG)": "16 mm2: 4 x 4 (VQFN|24)",
        "Package Group": "VQFN|24",
        "\"Approx. price\n(USD)\"": "$2.003 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS6213013A-Q1": {
        "Description": "3V - 17V 3A AUTOMOTIVE Step-Down Converter In 3X3 QFN Package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": "Functional Safety-Capable",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (VQFN|16)",
        "Package Group": "VQFN|16",
        "\"Approx. price\n(USD)\"": "$0.895 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS54340B-Q1": {
        "Description": "Automotive 4.5V to 42V Input 3.5A Step-Down Converter With Eco-Mode&trade;",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "19 mm2: 3.9 x 4.89 (SO PowerPAD|8)",
        "Package Group": "SO PowerPAD|8",
        "\"Approx. price\n(USD)\"": "$1.713 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS54360B-Q1": {
        "Description": "Automotive 60V Input 3.5A Step-Down DC-DC Converter With Eco-mode&trade;",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "19 mm2: 3.9 x 4.89 (SO PowerPAD|8)",
        "Package Group": "SO PowerPAD|8",
        "\"Approx. price\n(USD)\"": "$2.056 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS54540B-Q1": {
        "Description": "4.5-V to 42-V input 5-A step-down DC-DC converter with Eco-mode™",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "19 mm2: 3.9 x 4.89 (SO PowerPAD|8)",
        "Package Group": "SO PowerPAD|8",
        "\"Approx. price\n(USD)\"": "$1.999 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS61256C": {
        "Description": "3.5-MHz 5-V 900-mA load boost converter in 1.2-mm x 1.3-mm WCSP with pass-through mode",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "2 mm2: 1.4 x 1.4 (DSBGA|9)",
        "Package Group": "DSBGA|9",
        "\"Approx. price\n(USD)\"": "$0.418 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS568215OA": {
        "Description": "4.5-V to 17-V 8-A synchronous SWIFT™ buck converter with D-CAP3 control and Out-of-Audio™ mode",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "12 mm2: 3.5 x 3.5 (VQFN-HR|18)",
        "Package Group": "VQFN-HR|18",
        "\"Approx. price\n(USD)\"": "$1.353 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62672": {
        "Description": "500-mA 6-MHz High-Efficiency Step-Down Converter Vout=1.5V",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "1 mm2: 1 x 1.4 (DSBGA|6)",
        "Package Group": "DSBGA|6",
        "\"Approx. price\n(USD)\"": "$0.418 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS548B22": {
        "Description": "1.5-V to 18-V 25-A synchronous SWIFT™ buck converter with differential remote sense",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "35 mm2: 5 x 7 (LQFN-CLIP|40)",
        "Package Group": "LQFN-CLIP|40",
        "\"Approx. price\n(USD)\"": "$3.500 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS65235-1": {
        "Description": "LNB voltage regulator with I2C interface in FCCM mode",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (WQFN|20)",
        "Package Group": "WQFN|20",
        "\"Approx. price\n(USD)\"": "$0.678 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS54260-EP": {
        "Description": "3.5-V to 60-V Input 2.5A Step-Down Converter With Eco-mode&trade;",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "HiRel Enhanced Product",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-55 to 125",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (HVSSOP|10) 9 mm2: 3 x 3 (VSON|10)",
        "Package Group": "HVSSOP|10 VSON|10",
        "\"Approx. price\n(USD)\"": "$3.960 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS54262-EP": {
        "Description": "Enhanced Plastic 2A 60V Step Down DC/DC Converter with Low Iq Voltage Supervision and Reset",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "HiRel Enhanced Product",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-55 to 125",
        "Package size: mm2:W x L (PKG)": "42 mm2: 6.4 x 6.5 (HTSSOP|20)",
        "Package Group": "HTSSOP|20",
        "\"Approx. price\n(USD)\"": "$3.925 | 1ku",
        "Status": "ACTIVE"
    },
    "TPSM84A21": {
        "Description": "8V to 14V 0.508V to 1.35V Output 10A Power Module with Integrated Input and Output Capacitors",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck modules (integrated inductor)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "135 mm2: 9 x 15 (QFM|20)",
        "Package Group": "QFM|20",
        "\"Approx. price\n(USD)\"": "$6.600 | 1ku",
        "Status": "ACTIVE"
    },
    "TPSM84A22": {
        "Description": "8V to 14V Input 1.2V to 2.05V Output 10A Power Module with Integrated Input and Output Capacitors",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck modules (integrated inductor)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "135 mm2: 9 x 15 (QFM|20)",
        "Package Group": "QFM|20",
        "\"Approx. price\n(USD)\"": "$6.600 | 1ku",
        "Status": "ACTIVE"
    },
    "LMR23625-Q1": {
        "Description": "Automotive Qualified SIMPLE SWITCHER® 4V to 36V 2.5A Synchronous Step-Down Converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "19 mm2: 3.9 x 4.89 (SO PowerPAD|8) 9 mm2: 3 x 3 (WSON|12)",
        "Package Group": "SO PowerPAD|8 WSON|12",
        "\"Approx. price\n(USD)\"": "$1.542 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS63027": {
        "Description": "High Efficiency 4.5A Switch Single-Inductor Buck-Boost Converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck-boost inverting & split-rail converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "5 mm2: 2.2 x 2.2 (DSBGA|25)",
        "Package Group": "DSBGA|25",
        "\"Approx. price\n(USD)\"": "$1.016 | 1ku",
        "Status": "ACTIVE"
    },
    "LM5166": {
        "Description": "3V-65V Input 500mA Synchronous Buck Converter With Ultra-Low Iq",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 150",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (VSON|10)",
        "Package Group": "VSON|10",
        "\"Approx. price\n(USD)\"": "$1.405 | 1ku",
        "Status": "ACTIVE"
    },
    "LMR23610-Q1": {
        "Description": "Automotive Qualified SIMPLE SWITCHER 4V to 36V 1A Synchronous Step-Down Converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "19 mm2: 3.9 x 4.89 (SO PowerPAD|8)",
        "Package Group": "SO PowerPAD|8",
        "\"Approx. price\n(USD)\"": "$1.484 | 1ku",
        "Status": "ACTIVE"
    },
    "LMR23630-Q1": {
        "Description": "Automotive Qualified SIMPLE SWITCHER® 4V to 36V3A Synchronous Step-Down Converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "19 mm2: 3.9 x 4.89 (SO PowerPAD|8) 9 mm2: 3 x 3 (WSON|12)",
        "Package Group": "SO PowerPAD|8 WSON|12",
        "\"Approx. price\n(USD)\"": "$1.599 | 1ku",
        "Status": "ACTIVE"
    },
    "TLV62568": {
        "Description": "2.5V-5.5V input 1A high efficiency step-down buck converter in SOT23 and SOT563 package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "5 mm2: 1.6 x 2.9 (SOT-23|5) 5 mm2: 1.6 x 2.9 (SOT-23-THIN|6) 2 mm2: 1.2 x 1.6 (SOT-5X3|6)",
        "Package Group": "SOT-23-THIN|6 SOT-23|5 SOT-5X3|6",
        "\"Approx. price\n(USD)\"": "$0.096 | 1ku",
        "Status": "ACTIVE"
    },
    "TLV62569": {
        "Description": "2.5V-5.5V input 2-A high efficiency step-down buck converter in SOT23 and SOT563 package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "5 mm2: 1.6 x 2.9 (SOT-23|5) 5 mm2: 1.6 x 2.9 (SOT-23-THIN|6) 2 mm2: 1.2 x 1.6 (SOT-5X3|6)",
        "Package Group": "SOT-23-THIN|6 SOT-23|5 SOT-5X3|6",
        "\"Approx. price\n(USD)\"": "$0.150 | 1ku",
        "Status": "ACTIVE"
    },
    "LM53603": {
        "Description": "3-A 3.5-V to 36-V wide VIN synchronous 2.1-MHz step-down converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "32 mm2: 6.4 x 5 (HTSSOP|16)",
        "Package Group": "HTSSOP|16",
        "\"Approx. price\n(USD)\"": "$1.862 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62162-Q1": {
        "Description": "3V-17V 1A Automotive Step-Down Converters in 2x2SON",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": "Functional Safety-Capable",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "4 mm2: 2 x 2 (WSON|8)",
        "Package Group": "WSON|8",
        "\"Approx. price\n(USD)\"": "$0.602 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS562210A": {
        "Description": "17V Input 2A Synchronous Step-Down Regulator in SOT-23 w/ Advanced Eco-mode&trade; PG Soft Start",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "5 mm2: 1.6 x 2.9 (SOT-23-THIN|8)",
        "Package Group": "SOT-23-THIN|8",
        "\"Approx. price\n(USD)\"": "$0.400 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS562219A": {
        "Description": "17V Input 2A Synchronous Step-Down Regulator in SOT-23 With Power-good and Soft-start",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "5 mm2: 1.6 x 2.9 (SOT-23-THIN|8)",
        "Package Group": "SOT-23-THIN|8",
        "\"Approx. price\n(USD)\"": "$0.400 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS563210A": {
        "Description": "17V Input 3A Synchronous Step-Down Regulator in SOT-23 w/ Advanced Eco-mode&trade; PG Soft Start",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "5 mm2: 1.6 x 2.9 (SOT-23-THIN|8)",
        "Package Group": "SOT-23-THIN|8",
        "\"Approx. price\n(USD)\"": "$0.484 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS563219A": {
        "Description": "17V Input 3A Synchronous Step-Down Regulator in SOT-23 With Power-good and Soft-start",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "5 mm2: 1.6 x 2.9 (SOT-23-THIN|8)",
        "Package Group": "SOT-23-THIN|8",
        "\"Approx. price\n(USD)\"": "$0.484 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS54824": {
        "Description": "4.5-V to 17-V 8-A synchronous SWIFT™ buck converter in HotRod™ QFN",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 150",
        "Package size: mm2:W x L (PKG)": "12 mm2: 3.5 x 3.5 (VQFN-HR|18)",
        "Package Group": "VQFN-HR|18",
        "\"Approx. price\n(USD)\"": "$1.722 | 1ku",
        "Status": "ACTIVE"
    },
    "LM5170-Q1": {
        "Description": "Multiphase bidirectional current controller AEC-Q100 qualified",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck-boost & inverting controllers (external switch)",
        "Rating": "Automotive",
        "TI functional safety category": "Functional Safety-Capable",
        "\"Operating temperature range\n(C)\"": "-40 to 150",
        "Package size: mm2:W x L (PKG)": "49 mm2: 7 x 7 (HTQFP|48)",
        "Package Group": "HTQFP|48",
        "\"Approx. price\n(USD)\"": "$5.140 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS53622": {
        "Description": "VR13 Dual-Channel D-CAP+&trade; 2+0/1+1 Step-Down Controller With NVM and PMBus",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck controllers (external switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "25 mm2: 5 x 5 (WQFN|40)",
        "Package Group": "WQFN|40",
        "\"Approx. price\n(USD)\"": "$2.035 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS53659": {
        "Description": "4+1/3+2 Dual-Channel VR13 D-CAP+&trade; Step-Down Multiphase Controller With NVM and PMBus",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck controllers (external switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "25 mm2: 5 x 5 (WQFN|40)",
        "Package Group": "WQFN|40",
        "\"Approx. price\n(USD)\"": "$4.211 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS53679": {
        "Description": "Dual-Channel 6+1/5+2 VR13 D-CAP+&trade; Step-Down Multiphase Controller With NVM and PMBus",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck controllers (external switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "25 mm2: 5 x 5 (WQFN|40)",
        "Package Group": "WQFN|40",
        "\"Approx. price\n(USD)\"": "$4.840 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS568215": {
        "Description": "4.5-V to 17-V 8-A synchronous SWIFT™ buck converter with D-CAP3 control",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "12 mm2: 3.5 x 3.5 (VQFN-HR|18)",
        "Package Group": "VQFN-HR|18",
        "\"Approx. price\n(USD)\"": "$1.451 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS65266-1": {
        "Description": "2.7V to 6.5V Input 3A/2A/2A Triple Buck Converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck controllers (external switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "25 mm2: 5 x 5 (VQFN|32)",
        "Package Group": "VQFN|32",
        "\"Approx. price\n(USD)\"": "$1.404 | 1ku",
        "Status": "ACTIVE"
    },
    "LM53602": {
        "Description": "2A 3.5V-to-36V Wide-Vin Synchronous 2.1MHz Step-Down Converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "32 mm2: 6.4 x 5 (HTSSOP|16)",
        "Package Group": "HTSSOP|16",
        "\"Approx. price\n(USD)\"": "$1.768 | 1ku",
        "Status": "ACTIVE"
    },
    "LM27762": {
        "Description": "Low-Noise Positive- and Negative-Output Charge Pump With Integrated LDO",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Charge pumps (inductorless)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "6 mm2: 3 x 2 (WSON|12)",
        "Package Group": "WSON|12",
        "\"Approx. price\n(USD)\"": "$0.660 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62171-Q1": {
        "Description": "Automotive Catalog 3-17V 0.5A 2.5MHZ Step-Down Converter 1.8V Output Voltage",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": "Functional Safety-Capable",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "4 mm2: 2 x 2 (WSON|8)",
        "Package Group": "WSON|8",
        "\"Approx. price\n(USD)\"": "$0.506 | 1ku",
        "Status": "ACTIVE"
    },
    "TLV62084A": {
        "Description": "2A High Efficient Step Down Converter in 2x2mm SON Package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "4 mm2: 2 x 2 (WSON|8)",
        "Package Group": "WSON|8",
        "\"Approx. price\n(USD)\"": "$0.506 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS53667": {
        "Description": "6-Phase D-CAP+ step-down driverless buck controller with NVM and PMBus interface for ASIC",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck controllers (external switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "36 mm2: 6 x 6 (WQFN|40)",
        "Package Group": "WQFN|40",
        "\"Approx. price\n(USD)\"": "$2.757 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62135": {
        "Description": "3-17V 4.0A Step-Down Converter with 1% accuracy and PFM/Forced-PWM in 2x3QFN",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "6 mm2: 2 x 3 (VQFN-HR|11)",
        "Package Group": "VQFN-HR|11",
        "\"Approx. price\n(USD)\"": "$0.644 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS546C23": {
        "Description": "4.5-V to 18-V stackable 35-A synchronous SWIFT™ buck converter with PMBus and telemetry",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "35 mm2: 5 x 7 (LQFN-CLIP|40)",
        "Package Group": "LQFN-CLIP|40",
        "\"Approx. price\n(USD)\"": "$4.510 | 1ku",
        "Status": "ACTIVE"
    },
    "LM5141-Q1": {
        "Description": "Automotive wide-input 2.2-MHz low-IQ synchronous buck controller",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck controllers (external switch)",
        "Rating": "Automotive",
        "TI functional safety category": "Functional Safety-Capable",
        "\"Operating temperature range\n(C)\"": "-40 to 150",
        "Package size: mm2:W x L (PKG)": "16 mm2: 4 x 4 (VQFN|24)",
        "Package Group": "VQFN|24",
        "\"Approx. price\n(USD)\"": "$2.170 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS61099": {
        "Description": "0.7Vin Synchronous Boost Converter with 800 nA Ultra-Low Quiescent Current",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "\"-40 to 125\n-40 to 150\n-40 to 85\"",
        "Package size: mm2:W x L (PKG)": "See datasheet (DSBGA) 4 mm2: 2 x 2 (WSON|6)",
        "Package Group": "DSBGA|6 WSON|6",
        "\"Approx. price\n(USD)\"": "$0.561 | 1ku",
        "Status": "ACTIVE"
    },
    "LM5161-Q1": {
        "Description": "Wide Input 4.5-V to 100-V 1-A Synchronous Buck / Fly-Buck Converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "22 mm2: 4.4 x 5 (HTSSOP|14)",
        "Package Group": "HTSSOP|14",
        "\"Approx. price\n(USD)\"": "$2.056 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS546C20A": {
        "Description": "4.5-V to 18-V stackable 35-A synchronous SWIFT™ buck converter with PMBus and pin-strapping",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "35 mm2: 5 x 7 (LQFN-CLIP|40)",
        "Package Group": "LQFN-CLIP|40",
        "\"Approx. price\n(USD)\"": "$4.510 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS548D21": {
        "Description": "1.5-V to 16-V 40-A synchronous SWIFT™ buck converter with AVSO and differential remote sense",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "35 mm2: 5 x 7 (LQFN-CLIP|40)",
        "Package Group": "LQFN-CLIP|40",
        "\"Approx. price\n(USD)\"": "$3.960 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS549D22": {
        "Description": "1.5-V to 16-V 40-A synchronous SWIFT™ buck converter with differential remote sense and PMBus",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "35 mm2: 5 x 7 (LQFN-CLIP|40)",
        "Package Group": "LQFN-CLIP|40",
        "\"Approx. price\n(USD)\"": "$4.424 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS61230A": {
        "Description": "5-V/6-A High Efficiency Step-Up Converter in 2.0-mm x 2.0-mm QFN Package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "4 mm2: 2 x 2 (VQFN-HR|7)",
        "Package Group": "VQFN-HR|7",
        "\"Approx. price\n(USD)\"": "$0.658 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS63070": {
        "Description": "Wide input voltage (2V-16V) buck-boost converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck-boost inverting & split-rail converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "8 mm2: 2.5 x 3 (VQFN-HR|15)",
        "Package Group": "VQFN-HR|15",
        "\"Approx. price\n(USD)\"": "$1.007 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS54335-2A": {
        "Description": "4.5V to 28V Input 3A Synchronous Step-Down Converter With Eco-mode",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (VSON|10)",
        "Package Group": "VSON|10",
        "\"Approx. price\n(USD)\"": "$0.873 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS54388C-Q1": {
        "Description": "Automotive 2.95-V to 6-V 3-A 2-MHz synchronous buck converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": "Functional Safety-Capable",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (WQFN|16)",
        "Package Group": "WQFN|16",
        "\"Approx. price\n(USD)\"": "$0.825 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS57114C-Q1": {
        "Description": "Automotive 2.95-V to 6-V 4-A 2-MHz synchronous buck converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": "Functional Safety-Capable",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (WQFN|16)",
        "Package Group": "WQFN|16",
        "\"Approx. price\n(USD)\"": "$0.968 | 1ku",
        "Status": "ACTIVE"
    },
    "LMR23610": {
        "Description": "SIMPLE SWITCHER 36V 1A Synchronous Step-Down Converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "19 mm2: 3.9 x 4.89 (SO PowerPAD|8)",
        "Package Group": "SO PowerPAD|8",
        "\"Approx. price\n(USD)\"": "$1.258 | 1ku",
        "Status": "ACTIVE"
    },
    "LMR23625": {
        "Description": "SIMPLE SWITCHER® 36V 2.5A Synchronous Step-Down Converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "19 mm2: 3.9 x 4.89 (SO PowerPAD|8) 9 mm2: 3 x 3 (WSON|12)",
        "Package Group": "SO PowerPAD|8 WSON|12",
        "\"Approx. price\n(USD)\"": "$1.307 | 1ku",
        "Status": "ACTIVE"
    },
    "LMR23630": {
        "Description": "SIMPLE SWITCHER® 36V 3A Synchronous Step-Down Converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "19 mm2: 3.9 x 4.89 (SO PowerPAD|8) 9 mm2: 3 x 3 (WSON|12)",
        "Package Group": "SO PowerPAD|8 WSON|12",
        "\"Approx. price\n(USD)\"": "$1.355 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS61235P": {
        "Description": "8-A valley current 5.1-V fixed output voltage synchronous boost converters",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "6 mm2: 2.5 x 2.5 (VQFN-HR|9)",
        "Package Group": "VQFN-HR|9",
        "\"Approx. price\n(USD)\"": "$0.755 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS61236P": {
        "Description": "8-A valley current adjustable output voltage synchronous boost converters",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "6 mm2: 2.5 x 2.5 (VQFN-HR|9)",
        "Package Group": "VQFN-HR|9",
        "\"Approx. price\n(USD)\"": "$0.755 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS53626": {
        "Description": "2-Phase D-CAP+&trade; Step-Down Controller for VR13 CPU VCORE and DDR Memory",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck controllers (external switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 105",
        "Package size: mm2:W x L (PKG)": "16 mm2: 4 x 4 (VQFN|32)",
        "Package Group": "VQFN|32",
        "\"Approx. price\n(USD)\"": "$2.081 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS54302": {
        "Description": "4.5-V to 28-V Input 3-A Output EMI Friendly Synchronous Step-Down Converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "5 mm2: 1.6 x 2.9 (SOT-23-THIN|6)",
        "Package Group": "SOT-23-THIN|6",
        "\"Approx. price\n(USD)\"": "$0.553 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS61021A": {
        "Description": "3-A Boost Converter with 0.5-V Ultra Low Input Voltage",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "4 mm2: 2 x 2 (WSON|8)",
        "Package Group": "WSON|8",
        "\"Approx. price\n(USD)\"": "$0.387 | 1ku",
        "Status": "ACTIVE"
    },
    "TLV627432": {
        "Description": "2.15-V to 5.5-V 400-mA high efficiency buck converter with ultra-low quiescent current",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "See datasheet (DSBGA)",
        "Package Group": "DSBGA|8",
        "\"Approx. price\n(USD)\"": "$0.396 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS560200-Q1": {
        "Description": "4.5V to 17V Input 500mA Synchronous Step-Down Converter with Advanced Eco-Mode&trade;",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "15 mm2: 4.9 x 3 (VSSOP|8)",
        "Package Group": "VSSOP|8",
        "\"Approx. price\n(USD)\"": "$0.542 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS612592": {
        "Description": "3.5-MHz 5.2-V 1.5-A load boost converter in 1.2-mm x 1.3-mm WCSP",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "2 mm2: 1.4 x 1.4 (DSBGA|9)",
        "Package Group": "DSBGA|9",
        "\"Approx. price\n(USD)\"": "$0.418 | 1ku",
        "Status": "ACTIVE"
    },
    "LMR16010": {
        "Description": "SIMPLE SWITCHER 60V 1A Step-Down Converter with 40uA Iq",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "19 mm2: 3.9 x 4.89 (SO PowerPAD|8)",
        "Package Group": "SO PowerPAD|8",
        "\"Approx. price\n(USD)\"": "$1.307 | 1ku",
        "Status": "ACTIVE"
    },
    "LMR16020": {
        "Description": "SIMPLE SWITCHER 60V 2A Step-Down Converter with 40uA Iq",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "19 mm2: 3.9 x 4.89 (SO PowerPAD|8)",
        "Package Group": "SO PowerPAD|8",
        "\"Approx. price\n(USD)\"": "$1.404 | 1ku",
        "Status": "ACTIVE"
    },
    "LMR16030": {
        "Description": "SIMPLE SWITCHER 60V 3A Step-Down Converter with 40uA Iq",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "19 mm2: 3.9 x 4.89 (SO PowerPAD|8)",
        "Package Group": "SO PowerPAD|8",
        "\"Approx. price\n(USD)\"": "$1.452 | 1ku",
        "Status": "ACTIVE"
    },
    "LM53635-Q1": {
        "Description": "3.5-A 36-V synchronous 2.1-MHz automotive step-down DC-DC converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 150",
        "Package size: mm2:W x L (PKG)": "20 mm2: 4 x 5 (VQFN-HR|22)",
        "Package Group": "VQFN-HR|22",
        "\"Approx. price\n(USD)\"": "$2.227 | 1ku",
        "Status": "ACTIVE"
    },
    "LM53625-Q1": {
        "Description": "2.5-A 36-V synchronous 2.1-MHz automotive step-down DC-DC converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 150",
        "Package size: mm2:W x L (PKG)": "20 mm2: 4 x 5 (VQFN-HR|22)",
        "Package Group": "VQFN-HR|22",
        "\"Approx. price\n(USD)\"": "$2.072 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS564201": {
        "Description": "4.5 V to 17 V input 4 A output synchronous step-down converter in Eco-mode",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "5 mm2: 1.6 x 2.9 (SOT-23-THIN|6)",
        "Package Group": "SOT-23-THIN|6",
        "\"Approx. price\n(USD)\"": "$0.352 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS54202H": {
        "Description": "4.5V to 28V Input 2A Output Synchronous Step-Down Voltage Converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "5 mm2: 1.6 x 2.9 (SOT-23-THIN|6)",
        "Package Group": "SOT-23-THIN|6",
        "\"Approx. price\n(USD)\"": "$0.476 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS548D22": {
        "Description": "1.5-V to 16-V 40-A synchronous SWIFT™ buck converter with differential remote sense",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "35 mm2: 5 x 7 (LQFN-CLIP|40)",
        "Package Group": "LQFN-CLIP|40",
        "\"Approx. price\n(USD)\"": "$3.960 | 1ku",
        "Status": "ACTIVE"
    },
    "LMZ34202": {
        "Description": "4.5V to 42V 2A Step-Down Power Module in QFN Package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck modules (integrated inductor)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 105",
        "Package size: mm2:W x L (PKG)": "100 mm2: 10 x 10 (B3QFN|43)",
        "Package Group": "B3QFN|43",
        "\"Approx. price\n(USD)\"": "$3.775 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS610987": {
        "Description": "4.3-V output voltage synchronous boost converter with integrated LDO and VSUB active discharge",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "2 mm2: 1.5 x 1.5 (WSON|6)",
        "Package Group": "WSON|6",
        "\"Approx. price\n(USD)\"": "$0.481 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS61089": {
        "Description": "12.6-V 7-A Fully-Integrated Synchronous Boost Converters in 2.0-mm x 2.5-mm VQFN Package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "5 mm2: 2 x 2.5 (VQFN-HR|11)",
        "Package Group": "VQFN-HR|11",
        "\"Approx. price\n(USD)\"": "$1.065 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS54A20": {
        "Description": "Small 10-MHz 8-V to 14-V 10-A synchronous SWIFT™ series capacitor buck converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "14 mm2: 3.5 x 4 (VQFN-HR|20)",
        "Package Group": "VQFN-HR|20",
        "\"Approx. price\n(USD)\"": "$3.080 | 1ku",
        "Status": "ACTIVE"
    },
    "LM5175-Q1": {
        "Description": "42-V wide VIN 4-switch synchronous buck-boost controller AEC-Q100 qualified",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck-boost & inverting controllers (external switch)",
        "Rating": "Automotive",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "43 mm2: 4.4 x 9.7 (HTSSOP|28)",
        "Package Group": "HTSSOP|28",
        "\"Approx. price\n(USD)\"": "$3.541 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS54202": {
        "Description": "4.5V to 28V Input 2A Output EMI Friendly Synchronous Step-Down Converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "5 mm2: 1.6 x 2.9 (SOT-23-THIN|6)",
        "Package Group": "SOT-23-THIN|6",
        "\"Approx. price\n(USD)\"": "$0.500 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS564208": {
        "Description": "4.5 V to 17 V input 4 A output synchronous step-down converter in FCCM mode",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "5 mm2: 1.6 x 2.9 (SOT-23-THIN|6)",
        "Package Group": "SOT-23-THIN|6",
        "\"Approx. price\n(USD)\"": "$0.352 | 1ku",
        "Status": "ACTIVE"
    },
    "TLV62095": {
        "Description": "4A Synchronous Step Down Converter with DCS Control",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (VQFN|16)",
        "Package Group": "VQFN|16",
        "\"Approx. price\n(USD)\"": "$0.616 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62770": {
        "Description": "Tiny Single-chip Dual Solution with 360nA Iq Buck and up to 15V Boost in WCSP",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "See datasheet (DSBGA)",
        "Package Group": "DSBGA|16",
        "\"Approx. price\n(USD)\"": "$0.726 | 1ku",
        "Status": "ACTIVE"
    },
    "LM5165": {
        "Description": "3V-65V 150mA Synchronous Buck Converter With Ultra-Low IQ",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 150",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (VSON|10)",
        "Package Group": "VSON|10",
        "\"Approx. price\n(USD)\"": "$1.309 | 1ku",
        "Status": "ACTIVE"
    },
    "LM5165-Q1": {
        "Description": "Automotive 3V-65V 150mA Synchronous Buck Converter With Ultra-Low IQ",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 150",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (VSON|10) 9 mm2: 3 x 3 (VSSOP|10)",
        "Package Group": "VSON|10 VSSOP|10",
        "\"Approx. price\n(USD)\"": "$1.486 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS56C215": {
        "Description": "3.8-V to 17-V 12-A synchronous SWIFT™ buck converter with D-CAP3 control",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "12 mm2: 3.5 x 3.5 (VQFN-HR|18)",
        "Package Group": "VQFN-HR|18",
        "\"Approx. price\n(USD)\"": "$1.540 | 1ku",
        "Status": "ACTIVE"
    },
    "LM5022-Q1": {
        "Description": "6-60V Wide Vin current mode boost SEPIC and Flyback controller AEC-Q100 qualified",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost controllers (external switch)",
        "Rating": "Automotive",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (VSSOP|10)",
        "Package Group": "VSSOP|10",
        "\"Approx. price\n(USD)\"": "$0.958 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS82130": {
        "Description": "17-V input 3-A step-down converter module with integrated inductor",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck modules (integrated inductor)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "See datasheet",
        "Package Group": " --- ",
        "\"Approx. price\n(USD)\"": "$1.600 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62480": {
        "Description": "6A 2.4V-5.5V input Synchronous step-down converter with PG Output Adjust. Soft-start and Optional",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "8 mm2: 3 x 2.5 (VQFN-HR|16)",
        "Package Group": "VQFN-HR|16",
        "\"Approx. price\n(USD)\"": "$1.016 | 1ku",
        "Status": "ACTIVE"
    },
    "LM27761": {
        "Description": "Low-Noise Regulated Inverter with Integrated LDO",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Charge pumps (inductorless)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "4 mm2: 2 x 2 (WSON|8)",
        "Package Group": "WSON|8",
        "\"Approx. price\n(USD)\"": "$0.480 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS562208": {
        "Description": "4.5 V to 17 V input 2 A output synchronous step-down converter in FCCM mode",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "5 mm2: 1.6 x 2.9 (SOT-23-THIN|6)",
        "Package Group": "SOT-23-THIN|6",
        "\"Approx. price\n(USD)\"": "$0.194 | 1ku",
        "Status": "ACTIVE"
    },
    "LM5140-Q1": {
        "Description": "Wide Vin Dual 2.2MHz low Iq Synchronous Buck Controller",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck controllers (external switch)",
        "Rating": "Automotive",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 150",
        "Package size: mm2:W x L (PKG)": "36 mm2: 6 x 6 (VQFNP|40)",
        "Package Group": "VQFNP|40",
        "\"Approx. price\n(USD)\"": "$6.000 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS563208": {
        "Description": "4.5 V to 17 V input 3 A output synchronous step-down converter in FCCM mode",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "5 mm2: 1.6 x 2.9 (SOT-23-THIN|6)",
        "Package Group": "SOT-23-THIN|6",
        "\"Approx. price\n(USD)\"": "$0.271 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS610985": {
        "Description": "Low input voltage 3-V output voltage synchronous boost converter with integrated load switch",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "2 mm2: 1.5 x 1.5 (WSON|6)",
        "Package Group": "WSON|6",
        "\"Approx. price\n(USD)\"": "$0.481 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS610986": {
        "Description": "Low input voltage 3.3-V output voltage synchronous boost converter with integrated load switch",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "2 mm2: 1.5 x 1.5 (WSON|6)",
        "Package Group": "WSON|6",
        "\"Approx. price\n(USD)\"": "$0.481 | 1ku",
        "Status": "ACTIVE"
    },
    "LMR14020-Q1": {
        "Description": "SIMPLE SWITCHER® Automotive 40-V 2-A 2.2-MHz step-down converter with 40-uA IQ",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "19 mm2: 3.9 x 4.89 (SO PowerPAD|8) 16 mm2: 4 x 4 (WSON|10)",
        "Package Group": "SO PowerPAD|8 WSON|10",
        "\"Approx. price\n(USD)\"": "$1.086 | 1ku",
        "Status": "ACTIVE"
    },
    "LMR14030-Q1": {
        "Description": "SIMPLE SWITCHER® Automotive 40-V 3.5-A 2.2-MHz step-down converter with 40-uA IQ",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "19 mm2: 3.9 x 4.89 (SO PowerPAD|8) 16 mm2: 4 x 4 (WSON|10)",
        "Package Group": "SO PowerPAD|8 WSON|10",
        "\"Approx. price\n(USD)\"": "$1.199 | 1ku",
        "Status": "ACTIVE"
    },
    "LMR14050-Q1": {
        "Description": "SIMPLE SWITCHER® Automotive 40V 5A 2.2MHz Step-Down Converter with 40uA IQ",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "19 mm2: 3.9 x 4.89 (SO PowerPAD|8) 16 mm2: 4 x 4 (WSON|10)",
        "Package Group": "SO PowerPAD|8 WSON|10",
        "\"Approx. price\n(USD)\"": "$1.371 | 1ku",
        "Status": "ACTIVE"
    },
    "LM53600-Q1": {
        "Description": "Automotive 3.5-V to 36-V 650-mA synchronous 2.1-MHz step-down converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 150",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (WSON|10)",
        "Package Group": "WSON|10",
        "\"Approx. price\n(USD)\"": "$1.829 | 1ku",
        "Status": "ACTIVE"
    },
    "LM53601-Q1": {
        "Description": "Automotive 3.5-V to 36-V 1-A synchronous 2.1-MHz step-down converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 150",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (WSON|10)",
        "Package Group": "WSON|10",
        "\"Approx. price\n(USD)\"": "$1.898 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS562201": {
        "Description": "4.5 V to 17 V input 2 A output synchronous step-down converter in Eco-mode",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "5 mm2: 1.6 x 2.9 (SOT-23-THIN|6)",
        "Package Group": "SOT-23-THIN|6",
        "\"Approx. price\n(USD)\"": "$0.194 | 1ku",
        "Status": "ACTIVE"
    },
    "LM25122-Q1": {
        "Description": "3-42-V wide VIN synchronous boost controller with multiphase capability AEC-Q100 qualified",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost controllers (external switch)",
        "Rating": "Automotive",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "42 mm2: 6.4 x 6.5 (HTSSOP|20)",
        "Package Group": "HTSSOP|20",
        "\"Approx. price\n(USD)\"": "$1.694 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS563201": {
        "Description": "4.5 V to 17 V input 3 A output synchronous step-down converter in Eco-mode",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "5 mm2: 1.6 x 2.9 (SOT-23-THIN|6)",
        "Package Group": "SOT-23-THIN|6",
        "\"Approx. price\n(USD)\"": "$0.271 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS548A20": {
        "Description": "1.5-V to 20-V 15-A synchronous SWIFT™ buck converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "16 mm2: 3.5 x 4.5 (VQFN-CLIP|28)",
        "Package Group": "VQFN-CLIP|28",
        "\"Approx. price\n(USD)\"": "$2.585 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS549A20": {
        "Description": "1.5-V to 20-V 15-A synchronous SWIFT™ buck converter with PMBus",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "16 mm2: 3.5 x 4.5 (VQFN-CLIP|28)",
        "Package Group": "VQFN-CLIP|28",
        "\"Approx. price\n(USD)\"": "$3.297 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62097": {
        "Description": "2-A Step Down Converter with Selectable Switching Frequency in HotRod package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "4 mm2: 2 x 2 (VQFN-HR|11)",
        "Package Group": "VQFN-HR|11",
        "\"Approx. price\n(USD)\"": "$0.605 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS65265": {
        "Description": "4.5- to 17-V Input Voltage 5-A/3-A/2-A Output Current Triple Buck Converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "25 mm2: 5 x 5 (VQFN|32)",
        "Package Group": "VQFN|32",
        "\"Approx. price\n(USD)\"": "$1.210 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS63020-Q1": {
        "Description": "High Efficiency Automotive Single Inductor Buck-Boost Converter with 4A Switch",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck-boost inverting & split-rail converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "12 mm2: 4 x 3 (VSON|14)",
        "Package Group": "VSON|14",
        "\"Approx. price\n(USD)\"": "$1.385 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS65235": {
        "Description": "LNB voltage regulator with I2C interface",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (WQFN|20)",
        "Package Group": "WQFN|20",
        "\"Approx. price\n(USD)\"": "$0.678 | 1ku",
        "Status": "ACTIVE"
    },
    "TLV62085": {
        "Description": "3-A High Efficiency Step-Down Converter in 2x2 QFN",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "4 mm2: 2 x 2 (VSON-HR|7)",
        "Package Group": "VSON-HR|7",
        "\"Approx. price\n(USD)\"": "$0.560 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS40210-EP": {
        "Description": "Enhanced Product 4.5-V to 52-V Input Current Mode Boost Controller",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost controllers (external switch)",
        "Rating": "HiRel Enhanced Product",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-55 to 125",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (VSON|10)",
        "Package Group": "VSON|10",
        "\"Approx. price\n(USD)\"": "$2.410 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS54335-1A": {
        "Description": "4.5V to 28V Input 3A Synchronous Step-Down Converter with Eco-mode in alternative DRC package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (VSON|10)",
        "Package Group": "VSON|10",
        "\"Approx. price\n(USD)\"": "$0.873 | 1ku",
        "Status": "ACTIVE"
    },
    "LMZ36002": {
        "Description": "4.5V to 60V 2A Step-Down Power Module in QFN Package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck modules (integrated inductor)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 105",
        "Package size: mm2:W x L (PKG)": "100 mm2: 10 x 10 (B3QFN|43)",
        "Package Group": "B3QFN|43",
        "\"Approx. price\n(USD)\"": "$3.969 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62748": {
        "Description": "High-efficiency Buck Converter with Ultra-low Quiescent Current and Load Switch",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "See datasheet (DSBGA)",
        "Package Group": "DSBGA|8",
        "\"Approx. price\n(USD)\"": "$0.463 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS65400-Q1": {
        "Description": "Automotive 4.5 V to 18 V input 4 A / 4 A / 2 A / 2 A synchronous quad converter with PMBus / I2C",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "49 mm2: 7 x 7 (VQFN|48)",
        "Package Group": "VQFN|48",
        "\"Approx. price\n(USD)\"": "$2.700 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS57140-EP": {
        "Description": "TPS57140-EP 1.5-A 42-V STEP-DOWN DC-DC CONVERTER WITH Eco-mode&trade; CONTROL",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "HiRel Enhanced Product",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-55 to 125",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (VSON|10)",
        "Package Group": "VSON|10",
        "\"Approx. price\n(USD)\"": "$12.038 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS82084": {
        "Description": "2-A High-efficiency step-down converter module with integrated inductor",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck modules (integrated inductor)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "See datasheet",
        "Package Group": " --- ",
        "\"Approx. price\n(USD)\"": "$1.210 | 1ku",
        "Status": "ACTIVE"
    },
    "LM46002-Q1": {
        "Description": "Automotive Qualified 3.5V to 60V 2A Synchronous Step-Down Voltage Converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "32 mm2: 6.4 x 5 (HTSSOP|16)",
        "Package Group": "HTSSOP|16",
        "\"Approx. price\n(USD)\"": "$2.113 | 1ku",
        "Status": "ACTIVE"
    },
    "LM43601-Q1": {
        "Description": "Automotive Qualified 3.5V to 36V 1A Synchronous Step-Down Voltage Converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "32 mm2: 6.4 x 5 (HTSSOP|16)",
        "Package Group": "HTSSOP|16",
        "\"Approx. price\n(USD)\"": "$1.828 | 1ku",
        "Status": "ACTIVE"
    },
    "LM46001-Q1": {
        "Description": "Automotive Qualified 3.5 to 60V 1A Synchronous Step-Down Voltage Converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "32 mm2: 6.4 x 5 (HTSSOP|16)",
        "Package Group": "HTSSOP|16",
        "\"Approx. price\n(USD)\"": "$1.999 | 1ku",
        "Status": "ACTIVE"
    },
    "LM43600-Q1": {
        "Description": "Automotive Qualified 3.5V to 36V 0.5A Synchronous Step-Down Voltage Converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "32 mm2: 6.4 x 5 (HTSSOP|16)",
        "Package Group": "HTSSOP|16",
        "\"Approx. price\n(USD)\"": "$1.713 | 1ku",
        "Status": "ACTIVE"
    },
    "LM46000-Q1": {
        "Description": "AEC-Q100 Qualified 3.5 to 60V 0.5A Synchronous Step-Down Voltage Converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "32 mm2: 6.4 x 5 (HTSSOP|16)",
        "Package Group": "HTSSOP|16",
        "\"Approx. price\n(USD)\"": "$1.884 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS610982": {
        "Description": "Low input voltage 4.3-V output voltage synchronous boost converter with integrated LDO",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "2 mm2: 1.5 x 1.5 (WSON|6)",
        "Package Group": "WSON|6",
        "\"Approx. price\n(USD)\"": "$0.481 | 1ku",
        "Status": "ACTIVE"
    },
    "LMR16006Y-Q1": {
        "Description": "Automotive Qualified SIMPLE SWITCHER&reg; 40V (65V transient) 0.6A Buck Regulator with 28μA IQ",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "5 mm2: 1.6 x 2.9 (SOT-23-THIN|6)",
        "Package Group": "SOT-23-THIN|6",
        "\"Approx. price\n(USD)\"": "$1.371 | 1ku",
        "Status": "ACTIVE"
    },
    "LM53602-Q1": {
        "Description": "3.5 to 36Vin 2 Ampere Synchronous DC-DC Converter for Automotive Applications",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 150",
        "Package size: mm2:W x L (PKG)": "32 mm2: 6.4 x 5 (HTSSOP|16)",
        "Package Group": "HTSSOP|16",
        "\"Approx. price\n(USD)\"": "$2.024 | 1ku",
        "Status": "ACTIVE"
    },
    "LM53603-Q1": {
        "Description": "Automotive 3.5-V to 36-V 3-A synchronous step-down converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 150",
        "Package size: mm2:W x L (PKG)": "32 mm2: 6.4 x 5 (HTSSOP|16)",
        "Package Group": "HTSSOP|16",
        "\"Approx. price\n(USD)\"": "$2.130 | 1ku",
        "Status": "ACTIVE"
    },
    "LM5160-Q1": {
        "Description": "Wide Input 65V 2A Synchronous Buck / Fly-Buck™ Converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "22 mm2: 4.4 x 5 (HTSSOP|14)",
        "Package Group": "HTSSOP|14",
        "\"Approx. price\n(USD)\"": "$2.056 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS50601A-SP": {
        "Description": "Radiation-hardened QMLV 3-V to 7-V input 6-A synchronous step-down converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Space",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "\"-55 to 125\n25 to 25\"",
        "Package size: mm2:W x L (PKG)": "94 mm2: 7.38 x 12.7 (CFP|20)",
        "Package Group": "CFP|20",
        "\"Approx. price\n(USD)\"": "$2286.900 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS61098": {
        "Description": "Low input voltage 4.3-V output voltage synchronous boost converter with integrated LDO",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "2 mm2: 1.5 x 1.5 (WSON|6)",
        "Package Group": "WSON|6",
        "\"Approx. price\n(USD)\"": "$0.481 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62745": {
        "Description": "3.3V-10V input 300mA Ultra Low Iq step-down converter with VSEL and input voltage switch",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "6 mm2: 3 x 2 (WSON|12)",
        "Package Group": "WSON|12",
        "\"Approx. price\n(USD)\"": "$0.583 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS627451": {
        "Description": "10Vin Ultra Low Iq Step-Down Converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "6 mm2: 3 x 2 (WSON|12)",
        "Package Group": "WSON|12",
        "\"Approx. price\n(USD)\"": "$0.583 | 1ku",
        "Status": "ACTIVE"
    },
    "LM2776": {
        "Description": "Switched Capacitor Inverter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Charge pumps (inductorless)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "5 mm2: 1.6 x 2.9 (SOT-23|6)",
        "Package Group": "SOT-23|6",
        "\"Approx. price\n(USD)\"": "$0.326 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62746": {
        "Description": "Ultra-low-power DCDC converter with Vin-switch in WCSP",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "See datasheet (DSBGA)",
        "Package Group": "DSBGA|8",
        "\"Approx. price\n(USD)\"": "$0.463 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS8268120": {
        "Description": "1.6-A HIGH-EFFICIENCY MicroSiP™ STEP-DOWN CONVERTER Module",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck modules (integrated inductor)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "See datasheet",
        "Package Group": " --- ",
        "\"Approx. price\n(USD)\"": "$1.162 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS8268180": {
        "Description": "1.6-A High-Efficiency MicroSiP™ Step-Down Converter Module",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck modules (integrated inductor)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "See datasheet",
        "Package Group": " --- ",
        "\"Approx. price\n(USD)\"": "$1.162 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS610981": {
        "Description": "Low input voltage 3.3-V output voltage synchronous boost converter with integrated LDO",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "2 mm2: 1.5 x 1.5 (WSON|6)",
        "Package Group": "WSON|6",
        "\"Approx. price\n(USD)\"": "$0.481 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62743": {
        "Description": "2V-5.5V input ultra-low-power 300mA to 400mA step-down buck DCDC converter with 360nA Iq",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "See datasheet (DSBGA)",
        "Package Group": "DSBGA|8",
        "\"Approx. price\n(USD)\"": "$0.463 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS53647": {
        "Description": "4-Phase D-CAP+TM Step-Down Buck Controller with NVM and PMBus Interface for ASIC",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck controllers (external switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "36 mm2: 6 x 6 (WQFN|40)",
        "Package Group": "WQFN|40",
        "\"Approx. price\n(USD)\"": "$2.652 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS51275B-1": {
        "Description": "5.5-V to 24-V dual-synchronous buck controller with Out-of-Audio™ mode and 3.2 ms soft start",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck controllers (external switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (WQFN|20)",
        "Package Group": "WQFN|20",
        "\"Approx. price\n(USD)\"": "$0.303 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS54334": {
        "Description": "4.2V to 28V Input voltage 3A Output current Synchronous buck Converter with 570kHz fixed frequency",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "19 mm2: 3.9 x 4.89 (SO PowerPAD|8) 9 mm2: 3 x 3 (VSON|10)",
        "Package Group": "SO PowerPAD|8 VSON|10",
        "\"Approx. price\n(USD)\"": "$0.823 | 1ku",
        "Status": "ACTIVE"
    },
    "LM2775": {
        "Description": "2.7-V to 5.5-VIN 200-mA output current 5-V fixed output voltage doubler",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Charge pumps (inductorless)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "4 mm2: 2 x 2 (WSON|8)",
        "Package Group": "WSON|8",
        "\"Approx. price\n(USD)\"": "$0.501 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS544B25": {
        "Description": "4.5-V to 18-V 20-A synchronous SWIFT™ buck converter with PMBus and frequency sync",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "35 mm2: 5 x 7 (LQFN-CLIP|40)",
        "Package Group": "LQFN-CLIP|40",
        "\"Approx. price\n(USD)\"": "$3.511 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS544C25": {
        "Description": "4.5-V to 18-V 30-A synchronous SWIFT™ buck converter with PMBus and frequency sync",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "35 mm2: 5 x 7 (LQFN-CLIP|40)",
        "Package Group": "LQFN-CLIP|40",
        "\"Approx. price\n(USD)\"": "$3.960 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS61088": {
        "Description": "10-A Fully-Integrated Synchronous Boost Converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "16 mm2: 3.5 x 4.5 (VQFN|20)",
        "Package Group": "VQFN|20",
        "\"Approx. price\n(USD)\"": "$1.549 | 1ku",
        "Status": "ACTIVE"
    },
    "LM43602-Q1": {
        "Description": "Automotive Qualified 3.5V to 36V 2A Synchronous Step-Down Voltage Converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "32 mm2: 6.4 x 5 (HTSSOP|16)",
        "Package Group": "HTSSOP|16",
        "\"Approx. price\n(USD)\"": "$1.999 | 1ku",
        "Status": "ACTIVE"
    },
    "LM43603-Q1": {
        "Description": "Automotive Qualified 3.5V to 36V 3A Synchronous Step-Down Voltage Converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "32 mm2: 6.4 x 5 (HTSSOP|16)",
        "Package Group": "HTSSOP|16",
        "\"Approx. price\n(USD)\"": "$2.113 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS82085": {
        "Description": "3A High-Efficiency Step-Down Converter Module with Integrated Inductor",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck modules (integrated inductor)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "See datasheet",
        "Package Group": " --- ",
        "\"Approx. price\n(USD)\"": "$1.320 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS61046": {
        "Description": "28-V Output Voltage Boost Converter in WCSP Package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "See datasheet (DSBGA)",
        "Package Group": "DSBGA|6",
        "\"Approx. price\n(USD)\"": "$0.370 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS566250": {
        "Description": "4.5-V to 17-V 6-A synchronous buck converter with VID control",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "19 mm2: 3.9 x 4.89 (SO PowerPAD|8)",
        "Package Group": "SO PowerPAD|8",
        "\"Approx. price\n(USD)\"": "$0.792 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS826716": {
        "Description": "600-mA High-Efficiency MicroSiP&trade; Step-Down Converter Module (Profile <1.0mm)",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck modules (integrated inductor)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "7 mm2: 2.9 x 2.3 (uSiP|8)",
        "Package Group": "uSiP|8",
        "\"Approx. price\n(USD)\"": "$0.910 | 1ku",
        "Status": "ACTIVE"
    },
    "LM5175": {
        "Description": "42V Wide Vin 4-Switch Synchronous Buck-Boost Controller",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck-boost & inverting controllers (external switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "43 mm2: 4.4 x 9.7 (HTSSOP|28) 20 mm2: 4 x 5 (VQFN|28)",
        "Package Group": "HTSSOP|28 VQFN|28",
        "\"Approx. price\n(USD)\"": "$3.001 | 1ku",
        "Status": "ACTIVE"
    },
    "LMR14020": {
        "Description": "SIMPLE SWITCHER 4-V to 40-V 2-A 2.2-MHz step-down converter with Low IQ",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "19 mm2: 3.9 x 4.89 (SO PowerPAD|8)",
        "Package Group": "SO PowerPAD|8",
        "\"Approx. price\n(USD)\"": "$0.920 | 1ku",
        "Status": "ACTIVE"
    },
    "LMR14030": {
        "Description": "SIMPLE SWITCHER® 40-V 3.5-A 2.2-MHz step-down converter with 40-uA IQ",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "19 mm2: 3.9 x 4.89 (SO PowerPAD|8)",
        "Package Group": "SO PowerPAD|8",
        "\"Approx. price\n(USD)\"": "$1.016 | 1ku",
        "Status": "ACTIVE"
    },
    "LMR14050": {
        "Description": "SIMPLE SWITCHER® 40-V 5-A 2.2-MHz step-down converter with 40-μA IQ",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "19 mm2: 3.9 x 4.89 (SO PowerPAD|8)",
        "Package Group": "SO PowerPAD|8",
        "\"Approx. price\n(USD)\"": "$1.162 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62184": {
        "Description": "4-V to 17-V 6-A synchronous buck converter with power good 1% accuracy and adjustable soft start",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "7 mm2: 2.25 x 3.25 (DSBGA|24)",
        "Package Group": "DSBGA|24",
        "\"Approx. price\n(USD)\"": "$1.166 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS61093-Q1": {
        "Description": "Automotive 6-VIN 17-VOUT 1.1-A boost converter with integrated power diode AEC-Q100 qualified",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "6 mm2: 2.5 x 2.5 (SON|10)",
        "Package Group": "SON|10",
        "\"Approx. price\n(USD)\"": "$1.371 | 1ku",
        "Status": "ACTIVE"
    },
    "LM5160A": {
        "Description": "LM5160A Wide Input 65V 2A Synchronous Buck / Fly-Buck™ Converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "16 mm2: 4 x 4 (WSON|12)",
        "Package Group": "WSON|12",
        "\"Approx. price\n(USD)\"": "$1.742 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62134D": {
        "Description": "17-V Input Step-down Converter with Low Power Mode Input for Intel SkyLake Platform",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (VQFN|16)",
        "Package Group": "VQFN|16",
        "\"Approx. price\n(USD)\"": "$0.770 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62067-Q1": {
        "Description": "3MHz 2A Automotive Step-Down Converter in 2x2 SON Package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": "Functional Safety-Capable",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "4 mm2: 2 x 2 (WSON|8)",
        "Package Group": "WSON|8",
        "\"Approx. price\n(USD)\"": "$0.709 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS65263-Q1": {
        "Description": "4.0V-18V Vin 3A/2A/2A Triple Synchronous Buck Converter with I2C Controlled Dynamic Voltage Scaling",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "25 mm2: 5 x 5 (VQFN|32)",
        "Package Group": "VQFN|32",
        "\"Approx. price\n(USD)\"": "$2.056 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62160-Q1": {
        "Description": "3V-17V 1A Automotive Step-Down Converters in 2x2SON",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": "Functional Safety-Capable",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "4 mm2: 2 x 2 (WSON|8)",
        "Package Group": "WSON|8",
        "\"Approx. price\n(USD)\"": "$0.602 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62170-Q1": {
        "Description": "3-17V 0.5A Automotive Step-Down Converter in 2x2 QFN package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": "Functional Safety-Capable",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "4 mm2: 2 x 2 (WSON|8)",
        "Package Group": "WSON|8",
        "\"Approx. price\n(USD)\"": "$0.506 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62172-Q1": {
        "Description": "3-17V 0.5A Automotive Step-Down Converter in 2x2 QFN",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": "Functional Safety-Capable",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "4 mm2: 2 x 2 (WSON|8)",
        "Package Group": "WSON|8",
        "\"Approx. price\n(USD)\"": "$0.506 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS54335A": {
        "Description": "4.5V to 28V Input 3A Synchronous Step-Down Converter with Eco-mode",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 150",
        "Package size: mm2:W x L (PKG)": "19 mm2: 3.9 x 4.89 (SO PowerPAD|8) 9 mm2: 3 x 3 (VSON|10)",
        "Package Group": "SO PowerPAD|8 VSON|10",
        "\"Approx. price\n(USD)\"": "$0.823 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS54336A": {
        "Description": "4.5V to 28V Input 3A Synchronous Step-Down Converter with Eco-mode(tm)",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 150",
        "Package size: mm2:W x L (PKG)": "19 mm2: 3.9 x 4.89 (SO PowerPAD|8) 9 mm2: 3 x 3 (VSON|10)",
        "Package Group": "SO PowerPAD|8 VSON|10",
        "\"Approx. price\n(USD)\"": "$0.823 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS61175-Q1": {
        "Description": "3-A 40-V high voltage boost converter with soft-start and programmable switching frequency",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": "Functional Safety-Capable",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "22 mm2: 4.4 x 5 (HTSSOP|14)",
        "Package Group": "HTSSOP|14",
        "\"Approx. price\n(USD)\"": "$1.486 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62406-Q1": {
        "Description": "Automotive 2.25-MHz Fixed VOUT Dual 1000mA/400mA Step-Down Converter for ADAS Camera applications",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (VSON|10)",
        "Package Group": "VSON|10",
        "\"Approx. price\n(USD)\"": "$0.719 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62407-Q1": {
        "Description": "Automotive 2.25-MHz Fixed VOUT Dual 400mA/600mA Step-Down Converter for ADAS Camera applications",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (VSON|10)",
        "Package Group": "VSON|10",
        "\"Approx. price\n(USD)\"": "$0.719 | 1ku",
        "Status": "ACTIVE"
    },
    "LMZ20501": {
        "Description": "2.7V to 5.5V 1A High Density Nano Module",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck modules (integrated inductor)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "See datasheet",
        "Package Group": " --- ",
        "\"Approx. price\n(USD)\"": "$1.595 | 1ku",
        "Status": "ACTIVE"
    },
    "LMZ20502": {
        "Description": "2.7V to 5.5V 2A High Density Nano Module",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck modules (integrated inductor)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "See datasheet",
        "Package Group": " --- ",
        "\"Approx. price\n(USD)\"": "$1.760 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS53625": {
        "Description": "2-Phase D-CAP+™ buck controller for VR12.0 microserver",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck controllers (external switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 105",
        "Package size: mm2:W x L (PKG)": "16 mm2: 4 x 4 (VQFN|32)",
        "Package Group": "VQFN|32",
        "\"Approx. price\n(USD)\"": "$1.375 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS63024": {
        "Description": "High Efficiency 1.5A Single Inductor Buck-Boost Converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck-boost inverting & split-rail converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "See datasheet (DSBGA)",
        "Package Group": "DSBGA|20",
        "\"Approx. price\n(USD)\"": "$0.843 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS630241": {
        "Description": "High Efficiency 1.5A Single Inductor Buck-Boost Converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck-boost inverting & split-rail converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "See datasheet (DSBGA)",
        "Package Group": "DSBGA|20",
        "\"Approx. price\n(USD)\"": "$0.843 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS630242": {
        "Description": "High Efficiency 1.5A Single Inductor Buck-Boost Converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck-boost inverting & split-rail converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "See datasheet (DSBGA)",
        "Package Group": "DSBGA|20",
        "\"Approx. price\n(USD)\"": "$0.843 | 1ku",
        "Status": "ACTIVE"
    },
    "LM3281": {
        "Description": "3.3-V 1.2-A 6-MHz Mini Step-Down DC-DC Converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-30 to 90",
        "Package size: mm2:W x L (PKG)": "See datasheet (DSBGA)",
        "Package Group": "DSBGA|6",
        "\"Approx. price\n(USD)\"": "$0.539 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS65400": {
        "Description": "4.5 V to 18 V input 4 A / 4 A / 2 A / 2 A synchronous quad converter with PMBus/I2C interface",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "49 mm2: 7 x 7 (VQFN|48)",
        "Package Group": "VQFN|48",
        "\"Approx. price\n(USD)\"": "$2.051 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS8268090": {
        "Description": "1.6-A HIGH-EFFICIENCY MicroSiP™ STEP-DOWN CONVERTER Module",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck modules (integrated inductor)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "See datasheet",
        "Package Group": " --- ",
        "\"Approx. price\n(USD)\"": "$1.162 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS8268105": {
        "Description": "1.6-A HIGH-EFFICIENCY MicroSiP™ STEP-DOWN CONVERTER Module",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck modules (integrated inductor)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "See datasheet",
        "Package Group": " --- ",
        "\"Approx. price\n(USD)\"": "$1.162 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS8268150": {
        "Description": "1.6-A High-Efficency MicroSiP™ Step-Down Converter Module",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck modules (integrated inductor)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "See datasheet",
        "Package Group": " --- ",
        "\"Approx. price\n(USD)\"": "$1.162 | 1ku",
        "Status": "ACTIVE"
    },
    "LMZ21700": {
        "Description": "3V to 17V 0.65A Step-Down DC/DC Power Module in 3.5mm × 3.5mm Package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck modules (integrated inductor)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "See datasheet",
        "Package Group": " --- ",
        "\"Approx. price\n(USD)\"": "$1.709 | 1ku",
        "Status": "ACTIVE"
    },
    "LMZ21701": {
        "Description": "3V to 17V 1A Step-Down DC/DC Power Module in 3.5mm × 3.5mm Package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck modules (integrated inductor)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "See datasheet",
        "Package Group": " --- ",
        "\"Approx. price\n(USD)\"": "$1.750 | 1ku",
        "Status": "ACTIVE"
    },
    "LMR16006": {
        "Description": "SIMPLE SWITCHER&reg; 4V to 60V 600mA Step-Down Regulator with Low Iq",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "5 mm2: 1.6 x 2.9 (SOT-23-THIN|6)",
        "Package Group": "SOT-23-THIN|6",
        "\"Approx. price\n(USD)\"": "$1.162 | 1ku",
        "Status": "ACTIVE"
    },
    "LV2862": {
        "Description": "4.5-V to 60-V 600-mA buck converter in ultra-small SOT23 package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "5 mm2: 1.6 x 2.9 (SOT-23-THIN|6)",
        "Package Group": "SOT-23-THIN|6",
        "\"Approx. price\n(USD)\"": "$0.550 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS826721": {
        "Description": "600mA Fully Integrated Low Noise Step-Down Converter Module in MicroSiP&trade; Package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck modules (integrated inductor)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "7 mm2: 2.9 x 2.3 (uSiP|8)",
        "Package Group": "uSiP|8",
        "\"Approx. price\n(USD)\"": "$0.910 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS563209": {
        "Description": "17 V Input 3A Synchronous Step-Down Regulator in SOT-23",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "5 mm2: 1.6 x 2.9 (SOT-23-THIN|6)",
        "Package Group": "SOT-23-THIN|6",
        "\"Approx. price\n(USD)\"": "$0.297 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS51623": {
        "Description": "2-Phase D-CAP+™ step-down controller for VR12.1 VCPU",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck controllers (external switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 105",
        "Package size: mm2:W x L (PKG)": "16 mm2: 4 x 4 (VQFN|32)",
        "Package Group": "VQFN|32",
        "\"Approx. price\n(USD)\"": "$1.162 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS51633": {
        "Description": "3-Phase D-CAP+™ step-down controller for VR12.6/VR12.6+ VCPU",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck controllers (external switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 105",
        "Package size: mm2:W x L (PKG)": "16 mm2: 4 x 4 (VQFN|32)",
        "Package Group": "VQFN|32",
        "\"Approx. price\n(USD)\"": "$1.791 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS61291": {
        "Description": "Low Iq Boost Converter with 15nA Bypass Operation",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "4 mm2: 2 x 2 (WSON|6)",
        "Package Group": "WSON|6",
        "\"Approx. price\n(USD)\"": "$0.536 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS563200": {
        "Description": "17 V Input 3A Synchronous Step-Down Regulator in SOT-23 with Advanced Eco-mode&trade;",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "5 mm2: 1.6 x 2.9 (SOT-23-THIN|6)",
        "Package Group": "SOT-23-THIN|6",
        "\"Approx. price\n(USD)\"": "$0.297 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS53632": {
        "Description": "3-2-1 Phase D-CAP+ Step-Down Driverless Controller with I2C control",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck controllers (external switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-10 to 105",
        "Package size: mm2:W x L (PKG)": "16 mm2: 4 x 4 (VQFN|32)",
        "Package Group": "VQFN|32",
        "\"Approx. price\n(USD)\"": "$2.640 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS54561-Q1": {
        "Description": "Automotive 4.5V to 60V Input 5A Step-Down DC-DC Converter With Soft-Start and Eco-mode&trade;",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "16 mm2: 4 x 4 (WSON|10)",
        "Package Group": "WSON|10",
        "\"Approx. price\n(USD)\"": "$2.627 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62180": {
        "Description": "4-V to 15-V 6-A synchronous buck converter with power good 1% accuracy and adjustable soft start",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "7 mm2: 2.25 x 3.25 (DSBGA|24)",
        "Package Group": "DSBGA|24",
        "\"Approx. price\n(USD)\"": "$1.166 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62182": {
        "Description": "4-V to 15-V 6-A ultra-small 2-phase synchronous buck converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "7 mm2: 2.25 x 3.25 (DSBGA|24)",
        "Package Group": "DSBGA|24",
        "\"Approx. price\n(USD)\"": "$1.166 | 1ku",
        "Status": "ACTIVE"
    },
    "LM43600": {
        "Description": "3.5V to 36V 500mA Synchronous Step-Down Voltage Converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "32 mm2: 6.4 x 5 (HTSSOP|16)",
        "Package Group": "HTSSOP|16",
        "\"Approx. price\n(USD)\"": "$1.452 | 1ku",
        "Status": "ACTIVE"
    },
    "LM43601": {
        "Description": "3.5V to 36V 1A Synchronous Step-Down Voltage Converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "32 mm2: 6.4 x 5 (HTSSOP|16)",
        "Package Group": "HTSSOP|16",
        "\"Approx. price\n(USD)\"": "$1.549 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS51632-Q1": {
        "Description": "NVIDIA Tegra 2.5V to 24V 3/2/1-phase step-down controller for automotive applications",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck controllers (external switch)",
        "Rating": "Automotive",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "16 mm2: 4 x 4 (VQFN|32)",
        "Package Group": "VQFN|32",
        "\"Approx. price\n(USD)\"": "$3.341 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62134A": {
        "Description": "17-V Input Step-down Converter With Low Power Mode Input for Intel SkyLake Platform",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (VQFN|16)",
        "Package Group": "VQFN|16",
        "\"Approx. price\n(USD)\"": "$0.770 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62742": {
        "Description": "3V-5.5V input 360-nA Iq step-down converter with 400mA and integrated load switch",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "6 mm2: 3 x 2 (WSON|12)",
        "Package Group": "WSON|12",
        "\"Approx. price\n(USD)\"": "$0.484 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS57114-EP": {
        "Description": "2.95V to 6V Input 3.5-A Output 2MHz Synchronous Step Down Switcher",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "HiRel Enhanced Product",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-55 to 125",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (WQFN|16)",
        "Package Group": "WQFN|16",
        "\"Approx. price\n(USD)\"": "$3.548 | 1ku",
        "Status": "ACTIVE"
    },
    "LM46000": {
        "Description": "3.5 - 60V 500mA Synchronous Step-Down Voltage Converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "32 mm2: 6.4 x 5 (HTSSOP|16)",
        "Package Group": "HTSSOP|16",
        "\"Approx. price\n(USD)\"": "$1.597 | 1ku",
        "Status": "ACTIVE"
    },
    "LM46001": {
        "Description": "3.5 to 60V 1A Synchronous Step-Down Voltage Converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "32 mm2: 6.4 x 5 (HTSSOP|16)",
        "Package Group": "HTSSOP|16",
        "\"Approx. price\n(USD)\"": "$1.694 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS65263": {
        "Description": "4.5V to 18V Input Voltage 3A/2A/2A Output Current Step-Down Converter with I2C controlled DVS.",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "25 mm2: 5 x 5 (VQFN|32)",
        "Package Group": "VQFN|32",
        "\"Approx. price\n(USD)\"": "$1.452 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS54060-EP": {
        "Description": "TPS54060-EP- 0.5-A 60V Step Down DC/DC Converter with Eco-Mode",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "HiRel Enhanced Product",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-55 to 125",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (HVSSOP|10)",
        "Package Group": "HVSSOP|10",
        "\"Approx. price\n(USD)\"": "$2.658 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS55340-EP": {
        "Description": "Enhanced integrated 5-A 40-V wide input range boost/SEPIC/flyback DC/DC regulator",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost converters (integrated switch)",
        "Rating": "HiRel Enhanced Product",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-55 to 125",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (WQFN|16)",
        "Package Group": "WQFN|16",
        "\"Approx. price\n(USD)\"": "$3.979 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS53631": {
        "Description": "3-Phase D-CAP+TM Step-Down VR12.x Server CPU Vcore",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck controllers (external switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-10 to 105",
        "Package size: mm2:W x L (PKG)": "25 mm2: 5 x 5 (WQFN|40)",
        "Package Group": "WQFN|40",
        "\"Approx. price\n(USD)\"": "$2.372 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS53641": {
        "Description": "4-Phase D-CAP+TM Step-Down VR12.x Server CPU VCORE",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck controllers (external switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-10 to 105",
        "Package size: mm2:W x L (PKG)": "25 mm2: 5 x 5 (WQFN|40)",
        "Package Group": "WQFN|40",
        "\"Approx. price\n(USD)\"": "$2.759 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS53661": {
        "Description": "6-Phase D-CAP+&trade; Step-Down VR12.x Server CPU VCORE",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck controllers (external switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-10 to 105",
        "Package size: mm2:W x L (PKG)": "25 mm2: 5 x 5 (WQFN|40)",
        "Package Group": "WQFN|40",
        "\"Approx. price\n(USD)\"": "$3.340 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS53640": {
        "Description": "3-Phase D-CAP+&trade; Step-Down Controller with PMBus Interface for VR12/VR12.5",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck controllers (external switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-10 to 105",
        "Package size: mm2:W x L (PKG)": "25 mm2: 5 x 5 (WQFN|40)",
        "Package Group": "WQFN|40",
        "\"Approx. price\n(USD)\"": "$2.710 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS53640A": {
        "Description": "4-Phase D-CAP+&trade; Step-Down Controller with PMBus",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck controllers (external switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-10 to 105",
        "Package size: mm2:W x L (PKG)": "25 mm2: 5 x 5 (WQFN|40)",
        "Package Group": "WQFN|40",
        "\"Approx. price\n(USD)\"": "$3.001 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62133A-Q1": {
        "Description": "3V - 17V 3A AUTOMOTIVE Step-Down Converter In 3X3 QFN Package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": "Functional Safety-Capable",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (VQFN|16)",
        "Package Group": "VQFN|16",
        "\"Approx. price\n(USD)\"": "$0.895 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62153A-Q1": {
        "Description": "3–17V 1A Automotive Step-Down Converter in 3x3 QFN package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": "Functional Safety-Capable",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (VQFN|16)",
        "Package Group": "VQFN|16",
        "\"Approx. price\n(USD)\"": "$0.620 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS82740A": {
        "Description": "200-mA Step Down Converter Module with 360nA Iq",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck modules (integrated inductor)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "See datasheet",
        "Package Group": " --- ",
        "\"Approx. price\n(USD)\"": "$1.045 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS82740B": {
        "Description": "200-mA Step Down Converter Module with 360nA Iq",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck modules (integrated inductor)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "See datasheet",
        "Package Group": " --- ",
        "\"Approx. price\n(USD)\"": "$1.045 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS55340-Q1": {
        "Description": "Integrated 5-A 40-V wide input range boost/SEPIC/flyback DC/DC regulator AEC-Q100 qualified",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (WQFN|16)",
        "Package Group": "WQFN|16",
        "\"Approx. price\n(USD)\"": "$1.694 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS626765": {
        "Description": "650mA 6-MHz High-Efficiency 0.4mm Profile Chip Scale Package Step-Down Converter Vout=1.05V",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "1 mm2: 1 x 1.4 (DSBGA|6)",
        "Package Group": "DSBGA|6",
        "\"Approx. price\n(USD)\"": "$0.418 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62130A-Q1": {
        "Description": "TPS62130A-Q1 3 to 17-V 3-A Automotive Step-Down Converter in 3 × 3 QFN Package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": "Functional Safety-Capable",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (VQFN|16)",
        "Package Group": "VQFN|16",
        "\"Approx. price\n(USD)\"": "$0.895 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62150A-Q1": {
        "Description": "TPS62150A-Q1 3 to 17-V 1-A AUTOMOTIVE Step-Down Converter in 3 × 3 QFN Package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": "Functional Safety-Capable",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (VQFN|16)",
        "Package Group": "VQFN|16",
        "\"Approx. price\n(USD)\"": "$0.620 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS40428": {
        "Description": "Dual Output 2-Phase Stackable PMBus Synchronous Buck Driverless Controller",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck controllers (external switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "36 mm2: 6 x 6 (VQFN|40)",
        "Package Group": "VQFN|40",
        "\"Approx. price\n(USD)\"": "$3.388 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS544B20": {
        "Description": "4.5-V to 18-V 20-A synchronous SWIFT™ buck converter with PMBus programmability and monitoring",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "35 mm2: 5 x 7 (LQFN-CLIP|40)",
        "Package Group": "LQFN-CLIP|40",
        "\"Approx. price\n(USD)\"": "$3.650 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS544C20": {
        "Description": "4.5-V to 18-V 30-A synchronous SWIFT™ buck converter with PMBus programmability and monitoring",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "35 mm2: 5 x 7 (LQFN-CLIP|40)",
        "Package Group": "LQFN-CLIP|40",
        "\"Approx. price\n(USD)\"": "$3.960 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS630250": {
        "Description": "4-A switch single-inductor buck-boost converter in 3.7 mm² DSBGA package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck-boost inverting & split-rail converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "See datasheet (DSBGA) 8 mm2: 3 x 2.5 (VQFN-HR|14)",
        "Package Group": "DSBGA|20 VQFN-HR|14",
        "\"Approx. price\n(USD)\"": "$1.016 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS630251": {
        "Description": "4A switch Single-Inductor Buck-Boost Converter in WCSP",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck-boost inverting & split-rail converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "See datasheet (DSBGA)",
        "Package Group": "DSBGA|20",
        "\"Approx. price\n(USD)\"": "$1.016 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS630252": {
        "Description": "4A switch Single-Inductor Buck-Boost Converter in WCSP",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck-boost inverting & split-rail converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "See datasheet (DSBGA)",
        "Package Group": "DSBGA|20",
        "\"Approx. price\n(USD)\"": "$1.016 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62095": {
        "Description": "4A Synchronous Step Down Converter with DCS Control",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (VQFN|16)",
        "Package Group": "VQFN|16",
        "\"Approx. price\n(USD)\"": "$0.807 | 1ku",
        "Status": "ACTIVE"
    },
    "LM5001-Q1": {
        "Description": "3.1-V to 75-V wide VIN 1-A current mode non-synchronous switch mode regulator",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "19 mm2: 3.91 x 4.9 (SOIC|8)",
        "Package Group": "SOIC|8",
        "\"Approx. price\n(USD)\"": "$2.078 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS54361-Q1": {
        "Description": "4.5-V to 60-V Input 3.5-A Step Down DC-DC Converter with Soft-Start",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "16 mm2: 4 x 4 (WSON|10)",
        "Package Group": "WSON|10",
        "\"Approx. price\n(USD)\"": "$2.284 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62684": {
        "Description": "1600-mA High-Efficiency Step-Down Converter optimized for small solution size",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "See datasheet (DSBGA)",
        "Package Group": "DSBGA|6",
        "\"Approx. price\n(USD)\"": "$0.609 | 1ku",
        "Status": "ACTIVE"
    },
    "LM43602": {
        "Description": "3.5V to 36V 2A Synchronous Step-Down Voltage Converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "32 mm2: 6.4 x 5 (HTSSOP|16) 20 mm2: 4 x 5 (SON|16)",
        "Package Group": "HTSSOP|16 SON|16",
        "\"Approx. price\n(USD)\"": "$1.694 | 1ku",
        "Status": "ACTIVE"
    },
    "LM43603": {
        "Description": "3.5V to 36V 3A Synchronous Step-Down Voltage Converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "32 mm2: 6.4 x 5 (HTSSOP|16) 20 mm2: 4 x 5 (SON|16)",
        "Package Group": "HTSSOP|16 SON|16",
        "\"Approx. price\n(USD)\"": "$1.791 | 1ku",
        "Status": "ACTIVE"
    },
    "LM46002": {
        "Description": "3.5V to 60V 2A Synchronous Step-Down Voltage Converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "32 mm2: 6.4 x 5 (HTSSOP|16)",
        "Package Group": "HTSSOP|16",
        "\"Approx. price\n(USD)\"": "$1.791 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS61230": {
        "Description": "5-A adjustable output voltage high efficiency synchronous boost converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (VSON|10)",
        "Package Group": "VSON|10",
        "\"Approx. price\n(USD)\"": "$0.920 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS82692": {
        "Description": "800-mA High-Efficiency MicroSiP&trade; Step-Down Converter Module",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck modules (integrated inductor)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "7 mm2: 2.9 x 2.3 (uSiP|8)",
        "Package Group": "uSiP|8",
        "\"Approx. price\n(USD)\"": "$0.968 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS826951": {
        "Description": "High-Efficiency MicroSiP&trade; Step-Down Converter Module (PROFILE <1mm)",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck modules (integrated inductor)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "7 mm2: 2.9 x 2.3 (uSiP|8)",
        "Package Group": "uSiP|8",
        "\"Approx. price\n(USD)\"": "$0.968 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS40425": {
        "Description": "Dual Output 2-Phase Stackable PMBUS Synchronous Buck Driverless Controller",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck controllers (external switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "36 mm2: 6 x 6 (VQFN|40)",
        "Package Group": "VQFN|40",
        "\"Approx. price\n(USD)\"": "$3.146 | 1ku",
        "Status": "ACTIVE"
    },
    "TLV62084": {
        "Description": "2A High Efficient Step Down Converter in 2x2mm SON Package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "4 mm2: 2 x 2 (WSON|8)",
        "Package Group": "WSON|8",
        "\"Approx. price\n(USD)\"": "$0.506 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS63050": {
        "Description": "TPS6305x Single Inductor Buck-Boost with 1-A Switches and Adjustable Soft Start",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck-boost inverting & split-rail converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "2 mm2: 1.16 x 2 (DSBGA|12) 6 mm2: 2.5 x 2.5 (VQFN-HR|12)",
        "Package Group": "DSBGA|12 VQFN-HR|12",
        "\"Approx. price\n(USD)\"": "$0.678 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS562200": {
        "Description": "17 V Input 2A Synchronous Step-Down Regulator in SOT-23 with Advanced Eco-mode&trade;",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "5 mm2: 1.6 x 2.9 (SOT-23-THIN|6)",
        "Package Group": "SOT-23-THIN|6",
        "\"Approx. price\n(USD)\"": "$0.209 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS562209": {
        "Description": "17 V Input 2A Synchronous Step-Down Regulator in SOT-23",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "5 mm2: 1.6 x 2.9 (SOT-23-THIN|6)",
        "Package Group": "SOT-23-THIN|6",
        "\"Approx. price\n(USD)\"": "$0.209 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS61097A-33": {
        "Description": "0.9Vin 3.3Vout Boost Converter with Bypass Switch - 5nA Shutdown Current",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "5 mm2: 1.6 x 2.9 (SOT-23|5)",
        "Package Group": "SOT-23|5",
        "\"Approx. price\n(USD)\"": "$0.678 | 1ku",
        "Status": "ACTIVE"
    },
    "LMZ10500": {
        "Description": "5.5V 0.5A Step-Down DC/DC Power Module in 3mm × 2.6mm Package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck modules (integrated inductor)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "See datasheet",
        "Package Group": " --- ",
        "\"Approx. price\n(USD)\"": "$1.265 | 1ku",
        "Status": "ACTIVE"
    },
    "LMZ10501": {
        "Description": "5.5V 1A Step-Down DC/DC Power Module in 3mm × 2.6mm Package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck modules (integrated inductor)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "See datasheet",
        "Package Group": " --- ",
        "\"Approx. price\n(USD)\"": "$1.650 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS65279": {
        "Description": "4.5-V to 18-V Input Dual 5-A Synchronous Step-Down Converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "68 mm2: 6.2 x 11 (HTSSOP|32) 36 mm2: 6 x 6 (VQFN|36)",
        "Package Group": "HTSSOP|32 VQFN|36",
        "\"Approx. price\n(USD)\"": "$1.839 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS63060-EP": {
        "Description": "HIGH INPUT VOLTAGE BUCK-BOOST CONVERTER WITH 2-A SWITCH CURRENT",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck-boost inverting & split-rail converters (integrated switch)",
        "Rating": "HiRel Enhanced Product",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-55 to 125",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (WSON|10)",
        "Package Group": "WSON|10",
        "\"Approx. price\n(USD)\"": "$4.954 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS626751": {
        "Description": "500-mA 6-MHz High-Efficiency Step-Down Converter Vout=1.2V",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "1 mm2: 1 x 1.4 (DSBGA|6)",
        "Package Group": "DSBGA|6",
        "\"Approx. price\n(USD)\"": "$0.418 | 1ku",
        "Status": "ACTIVE"
    },
    "LMZ31520": {
        "Description": "3V to 14.5V 20A Step-Down Power Module in 15x16x5.8mm QFN Package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck modules (integrated inductor)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "240 mm2: 15 x 16 (BQFN|72)",
        "Package Group": "BQFN|72",
        "\"Approx. price\n(USD)\"": "$14.364 | 1ku",
        "Status": "ACTIVE"
    },
    "LMZ31530": {
        "Description": "3V to 14.5V 30A Step-Down Power Module in 15x16x5.8mm QFN Package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck modules (integrated inductor)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "240 mm2: 15 x 16 (BQFN|72)",
        "Package Group": "BQFN|72",
        "\"Approx. price\n(USD)\"": "$14.036 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS65261": {
        "Description": "4.5V to 18V Input Voltage 3A/2A/2A Output Current Triple Synchronous Buck Converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "25 mm2: 5 x 5 (VQFN|32)",
        "Package Group": "VQFN|32",
        "\"Approx. price\n(USD)\"": "$1.065 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS65261-1": {
        "Description": "4.5V to 18V Input Voltage 3A/2A/2A Output Current Triple Synchronous",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "25 mm2: 5 x 5 (VQFN|32)",
        "Package Group": "VQFN|32",
        "\"Approx. price\n(USD)\"": "$1.065 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS54341": {
        "Description": "4.5 to 42V Input 3.5A Step-Down DC-DC Converter With Soft-Start and Eco-mode&trade;",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "16 mm2: 4 x 4 (WSON|10)",
        "Package Group": "WSON|10",
        "\"Approx. price\n(USD)\"": "$1.597 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS54361": {
        "Description": "4.5 to 60V Input 3.5A Step-Down DC-DC Converter With Soft-Start and Eco-mode&trade;",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "16 mm2: 4 x 4 (WSON|10)",
        "Package Group": "WSON|10",
        "\"Approx. price\n(USD)\"": "$1.936 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS54561": {
        "Description": "4.5V to 60V Input 5A Step-Down DC-DC Converter With Soft-Start and Eco-mode&trade;",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "16 mm2: 4 x 4 (WSON|10)",
        "Package Group": "WSON|10",
        "\"Approx. price\n(USD)\"": "$2.226 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS54541": {
        "Description": "4.5V to 42V Input 5A Step-Down DC-DC Converter With Soft-Start and Eco-mode&trade;",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "16 mm2: 4 x 4 (WSON|10)",
        "Package Group": "WSON|10",
        "\"Approx. price\n(USD)\"": "$1.839 | 1ku",
        "Status": "ACTIVE"
    },
    "LMR14006": {
        "Description": "SIMPLE SWITCHER® 4-V to 40-V 600-mA step-down converter with Low Iq",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "5 mm2: 1.6 x 2.9 (SOT-23-THIN|6)",
        "Package Group": "SOT-23-THIN|6",
        "\"Approx. price\n(USD)\"": "$0.774 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS82697": {
        "Description": "800-mA High-Efficiency MicroSiP&trade; Step-Down Converter (Profile <1mm)",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck modules (integrated inductor)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "7 mm2: 2.9 x 2.3 (uSiP|8)",
        "Package Group": "uSiP|8",
        "\"Approx. price\n(USD)\"": "$0.968 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS563900": {
        "Description": "18V Input 3.5A/3.5A Dual Synchronous Step-down Regulator with Voltage Scaling",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "68 mm2: 6.2 x 11 (HTSSOP|32)",
        "Package Group": "HTSSOP|32",
        "\"Approx. price\n(USD)\"": "$1.646 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS53915": {
        "Description": "1.5-V to 18-V 12-A synchronous SWIFT™ buck converter with PMBus",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "16 mm2: 3.5 x 4.5 (VQFN-CLIP|28)",
        "Package Group": "VQFN-CLIP|28",
        "\"Approx. price\n(USD)\"": "$3.010 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS53513": {
        "Description": "1.5-V to 18-V 8-A synchronous SWIFT™ buck converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "16 mm2: 3.5 x 4.5 (VQFN-CLIP|28)",
        "Package Group": "VQFN-CLIP|28",
        "\"Approx. price\n(USD)\"": "$2.035 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS53515": {
        "Description": "1.5-V to 18-V 12-A synchronous SWIFT™ buck converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "16 mm2: 3.5 x 4.5 (VQFN-CLIP|28)",
        "Package Group": "VQFN-CLIP|28",
        "\"Approx. price\n(USD)\"": "$2.614 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS54418A": {
        "Description": "2.95V to 6V Input 4A Synchronous Step-Down SWIFT&trade; Converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 150",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (WQFN|16)",
        "Package Group": "WQFN|16",
        "\"Approx. price\n(USD)\"": "$1.031 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS56520": {
        "Description": "17V Input 5A Synchronous Step-Down Regulator with Voltage Scaling",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "42 mm2: 6.4 x 6.5 (HTSSOP|20)",
        "Package Group": "HTSSOP|20",
        "\"Approx. price\n(USD)\"": "$1.029 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS56628": {
        "Description": "4.5-V to 18-V 6-A synchronous buck converter with eco-mode",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "19 mm2: 3.9 x 4.89 (SO PowerPAD|8)",
        "Package Group": "SO PowerPAD|8",
        "\"Approx. price\n(USD)\"": "$0.660 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS56C20": {
        "Description": "4.5-V to 17-V 12-A synchronous buck converter with voltage scaling",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "34 mm2: 4.4 x 7.8 (HTSSOP|24)",
        "Package Group": "HTSSOP|24",
        "\"Approx. price\n(USD)\"": "$2.173 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62740": {
        "Description": "2.2V-5.5V input ultra-low-power 300mA step-down buck DCDC converter with 360nA Iq",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "6 mm2: 3 x 2 (WSON|12)",
        "Package Group": "WSON|12",
        "\"Approx. price\n(USD)\"": "$0.455 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS51678": {
        "Description": "2-Phase D-CAP+TM Step-Down Controller for VR12.6 V.CPU",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck controllers (external switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 105",
        "Package size: mm2:W x L (PKG)": "16 mm2: 4 x 4 (VQFN|32)",
        "Package Group": "VQFN|32",
        "\"Approx. price\n(USD)\"": "$1.791 | 1ku",
        "Status": "ACTIVE"
    },
    "LMZ31704": {
        "Description": "2.95V to 17V 4A Step-Down Power Module with Current Sharing in 10x10x4.3mm QFN Package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck modules (integrated inductor)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "100 mm2: 10 x 10 (B3QFN|42)",
        "Package Group": "B3QFN|42",
        "\"Approx. price\n(USD)\"": "$3.465 | 1ku",
        "Status": "ACTIVE"
    },
    "LMZ31707": {
        "Description": "2.95V to 17V 7A Step-Down Power Module with Current Sharing in 10x10x4.3mm QFN Package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck modules (integrated inductor)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "100 mm2: 10 x 10 (B3QFN|42)",
        "Package Group": "B3QFN|42",
        "\"Approx. price\n(USD)\"": "$5.082 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS40007-DIE": {
        "Description": "Low Input High-Efficiency Synchronous Buck Controller TPS40007-DIE",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck controllers (external switch)",
        "Rating": "Military",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "25 to 25",
        "Package size: mm2:W x L (PKG)": "See datasheet",
        "Package Group": " --- ",
        "\"Approx. price\n(USD)\"": "$5.950 | 1ku",
        "Status": "ACTIVE"
    },
    "TLV62565": {
        "Description": "1.5A Buck Converter in SOT23 Package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "5 mm2: 1.6 x 2.9 (SOT-23|5)",
        "Package Group": "SOT-23|5",
        "\"Approx. price\n(USD)\"": "$0.330 | 1ku",
        "Status": "ACTIVE"
    },
    "TLV62566": {
        "Description": "1.5A Buck Converter with Power Good in SOT23 Package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "5 mm2: 1.6 x 2.9 (SOT-23|5)",
        "Package Group": "SOT-23|5",
        "\"Approx. price\n(USD)\"": "$0.330 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62085": {
        "Description": "3-A Step-Down Converter with DCS-Control and Hiccup Short Circuit Protection in 2x2 HotRod Package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "4 mm2: 2 x 2 (VSON-HR|7)",
        "Package Group": "VSON-HR|7",
        "\"Approx. price\n(USD)\"": "$0.784 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62086": {
        "Description": "3-A Step-Down Converter with DCS-Control and Hiccup Short Circuit Protection in 2x2 QFN Package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "4 mm2: 2 x 2 (VSON-HR|7)",
        "Package Group": "VSON-HR|7",
        "\"Approx. price\n(USD)\"": "$0.784 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62087": {
        "Description": "3-A Step-Down Converter with DCS-Control and Hiccup Short Circuit Protection in 2x2 QFN Package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "4 mm2: 2 x 2 (VSON-HR|7)",
        "Package Group": "VSON-HR|7",
        "\"Approx. price\n(USD)\"": "$0.784 | 1ku",
        "Status": "ACTIVE"
    },
    "LM5116-HT": {
        "Description": "80V High Temperature Wide Range Synchronous Buck Controller",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck controllers (external switch)",
        "Rating": "High Temp",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-55 to 175",
        "Package size: mm2:W x L (PKG)": "189 mm2: 7.37 x 25.65 (CDIP SB|20)",
        "Package Group": "CDIP SB|20",
        "\"Approx. price\n(USD)\"": "$141.750 | 100u",
        "Status": "ACTIVE"
    },
    "LM3248": {
        "Description": "2.5A Adjustable Boost-Buck RF DC/DC Converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-30 to 90",
        "Package size: mm2:W x L (PKG)": "See datasheet (DSBGA)",
        "Package Group": "DSBGA|30",
        "\"Approx. price\n(USD)\"": "$0.935 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS51624": {
        "Description": "4.5 V to 28 V 1/2-phase step-down driverless controller for Intel VR12.6 CPUs",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck controllers (external switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 105",
        "Package size: mm2:W x L (PKG)": "16 mm2: 4 x 4 (VQFN|32)",
        "Package Group": "VQFN|32",
        "\"Approx. price\n(USD)\"": "$1.597 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS65581": {
        "Description": "4.5V to 20V Input 3.3V 3A Synchronous Step-Down SWIFT&trade; Converter w/ Low-Side Gate Driver",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "42 mm2: 6.4 x 6.5 (HTSSOP|20)",
        "Package Group": "HTSSOP|20",
        "\"Approx. price\n(USD)\"": "$1.452 | 1ku",
        "Status": "ACTIVE"
    },
    "LM5121": {
        "Description": "3-65V Wide Vin Current Mode Synchronous Boost with Disconnection Switch Control",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost controllers (external switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "42 mm2: 6.4 x 6.5 (HTSSOP|20)",
        "Package Group": "HTSSOP|20",
        "\"Approx. price\n(USD)\"": "$1.742 | 1ku",
        "Status": "ACTIVE"
    },
    "LM5121-Q1": {
        "Description": "Automotive 3-65-V wide VIN current mode synchronous boost with disconnection switch control",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost controllers (external switch)",
        "Rating": "Automotive",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "42 mm2: 6.4 x 6.5 (HTSSOP|20)",
        "Package Group": "HTSSOP|20",
        "\"Approx. price\n(USD)\"": "$2.056 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS560200": {
        "Description": "17V Input 500mA Synchronous Step-Down Regulator in SOT-23 with Advanced Eco-Mode&trade;",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "5 mm2: 1.6 x 2.9 (SOT-23|5)",
        "Package Group": "SOT-23|5",
        "\"Approx. price\n(USD)\"": "$0.265 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS65580": {
        "Description": "4.5 to 18V Input 2.5A/1.5A/1.5A Triple Sync. Step-Down Converter w/ Advanced D-CAP2&trade;",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "42 mm2: 6.4 x 6.5 (HTSSOP|20)",
        "Package Group": "HTSSOP|20",
        "\"Approx. price\n(USD)\"": "$1.452 | 1ku",
        "Status": "ACTIVE"
    },
    "LMZ30604": {
        "Description": "2.95V to 6V 4A Step-Down Power Module in 9x11x2.8mm QFN Package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck modules (integrated inductor)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "99 mm2: 9 x 11 (B1QFN|39)",
        "Package Group": "B1QFN|39",
        "\"Approx. price\n(USD)\"": "$3.080 | 1ku",
        "Status": "ACTIVE"
    },
    "LMZ30606": {
        "Description": "2.95V to 6V 6A Step-Down Power Module in 9x11x2.8mm QFN Package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck modules (integrated inductor)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "99 mm2: 9 x 11 (B1QFN|39)",
        "Package Group": "B1QFN|39",
        "\"Approx. price\n(USD)\"": "$3.850 | 1ku",
        "Status": "ACTIVE"
    },
    "LMZ31503": {
        "Description": "4.5V to 15V 3A Step-Down Power Module in 9x15x2.8mm QFN Package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck modules (integrated inductor)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "135 mm2: 9 x 15 (B1QFN|47)",
        "Package Group": "B1QFN|47",
        "\"Approx. price\n(USD)\"": "$4.125 | 1ku",
        "Status": "ACTIVE"
    },
    "LMZ31506": {
        "Description": "4.5V to 15V 6A Step-Down Power Module in 9x15x2.8mm QFN Package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck modules (integrated inductor)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "135 mm2: 9 x 15 (B1QFN|47)",
        "Package Group": "B1QFN|47",
        "\"Approx. price\n(USD)\"": "$5.777 | 1ku",
        "Status": "ACTIVE"
    },
    "LMZ31506H": {
        "Description": "6A Power Module with 4.5V-14.5V Input in QFN package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck modules (integrated inductor)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "135 mm2: 9 x 15 (B1QFN|47)",
        "Package Group": "B1QFN|47",
        "\"Approx. price\n(USD)\"": "$5.500 | 1ku",
        "Status": "ACTIVE"
    },
    "LMZ31710": {
        "Description": "2.95V to 17V 10A Step-Down Power Module with Current Sharing in 10x10x4.3mm QFN Package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck modules (integrated inductor)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "100 mm2: 10 x 10 (B3QFN|42)",
        "Package Group": "B3QFN|42",
        "\"Approx. price\n(USD)\"": "$6.716 | 1ku",
        "Status": "ACTIVE"
    },
    "LMZ35003": {
        "Description": "7V to 50V 2.5A Step-Down Power Module in 9x11x2.8mm QFN Package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck modules (integrated inductor)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "99 mm2: 9 x 11 (B1QFN|41)",
        "Package Group": "B1QFN|41",
        "\"Approx. price\n(USD)\"": "$7.696 | 1ku",
        "Status": "ACTIVE"
    },
    "LMZ30602": {
        "Description": "2.95V to 6V 2A Step-Down Power Module in 9x11x2.8mm QFN Package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck modules (integrated inductor)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "99 mm2: 9 x 11 (B1QFN|39)",
        "Package Group": "B1QFN|39",
        "\"Approx. price\n(USD)\"": "$2.420 | 1ku",
        "Status": "ACTIVE"
    },
    "LMZ34002": {
        "Description": "4.5-V to 40-V 2-A Negative output power module",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck-boost & inverting modules (integrated inductor)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "99 mm2: 9 x 11 (B1QFN|41)",
        "Package Group": "B1QFN|41",
        "\"Approx. price\n(USD)\"": "$6.534 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS51622A": {
        "Description": "2-Phase D-CAP+&trade; Step-Down Controller for VR12.6 Vcpu",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck controllers (external switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "16 mm2: 4 x 4 (VQFN|32)",
        "Package Group": "VQFN|32",
        "\"Approx. price\n(USD)\"": "$0.660 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS51631A": {
        "Description": "3-Phase D-CAP+&trade; Step-Down Controller for VR12.5 Vcpu",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck controllers (external switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 105",
        "Package size: mm2:W x L (PKG)": "16 mm2: 4 x 4 (VQFN|32)",
        "Package Group": "VQFN|32",
        "\"Approx. price\n(USD)\"": "$1.791 | 1ku",
        "Status": "ACTIVE"
    },
    "LM27403": {
        "Description": "3-V to 20-V voltage-mode synchronous buck controller and temperature-compensated DCR current sensing",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck controllers (external switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "16 mm2: 4 x 4 (WQFN|24)",
        "Package Group": "WQFN|24",
        "\"Approx. price\n(USD)\"": "$0.920 | 1ku",
        "Status": "ACTIVE"
    },
    "LM34919C-Q1": {
        "Description": "Automotive 4.5-50V Wide Vin 600mA 2.6MHz Ultra-Small Constant On-Time Non-Synchronous Buck Regulator",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "4 mm2: 1.8 x 2 (DSBGA|12) 16 mm2: 4 x 4 (WSON|12)",
        "Package Group": "DSBGA|12 WSON|12",
        "\"Approx. price\n(USD)\"": "$0.974 | 1ku",
        "Status": "ACTIVE"
    },
    "LMR12007": {
        "Description": "750mA Load Step-Down DC/DC Regulator in Thin SOT23 Package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "5 mm2: 1.6 x 2.9 (SOT-23-THIN|6)",
        "Package Group": "SOT-23-THIN|6",
        "\"Approx. price\n(USD)\"": "$0.617 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS61232": {
        "Description": "5-A 5-V fixed output voltage high efficiency synchronous boost converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (VSON|10)",
        "Package Group": "VSON|10",
        "\"Approx. price\n(USD)\"": "$0.920 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS54625": {
        "Description": "4.5-V to 18-V 6.5-A synchronous buck converter in HTSSOP package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "22 mm2: 4.4 x 5 (HTSSOP|14)",
        "Package Group": "HTSSOP|14",
        "\"Approx. price\n(USD)\"": "$0.847 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS54626": {
        "Description": "4.5-V to 18-V 6.5-A synchronous buck converter with eco-mode in HTSSOP package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "22 mm2: 4.4 x 5 (HTSSOP|14)",
        "Package Group": "HTSSOP|14",
        "\"Approx. price\n(USD)\"": "$0.867 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62090-Q1": {
        "Description": "Automotive: 3A 2.5 to 6V input up to 97% efficiency 3x3 QFN Step-Down Converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (VQFN|16)",
        "Package Group": "VQFN|16",
        "\"Approx. price\n(USD)\"": "$0.925 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62065-Q1": {
        "Description": "3MHz 2A Automotive Step-Down Converter in 2x2 SON Package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": "Functional Safety-Capable",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "4 mm2: 2 x 2 (WSON|8)",
        "Package Group": "WSON|8",
        "\"Approx. price\n(USD)\"": "$0.709 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS63051": {
        "Description": "Tiny Single Inductor Buck Boost Converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck-boost inverting & split-rail converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "2 mm2: 1.16 x 2 (DSBGA|12) 6 mm2: 2.5 x 2.5 (VQFN-HR|12)",
        "Package Group": "DSBGA|12 VQFN-HR|12",
        "\"Approx. price\n(USD)\"": "$0.678 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS82698": {
        "Description": "700-mA High-Efficiency MicroSiP&trade; Step-Down Converter (PROFILE <1mm)",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck modules (integrated inductor)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "7 mm2: 2.9 x 2.3 (uSiP|8)",
        "Package Group": "uSiP|8",
        "\"Approx. price\n(USD)\"": "$0.968 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62130A": {
        "Description": "3-V to 17-V 3-A step-down converter with DCS-control in 3x3 QFN package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (VQFN|16)",
        "Package Group": "VQFN|16",
        "\"Approx. price\n(USD)\"": "$0.635 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62737": {
        "Description": "Programmable Output Voltage Ultra-Low Power Buck Converter with up to 200 mA Output Current",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 105",
        "Package size: mm2:W x L (PKG)": "12 mm2: 3.5 x 3.5 (VQFN|14)",
        "Package Group": "VQFN|14",
        "\"Approx. price\n(USD)\"": "$2.443 | 1ku",
        "Status": "ACTIVE"
    },
    "LM3017": {
        "Description": "High Efficiency Low-Side Controller with True Shutdown",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost controllers (external switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "6 mm2: 2.4 x 2.7 (WQFN|10)",
        "Package Group": "WQFN|10",
        "\"Approx. price\n(USD)\"": "$0.618 | 1ku",
        "Status": "ACTIVE"
    },
    "TLV62150A": {
        "Description": "4-17V 1A STEP-DOWN CONVERTER with DCS-Control in 3x3 QFN Package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (VQFN|16)",
        "Package Group": "VQFN|16",
        "\"Approx. price\n(USD)\"": "$0.452 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62150A": {
        "Description": "3-17V 1A 3MHz Step-Down Converter with DCS-Control in 3x3 QFN Package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (VQFN|16)",
        "Package Group": "VQFN|16",
        "\"Approx. price\n(USD)\"": "$0.525 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62140A": {
        "Description": "3–17V 2A Step-Down Converter with DCS-Control in 3x3 QFN package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (VQFN|16)",
        "Package Group": "VQFN|16",
        "\"Approx. price\n(USD)\"": "$0.593 | 1ku",
        "Status": "ACTIVE"
    },
    "LM3263": {
        "Description": "High-Current Step-Down DC/DC Converter with MIPI® RF Front-End Interface",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-30 to 90",
        "Package size: mm2:W x L (PKG)": "See datasheet (DSBGA)",
        "Package Group": "DSBGA|16",
        "\"Approx. price\n(USD)\"": "$0.440 | 1ku",
        "Status": "ACTIVE"
    },
    "TLV62130A": {
        "Description": "3-17V 3A Step-Down Converter with DCS-Control in 3x3 QFN Package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (VQFN|16)",
        "Package Group": "VQFN|16",
        "\"Approx. price\n(USD)\"": "$0.550 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS65133": {
        "Description": "Split-Rail Converter ±5V 250mA Dual Output Power Supply",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck-boost inverting & split-rail converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (WSON|12)",
        "Package Group": "WSON|12",
        "\"Approx. price\n(USD)\"": "$0.836 | 1ku",
        "Status": "ACTIVE"
    },
    "LM5122": {
        "Description": "3-65V Wide Vin Current Mode Synchronous Boost Controller with Multiphase Capability",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost controllers (external switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "34 mm2: 4.4 x 7.8 (HTSSOP|24) 42 mm2: 6.4 x 6.5 (HTSSOP|20)",
        "Package Group": "HTSSOP|20 HTSSOP|24",
        "\"Approx. price\n(USD)\"": "$1.742 | 1ku",
        "Status": "ACTIVE"
    },
    "LM5122-Q1": {
        "Description": "Automotive 3-V to 65-V wide VIN current mode synchronous boost controller with multiphase",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost controllers (external switch)",
        "Rating": "Automotive",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "42 mm2: 6.4 x 6.5 (HTSSOP|20)",
        "Package Group": "HTSSOP|20",
        "\"Approx. price\n(USD)\"": "$2.056 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS65132": {
        "Description": "Split-Rail Single Inductor Dual Output Converter with Positive and Negative Outputs",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck-boost inverting & split-rail converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "See datasheet (DSBGA) 12 mm2: 4 x 3 (WQFN|20)",
        "Package Group": "DSBGA|15 WQFN|20",
        "\"Approx. price\n(USD)\"": "$0.396 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS54540": {
        "Description": "42 V 5 A Step-Down DC-DC Converter with Eco-Mode",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "19 mm2: 3.9 x 4.89 (SO PowerPAD|8)",
        "Package Group": "SO PowerPAD|8",
        "\"Approx. price\n(USD)\"": "$1.714 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS55330": {
        "Description": "Integrated 5-A 24-V Wide Input Range Boost/SEPIC/Flyback DC-DC Regulator",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 150",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (WQFN|16)",
        "Package Group": "WQFN|16",
        "\"Approx. price\n(USD)\"": "$0.930 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62402-Q1": {
        "Description": "Automotive Catalog Dual Fixed Vout 400mA & 600mA 2.25MHz Step-Down Converter w/ 1-Wire Interface",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (VSON|10)",
        "Package Group": "VSON|10",
        "\"Approx. price\n(USD)\"": "$0.719 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62405-Q1": {
        "Description": "Automotive Catalog Dual Fixed Vout 400mA & 600mA 2.25MHz Step-Down Converter w/ 1-Wire Interface",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (VSON|10)",
        "Package Group": "VSON|10",
        "\"Approx. price\n(USD)\"": "$0.719 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS54531": {
        "Description": "3.5V to 28V Input 5A 570kHz Step-Down Converter with Eco-mode",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "19 mm2: 3.9 x 4.89 (SO PowerPAD|8)",
        "Package Group": "SO PowerPAD|8",
        "\"Approx. price\n(USD)\"": "$0.645 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS54627": {
        "Description": "4.5-V to 18-V 6-A synchronous buck converter in HTSSOP package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "19 mm2: 3.9 x 4.89 (SO PowerPAD|8)",
        "Package Group": "SO PowerPAD|8",
        "\"Approx. price\n(USD)\"": "$1.640 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS54628": {
        "Description": "4.5-V to 18-V 6-A synchronous buck converter with eco-mode in HTSSOP package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 150",
        "Package size: mm2:W x L (PKG)": "19 mm2: 3.9 x 4.89 (SO PowerPAD|8)",
        "Package Group": "SO PowerPAD|8",
        "\"Approx. price\n(USD)\"": "$1.660 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS65251-1": {
        "Description": "4.5-V to 18-V input 3A/2A/2A output Synchronous triple buck converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "36 mm2: 6 x 6 (VQFN|40)",
        "Package Group": "VQFN|40",
        "\"Approx. price\n(USD)\"": "$1.549 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS65251-2": {
        "Description": "4.5-V to 18-V input 3A/2A/2A output Synchronous triple buck converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "36 mm2: 6 x 6 (VQFN|40)",
        "Package Group": "VQFN|40",
        "\"Approx. price\n(USD)\"": "$1.549 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS65251-3": {
        "Description": "4.5-V to 18-V input 3A/2A/2A output Synchronous triple buck converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "36 mm2: 6 x 6 (VQFN|40)",
        "Package Group": "VQFN|40",
        "\"Approx. price\n(USD)\"": "$1.549 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS56428": {
        "Description": "4.5V to 18V Input 4-A Synchronous Step-Down Converter with Advanced Eco-mode™",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "19 mm2: 3.9 x 4.89 (SO PowerPAD|8) 12 mm2: 3.5 x 3.5 (VQFN|14)",
        "Package Group": "SO PowerPAD|8 VQFN|14",
        "\"Approx. price\n(USD)\"": "$0.418 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS56528": {
        "Description": "4.5V to 18V Input 5-A Synchronous Step-Down Converter with Advanced Eco-mode™",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "19 mm2: 3.9 x 4.89 (SO PowerPAD|8)",
        "Package Group": "SO PowerPAD|8",
        "\"Approx. price\n(USD)\"": "$0.418 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS51285A": {
        "Description": "5-V to 24-V dual-synchronous buck controller with 3.2 ms soft start",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck controllers (external switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (WQFN|20)",
        "Package Group": "WQFN|20",
        "\"Approx. price\n(USD)\"": "$0.561 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS51285B": {
        "Description": "5-V to 24-V dual-synchronous buck controller with ultra-low quiescent current",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck controllers (external switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (WQFN|20)",
        "Package Group": "WQFN|20",
        "\"Approx. price\n(USD)\"": "$0.561 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS40170-EP": {
        "Description": "Enhanced Product 4.5 V to 60 V Wide-Input Synchronous PWM Buck Controller",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck controllers (external switch)",
        "Rating": "HiRel Enhanced Product",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-55 to 125",
        "Package size: mm2:W x L (PKG)": "16 mm2: 3.5 x 4.5 (VQFN|20)",
        "Package Group": "VQFN|20",
        "\"Approx. price\n(USD)\"": "$5.895 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS51632": {
        "Description": "2.5V to 24V 3/2/1-phase Step-Down Driverless Controller for Nvidia Tegra&reg; T40 CPUs",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck controllers (external switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-10 to 105",
        "Package size: mm2:W x L (PKG)": "16 mm2: 4 x 4 (VQFN|32)",
        "Package Group": "VQFN|32",
        "\"Approx. price\n(USD)\"": "$1.791 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62400-Q1": {
        "Description": "Automotive Catalog Dual Adjustable 400mA & 600mA 2.25MHz Step-Down Converter w/ 1-Wire Interface",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (VSON|10)",
        "Package Group": "VSON|10",
        "\"Approx. price\n(USD)\"": "$0.719 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS53511": {
        "Description": "1.5A Step-Down Regulator with Integrated MOSFETs",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (VQFN|16)",
        "Package Group": "VQFN|16",
        "\"Approx. price\n(USD)\"": "$0.653 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS84A20": {
        "Description": "2.95V to 17V 10A Synchronous Buck Integrated Power Solution",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck modules (integrated inductor)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "100 mm2: 10 x 10 (B3QFN|42)",
        "Package Group": "B3QFN|42",
        "\"Approx. price\n(USD)\"": "$8.664 | 1ku",
        "Status": "ACTIVE"
    },
    "LM3279": {
        "Description": "Buck-Boost Converter with MIPI® RFFE Interface for 3G and 4G RF Power Amplifiers",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-30 to 85",
        "Package size: mm2:W x L (PKG)": "6 mm2: 2.3 x 2.5 (DSBGA|16)",
        "Package Group": "DSBGA|16",
        "\"Approx. price\n(USD)\"": "$0.826 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS51622": {
        "Description": "2-Phase DCAP+ Step-Down Controller for VR12.6 CPU",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck controllers (external switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 105",
        "Package size: mm2:W x L (PKG)": "16 mm2: 4 x 4 (VQFN|32)",
        "Package Group": "VQFN|32",
        "\"Approx. price\n(USD)\"": "$0.660 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS54061-Q1": {
        "Description": "Automotive Catalog 4.7V -60-V 200-mA Synchronous Step-Down DC-DC Converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 150",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (SON|8)",
        "Package Group": "SON|8",
        "\"Approx. price\n(USD)\"": "$1.028 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62736": {
        "Description": "High Efficiency  Nanopower Buck Converter with 50mA Load Capability | Step-Down",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "12 mm2: 3.5 x 3.5 (VQFN|14)",
        "Package Group": "VQFN|14",
        "\"Approx. price\n(USD)\"": "$1.870 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS51275B": {
        "Description": "5.5-V to 24-V dual-synchronous buck controller with Out-of-Audio™ mode",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck controllers (external switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (WQFN|20)",
        "Package Group": "WQFN|20",
        "\"Approx. price\n(USD)\"": "$0.303 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS51362": {
        "Description": "3-V to 22-V 10-A synchronous buck converter with ultra-low quiescent current",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-10 to 85",
        "Package size: mm2:W x L (PKG)": "16 mm2: 3.5 x 4.5 (VQFN-CLIP|28)",
        "Package Group": "VQFN-CLIP|28",
        "\"Approx. price\n(USD)\"": "$1.452 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS51363": {
        "Description": "3-V to 22-V 8-A synchronous buck converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-10 to 85",
        "Package size: mm2:W x L (PKG)": "16 mm2: 3.5 x 4.5 (VQFN-CLIP|28)",
        "Package Group": "VQFN-CLIP|28",
        "\"Approx. price\n(USD)\"": "$1.331 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS51367": {
        "Description": "3-V to 22-V 12-A synchronous buck converter with ultra-low quiescent current",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-10 to 85",
        "Package size: mm2:W x L (PKG)": "16 mm2: 3.5 x 4.5 (VQFN-CLIP|28)",
        "Package Group": "VQFN-CLIP|28",
        "\"Approx. price\n(USD)\"": "$1.646 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS65273V": {
        "Description": "4.5V to 18V Input 3.5A/3.5A Dual Synchronous Step-down Converter with I2C Controlled VID",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "68 mm2: 6.2 x 11 (HTSSOP|32) 36 mm2: 6 x 6 (VQFN|36)",
        "Package Group": "HTSSOP|32 VQFN|36",
        "\"Approx. price\n(USD)\"": "$1.742 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS65276V": {
        "Description": "4.5-V to 18-V Input Dual (6-A and 3.5-A) Synchronous Step-Down Converter with I2C Control",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "68 mm2: 6.2 x 11 (HTSSOP|32) 36 mm2: 6 x 6 (VQFN|36)",
        "Package Group": "HTSSOP|32 VQFN|36",
        "\"Approx. price\n(USD)\"": "$1.756 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS65279V": {
        "Description": "4.5-V to 18-V Input Dual 5-A Synchronous Step-Down Converter with I2C interface",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "68 mm2: 6.2 x 11 (HTSSOP|32) 36 mm2: 6 x 6 (VQFN|36)",
        "Package Group": "HTSSOP|32 VQFN|36",
        "\"Approx. price\n(USD)\"": "$1.338 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS82693": {
        "Description": "800-mA High-Efficiency MicroSiP Step-Down Converter (Profile <1mm). Vout=2.85V with Spread Spectrum",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck modules (integrated inductor)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "7 mm2: 2.9 x 2.3 (uSiP|8)",
        "Package Group": "uSiP|8",
        "\"Approx. price\n(USD)\"": "$0.968 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS43060": {
        "Description": "Low Iq 58V Synchronous Boost Controller w/ Wide Input Voltage & 7.5V Gate Drive for Standard FETs",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost controllers (external switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 150",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (WQFN|16)",
        "Package Group": "WQFN|16",
        "\"Approx. price\n(USD)\"": "$0.938 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS54020": {
        "Description": "4.5-V to 17-V 10-A synchronous SWIFT&trade; buck converter with out-of-phase synchronization",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 150",
        "Package size: mm2:W x L (PKG)": "12 mm2: 3.5 x 3.5 (VQFN-HR|15)",
        "Package Group": "VQFN-HR|15",
        "\"Approx. price\n(USD)\"": "$3.053 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS54560": {
        "Description": "4.5V to 60 V input 5 A step-down converter with Eco-Mode",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "19 mm2: 3.9 x 4.89 (SO PowerPAD|8)",
        "Package Group": "SO PowerPAD|8",
        "\"Approx. price\n(USD)\"": "$2.033 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS53624": {
        "Description": "Dual Phase D-CAP Buck Regulator with 8-Bit VID",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck controllers (external switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "36 mm2: 6 x 6 (VQFN|40)",
        "Package Group": "VQFN|40",
        "\"Approx. price\n(USD)\"": "$1.597 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS65131-Q1": {
        "Description": "Automotive Split-Rail Converter with Dual Positive and Negative Outputs (750mA typ)",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck-boost inverting & split-rail converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 105",
        "Package size: mm2:W x L (PKG)": "16 mm2: 4 x 4 (VQFN|24)",
        "Package Group": "VQFN|24",
        "\"Approx. price\n(USD)\"": "$1.242 | 1ku",
        "Status": "ACTIVE"
    },
    "LM25119Q": {
        "Description": "Automotive grade 4.5-42V wide VIN current mode dual synchronous buck controller",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck controllers (external switch)",
        "Rating": "Automotive",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "25 mm2: 5 x 5 (WQFN|32)",
        "Package Group": "WQFN|32",
        "\"Approx. price\n(USD)\"": "$2.631 | 1ku",
        "Status": "ACTIVE"
    },
    "LM5119Q": {
        "Description": "Automotive Grade 5.5-65V Wide Vin Current Mode Dual Synchronous Buck Controller",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck controllers (external switch)",
        "Rating": "Automotive",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "25 mm2: 5 x 5 (WQFN|32)",
        "Package Group": "WQFN|32",
        "\"Approx. price\n(USD)\"": "$3.290 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS54239": {
        "Description": "4.5V to 23V Input 2A Synchronous Step-Down Converter with D-CAP2 Mode",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "19 mm2: 3.9 x 4.89 (SO PowerPAD|8)",
        "Package Group": "SO PowerPAD|8",
        "\"Approx. price\n(USD)\"": "$0.637 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS54239E": {
        "Description": "4.5V to 23V Input 2-A Synchronous Step-Down Converter with Eco-Mode",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "19 mm2: 3.9 x 4.89 (SO PowerPAD|8)",
        "Package Group": "SO PowerPAD|8",
        "\"Approx. price\n(USD)\"": "$0.657 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS54339": {
        "Description": "4.5-V to 23-V input 3-A synchronous step-down converter with D-CAP2 mode",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "19 mm2: 3.9 x 4.89 (SO PowerPAD|8)",
        "Package Group": "SO PowerPAD|8",
        "\"Approx. price\n(USD)\"": "$0.678 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS54010-EP": {
        "Description": "Enhanced Product 2.2-V to 4-V 14-A Output Synchronous Buck PWM Switcher",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "HiRel Enhanced Product",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-55 to 125",
        "Package size: mm2:W x L (PKG)": "43 mm2: 4.4 x 9.7 (HTSSOP|28)",
        "Package Group": "HTSSOP|28",
        "\"Approx. price\n(USD)\"": "$7.124 | 1ku",
        "Status": "ACTIVE"
    },
    "LM25017": {
        "Description": "7.5-48V Wide Vin 650mA Constant On-Time Synchronous Buck Regulator",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "19 mm2: 3.9 x 4.89 (SO PowerPAD|8) 16 mm2: 4 x 4 (WSON|8)",
        "Package Group": "SO PowerPAD|8 WSON|8",
        "\"Approx. price\n(USD)\"": "$1.084 | 1ku",
        "Status": "ACTIVE"
    },
    "LM25018": {
        "Description": "7.5-48V Wide Vin 300mA Constant On-Time Synchronous Buck Regulator",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "19 mm2: 3.9 x 4.89 (SO PowerPAD|8) 16 mm2: 4 x 4 (WSON|8)",
        "Package Group": "SO PowerPAD|8 WSON|8",
        "\"Approx. price\n(USD)\"": "$0.935 | 1ku",
        "Status": "ACTIVE"
    },
    "LM25019": {
        "Description": "7.5-48V Wide Vin 100mA Constant On-Time Synchronous Buck Regulator",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "19 mm2: 3.9 x 4.89 (SO PowerPAD|8) 16 mm2: 4 x 4 (WSON|8)",
        "Package Group": "SO PowerPAD|8 WSON|8",
        "\"Approx. price\n(USD)\"": "$0.715 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS50601-SP": {
        "Description": "Radiation-hardened QMLV 3-V to 6.3-V input 6-A synchronous step-down converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Space",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "\"-55 to 125\n25 to 25\"",
        "Package size: mm2:W x L (PKG)": "94 mm2: 7.38 x 12.7 (CFP|20)",
        "Package Group": "CFP|20",
        "\"Approx. price\n(USD)\"": "$2223.585 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS826745": {
        "Description": "600mA Fully Integrated Low Noise Step-Down Converter in MicroSiP™ Package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck modules (integrated inductor)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "7 mm2: 2.9 x 2.3 (uSiP|8)",
        "Package Group": "uSiP|8",
        "\"Approx. price\n(USD)\"": "$0.910 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS51631": {
        "Description": "3-phase DCAP+ Step-Down Controller for VR12.5 CPUs",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck controllers (external switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 105",
        "Package size: mm2:W x L (PKG)": "16 mm2: 4 x 4 (VQFN|32)",
        "Package Group": "VQFN|32",
        "\"Approx. price\n(USD)\"": "$1.597 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS54339E": {
        "Description": "4.5-V to 23-V input 3-A synchronous step-down converter with D-CAP2 mode and light load efficiency",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "19 mm2: 3.9 x 4.89 (SO PowerPAD|8)",
        "Package Group": "SO PowerPAD|8",
        "\"Approx. price\n(USD)\"": "$0.698 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62698": {
        "Description": "800-mA 3-MHz High-Efficiency Step-Down Converter. 3.0V fixed Output voltage.",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "1 mm2: 1 x 1.4 (DSBGA|6)",
        "Package Group": "DSBGA|6",
        "\"Approx. price\n(USD)\"": "$0.464 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62693": {
        "Description": "800-mA 3-MHz High-Efficiency Step-Down Converter TPS6269x",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "1 mm2: 1 x 1.4 (DSBGA|6)",
        "Package Group": "DSBGA|6",
        "\"Approx. price\n(USD)\"": "$0.464 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS50301-HT": {
        "Description": "1.6-V to 6.3-V INPUT 3-A SYNCHRONOUS STEP DOWN CONVERTER",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "High Temp",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-55 to 210",
        "Package size: mm2:W x L (PKG)": "94 mm2: 7.38 x 12.7 (CFP|20)",
        "Package Group": "CFP|20",
        "\"Approx. price\n(USD)\"": "$1800.000 | 100u",
        "Status": "ACTIVE"
    },
    "TPS62732": {
        "Description": "Step Down Converter with Bypass Mode for Ultra Low Power Wireless Applications",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "1 mm2: 1 x 1.45 (SON|6)",
        "Package Group": "SON|6",
        "\"Approx. price\n(USD)\"": "$0.426 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS43061": {
        "Description": "Low Iq Synchronous Boost Controller with Wide Input Voltage and 5.5V Gate Drive for Low Qg NexFETs",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost controllers (external switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 150",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (WQFN|16)",
        "Package Group": "WQFN|16",
        "\"Approx. price\n(USD)\"": "$0.938 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62733": {
        "Description": "Step Down Converter with Bypass Mode for Ultra Low Power Wireless Applications",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "1 mm2: 1 x 1.45 (SON|6)",
        "Package Group": "SON|6",
        "\"Approx. price\n(USD)\"": "$0.426 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS53819A": {
        "Description": "3-V to 28-V 40-A synchronous D-CAP2 buck controller with PMBus",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck controllers (external switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (VQFN|16)",
        "Package Group": "VQFN|16",
        "\"Approx. price\n(USD)\"": "$0.958 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS54340": {
        "Description": "42 V Input 3.5 A Step-Down DC/DC Converter with Eco-mode&trade;",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "19 mm2: 3.9 x 4.89 (SO PowerPAD|8)",
        "Package Group": "SO PowerPAD|8",
        "\"Approx. price\n(USD)\"": "$1.472 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62175": {
        "Description": "28V 0.5A Step-Down Converter with SNOOZE Mode",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "6 mm2: 3 x 2 (WSON|10)",
        "Package Group": "WSON|10",
        "\"Approx. price\n(USD)\"": "$0.528 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62177": {
        "Description": "28V 0.5A Step-Down Converter with SNOOZE Mode",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "6 mm2: 3 x 2 (WSON|10)",
        "Package Group": "WSON|10",
        "\"Approx. price\n(USD)\"": "$0.528 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS826765": {
        "Description": "600mA Fully Integrated Low Noise Step-Down Converter in MicroSiP(tm) Package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck modules (integrated inductor)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "7 mm2: 2.9 x 2.3 (uSiP|8)",
        "Package Group": "uSiP|8",
        "\"Approx. price\n(USD)\"": "$0.910 | 1ku",
        "Status": "ACTIVE"
    },
    "LM22673-Q1": {
        "Description": "3A SIMPLE SWITCHER&reg; Step-Down Voltage Reg. with Adjustable Soft-Start and Current Limit",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "19 mm2: 3.9 x 4.89 (SO PowerPAD|8) 100 mm2: 9.85 x 10.16 (TO-263|7)",
        "Package Group": "SO PowerPAD|8 TO-263|7",
        "\"Approx. price\n(USD)\"": "$2.113 | 1ku",
        "Status": "ACTIVE"
    },
    "LM22679-Q1": {
        "Description": "5A SIMPLE SWITCHER Step-Down Voltage Regulator with Adjustable Soft-Start & Current Limit",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "100 mm2: 9.85 x 10.16 (TO-263|7)",
        "Package Group": "TO-263|7",
        "\"Approx. price\n(USD)\"": "$2.741 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS40021-EP": {
        "Description": "Enhanced Product Synchronous Buck Controller",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck controllers (external switch)",
        "Rating": "HiRel Enhanced Product",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-55 to 125",
        "Package size: mm2:W x L (PKG)": "32 mm2: 6.4 x 5 (HTSSOP|16)",
        "Package Group": "HTSSOP|16",
        "\"Approx. price\n(USD)\"": "$3.687 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS51312": {
        "Description": "3.1V to 5.5V Input DCAP2 Mode 3A 900KHz Integrated Step-Down Converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (VSON|10)",
        "Package Group": "VSON|10",
        "\"Approx. price\n(USD)\"": "$0.880 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS51313": {
        "Description": "3V to 5.5V input DCAP2 1MHz Step-Down DC/DC Converter for nVidia Graphics PEX (PCI-Express) Rail",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-10 to 85",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (VSON|10)",
        "Package Group": "VSON|10",
        "\"Approx. price\n(USD)\"": "$1.415 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS61222-EP": {
        "Description": "0.7-VIN 5-V fixed output voltage boost converter with 5.5-μA quiescent current",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost converters (integrated switch)",
        "Rating": "HiRel Enhanced Product",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-55 to 125",
        "Package size: mm2:W x L (PKG)": "4 mm2: 2.1 x 2 (SC70|6)",
        "Package Group": "SC70|6",
        "\"Approx. price\n(USD)\"": "$1.980 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS54360": {
        "Description": "4.5V to 60 V Input 3.5 A Step-Down Converter with Eco-mode",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "19 mm2: 3.9 x 4.89 (SO PowerPAD|8)",
        "Package Group": "SO PowerPAD|8",
        "\"Approx. price\n(USD)\"": "$1.762 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS5402": {
        "Description": "3.5V to 28V Input 1.7A Output Non-Synchronous Step-Down Regulator with Integrated MOSFET",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "19 mm2: 3.91 x 4.9 (SOIC|8)",
        "Package Group": "SOIC|8",
        "\"Approx. price\n(USD)\"": "$0.532 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS5403": {
        "Description": "4.5V to 28V Input 3.3V 1.7A Output Non-Synchronous Step-Down Regulator with Integrated MOSFET",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "19 mm2: 3.91 x 4.9 (SOIC|8)",
        "Package Group": "SOIC|8",
        "\"Approx. price\n(USD)\"": "$0.532 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS53015": {
        "Description": "4.5-V to 28-V 25-A synchronous D-CAP2 buck controller with power good",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck controllers (external switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (VSSOP|10)",
        "Package Group": "VSSOP|10",
        "\"Approx. price\n(USD)\"": "$0.748 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS54362-HT": {
        "Description": "1-A 48-V Step-Down DC/DC Converter with Low Iq",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "High Temp",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-55 to 175",
        "Package size: mm2:W x L (PKG)": "42 mm2: 6.4 x 6.5 (HTSSOP|20)",
        "Package Group": "HTSSOP|20",
        "\"Approx. price\n(USD)\"": "$113.520 | 100u",
        "Status": "ACTIVE"
    },
    "LM3262": {
        "Description": "6MHz 800mA Miniature Adjustable Step-Down DC-DC Converter with Bypass",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-30 to 90",
        "Package size: mm2:W x L (PKG)": "See datasheet (DSBGA)",
        "Package Group": "DSBGA|9",
        "\"Approx. price\n(USD)\"": "$0.517 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS84259": {
        "Description": "4.5V to 40V 2A up to 15W Negative-Output Integrated Power Solution",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck-boost & inverting modules (integrated inductor)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "99 mm2: 9 x 11 (B1QFN|41)",
        "Package Group": "B1QFN|41",
        "\"Approx. price\n(USD)\"": "$6.534 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS63036": {
        "Description": "High Efficient Single Inductor Buck-Boost Converter with 1-A Switches",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck-boost inverting & split-rail converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "See datasheet (DSBGA)",
        "Package Group": "DSBGA|8",
        "\"Approx. price\n(USD)\"": "$0.725 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS61259": {
        "Description": "3.5-MHz 5.1-V 1.5-A load boost converter in 1.2-mm x 1.3-mm WCSP",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "2 mm2: 1.4 x 1.4 (DSBGA|9)",
        "Package Group": "DSBGA|9",
        "\"Approx. price\n(USD)\"": "$0.418 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS84250": {
        "Description": "7V to 50V 2.5A Step-Down Integrated Power Solution",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck modules (integrated inductor)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "99 mm2: 9 x 11 (B1QFN|41)",
        "Package Group": "B1QFN|41",
        "\"Approx. price\n(USD)\"": "$7.696 | 1ku",
        "Status": "ACTIVE"
    },
    "LMR10530": {
        "Description": "5.5V 3A 3MHz Step-Down Regulator in WSON Package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (WSON|10)",
        "Package Group": "WSON|10",
        "\"Approx. price\n(USD)\"": "$0.462 | 1ku",
        "Status": "ACTIVE"
    },
    "LMR12015": {
        "Description": "20Vin 1.5A Step-Down Voltage Regulator in LLP-10",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (WSON|10)",
        "Package Group": "WSON|10",
        "\"Approx. price\n(USD)\"": "$0.860 | 1ku",
        "Status": "ACTIVE"
    },
    "LMR12020": {
        "Description": "3V to 20V 2.0A Step-Down DC/DC Switching Regulator in LLP-10",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (WSON|10)",
        "Package Group": "WSON|10",
        "\"Approx. price\n(USD)\"": "$0.961 | 1ku",
        "Status": "ACTIVE"
    },
    "LMR61428": {
        "Description": "1.2V to 14V 2.85A 2MHz Step-Up Voltage Regulator",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "15 mm2: 4.9 x 3 (VSSOP|8)",
        "Package Group": "VSSOP|8",
        "\"Approx. price\n(USD)\"": "$0.658 | 1ku",
        "Status": "ACTIVE"
    },
    "LM5018": {
        "Description": "7.5-100V Wide Vin 300mA Constant On-Time Synchronous Buck Regulator",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "19 mm2: 3.9 x 4.89 (SO PowerPAD|8) 16 mm2: 4 x 4 (WSON|8)",
        "Package Group": "SO PowerPAD|8 WSON|8",
        "\"Approx. price\n(USD)\"": "$1.188 | 1ku",
        "Status": "ACTIVE"
    },
    "LM5019": {
        "Description": "7.5-100V Wide Vin 100mA Constant On-Time Synchronous Buck Regulator",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "19 mm2: 3.9 x 4.89 (SO PowerPAD|8) 16 mm2: 4 x 4 (WSON|8)",
        "Package Group": "SO PowerPAD|8 WSON|8",
        "\"Approx. price\n(USD)\"": "$0.957 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62203-DIE": {
        "Description": "3.3-V Output 300-mA 95% Efficient Step-Down Converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "See datasheet",
        "Package Group": " --- ",
        "\"Approx. price\n(USD)\"": "$1.056 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62366A": {
        "Description": "4A Processor Supply with I2C Compatible Interface and Remote Sense",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "5 mm2: 2.25 x 2.25 (DSBGA|16)",
        "Package Group": "DSBGA|16",
        "\"Approx. price\n(USD)\"": "$0.765 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62366B": {
        "Description": "4A Processor Supply with I2C Compatible Interface and Remote Sense",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "5 mm2: 2.25 x 2.25 (DSBGA|16)",
        "Package Group": "DSBGA|16",
        "\"Approx. price\n(USD)\"": "$0.765 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS542951": {
        "Description": "4.5 V to 18 V input 2 A / 3 A dual channel synchronous step-down converter adjustable soft start",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "32 mm2: 6.4 x 5 (HTSSOP|16) 16 mm2: 4 x 4 (QFN|16)",
        "Package Group": "HTSSOP|16 QFN|16",
        "\"Approx. price\n(USD)\"": "$1.016 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS542941": {
        "Description": "4.5 V to 18 V input 2 A / 3 A dual channel synchronous step-down converter 1 ms fixed soft start",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "32 mm2: 6.4 x 5 (HTSSOP|16) 16 mm2: 4 x 4 (QFN|16)",
        "Package Group": "HTSSOP|16 QFN|16",
        "\"Approx. price\n(USD)\"": "$1.016 | 1ku",
        "Status": "ACTIVE"
    },
    "LM3269": {
        "Description": "Seamless Transition Buck/Boost Converter for LTE and HSPA RF Power Amplifiers",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-30 to 85",
        "Package size: mm2:W x L (PKG)": "4 mm2: 1.8 x 2 (DSBGA|12)",
        "Package Group": "DSBGA|12",
        "\"Approx. price\n(USD)\"": "$0.660 | 1ku",
        "Status": "ACTIVE"
    },
    "LMR70503": {
        "Description": "2.8V to 5.5V 300mA Buck/Boost Negative Output Voltage Regulator",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck-boost inverting & split-rail converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "2 mm2: 1 x 1.8 (DSBGA|8)",
        "Package Group": "DSBGA|8",
        "\"Approx. price\n(USD)\"": "$0.899 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS54678": {
        "Description": "2.95V to 6V Input 6A Synchronous Step-Down SWIFT™ Converter with Hiccup Current Limit",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "\"-40 to 125\n-40 to 150\"",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (WQFN|16)",
        "Package Group": "WQFN|16",
        "\"Approx. price\n(USD)\"": "$1.360 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS5405": {
        "Description": "6.5V to 28V Input 5V Fixed Output at 2A Step-Down Regulator with Intregrated MosFET",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "19 mm2: 3.91 x 4.9 (SOIC|8)",
        "Package Group": "SOIC|8",
        "\"Approx. price\n(USD)\"": "$0.532 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS51275": {
        "Description": "5.5-V to 24-V dual-synchronous buck controller with 5-V and 3.3-V LDOs",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck controllers (external switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (WQFN|20)",
        "Package Group": "WQFN|20",
        "\"Approx. price\n(USD)\"": "$0.303 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS51275C": {
        "Description": "5.5-V to 24-V dual-synchronous buck controller with VREG5 always-on LDO",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck controllers (external switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (WQFN|20)",
        "Package Group": "WQFN|20",
        "\"Approx. price\n(USD)\"": "$0.303 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS53318": {
        "Description": "1.5-V to 22-V 8-A synchronous buck converter with eco-mode",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "30 mm2: 5 x 6 (LSON-CLIP|22)",
        "Package Group": "LSON-CLIP|22",
        "\"Approx. price\n(USD)\"": "$2.000 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS54394": {
        "Description": "3A Dual Channel Synchronous Step-Down Switcher with Integrated FET",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "32 mm2: 6.4 x 5 (HTSSOP|16) 16 mm2: 4 x 4 (QFN|16)",
        "Package Group": "HTSSOP|16 QFN|16",
        "\"Approx. price\n(USD)\"": "$1.065 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS54395": {
        "Description": "4.5V to 18V Input Dual 3A Output Synchronous Step-Down Converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "32 mm2: 6.4 x 5 (HTSSOP|16) 16 mm2: 4 x 4 (QFN|16)",
        "Package Group": "HTSSOP|16 QFN|16",
        "\"Approx. price\n(USD)\"": "$1.065 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS54494": {
        "Description": "4A Dual Channel Synchronous Step-Down Switcher with Integrated FET",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "32 mm2: 6.4 x 5 (HTSSOP|16) 16 mm2: 4 x 4 (QFN|16)",
        "Package Group": "HTSSOP|16 QFN|16",
        "\"Approx. price\n(USD)\"": "$1.258 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS54495": {
        "Description": "4.5V to 18V Input Dual 4A/2A Output Synchronous Step-Down Converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "32 mm2: 6.4 x 5 (HTSSOP|16) 16 mm2: 4 x 4 (QFN|16)",
        "Package Group": "HTSSOP|16 QFN|16",
        "\"Approx. price\n(USD)\"": "$1.258 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS826711": {
        "Description": "600mA Fully Integrated Low Noise Step-Down Converter Module in MicroSiP&trade; Package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck modules (integrated inductor)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "7 mm2: 2.9 x 2.3 (uSiP|8)",
        "Package Group": "uSiP|8",
        "\"Approx. price\n(USD)\"": "$0.910 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS54525": {
        "Description": "4.5V to 18V Input 5.5-A Synchronous Step-Down Converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "22 mm2: 4.4 x 5 (HTSSOP|14)",
        "Package Group": "HTSSOP|14",
        "\"Approx. price\n(USD)\"": "$1.021 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS54526": {
        "Description": "4.5V to 18V Input 5.5A Synchronous Step-Down Converter with Eco-Mode&trade;",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "22 mm2: 4.4 x 5 (HTSSOP|14) 16 mm2: 4 x 4 (QFN|16)",
        "Package Group": "HTSSOP|14 QFN|16",
        "\"Approx. price\n(USD)\"": "$1.041 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS53319": {
        "Description": "1.5-V to 22-V 14-A synchronous buck converter with eco-mode",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "30 mm2: 5 x 6 (LSON-CLIP|22)",
        "Package Group": "LSON-CLIP|22",
        "\"Approx. price\n(USD)\"": "$2.700 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS54719": {
        "Description": "2.95V to 6V Input 7A Synchronous Step-Down DC/DC Converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 140",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (WQFN|16)",
        "Package Group": "WQFN|16",
        "\"Approx. price\n(USD)\"": "$1.254 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS81256": {
        "Description": "Integrated Power Solution 3W High-Efficiency boost converter module in MicroSiP&trade; package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost modules (integrated inductor)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "See datasheet",
        "Package Group": " --- ",
        "\"Approx. price\n(USD)\"": "$1.060 | 1ku",
        "Status": "ACTIVE"
    },
    "TLV61220": {
        "Description": "0.7V Low Input Voltage Step-Up Converter with 5uA Iq",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "5 mm2: 1.6 x 2.9 (SOT-23|6)",
        "Package Group": "SOT-23|6",
        "\"Approx. price\n(USD)\"": "$0.330 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS59641": {
        "Description": "Dual channel SVID D-CAP+; step down industrial grade controller for IMVP-7 Vcore with 1.1V VBoot",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck controllers (external switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 105",
        "Package size: mm2:W x L (PKG)": "36 mm2: 6 x 6 (VQFN|48)",
        "Package Group": "VQFN|48",
        "\"Approx. price\n(USD)\"": "$2.178 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS53014": {
        "Description": "4.5-V to 28-V 25-A synchronous D-CAP2 buck controller",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck controllers (external switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (VSSOP|10)",
        "Package Group": "VSSOP|10",
        "\"Approx. price\n(USD)\"": "$0.770 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS54061": {
        "Description": "4.7V to 60V Input 200mA Synchronous Step-Down Converter with Low IQ",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 150",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (SON|8)",
        "Package Group": "SON|8",
        "\"Approx. price\n(USD)\"": "$0.871 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS54140A": {
        "Description": "3.5V to 42V Input 1.5A Step-Down Converter with Eco-Mode",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (HVSSOP|10) 9 mm2: 3 x 3 (VSON|10)",
        "Package Group": "HVSSOP|10 VSON|10",
        "\"Approx. price\n(USD)\"": "$0.920 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS54160A": {
        "Description": "3.5V to 60V Input 1.5A Step-Down Converter with Eco-Mode",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (HVSSOP|10) 9 mm2: 3 x 3 (VSON|10)",
        "Package Group": "HVSSOP|10 VSON|10",
        "\"Approx. price\n(USD)\"": "$1.307 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS55340": {
        "Description": "5-A 40-V wide VIN boost flyback & SEPIC converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 150",
        "Package size: mm2:W x L (PKG)": "22 mm2: 4.4 x 5 (HTSSOP|14) 9 mm2: 3 x 3 (WQFN|16)",
        "Package Group": "HTSSOP|14 WQFN|16",
        "\"Approx. price\n(USD)\"": "$0.924 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS61253": {
        "Description": "3.5-MHz 5-V 1.5-A load boost converter in 1.2-mm x 1.3-mm WCSP",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "2 mm2: 1.4 x 1.4 (DSBGA|9)",
        "Package Group": "DSBGA|9",
        "\"Approx. price\n(USD)\"": "$0.418 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS61258": {
        "Description": "3.5-MHz 4.5-V 1.5-A load boost converter in 1.2-mm x 1.3-mm WCSP",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "2 mm2: 1.4 x 1.4 (DSBGA|9)",
        "Package Group": "DSBGA|9",
        "\"Approx. price\n(USD)\"": "$0.418 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62125": {
        "Description": "3V-17V 300mA Buck Converter With Adjustable Enable Threshold And Hysteresis",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "4 mm2: 2 x 2 (WSON|8)",
        "Package Group": "WSON|8",
        "\"Approx. price\n(USD)\"": "$0.407 | 1ku",
        "Status": "ACTIVE"
    },
    "LM2700Q-Q1": {
        "Description": "600kHz/1.25MHz 2.5A step-up PWM DC/DC converter AEC-Q100 qualified",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 105",
        "Package size: mm2:W x L (PKG)": "32 mm2: 6.4 x 5 (TSSOP|14)",
        "Package Group": "TSSOP|14",
        "\"Approx. price\n(USD)\"": "$1.947 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS82670": {
        "Description": "600mA Fully Integrated Low Noise Step-Down Converter in MicroSiP™ Package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck modules (integrated inductor)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "7 mm2: 2.9 x 2.3 (uSiP|8)",
        "Package Group": "uSiP|8",
        "\"Approx. price\n(USD)\"": "$0.825 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS82673": {
        "Description": "600mA Fully Integrated Low Noise Step-Down Converter in MicroSiP™ Package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck modules (integrated inductor)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "7 mm2: 2.9 x 2.3 (uSiP|8)",
        "Package Group": "uSiP|8",
        "\"Approx. price\n(USD)\"": "$0.825 | 1ku",
        "Status": "ACTIVE"
    },
    "LM25117-Q1": {
        "Description": "Automotive Grade 4.5-42V Wide Vin Current Mode Synchronous Buck Controller with Tracking",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck controllers (external switch)",
        "Rating": "Automotive",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "42 mm2: 6.4 x 6.5 (HTSSOP|20) 16 mm2: 4 x 4 (WQFN|24)",
        "Package Group": "HTSSOP|20 WQFN|24",
        "\"Approx. price\n(USD)\"": "$2.058 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS40170-Q1": {
        "Description": "Automotive 4.5V to 60V Synchronous Buck Controller with Voltage Tracking",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck controllers (external switch)",
        "Rating": "Automotive",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "16 mm2: 3.5 x 4.5 (VQFN|20)",
        "Package Group": "VQFN|20",
        "\"Approx. price\n(USD)\"": "$2.741 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS54386-Q1": {
        "Description": "Automotive 4.5V to 28V 600kHz Fixed Frequency Dual 3A Buck Converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 105",
        "Package size: mm2:W x L (PKG)": "22 mm2: 4.4 x 5 (HTSSOP|14)",
        "Package Group": "HTSSOP|14",
        "\"Approx. price\n(USD)\"": "$1.114 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62242-Q1": {
        "Description": "Automotive 2V to 6V 2.25MHz Fixed Frequency 300mA Buck Converter with 1.2V Fixed Output Voltage",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 115",
        "Package size: mm2:W x L (PKG)": "8 mm2: 2.8 x 2.9 (SOT-23-THIN|5)",
        "Package Group": "SOT-23-THIN|5",
        "\"Approx. price\n(USD)\"": "$0.467 | 1ku",
        "Status": "ACTIVE"
    },
    "TLV62090": {
        "Description": "3A High Efficiency Step Down Converter in 3x3mm QFN Package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (VQFN|16)",
        "Package Group": "VQFN|16",
        "\"Approx. price\n(USD)\"": "$0.560 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS54233-Q1": {
        "Description": "Automotive 3.5V to 28V 300kHz Fixed Frequency 2A Buck Converter with Eco-Mode&trade;",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "19 mm2: 3.91 x 4.9 (SOIC|8)",
        "Package Group": "SOIC|8",
        "\"Approx. price\n(USD)\"": "$1.529 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62090": {
        "Description": "3A 6V input up to 97% efficiency Synchronous Step Down Converter with DCS™ Control",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (VQFN|16)",
        "Package Group": "VQFN|16",
        "\"Approx. price\n(USD)\"": "$0.784 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62091": {
        "Description": "3A2.5V to 6V input up to 97% efficiency Synchronous Step Down Converter with DCS™ Control",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (VQFN|16)",
        "Package Group": "VQFN|16",
        "\"Approx. price\n(USD)\"": "$0.784 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62092": {
        "Description": "3A2.5V to 6V input up to 97% efficiency Synchronous Step Down Converter with DCS™ Control",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (VQFN|16)",
        "Package Group": "VQFN|16",
        "\"Approx. price\n(USD)\"": "$0.784 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62093": {
        "Description": "3A2.5V to 6V input up to 97% efficiency Synchronous Step Down Converter with DCS™ Control",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (VQFN|16)",
        "Package Group": "VQFN|16",
        "\"Approx. price\n(USD)\"": "$0.784 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62650-Q1": {
        "Description": "Automotive 2.3V to 5.5V 6MHz Fixed Frequency 800mA Buck Converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 105",
        "Package size: mm2:W x L (PKG)": "2 mm2: 1.4 x 1.4 (DSBGA|9)",
        "Package Group": "DSBGA|9",
        "\"Approx. price\n(USD)\"": "$0.675 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62080A": {
        "Description": "1.2A High Efficient Step Down Converter in 2x2mm SON Package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "4 mm2: 2 x 2 (WSON|8)",
        "Package Group": "WSON|8",
        "\"Approx. price\n(USD)\"": "$0.552 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS54040A": {
        "Description": "3.5V to 42V Input 0.5A Step-Down Converter with Eco-Mode",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (HVSSOP|10) 9 mm2: 3 x 3 (VSON|10)",
        "Package Group": "HVSSOP|10 VSON|10",
        "\"Approx. price\n(USD)\"": "$0.871 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS54060A": {
        "Description": "3.5V to 60V Input 0.5A Step-Down Converter with Eco-Mode",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (HVSSOP|10) 9 mm2: 3 x 3 (VSON|10)",
        "Package Group": "HVSSOP|10 VSON|10",
        "\"Approx. price\n(USD)\"": "$1.065 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62363": {
        "Description": "Processor Core Supply with I2C Compatible Interface and Remote Sense",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "5 mm2: 2.25 x 2.25 (DSBGA|16)",
        "Package Group": "DSBGA|16",
        "\"Approx. price\n(USD)\"": "$0.706 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS54120": {
        "Description": "Low-Noise 1A Power Supply with Integrated DC-DC Converter and Low-Dropout Regulator",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "19 mm2: 3.5 x 5.5 (VQFN|24)",
        "Package Group": "VQFN|24",
        "\"Approx. price\n(USD)\"": "$1.355 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS5432": {
        "Description": "2.95V to 6V Input 3A Synchronous Step-Down Converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "19 mm2: 3.9 x 4.89 (SO PowerPAD|8)",
        "Package Group": "SO PowerPAD|8",
        "\"Approx. price\n(USD)\"": "$0.231 | 1ku",
        "Status": "ACTIVE"
    },
    "LM26420-Q1": {
        "Description": "Dual 2 A automotive-qualified high-efficiency synchronous DC/DC converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": "Functional Safety-Capable",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "42 mm2: 6.4 x 6.5 (HTSSOP|20) 16 mm2: 4 x 4 (WQFN|16)",
        "Package Group": "HTSSOP|20 WQFN|16",
        "\"Approx. price\n(USD)\"": "$1.113 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS51463": {
        "Description": "3.3-V/5-V Input D-CAP+&trade; Mode Synchronous Step-Down Integrated FETs Converter with 2-Bit VID",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "16 mm2: 4 x 4 (VQFN|24)",
        "Package Group": "VQFN|24",
        "\"Approx. price\n(USD)\"": "$2.420 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS59650": {
        "Description": "Dual Channel (3-Phase CPU / 2-Phase GPU) SVID D-CAP+TM Step-Down Controller",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck controllers (external switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 105",
        "Package size: mm2:W x L (PKG)": "36 mm2: 6 x 6 (VQFN|48)",
        "Package Group": "VQFN|48",
        "\"Approx. price\n(USD)\"": "$2.565 | 1ku",
        "Status": "ACTIVE"
    },
    "TLV62080": {
        "Description": "1.2A High Efficient Step Down Converter in 2x2mm SON Package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "4 mm2: 2 x 2 (WSON|8)",
        "Package Group": "WSON|8",
        "\"Approx. price\n(USD)\"": "$0.451 | 1ku",
        "Status": "ACTIVE"
    },
    "SM72445": {
        "Description": "Programmable Maximum Power Point Tracking Controller with Adjustable PWM Frequency",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck-boost & inverting controllers (external switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "62 mm2: 6.4 x 9.7 (TSSOP|28)",
        "Package Group": "TSSOP|28",
        "\"Approx. price\n(USD)\"": "$4.498 | 1ku",
        "Status": "ACTIVE"
    },
    "TLV62130": {
        "Description": "3-17V 3A Step-Down Converter in 3x3 QFN Package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (VQFN|16)",
        "Package Group": "VQFN|16",
        "\"Approx. price\n(USD)\"": "$0.550 | 1ku",
        "Status": "ACTIVE"
    },
    "TLV62150": {
        "Description": "4-17V 1A Step-Down Converter with DCS-Control&trade;",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (VQFN|16)",
        "Package Group": "VQFN|16",
        "\"Approx. price\n(USD)\"": "$0.452 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS51225": {
        "Description": "5.5-V to 24-V dual-synchronous buck controller with 5-V and 3.3-V LDOs",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck controllers (external switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (WQFN|20)",
        "Package Group": "WQFN|20",
        "\"Approx. price\n(USD)\"": "$0.716 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS51225B": {
        "Description": "5.5-V to 24-V dual-synchronous buck controller with Out-of-Audio™ mode",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck controllers (external switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (WQFN|20)",
        "Package Group": "WQFN|20",
        "\"Approx. price\n(USD)\"": "$0.716 | 1ku",
        "Status": "ACTIVE"
    },
    "LM5017": {
        "Description": "7.5-100V Wide Vin 600mA Constant On-Time Synchronous Buck Regulator",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "19 mm2: 3.9 x 4.89 (SO PowerPAD|8) 16 mm2: 4 x 4 (WSON|8)",
        "Package Group": "SO PowerPAD|8 WSON|8",
        "\"Approx. price\n(USD)\"": "$1.309 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS82695": {
        "Description": "500-mA High-Efficiency MicroSiP™ Step-Down Converter (Profile <1mm). Vout=2.5V",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck modules (integrated inductor)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "7 mm2: 2.9 x 2.3 (uSiP|8)",
        "Package Group": "uSiP|8",
        "\"Approx. price\n(USD)\"": "$0.891 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS82672": {
        "Description": "600-mA High-Efficiency MicroSiP&trade; Step-Down Converter Module (Profile <1.0mm)",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck modules (integrated inductor)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "7 mm2: 2.9 x 2.3 (uSiP|8)",
        "Package Group": "uSiP|8",
        "\"Approx. price\n(USD)\"": "$0.825 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS51650": {
        "Description": "Dual Channel (3-Phase CPU / 2-Phase GPU) SVID D-CAP+ Step-Down Controller for IMVP-7 Vcore",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck controllers (external switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-10 to 105",
        "Package size: mm2:W x L (PKG)": "36 mm2: 6 x 6 (VQFN|48)",
        "Package Group": "VQFN|48",
        "\"Approx. price\n(USD)\"": "$2.565 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS51640A": {
        "Description": "Dual channel SVID D-CAP+; step down commercial grade controller for IMVP-7 Vcore with 0V VBoot",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck controllers (external switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-10 to 105",
        "Package size: mm2:W x L (PKG)": "36 mm2: 6 x 6 (VQFN|48)",
        "Package Group": "VQFN|48",
        "\"Approx. price\n(USD)\"": "$2.178 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS59640": {
        "Description": "Dual channel SVID D-CAP+; step down industrial grade controller for IMVP-7 Vcore with 0V VBoot",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck controllers (external switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 105",
        "Package size: mm2:W x L (PKG)": "36 mm2: 6 x 6 (VQFN|48)",
        "Package Group": "VQFN|48",
        "\"Approx. price\n(USD)\"": "$2.178 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS82674": {
        "Description": "600mA High-Efficiency MicroSiP&trade; Step-Down Converter Module (Profile <1.0mm).",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck modules (integrated inductor)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "7 mm2: 2.9 x 2.3 (uSiP|8)",
        "Package Group": "uSiP|8",
        "\"Approx. price\n(USD)\"": "$0.910 | 1ku",
        "Status": "ACTIVE"
    },
    "LM3253-C": {
        "Description": "High Current Step Down DC/DC converter for 2G/3G/4G Power Amplifiers",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-30 to 90",
        "Package size: mm2:W x L (PKG)": "See datasheet (DSBGA)",
        "Package Group": "DSBGA|16",
        "\"Approx. price\n(USD)\"": "$0.833 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS51225C": {
        "Description": "5.5-V to 24-V dual-synchronous buck controller with VREG5 always-on LDO",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck controllers (external switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (WQFN|20)",
        "Package Group": "WQFN|20",
        "\"Approx. price\n(USD)\"": "$0.716 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS40422": {
        "Description": "Dual Output or Multiphase Synchronous Buck Controller with PMBus",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck controllers (external switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "36 mm2: 6 x 6 (VQFN|40) 25 mm2: 5 x 5 (WQFN|40)",
        "Package Group": "VQFN|40 WQFN|40",
        "\"Approx. price\n(USD)\"": "$2.081 | 1ku",
        "Status": "ACTIVE"
    },
    "LM3102-Q1": {
        "Description": "Synchronous 1MHz 2.5A Step-Down Voltage  Regulator",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "42 mm2: 6.4 x 6.5 (HTSSOP|20)",
        "Package Group": "HTSSOP|20",
        "\"Approx. price\n(USD)\"": "$2.399 | 1ku",
        "Status": "ACTIVE"
    },
    "LM3243": {
        "Description": "2.7MHz 2.5A Step-Down DC-DC Converter with Analog Bypass Mode for 2G/3G/4G PAs",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-30 to 90",
        "Package size: mm2:W x L (PKG)": "See datasheet (DSBGA)",
        "Package Group": "DSBGA|16",
        "\"Approx. price\n(USD)\"": "$0.373 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS53219A": {
        "Description": "3-V to 28-V 20-A synchronous D-CAP buck controller with Eco Mode",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck controllers (external switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (VQFN|16)",
        "Package Group": "VQFN|16",
        "\"Approx. price\n(USD)\"": "$0.572 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS51462": {
        "Description": "3.3-V/5-V Input D-CAP+&trade; Mode Synchronous Step-Down Integrated FETs Converter With 2-Bit VID",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "16 mm2: 4 x 4 (VQFN|24)",
        "Package Group": "VQFN|24",
        "\"Approx. price\n(USD)\"": "$2.565 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS61087-Q1": {
        "Description": "18.5-V 3.2-A 650-kHz 1.2-MHz step-up DC/DC converter with forced PWM mode AEC-Q100 qualified",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": "Functional Safety-Capable",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (VSON|10)",
        "Package Group": "VSON|10",
        "\"Approx. price\n(USD)\"": "$0.622 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62231-Q1": {
        "Description": "Automotive 2V to 6V 500mA Buck Converter with 1.8V Fixed Output Voltage in 1x1.5mm SON Package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 105",
        "Package size: mm2:W x L (PKG)": "1 mm2: 1 x 1.45 (SON|6)",
        "Package Group": "SON|6",
        "\"Approx. price\n(USD)\"": "$0.505 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS622314-Q1": {
        "Description": "Automotive 2V to 6V 500mA Buck Converter with 1.5V Fixed Output Voltage in 1x1.5mm SON Package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 105",
        "Package size: mm2:W x L (PKG)": "1 mm2: 1 x 1.45 (SON|6)",
        "Package Group": "SON|6",
        "\"Approx. price\n(USD)\"": "$0.505 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS63060": {
        "Description": "2.5V to 12V input voltage 93% Efficient 2.25A Switch Current Limit Buck-Boost Converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck-boost inverting & split-rail converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (WSON|10)",
        "Package Group": "WSON|10",
        "\"Approx. price\n(USD)\"": "$0.906 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS63061": {
        "Description": "2.5V to 12V input voltage 93% Efficient 2.25A Switch Current Limit Buck-Boost Converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck-boost inverting & split-rail converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (WSON|10)",
        "Package Group": "WSON|10",
        "\"Approx. price\n(USD)\"": "$0.906 | 1ku",
        "Status": "ACTIVE"
    },
    "TPIC74101-Q1": {
        "Description": "480kHz 1.5V to 40V 1A buck-boost converter with 5V Fixed output Voltage AEC-Q100 qualified",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck-boost inverting & split-rail converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "42 mm2: 6.4 x 6.5 (HTSSOP|20)",
        "Package Group": "HTSSOP|20",
        "\"Approx. price\n(USD)\"": "$1.646 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS53316": {
        "Description": "High-Efficiency 5-A Step-Down Regulator with Integrated Switcher",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (VQFN|16)",
        "Package Group": "VQFN|16",
        "\"Approx. price\n(USD)\"": "$0.924 | 1ku",
        "Status": "ACTIVE"
    },
    "LM25118": {
        "Description": "3-42V Wide Vin Current Mode Non-Synchronous Buck-Boost Controller",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck-boost & inverting controllers (external switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "42 mm2: 6.4 x 6.5 (HTSSOP|20)",
        "Package Group": "HTSSOP|20",
        "\"Approx. price\n(USD)\"": "$1.936 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS51518": {
        "Description": "Single Phase D-CAP and D-CAP2 Controller with 2-bit Flexible VID Controller",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck controllers (external switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-10 to 105",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (WQFN|20)",
        "Package Group": "WQFN|20",
        "\"Approx. price\n(USD)\"": "$1.404 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS84621": {
        "Description": "2.95-V to 14.5-V Input 6-A Synchronous Buck Integrated Power Solution",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck modules (integrated inductor)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "135 mm2: 9 x 15 (B1QFN|47)",
        "Package Group": "B1QFN|47",
        "\"Approx. price\n(USD)\"": "$5.720 | 1ku",
        "Status": "ACTIVE"
    },
    "LM3671-Q1": {
        "Description": "2MHz 600mA Step-Down DC-DC Converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "2 mm2: 1.2 x 1.5 (DSBGA|5) 5 mm2: 1.6 x 2.9 (SOT-23|5)",
        "Package Group": "DSBGA|5 SOT-23|5",
        "\"Approx. price\n(USD)\"": "$0.548 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS54294": {
        "Description": "4.5 V to 18 V input dual 2 A output synchronous step-down converter with 1 ms fixed soft start",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "32 mm2: 6.4 x 5 (HTSSOP|16) 16 mm2: 4 x 4 (QFN|16)",
        "Package Group": "HTSSOP|16 QFN|16",
        "\"Approx. price\n(USD)\"": "$0.920 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS54428": {
        "Description": "4.5V to 18V Input 4-A Synchronous Step-Down SWIFT™ Converter with Eco-mode™",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "19 mm2: 3.9 x 4.89 (SO PowerPAD|8) 9 mm2: 3 x 3 (VSON|10)",
        "Package Group": "SO PowerPAD|8 VSON|10",
        "\"Approx. price\n(USD)\"": "$0.495 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS84610": {
        "Description": "2.95-V to 6-V Input 6-A synchronous buck integrated power solution",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck modules (integrated inductor)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "99 mm2: 9 x 11 (B1QFN|39)",
        "Package Group": "B1QFN|39",
        "\"Approx. price\n(USD)\"": "$3.850 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62150": {
        "Description": "3–17V 1A Step-Down Converter with DCS-Control in 3x3 QFN package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (VQFN|16)",
        "Package Group": "VQFN|16",
        "\"Approx. price\n(USD)\"": "$0.525 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62151": {
        "Description": "3–17V 1A Step-Down Converter in 3x3 QFN package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (VQFN|16)",
        "Package Group": "VQFN|16",
        "\"Approx. price\n(USD)\"": "$0.525 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62152": {
        "Description": "3–17V 1A Step-Down Converter in 3x3 QFN package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (VQFN|16)",
        "Package Group": "VQFN|16",
        "\"Approx. price\n(USD)\"": "$0.525 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62153": {
        "Description": "3–17V 1A Step-Down Converter in 3x3 QFN package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (VQFN|16)",
        "Package Group": "VQFN|16",
        "\"Approx. price\n(USD)\"": "$0.525 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS54295": {
        "Description": "4.5 V to 18 V input dual 2 A output synchronous step-down converter with adjustable soft start",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "32 mm2: 6.4 x 5 (HTSSOP|16) 16 mm2: 4 x 4 (QFN|16)",
        "Package Group": "HTSSOP|16 QFN|16",
        "\"Approx. price\n(USD)\"": "$0.920 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS54427": {
        "Description": "4.5V to 18V Input 4-A Synchronous Step-Down Converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "19 mm2: 3.9 x 4.89 (SO PowerPAD|8) 9 mm2: 3 x 3 (VSON|10)",
        "Package Group": "SO PowerPAD|8 VSON|10",
        "\"Approx. price\n(USD)\"": "$0.495 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62130": {
        "Description": "3-17V 3A Step-Down Converter with DCS-Control in 3x3 QFN Package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (VQFN|16)",
        "Package Group": "VQFN|16",
        "\"Approx. price\n(USD)\"": "$0.635 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62131": {
        "Description": "3-17V 3A Step-Down Converter in 3x3 QFN Package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (VQFN|16)",
        "Package Group": "VQFN|16",
        "\"Approx. price\n(USD)\"": "$0.635 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62132": {
        "Description": "3-17V 3A Step-Down Converter in 3x3 QFN Package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (VQFN|16)",
        "Package Group": "VQFN|16",
        "\"Approx. price\n(USD)\"": "$0.635 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62133": {
        "Description": "3-17V 3A Step-Down Converter in 3x3 QFN Package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (VQFN|16)",
        "Package Group": "VQFN|16",
        "\"Approx. price\n(USD)\"": "$0.635 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62140": {
        "Description": "3–17V 2A Step-Down Converter with DCS-Control in 3x3 QFN package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (VQFN|16)",
        "Package Group": "VQFN|16",
        "\"Approx. price\n(USD)\"": "$0.593 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62141": {
        "Description": "3–17V 2A Step-Down Converter in 3x3 QFN package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (VQFN|16)",
        "Package Group": "VQFN|16",
        "\"Approx. price\n(USD)\"": "$0.593 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62142": {
        "Description": "3–17V 2A Step-Down Converter in 3x3 QFN package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (VQFN|16)",
        "Package Group": "VQFN|16",
        "\"Approx. price\n(USD)\"": "$0.593 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62143": {
        "Description": "3–17V 2A Step-Down Converter in 3x3 QFN package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (VQFN|16)",
        "Package Group": "VQFN|16",
        "\"Approx. price\n(USD)\"": "$0.593 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS65135": {
        "Description": "Split-Rail Converter Single-Inductor Multiple-Output (SIMO) Regulator",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck-boost inverting & split-rail converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (WQFN|16)",
        "Package Group": "WQFN|16",
        "\"Approx. price\n(USD)\"": "$0.792 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62160": {
        "Description": "3V-17V 1A Step-Down Converters with DCS-Control&trade;",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "15 mm2: 4.9 x 3 (VSSOP|8) 4 mm2: 2 x 2 (WSON|8)",
        "Package Group": "VSSOP|8 WSON|8",
        "\"Approx. price\n(USD)\"": "$0.510 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62161": {
        "Description": "3V-17V 1A Step-Down Converters with DCS-Control&trade;",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "4 mm2: 2 x 2 (WSON|8)",
        "Package Group": "WSON|8",
        "\"Approx. price\n(USD)\"": "$0.510 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62162": {
        "Description": "3V-17V 1A Step-Down Converters with DCS-Control&trade;",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "4 mm2: 2 x 2 (WSON|8)",
        "Package Group": "WSON|8",
        "\"Approx. price\n(USD)\"": "$0.510 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62163": {
        "Description": "3V-17V 1A Step-Down Converters with DCS-Control™",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "4 mm2: 2 x 2 (WSON|8)",
        "Package Group": "WSON|8",
        "\"Approx. price\n(USD)\"": "$0.510 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62171": {
        "Description": "3–17V 0.5A Step-Down Converter in 2x2 QFN package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "4 mm2: 2 x 2 (WSON|8)",
        "Package Group": "WSON|8",
        "\"Approx. price\n(USD)\"": "$0.429 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62172": {
        "Description": "3–17V 0.5A Step-Down Converter in 2x2 QFN package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "4 mm2: 2 x 2 (WSON|8)",
        "Package Group": "WSON|8",
        "\"Approx. price\n(USD)\"": "$0.429 | 1ku",
        "Status": "ACTIVE"
    },
    "LM20144-Q1": {
        "Description": "Automotive Grade 2.95-5.5V 4A Current Mode Synchronous Buck Regulator with Adjustable Frequency",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "32 mm2: 6.4 x 5 (HTSSOP|16)",
        "Package Group": "HTSSOP|16",
        "\"Approx. price\n(USD)\"": "$1.313 | 1ku",
        "Status": "ACTIVE"
    },
    "LM20145-Q1": {
        "Description": "Automotive Grade 2.95-5.5V 5A Current Mode Synchronous Buck Regulator with Adjustable Frequency",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "32 mm2: 6.4 x 5 (HTSSOP|16)",
        "Package Group": "HTSSOP|16",
        "\"Approx. price\n(USD)\"": "$1.371 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62170": {
        "Description": "3–17V 0.5A Step-Down Converter with DCS-Control in 2x2 QFN package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "4 mm2: 2 x 2 (WSON|8)",
        "Package Group": "WSON|8",
        "\"Approx. price\n(USD)\"": "$0.429 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62173": {
        "Description": "3–17V 0.5A Step-Down Converter in 2x2 QFN package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "4 mm2: 2 x 2 (WSON|8)",
        "Package Group": "WSON|8",
        "\"Approx. price\n(USD)\"": "$0.429 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS54329E": {
        "Description": "4.5V to 18V Input 3A Synchronous Step-Down Converter w/ D-CAP2 Mode and Light Load Efficiency",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "19 mm2: 3.9 x 4.89 (SO PowerPAD|8)",
        "Package Group": "SO PowerPAD|8",
        "\"Approx. price\n(USD)\"": "$0.572 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS54229E": {
        "Description": "4.5V to 18V Input 2-A Synchronous Step-Down Converter with Eco-Mode",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "19 mm2: 3.9 x 4.89 (SO PowerPAD|8)",
        "Package Group": "SO PowerPAD|8",
        "\"Approx. price\n(USD)\"": "$0.494 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS61256": {
        "Description": "3.5-MHz 5-V 900-mA load boost converter in 1.2-mm x 1.3-mm WCSP",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "2 mm2: 1.4 x 1.4 (DSBGA|9)",
        "Package Group": "DSBGA|9",
        "\"Approx. price\n(USD)\"": "$0.418 | 1ku",
        "Status": "ACTIVE"
    },
    "LM25118-Q1": {
        "Description": "3-42-V wide VIN current mode non-synchronous buck-boost controller AEC-Q100 qualified",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck-boost & inverting controllers (external switch)",
        "Rating": "Automotive",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "42 mm2: 6.4 x 6.5 (HTSSOP|20)",
        "Package Group": "HTSSOP|20",
        "\"Approx. price\n(USD)\"": "$2.284 | 1ku",
        "Status": "ACTIVE"
    },
    "LMR14203": {
        "Description": "4.5V to 42V 0.3A Step-Down DC/DC Switching Regulator in SOT-23",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "5 mm2: 1.6 x 2.9 (SOT-23-THIN|6)",
        "Package Group": "SOT-23-THIN|6",
        "\"Approx. price\n(USD)\"": "$0.774 | 1ku",
        "Status": "ACTIVE"
    },
    "LMR14206": {
        "Description": "4.5V to 42V 0.6A Step-Down DC/DC Switching Regulator in SOT-23 Package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "5 mm2: 1.6 x 2.9 (SOT-23-THIN|6)",
        "Package Group": "SOT-23-THIN|6",
        "\"Approx. price\n(USD)\"": "$0.823 | 1ku",
        "Status": "ACTIVE"
    },
    "LMR62421": {
        "Description": "SIMPLE SWITCHER 2.7V to 5.5V 24Vout 2.1A Boost Converter in SOT-23",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "5 mm2: 1.6 x 2.9 (SOT-23|5) 9 mm2: 3 x 3 (WSON|6)",
        "Package Group": "SOT-23|5 WSON|6",
        "\"Approx. price\n(USD)\"": "$0.449 | 1ku",
        "Status": "ACTIVE"
    },
    "LMR10510": {
        "Description": "3V to 5.5V 1A Step-Down DC/DC Switching Regulator in SOT-23 Package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "5 mm2: 1.6 x 2.9 (SOT-23|5) 9 mm2: 3 x 3 (WSON|6)",
        "Package Group": "SOT-23|5 WSON|6",
        "\"Approx. price\n(USD)\"": "$0.341 | 1ku",
        "Status": "ACTIVE"
    },
    "LMR10515": {
        "Description": "5.5Vin 1.5A Step-Down Voltage Regulator in SOT-23 and LLP",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "5 mm2: 1.6 x 2.9 (SOT-23|5) 9 mm2: 3 x 3 (WSON|6)",
        "Package Group": "SOT-23|5 WSON|6",
        "\"Approx. price\n(USD)\"": "$0.374 | 1ku",
        "Status": "ACTIVE"
    },
    "LMR10520": {
        "Description": "5.5-VIN 2-A step-down voltage regulator in WSON",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (WSON|6)",
        "Package Group": "WSON|6",
        "\"Approx. price\n(USD)\"": "$0.418 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS54362-Q1": {
        "Description": "Automotive 3.6V to 48V 3A Buck Converter with Low Iq and Voltage Supervisor",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "42 mm2: 6.4 x 6.5 (HTSSOP|20)",
        "Package Group": "HTSSOP|20",
        "\"Approx. price\n(USD)\"": "$1.918 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS54821": {
        "Description": "4.5-V to 17-V 8-A synchronous buck converter with hiccup current limit",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "12 mm2: 3.5 x 3.5 (VQFN|14)",
        "Package Group": "VQFN|14",
        "\"Approx. price\n(USD)\"": "$1.322 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS53211": {
        "Description": "1.5-V to 19-V single phase PWM buck controller with light-load efficiency",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck controllers (external switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (VQFN|16)",
        "Package Group": "VQFN|16",
        "\"Approx. price\n(USD)\"": "$0.583 | 1ku",
        "Status": "ACTIVE"
    },
    "LMR24210": {
        "Description": "42Vin 1.0A Step-Down Voltage Regulator in micro SMD",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "See datasheet (DSBGA)",
        "Package Group": "DSBGA|28",
        "\"Approx. price\n(USD)\"": "$1.452 | 1ku",
        "Status": "ACTIVE"
    },
    "LMR24220": {
        "Description": "42Vin 2.0A Step-Down Voltage Regulator in micro SMD",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-20 to 125",
        "Package size: mm2:W x L (PKG)": "See datasheet (DSBGA)",
        "Package Group": "DSBGA|28",
        "\"Approx. price\n(USD)\"": "$1.936 | 1ku",
        "Status": "ACTIVE"
    },
    "LMR62014": {
        "Description": "SIMPLE SWITCHER&reg; 2.7V to 14V 1.4A Step-Up Regulator in SOT-23 Package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "5 mm2: 1.6 x 2.9 (SOT-23|5)",
        "Package Group": "SOT-23|5",
        "\"Approx. price\n(USD)\"": "$0.275 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS54229": {
        "Description": "4.5V to 18V Input 2-A Synchronous Step-Down Converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "19 mm2: 3.9 x 4.89 (SO PowerPAD|8)",
        "Package Group": "SO PowerPAD|8",
        "\"Approx. price\n(USD)\"": "$0.474 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS652510": {
        "Description": "4.5-V to 16-V input 3A/2A/2A output Synchronous triple buck converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "36 mm2: 6 x 6 (VQFN|40)",
        "Package Group": "VQFN|40",
        "\"Approx. price\n(USD)\"": "$1.549 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS84320": {
        "Description": "4.5-V to 14.5-V Input 3-A Synchronous Buck Integrated Power Solution",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck modules (integrated inductor)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "135 mm2: 9 x 15 (B1QFN|47)",
        "Package Group": "B1QFN|47",
        "\"Approx. price\n(USD)\"": "$4.400 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS54519": {
        "Description": "2.95V to 6V Input 5A Synchronous Step-Down Converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 140",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (WQFN|16)",
        "Package Group": "WQFN|16",
        "\"Approx. price\n(USD)\"": "$0.792 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS54623": {
        "Description": "4.5-V to 17-V 6-A synchronous SWIFT™ buck converter with light load efficiency",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 150",
        "Package size: mm2:W x L (PKG)": "12 mm2: 3.5 x 3.5 (VQFN|14)",
        "Package Group": "VQFN|14",
        "\"Approx. price\n(USD)\"": "$1.309 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS61170-Q1": {
        "Description": "3-V to 18-V wide input range 1.2-A boost converter in 2-mm x 2-mm QFN package AEC-Q100 qualified",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": "Functional Safety-Capable",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "4 mm2: 2 x 2 (WSON|6)",
        "Package Group": "WSON|6",
        "\"Approx. price\n(USD)\"": "$0.913 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS54329": {
        "Description": "4.5V to 18V Input 3A Synchronous Step-Down Converter with D-CAP2 Mode",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "19 mm2: 3.9 x 4.89 (SO PowerPAD|8)",
        "Package Group": "SO PowerPAD|8",
        "\"Approx. price\n(USD)\"": "$0.552 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62080": {
        "Description": "1.2A High Efficient Step Down Converter in 2x2mm SON Package with Adjustable Vout",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "4 mm2: 2 x 2 (WSON|8)",
        "Package Group": "WSON|8",
        "\"Approx. price\n(USD)\"": "$0.552 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62081": {
        "Description": "1.2A Wide Range Efficient Step Down Converter with Snooze Mode. 1.8 Vout (Min)",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "4 mm2: 2 x 2 (WSON|8)",
        "Package Group": "WSON|8",
        "\"Approx. price\n(USD)\"": "$0.552 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62082": {
        "Description": "1.2A High Efficient Step Down Converter in 2x2mm SON Package. 3.3 Vout (Min)",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "4 mm2: 2 x 2 (WSON|8)",
        "Package Group": "WSON|8",
        "\"Approx. price\n(USD)\"": "$0.552 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS61254": {
        "Description": "3.5-MHz 4.5-V 800-mA load boost converter in 1.2-mm x 1.3-mm WCSP",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "2 mm2: 1.4 x 1.4 (DSBGA|9)",
        "Package Group": "DSBGA|9",
        "\"Approx. price\n(USD)\"": "$0.418 | 1ku",
        "Status": "ACTIVE"
    },
    "LMR12010": {
        "Description": "3V to 20V 1A Step-Down DC/DC Switching Regulator in SOT-23",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "5 mm2: 1.6 x 2.9 (SOT-23-THIN|6)",
        "Package Group": "SOT-23-THIN|6",
        "\"Approx. price\n(USD)\"": "$0.774 | 1ku",
        "Status": "ACTIVE"
    },
    "LMR64010": {
        "Description": "SIMPLE SWITCHER&reg; 2.7V to 14V 1A Step-Up Regulator in SOT-23 Package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "5 mm2: 1.6 x 2.9 (SOT-23|5)",
        "Package Group": "SOT-23|5",
        "\"Approx. price\n(USD)\"": "$0.581 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS65270": {
        "Description": "2 Buck Converter with 4.5V to 16V Input Voltage 2A/3A Output Current",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "34 mm2: 4.4 x 7.8 (HTSSOP|24) 16 mm2: 4 x 4 (VQFN|24)",
        "Package Group": "HTSSOP|24 VQFN|24",
        "\"Approx. price\n(USD)\"": "$0.968 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS82676": {
        "Description": "600mA High-Efficiency MicroSiP™ Step-Down Converter (Profile <1.0mm)",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck modules (integrated inductor)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "7 mm2: 2.9 x 2.3 (uSiP|8)",
        "Package Group": "uSiP|8",
        "\"Approx. price\n(USD)\"": "$0.825 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS53353": {
        "Description": "High-efficiency 1.5-V to 15-V 20-A synchronous SWIFT™ buck converter with eco-mode",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "30 mm2: 5 x 6 (LSON-CLIP|22)",
        "Package Group": "LSON-CLIP|22",
        "\"Approx. price\n(USD)\"": "$2.952 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS54527": {
        "Description": "4.5V to 18V Input 5-A Synchronous Step-Down Converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "19 mm2: 3.9 x 4.89 (SO PowerPAD|8)",
        "Package Group": "SO PowerPAD|8",
        "\"Approx. price\n(USD)\"": "$0.605 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS54528": {
        "Description": "4.5V to 18V Input 5-A Synchronous Step-Down Converter with Eco-mode&trade;",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "19 mm2: 3.9 x 4.89 (SO PowerPAD|8)",
        "Package Group": "SO PowerPAD|8",
        "\"Approx. price\n(USD)\"": "$0.625 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62362": {
        "Description": "Processor Core Supply with I2C Compatible Interface and Remote Sense. 0.77 to 1.4 Vout",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "5 mm2: 2.25 x 2.25 (DSBGA|16)",
        "Package Group": "DSBGA|16",
        "\"Approx. price\n(USD)\"": "$0.706 | 1ku",
        "Status": "ACTIVE"
    },
    "LM27313-Q1": {
        "Description": "1.6 MHz boost converter with 30V Internal FET switch in SOT-23 AEC-Q100 qualified",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "5 mm2: 1.6 x 2.9 (SOT-23|5)",
        "Package Group": "SOT-23|5",
        "\"Approx. price\n(USD)\"": "$0.686 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS40400": {
        "Description": "3-V to 20-V 30-A synchronous buck controller with PMBus™ including Telemetry",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck controllers (external switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "19 mm2: 3.5 x 5.5 (VQFN|24)",
        "Package Group": "VQFN|24",
        "\"Approx. price\n(USD)\"": "$1.936 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS61256A": {
        "Description": "3.5-MHz 5-V 1-A load boost converter in 1.2-mm x 1.3-mm WCSP",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "2 mm2: 1.4 x 1.4 (DSBGA|9)",
        "Package Group": "DSBGA|9",
        "\"Approx. price\n(USD)\"": "$0.418 | 1ku",
        "Status": "ACTIVE"
    },
    "LM25117": {
        "Description": "4.5-42V Wide Vin Current Mode Synchronous Buck Controller with Tracking",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck controllers (external switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "42 mm2: 6.4 x 6.5 (HTSSOP|20) 16 mm2: 4 x 4 (WQFN|24)",
        "Package Group": "HTSSOP|20 WQFN|24",
        "\"Approx. price\n(USD)\"": "$1.646 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS51123A": {
        "Description": "4.5-V to 28-V dual-synchronous buck controller with low IQ and flexible external components",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck controllers (external switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "16 mm2: 4 x 4 (VQFN|24)",
        "Package Group": "VQFN|24",
        "\"Approx. price\n(USD)\"": "$1.888 | 1ku",
        "Status": "ACTIVE"
    },
    "LM3242": {
        "Description": "6MHz 750mA Miniature Adjustable Step-Down DC-DC Converter with Bypass",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-30 to 90",
        "Package size: mm2:W x L (PKG)": "See datasheet (DSBGA)",
        "Package Group": "DSBGA|9",
        "\"Approx. price\n(USD)\"": "$0.517 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS54225-Q1": {
        "Description": "Automotive 4.5V to 18V 2A Synchronous Buck Converter with DCAP2 Mode",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 105",
        "Package size: mm2:W x L (PKG)": "22 mm2: 4.4 x 5 (HTSSOP|14)",
        "Package Group": "HTSSOP|14",
        "\"Approx. price\n(USD)\"": "$1.371 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS54325-Q1": {
        "Description": "Automotive 4.5V to 18V 3A Synchronous Buck Converter with DCAP2 Mode",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 105",
        "Package size: mm2:W x L (PKG)": "22 mm2: 4.4 x 5 (HTSSOP|14)",
        "Package Group": "HTSSOP|14",
        "\"Approx. price\n(USD)\"": "$1.486 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS54478": {
        "Description": "2.95V to 6V Input 4A Synchronous Step-Down SWIFT™ Converter with Hiccup Current Limit",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 150",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (WQFN|16)",
        "Package Group": "WQFN|16",
        "\"Approx. price\n(USD)\"": "$1.073 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS65253": {
        "Description": "4.5V to 16V input 2.5A/3.5A output Dual Buck Converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "25 mm2: 5 x 5 (VQFN|28)",
        "Package Group": "VQFN|28",
        "\"Approx. price\n(USD)\"": "$1.549 | 1ku",
        "Status": "ACTIVE"
    },
    "LM20143-Q1": {
        "Description": "Automotive Grade 2.95-5.5V 3A Current Mode Synchronous Buck Regulator with Adjustable Frequency",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "32 mm2: 6.4 x 5 (HTSSOP|16)",
        "Package Group": "HTSSOP|16",
        "\"Approx. price\n(USD)\"": "$1.428 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS40322": {
        "Description": "Dual Output or Two-phase Synchronous Buck Controller",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck controllers (external switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "25 mm2: 5 x 5 (VQFN|32)",
        "Package Group": "VQFN|32",
        "\"Approx. price\n(USD)\"": "$1.355 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS54429": {
        "Description": "7V to 18V Input 4.5A Synchronous Step-Down DCAP2 Mode Converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-20 to 85",
        "Package size: mm2:W x L (PKG)": "22 mm2: 4.4 x 5 (HTSSOP|14)",
        "Package Group": "HTSSOP|14",
        "\"Approx. price\n(USD)\"": "$0.774 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS54429E": {
        "Description": "7V to 18V Input 4.5A Synchronous Step-Down DCAP2 Mode Converter with Eco-Mode",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-20 to 85",
        "Package size: mm2:W x L (PKG)": "22 mm2: 4.4 x 5 (HTSSOP|14) 16 mm2: 4 x 4 (QFN|16)",
        "Package Group": "HTSSOP|14 QFN|16",
        "\"Approx. price\n(USD)\"": "$0.794 | 1ku",
        "Status": "ACTIVE"
    },
    "LM21305": {
        "Description": "3-18V 5A Current Mode Synchronous Buck Regulator with Adjustable Frequency",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "25 mm2: 5 x 5 (WQFN|28)",
        "Package Group": "WQFN|28",
        "\"Approx. price\n(USD)\"": "$2.420 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62360": {
        "Description": "Processor Core Supply with I2C Compatible Interface and Remote Sense. 0.77 to 1.4 Vout",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "5 mm2: 2.25 x 2.25 (DSBGA|16)",
        "Package Group": "DSBGA|16",
        "\"Approx. price\n(USD)\"": "$0.706 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62361B": {
        "Description": "Processor Core Supply with I2C Compatible Interface and Remote Sense. 0.5 to 1.77 Vout",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "5 mm2: 2.25 x 2.25 (DSBGA|16)",
        "Package Group": "DSBGA|16",
        "\"Approx. price\n(USD)\"": "$0.706 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62730": {
        "Description": "Step Down Converter with Bypass Mode for Ultra Low Power Wireless Applications",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "1 mm2: 1 x 1.45 (SON|6)",
        "Package Group": "SON|6",
        "\"Approx. price\n(USD)\"": "$0.426 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS82677": {
        "Description": "600mA High-Efficiency MicroSiP&trade; Step-Down Converter Module (Profile <1.0mm).",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck modules (integrated inductor)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "7 mm2: 2.9 x 2.3 (uSiP|8)",
        "Package Group": "uSiP|8",
        "\"Approx. price\n(USD)\"": "$0.825 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS61261": {
        "Description": "Tiny Low Input Voltage Boost Converter with 3.3 Output Voltage",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "4 mm2: 2 x 2 (WSON|6)",
        "Package Group": "WSON|6",
        "\"Approx. price\n(USD)\"": "$0.367 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS53314": {
        "Description": "4.5-V to 25-V 6-A synchronous buck converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "35 mm2: 5 x 7 (VQFN|40)",
        "Package Group": "VQFN|40",
        "\"Approx. price\n(USD)\"": "$1.650 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS54062": {
        "Description": "4.7V to 60V Input 50mA Synchronous Step-Down Converter with Low IQ",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (SON|8) 15 mm2: 4.9 x 3 (VSSOP|8)",
        "Package Group": "SON|8 VSSOP|8",
        "\"Approx. price\n(USD)\"": "$0.613 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS61260": {
        "Description": "Tiny Low Input Voltage Boost Converter with Adjustable Output Voltage",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "4 mm2: 2 x 2 (WSON|6)",
        "Package Group": "WSON|6",
        "\"Approx. price\n(USD)\"": "$0.367 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS54227": {
        "Description": "4.5 V to 18 V input 2 A synchronous step-down converter in HSOP and VSON package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "19 mm2: 3.9 x 4.89 (SO PowerPAD|8) 9 mm2: 3 x 3 (VSON|10)",
        "Package Group": "SO PowerPAD|8 VSON|10",
        "\"Approx. price\n(USD)\"": "$0.310 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS54228": {
        "Description": "4.5V to 18V Input 2-A Synchronous Step-Down Converter with Eco-mode™",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "19 mm2: 3.9 x 4.89 (SO PowerPAD|8) 19 mm2: 3.91 x 4.9 (SOIC|8) 9 mm2: 3 x 3 (VSON|10)",
        "Package Group": "SO PowerPAD|8 SOIC|8 VSON|10",
        "\"Approx. price\n(USD)\"": "$0.330 | 1ku",
        "Status": "ACTIVE"
    },
    "LM5117": {
        "Description": "5.5-65V Wide Vin Current Mode Synchronous Buck Controller with Analog Current Monitor",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck controllers (external switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "42 mm2: 6.4 x 6.5 (HTSSOP|20) 16 mm2: 4 x 4 (WQFN|24)",
        "Package Group": "HTSSOP|20 WQFN|24",
        "\"Approx. price\n(USD)\"": "$2.033 | 1ku",
        "Status": "ACTIVE"
    },
    "LM5117-Q1": {
        "Description": "Automotive Grade 5.5-65V Wide Vin Current Mode Synchronous Buck Controller w Analog Current Monitor",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck controllers (external switch)",
        "Rating": "Automotive",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "42 mm2: 6.4 x 6.5 (HTSSOP|20) 16 mm2: 4 x 4 (WQFN|24)",
        "Package Group": "HTSSOP|20 WQFN|24",
        "\"Approx. price\n(USD)\"": "$2.399 | 1ku",
        "Status": "ACTIVE"
    },
    "LMZ13608": {
        "Description": "8A SIMPLE SWITCHER&reg; Power Module with 36V Maximum Input Voltage",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck modules (integrated inductor)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "267 mm2: 17.79 x 15 (PFM|11)",
        "Package Group": "PFM|11",
        "\"Approx. price\n(USD)\"": "$12.390 | 1ku",
        "Status": "ACTIVE"
    },
    "LMZ13610": {
        "Description": "10A SIMPLE SWITCHER&reg; Power Module with 36V Maximum Input Voltage",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck modules (integrated inductor)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "267 mm2: 17.79 x 15 (PFM|11)",
        "Package Group": "PFM|11",
        "\"Approx. price\n(USD)\"": "$13.649 | 1ku",
        "Status": "ACTIVE"
    },
    "LMZ23608": {
        "Description": "8A SIMPLE SWITCHER&reg; Power Module with 36V Maximum Input Voltage and Current Sharing",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck modules (integrated inductor)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "267 mm2: 17.79 x 15 (PFM|11)",
        "Package Group": "PFM|11",
        "\"Approx. price\n(USD)\"": "$13.358 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62061": {
        "Description": "3MHz 1.6A Step-Down Converter in 2x2mm SON Package Vout=1.8V",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "4 mm2: 2 x 2 (WSON|8)",
        "Package Group": "WSON|8",
        "\"Approx. price\n(USD)\"": "$0.682 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62063": {
        "Description": "3MHz 1.6A Step-Down Converter in 2x2mm SON Package Vout=3.3V",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "4 mm2: 2 x 2 (WSON|8)",
        "Package Group": "WSON|8",
        "\"Approx. price\n(USD)\"": "$0.682 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62671": {
        "Description": "500-mA 6-MHz High-Efficiency Step-Down Converter Vout=1.8V",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "1 mm2: 1 x 1.4 (DSBGA|6)",
        "Package Group": "DSBGA|6",
        "\"Approx. price\n(USD)\"": "$0.418 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62675": {
        "Description": "500-mA 6-MHz High-Efficiency Step-Down Converter Vout=1.2V",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "1 mm2: 1 x 1.4 (DSBGA|6)",
        "Package Group": "DSBGA|6",
        "\"Approx. price\n(USD)\"": "$0.418 | 1ku",
        "Status": "ACTIVE"
    },
    "LM21215A": {
        "Description": "2.95-5.5V 15A  Voltage Mode Synchronous Buck Regulator with Frequency Synchronization",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "42 mm2: 6.4 x 6.5 (HTSSOP|20)",
        "Package Group": "HTSSOP|20",
        "\"Approx. price\n(USD)\"": "$3.080 | 1ku",
        "Status": "ACTIVE"
    },
    "LMZ12008": {
        "Description": "8A SIMPLE SWITCHER&reg; Power Module with 20V Maximum Input Voltage",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck modules (integrated inductor)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "267 mm2: 17.79 x 15 (PFM|11)",
        "Package Group": "PFM|11",
        "\"Approx. price\n(USD)\"": "$9.939 | 1ku",
        "Status": "ACTIVE"
    },
    "LMZ12010": {
        "Description": "10A SIMPLE SWITCHER&reg; Power Module with 20V Maximum Input Voltage",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck modules (integrated inductor)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "267 mm2: 17.79 x 15 (PFM|11)",
        "Package Group": "PFM|11",
        "\"Approx. price\n(USD)\"": "$10.450 | 1ku",
        "Status": "ACTIVE"
    },
    "LMZ22008": {
        "Description": "8A SIMPLE SWITCHER&reg; Power Module with 20V Maximum Input Voltage and Current Sharing",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck modules (integrated inductor)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "267 mm2: 17.79 x 15 (PFM|11)",
        "Package Group": "PFM|11",
        "\"Approx. price\n(USD)\"": "$10.780 | 1ku",
        "Status": "ACTIVE"
    },
    "LMZ22010": {
        "Description": "10A SIMPLE SWITCHER&reg; Power Module with 20V Maximum Input Voltage and Current Sharing",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck modules (integrated inductor)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "267 mm2: 17.79 x 15 (PFM|11)",
        "Package Group": "PFM|11",
        "\"Approx. price\n(USD)\"": "$11.000 | 1ku",
        "Status": "ACTIVE"
    },
    "LM5006": {
        "Description": "6-75V Wide Vin 600mA Constant On-Time Non-Synchronous Buck Regulator",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (VSSOP|10)",
        "Package Group": "VSSOP|10",
        "\"Approx. price\n(USD)\"": "$1.355 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS51220A-Q1": {
        "Description": "3-V to 28-V synchronous peak current mode automotive buck controller in RSN/RTV package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck controllers (external switch)",
        "Rating": "Automotive",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "25 mm2: 5 x 5 (WQFN|32)",
        "Package Group": "WQFN|32",
        "\"Approx. price\n(USD)\"": "$1.558 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS51317": {
        "Description": "3.3V / 5V Input 6A D-CAP+ Mode Synchronous Step-Down Converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "14 mm2: 3.5 x 4 (VQFN|20)",
        "Package Group": "VQFN|20",
        "\"Approx. price\n(USD)\"": "$1.386 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS54622": {
        "Description": "4.5-V to 17-V 6-A synchronous SWIFT™ buck converter with hiccup current limit",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "\"-40 to 125\n-40 to 150\"",
        "Package size: mm2:W x L (PKG)": "12 mm2: 3.5 x 3.5 (VQFN|14)",
        "Package Group": "VQFN|14",
        "\"Approx. price\n(USD)\"": "$1.673 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS40170": {
        "Description": "4.5 V to 60 V Wide-Input Synchronous PWM Buck Controller",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck controllers (external switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "16 mm2: 3.5 x 4.5 (VQFN|20)",
        "Package Group": "VQFN|20",
        "\"Approx. price\n(USD)\"": "$2.323 | 1ku",
        "Status": "ACTIVE"
    },
    "LM34922": {
        "Description": "6-28V 2A Constant On-Time Non-Synchronous Buck Regulator with Adjustable Current Limit",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (HVSSOP|10)",
        "Package Group": "HVSSOP|10",
        "\"Approx. price\n(USD)\"": "$0.920 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62690": {
        "Description": "500-mA 4-MHz 2.85-Vout High-Efficiency Step-Down Converter in Chip Scale Packaging",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "See datasheet (DSBGA)",
        "Package Group": "DSBGA|6",
        "\"Approx. price\n(USD)\"": "$0.446 | 1ku",
        "Status": "ACTIVE"
    },
    "LMZ22003": {
        "Description": "3A SIMPLE SWITCHER&reg; Power Module with 20V Maximum Input Voltage",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck modules (integrated inductor)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "140 mm2: 13.77 x 10.16 (TO-PMOD|7)",
        "Package Group": "TO-PMOD|7",
        "\"Approx. price\n(USD)\"": "$5.104 | 1ku",
        "Status": "ACTIVE"
    },
    "LMZ22005": {
        "Description": "5A SIMPLE SWITCHER&reg; Power Module with 20V Maximum Input Voltage",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck modules (integrated inductor)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "140 mm2: 13.77 x 10.16 (TO-PMOD|7)",
        "Package Group": "TO-PMOD|7",
        "\"Approx. price\n(USD)\"": "$5.951 | 1ku",
        "Status": "ACTIVE"
    },
    "LMZ23603": {
        "Description": "3A SIMPLE SWITCHER&reg; Power Module with 36V Maximum Input Voltage",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck modules (integrated inductor)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "140 mm2: 13.77 x 10.16 (TO-PMOD|7)",
        "Package Group": "TO-PMOD|7",
        "\"Approx. price\n(USD)\"": "$7.696 | 1ku",
        "Status": "ACTIVE"
    },
    "TLV61224": {
        "Description": "Single cell 3V output voltage high efficient step-up converter in 6 pin SC-70 package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "4 mm2: 2.1 x 2 (SC70|6)",
        "Package Group": "SC70|6",
        "\"Approx. price\n(USD)\"": "$0.339 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS56121": {
        "Description": "4.5-V to 14-V 15-A synchronous SWIFT™ buck converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "30 mm2: 5 x 6 (LSON-CLIP|22)",
        "Package Group": "LSON-CLIP|22",
        "\"Approx. price\n(USD)\"": "$2.800 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS56221": {
        "Description": "4.5-V to 14-V 25-A synchronous SWIFT™ buck converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "30 mm2: 5 x 6 (LSON-CLIP|22)",
        "Package Group": "LSON-CLIP|22",
        "\"Approx. price\n(USD)\"": "$3.135 | 1ku",
        "Status": "ACTIVE"
    },
    "LM34923": {
        "Description": "80V 600 mA Constant On-Time Buck Switching Regulator",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (VSSOP|10)",
        "Package Group": "VSSOP|10",
        "\"Approx. price\n(USD)\"": "$0.935 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS53355": {
        "Description": "High-efficiency 1.5-V to 15-V 30-A synchronous SWIFT™ buck converter with eco-mode",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "30 mm2: 5 x 6 (LSON-CLIP|22)",
        "Package Group": "LSON-CLIP|22",
        "\"Approx. price\n(USD)\"": "$3.575 | 1ku",
        "Status": "ACTIVE"
    },
    "LM25088-Q1": {
        "Description": "Automotive Grade 4.5-42V Wide Vin Current Mode Non-Synchronous Buck Controller",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck controllers (external switch)",
        "Rating": "Automotive",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "32 mm2: 6.4 x 5 (HTSSOP|16)",
        "Package Group": "HTSSOP|16",
        "\"Approx. price\n(USD)\"": "$1.428 | 1ku",
        "Status": "ACTIVE"
    },
    "LM5088-Q1": {
        "Description": "Automotive Grade 4.5-75V Wide Vin Current Mode Non-Synchronous Buck Controller",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck controllers (external switch)",
        "Rating": "Automotive",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "32 mm2: 6.4 x 5 (HTSSOP|16)",
        "Package Group": "HTSSOP|16",
        "\"Approx. price\n(USD)\"": "$1.679 | 1ku",
        "Status": "ACTIVE"
    },
    "LM22680-Q1": {
        "Description": "2A SIMPLE SWITCHER&reg; Step-Down Voltage Regulator with Precision Enable",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "19 mm2: 3.9 x 4.89 (SO PowerPAD|8)",
        "Package Group": "SO PowerPAD|8",
        "\"Approx. price\n(USD)\"": "$1.942 | 1ku",
        "Status": "ACTIVE"
    },
    "LM22676-Q1": {
        "Description": "3A SIMPLE SWITCHER Step-Down Voltage Regulator with Precision Enable",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "19 mm2: 3.9 x 4.89 (SO PowerPAD|8) 100 mm2: 9.85 x 10.16 (TO-263|7)",
        "Package Group": "SO PowerPAD|8 TO-263|7",
        "\"Approx. price\n(USD)\"": "$2.056 | 1ku",
        "Status": "ACTIVE"
    },
    "LM22678-Q1": {
        "Description": "5A SIMPLE SWITCHER Step-Down Voltage Regulator with Precision Enable",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "100 mm2: 9.85 x 10.16 (TO-263|7)",
        "Package Group": "TO-263|7",
        "\"Approx. price\n(USD)\"": "$2.799 | 1ku",
        "Status": "ACTIVE"
    },
    "LM21212-1": {
        "Description": "2.95-5.5V 12A Voltage Mode Synchronous Buck Regulator with Frequency Synchronization",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "42 mm2: 6.4 x 6.5 (HTSSOP|20)",
        "Package Group": "HTSSOP|20",
        "\"Approx. price\n(USD)\"": "$2.585 | 1ku",
        "Status": "ACTIVE"
    },
    "LM21212-2": {
        "Description": "2.95-5.5V 12A Voltage Mode Synchronous Buck Regulator with Adjustable Frequency",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "42 mm2: 6.4 x 6.5 (HTSSOP|20)",
        "Package Group": "HTSSOP|20",
        "\"Approx. price\n(USD)\"": "$2.585 | 1ku",
        "Status": "ACTIVE"
    },
    "LM21215": {
        "Description": "2.95-5.5V 15A Voltage Mode Synchronous Buck Regulator with Adjustable Frequency",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "42 mm2: 6.4 x 6.5 (HTSSOP|20)",
        "Package Group": "HTSSOP|20",
        "\"Approx. price\n(USD)\"": "$3.080 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62260-Q1": {
        "Description": "Automotive 2V to 6V 2.25MHz Fixed Frequency 600mA Buck Converter in 2x2mm SON/TSOT23 Package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "\"-40 to 105\n-40 to 85\"",
        "Package size: mm2:W x L (PKG)": "8 mm2: 2.8 x 2.9 (SOT-23-THIN|5) 4 mm2: 2 x 2 (WSON|6)",
        "Package Group": "SOT-23-THIN|5 WSON|6",
        "\"Approx. price\n(USD)\"": "$0.575 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS51219": {
        "Description": "3-V to 28-V synchronous buck controller with differential voltage feedback",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck controllers (external switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (WQFN|16)",
        "Package Group": "WQFN|16",
        "\"Approx. price\n(USD)\"": "$0.880 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62651": {
        "Description": "800mA 6MHz High Efficiency Step-Down Converter with I2C Compatible Interface",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "2 mm2: 1.4 x 1.4 (DSBGA|9)",
        "Package Group": "DSBGA|9",
        "\"Approx. price\n(USD)\"": "$0.572 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62679": {
        "Description": "500-mA 6-MHz High-Efficiency Step-Down Converter Vout=1.26V with Output Capacitor Discharge",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "2 mm2: 1.5 x 1.1 (DSLGA|6)",
        "Package Group": "DSLGA|6",
        "\"Approx. price\n(USD)\"": "$0.418 | 1ku",
        "Status": "ACTIVE"
    },
    "LMZ14201H": {
        "Description": "SIMPLE SWITCHER&reg; 6V to 42V 1A High Output Voltage Power Module",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck modules (integrated inductor)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "140 mm2: 13.77 x 10.16 (TO-PMOD|7)",
        "Package Group": "TO-PMOD|7",
        "\"Approx. price\n(USD)\"": "$5.663 | 1ku",
        "Status": "ACTIVE"
    },
    "LMZ14202H": {
        "Description": "SIMPLE SWITCHER&reg; 6V to 42V 2A High Output Voltage Power Module",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck modules (integrated inductor)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "140 mm2: 13.77 x 10.16 (TO-PMOD|7)",
        "Package Group": "TO-PMOD|7",
        "\"Approx. price\n(USD)\"": "$6.534 | 1ku",
        "Status": "ACTIVE"
    },
    "LMZ14203H": {
        "Description": "SIMPLE SWITCHER&reg; 6V to 42V 3A High Output Voltage Power Module",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck modules (integrated inductor)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "140 mm2: 13.77 x 10.16 (TO-PMOD|7)",
        "Package Group": "TO-PMOD|7",
        "\"Approx. price\n(USD)\"": "$8.228 | 1ku",
        "Status": "ACTIVE"
    },
    "TLV61225": {
        "Description": "Single cell 3.3V output voltage high efficient step-up converter in 6 pin SC-70 package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "4 mm2: 2.1 x 2 (SC70|6)",
        "Package Group": "SC70|6",
        "\"Approx. price\n(USD)\"": "$0.339 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS53315": {
        "Description": "3-V to 15-V 12-A synchronous buck converter with optimized light load efficiency",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "35 mm2: 5 x 7 (VQFN|40)",
        "Package Group": "VQFN|40",
        "\"Approx. price\n(USD)\"": "$2.662 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS54260-Q1": {
        "Description": "Automotive 3.5V to 60V 2.5A Step-down Converter with Eco-Mode™",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (HVSSOP|10) 9 mm2: 3 x 3 (VSON|10)",
        "Package Group": "HVSSOP|10 VSON|10",
        "\"Approx. price\n(USD)\"": "$1.815 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS54240-Q1": {
        "Description": "Automotive 3.5V to 42V 2.5A Buck Converter with Eco-Mode&trade;",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (HVSSOP|10) 9 mm2: 3 x 3 (VSON|10)",
        "Package Group": "HVSSOP|10 VSON|10",
        "\"Approx. price\n(USD)\"": "$1.453 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS57140-Q1": {
        "Description": "Automotive 3.5V to 42V 1.5A Buck Converter with Eco-Mode&trade;",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (HVSSOP|10) 9 mm2: 3 x 3 (VSON|10)",
        "Package Group": "HVSSOP|10 VSON|10",
        "\"Approx. price\n(USD)\"": "$1.248 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS57160-Q1": {
        "Description": "Automotive 3.5V to 60V 1.5A Buck Converter with Eco-Mode&trade;",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (HVSSOP|10) 9 mm2: 3 x 3 (VSON|10)",
        "Package Group": "HVSSOP|10 VSON|10",
        "\"Approx. price\n(USD)\"": "$1.635 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS57040-Q1": {
        "Description": "Automotive 3.5V to 42V 500mA Buck Converter with Eco-Mode&trade;",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (HVSSOP|10) 9 mm2: 3 x 3 (VSON|10)",
        "Package Group": "HVSSOP|10 VSON|10",
        "\"Approx. price\n(USD)\"": "$0.911 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS57060-Q1": {
        "Description": "Automotive 3.5V to 60V 500mA Buck Converter with Eco-Mode&trade;",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (HVSSOP|10) 9 mm2: 3 x 3 (VSON|10)",
        "Package Group": "HVSSOP|10 VSON|10",
        "\"Approx. price\n(USD)\"": "$1.451 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS61240-Q1": {
        "Description": "2.3-V to 5.5-V input range 3.5-MHz fixed frequency 450-mA boost converter AEC-Q100 qualified",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": "Functional Safety-Capable",
        "\"Operating temperature range\n(C)\"": "\"-40 to 105\n-40 to 85\"",
        "Package size: mm2:W x L (PKG)": "4 mm2: 2 x 2 (WSON|6)",
        "Package Group": "WSON|6",
        "\"Approx. price\n(USD)\"": "$0.704 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62590-Q1": {
        "Description": "Automotive 2.5V to 6V 2.25MHz Fixed Frequency 1A Buck Converter in 2x2mm SON Package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 105",
        "Package size: mm2:W x L (PKG)": "4 mm2: 2 x 2 (WSON|6)",
        "Package Group": "WSON|6",
        "\"Approx. price\n(USD)\"": "$0.631 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS51461": {
        "Description": "3.3V to 5V Input 6A D-CAP+ Mode Synchronous Step-Down Converter with 2-Bit VID",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "16 mm2: 4 x 4 (VQFN|24)",
        "Package Group": "VQFN|24",
        "\"Approx. price\n(USD)\"": "$2.856 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS53310": {
        "Description": "2.9V to 6V 3-A Step-Down Converter with Integrated MOSFETs",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (VQFN|16)",
        "Package Group": "VQFN|16",
        "\"Approx. price\n(USD)\"": "$1.404 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS53321": {
        "Description": "2.9V to 6V 5-A Step-Down Converter with Integrated MOSFETs",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (VQFN|16)",
        "Package Group": "VQFN|16",
        "\"Approx. price\n(USD)\"": "$0.924 | 1ku",
        "Status": "ACTIVE"
    },
    "LM8850": {
        "Description": "High-Performance Step-Up DC-DC Converter for High-Power Applications in Mobile Devices",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "See datasheet (DSBGA)",
        "Package Group": "DSBGA|9",
        "\"Approx. price\n(USD)\"": "$0.387 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS5401": {
        "Description": "3.5V to 42V Input 0.5 A Step Down Converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 150",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (HVSSOP|10)",
        "Package Group": "HVSSOP|10",
        "\"Approx. price\n(USD)\"": "$0.678 | 1ku",
        "Status": "ACTIVE"
    },
    "TLV62065": {
        "Description": "3MHz 2A Step Down Converter in 2x2 SON Package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "4 mm2: 2 x 2 (WSON|8)",
        "Package Group": "WSON|8",
        "\"Approx. price\n(USD)\"": "$0.542 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS51211": {
        "Description": "4.5-V to 28-V synchronous buck controller for notebook power",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck controllers (external switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (WSON|10)",
        "Package Group": "WSON|10",
        "\"Approx. price\n(USD)\"": "$1.162 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS54328": {
        "Description": "4.5V to 18V Input 3-A Synchronous Step-Down Converter with Eco-mode™",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "19 mm2: 3.9 x 4.89 (SO PowerPAD|8) 9 mm2: 3 x 3 (VSON|10)",
        "Package Group": "SO PowerPAD|8 VSON|10",
        "\"Approx. price\n(USD)\"": "$0.438 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS54327": {
        "Description": "4.5V to 18V Input 3-A Synchronous Step-Down Converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "19 mm2: 3.9 x 4.89 (SO PowerPAD|8) 9 mm2: 3 x 3 (VSON|10)",
        "Package Group": "SO PowerPAD|8 VSON|10",
        "\"Approx. price\n(USD)\"": "$0.418 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS54618": {
        "Description": "2.95V to 6V Input 6A Synchronous Step-Down SWIFT™ Converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 150",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (WQFN|16)",
        "Package Group": "WQFN|16",
        "\"Approx. price\n(USD)\"": "$1.360 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS54331-Q1": {
        "Description": "Automotive 3.5V to 28V 570kHz Fixed Frequency 3A Buck Converter with Eco-Mode&trade;",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 150",
        "Package size: mm2:W x L (PKG)": "19 mm2: 3.91 x 4.9 (SOIC|8)",
        "Package Group": "SOIC|8",
        "\"Approx. price\n(USD)\"": "$1.309 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS82671": {
        "Description": "600mA Fully Integrated Low Noise Step-Down Converter Module in MicroSiP&trade; Package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck modules (integrated inductor)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "7 mm2: 2.9 x 2.3 (uSiP|8)",
        "Package Group": "uSiP|8",
        "\"Approx. price\n(USD)\"": "$0.825 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS82675": {
        "Description": "600mA Fully Integrated Low Noise Step-Down Converter Module in MicroSiP&trade; Package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck modules (integrated inductor)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "7 mm2: 2.9 x 2.3 (uSiP|8)",
        "Package Group": "uSiP|8",
        "\"Approx. price\n(USD)\"": "$0.825 | 1ku",
        "Status": "ACTIVE"
    },
    "LM8801": {
        "Description": "High Precision 6MHz 600 mA Synchronous Step-Down DC-DC Converter for Mobile Applications",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-30 to 85",
        "Package size: mm2:W x L (PKG)": "See datasheet (DSBGA)",
        "Package Group": "DSBGA|6",
        "\"Approx. price\n(USD)\"": "$0.464 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS59620": {
        "Description": "Dual Phase D-CAP+&trade; Mode Step Down Controller for IMVP6+ CPU/GPU Vcore in Embedded Computing",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck controllers (external switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 105",
        "Package size: mm2:W x L (PKG)": "36 mm2: 6 x 6 (VQFN|40)",
        "Package Group": "VQFN|40",
        "\"Approx. price\n(USD)\"": "$2.013 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS61251": {
        "Description": "3.5-MHz 1.5-A 92% efficient boost converter adjustable input current Limit ±10% current accuracy",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "4 mm2: 2 x 2 (WSON|8)",
        "Package Group": "WSON|8",
        "\"Approx. price\n(USD)\"": "$0.567 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS61252": {
        "Description": "3.5-MHz 1.5-A 92% efficient boost converter adjustable input current Limit ±20% current accuracy",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "4 mm2: 2 x 2 (WSON|8)",
        "Package Group": "WSON|8",
        "\"Approx. price\n(USD)\"": "$0.567 | 1ku",
        "Status": "ACTIVE"
    },
    "PTD08A210W": {
        "Description": "Single 10-A Output 4.75V to 14V Input Non-Isolated Digital PowerTrain Module",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck modules (integrated inductor)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "310 mm2: 20.32 x 15.24 (DIP MODULE|16)",
        "Package Group": "DIP MODULE|16",
        "\"Approx. price\n(USD)\"": "$10.251 | 1ku",
        "Status": "ACTIVE"
    },
    "TL2575HV-05-Q1": {
        "Description": "Automotive Catalog 1-A Simple Step-Down Switching Voltage Regulators",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "155 mm2: 15.24 x 10.16 (DDPAK/TO-263|5)",
        "Package Group": "DDPAK/TO-263|5",
        "\"Approx. price\n(USD)\"": "$1.546 | 1ku",
        "Status": "ACTIVE"
    },
    "TL2575HV-33-Q1": {
        "Description": "Automotive Catalog 1-A Simple Step-Down Switching Voltage Regulators",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "155 mm2: 15.24 x 10.16 (DDPAK/TO-263|5)",
        "Package Group": "DDPAK/TO-263|5",
        "\"Approx. price\n(USD)\"": "$1.546 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62290-Q1": {
        "Description": "Automotive 2.3V to 6V 2.25MHz Fixed Frequency 1A Buck Converter in 2x2mm SON/TSOT23 Package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "\"-40 to 105\n-40 to 85\"",
        "Package size: mm2:W x L (PKG)": "4 mm2: 2 x 2 (WSON|6)",
        "Package Group": "WSON|6",
        "\"Approx. price\n(USD)\"": "$0.709 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62293-Q1": {
        "Description": "Automotive 2.3V to 6V 2.25MHz Fixed Frequency 1A Buck Converter with 1.8V Fixed Output Voltage",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 105",
        "Package size: mm2:W x L (PKG)": "4 mm2: 2 x 2 (WSON|6)",
        "Package Group": "WSON|6",
        "\"Approx. price\n(USD)\"": "$0.709 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62665": {
        "Description": "1000mA 6-MHz Synchronous Step-Down Converter in Chip Scale Packaging",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "See datasheet (DSBGA)",
        "Package Group": "DSBGA|6",
        "\"Approx. price\n(USD)\"": "$0.571 | 1ku",
        "Status": "ACTIVE"
    },
    "LM25119": {
        "Description": "4.5-42V Wide Vin Current Mode Dual Synchronous Buck Controller",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck controllers (external switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "25 mm2: 5 x 5 (WQFN|32)",
        "Package Group": "WQFN|32",
        "\"Approx. price\n(USD)\"": "$2.288 | 1ku",
        "Status": "ACTIVE"
    },
    "LM5119": {
        "Description": "5.5-65V Wide Vin Current Mode Dual Synchronous Buck Controller",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck controllers (external switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "25 mm2: 5 x 5 (WQFN|32)",
        "Package Group": "WQFN|32",
        "\"Approx. price\n(USD)\"": "$2.860 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS54320": {
        "Description": "4.5V to 17V Input 3A Synchronous Step-Down SWIFT&trade; Converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 150",
        "Package size: mm2:W x L (PKG)": "12 mm2: 3.5 x 3.5 (VQFN|14)",
        "Package Group": "VQFN|14",
        "\"Approx. price\n(USD)\"": "$0.880 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62120": {
        "Description": "15V 75mA 96% efficiency Step-Down Converter with DCS-Control",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "8 mm2: 2.8 x 2.9 (SOT-23|8)",
        "Package Group": "SOT-23|8",
        "\"Approx. price\n(USD)\"": "$0.444 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS53128": {
        "Description": "4.5-V to 24-V synchronous dual-D-CAP2 buck controller",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck controllers (external switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "34 mm2: 4.4 x 7.8 (TSSOP|24) 16 mm2: 4 x 4 (VQFN|24)",
        "Package Group": "TSSOP|24 VQFN|24",
        "\"Approx. price\n(USD)\"": "$1.975 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS53129": {
        "Description": "4.5-V to 24-V synchronous dual-D-CAP2 buck controller",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck controllers (external switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "34 mm2: 4.4 x 7.8 (TSSOP|24) 16 mm2: 4 x 4 (VQFN|24)",
        "Package Group": "TSSOP|24 VQFN|24",
        "\"Approx. price\n(USD)\"": "$1.646 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS54425": {
        "Description": "4.5V to 18V Input 4A Synchronous Step-Down Converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "22 mm2: 4.4 x 5 (HTSSOP|14)",
        "Package Group": "HTSSOP|14",
        "\"Approx. price\n(USD)\"": "$0.774 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS54426": {
        "Description": "4.5V to 18V Input 4A Synchronous Step-Down Converter with Eco-Mode&trade;",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "22 mm2: 4.4 x 5 (HTSSOP|14) 16 mm2: 4 x 4 (QFN|16)",
        "Package Group": "HTSSOP|14 QFN|16",
        "\"Approx. price\n(USD)\"": "$0.794 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62421": {
        "Description": "2.25MHz 600mA/1000mA Dual Step Down Converter In Small 3x3mm QFN Package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (VSON|10)",
        "Package Group": "VSON|10",
        "\"Approx. price\n(USD)\"": "$0.658 | 1ku",
        "Status": "ACTIVE"
    },
    "LMZ12001EXT": {
        "Description": "1A SIMPLE SWITCHER Power Module with 20V Maximum Input Voltage for Military and Rugged App",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck modules (integrated inductor)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-55 to 125",
        "Package size: mm2:W x L (PKG)": "140 mm2: 13.77 x 10.16 (TO-PMOD|7)",
        "Package Group": "TO-PMOD|7",
        "\"Approx. price\n(USD)\"": "$8.760 | 1ku",
        "Status": "ACTIVE"
    },
    "LMZ12002EXT": {
        "Description": "2A SIMPLE SWITCHER Power Module with 20V Maximum Input Voltage for Military and Rugged App",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck modules (integrated inductor)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-55 to 125",
        "Package size: mm2:W x L (PKG)": "140 mm2: 13.77 x 10.16 (TO-PMOD|7)",
        "Package Group": "TO-PMOD|7",
        "\"Approx. price\n(USD)\"": "$10.454 | 1ku",
        "Status": "ACTIVE"
    },
    "LMZ12003EXT": {
        "Description": "3A SIMPLE SWITCHER Power Module with 20V Maximum Input Voltage for Military and Rugged App",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck modules (integrated inductor)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-55 to 125",
        "Package size: mm2:W x L (PKG)": "140 mm2: 13.77 x 10.16 (TO-PMOD|7)",
        "Package Group": "TO-PMOD|7",
        "\"Approx. price\n(USD)\"": "$13.552 | 1ku",
        "Status": "ACTIVE"
    },
    "LMZ14201EXT": {
        "Description": "1A SIMPLE SWITCHER Power Module with 42V Maximum Input Voltage for Military and Rugged App",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck modules (integrated inductor)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-55 to 125",
        "Package size: mm2:W x L (PKG)": "140 mm2: 13.77 x 10.16 (TO-PMOD|7)",
        "Package Group": "TO-PMOD|7",
        "\"Approx. price\n(USD)\"": "$10.996 | 1ku",
        "Status": "ACTIVE"
    },
    "LMZ14202EXT": {
        "Description": "2A SIMPLE SWITCHER Power Module with 42V Maximum Input Voltage for Military and Rugged App",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck modules (integrated inductor)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-55 to 125",
        "Package size: mm2:W x L (PKG)": "140 mm2: 13.77 x 10.16 (TO-PMOD|7)",
        "Package Group": "TO-PMOD|7",
        "\"Approx. price\n(USD)\"": "$13.358 | 1ku",
        "Status": "ACTIVE"
    },
    "LMZ14203EXT": {
        "Description": "3A SIMPLE SWITCHER Power Module with 42V Maximum Input Voltage for Military and Rugged App",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck modules (integrated inductor)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-55 to 125",
        "Package size: mm2:W x L (PKG)": "140 mm2: 13.77 x 10.16 (TO-PMOD|7)",
        "Package Group": "TO-PMOD|7",
        "\"Approx. price\n(USD)\"": "$16.299 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62122": {
        "Description": "15V 75mA 96% efficiency Step-Down Converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "4 mm2: 2 x 2 (WSON|6)",
        "Package Group": "WSON|6",
        "\"Approx. price\n(USD)\"": "$0.370 | 1ku",
        "Status": "ACTIVE"
    },
    "LMZ10503EXT": {
        "Description": "3-A Power module with 5.5-V maximum input voltage for military and rugged applications",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck modules (integrated inductor)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-55 to 125",
        "Package size: mm2:W x L (PKG)": "140 mm2: 13.77 x 10.16 (TO-PMOD|7)",
        "Package Group": "TO-PMOD|7",
        "\"Approx. price\n(USD)\"": "$8.470 | 1ku",
        "Status": "ACTIVE"
    },
    "LMZ10504EXT": {
        "Description": "4-A Power module with 5.5-V maximum input voltage for military and rugged applications",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck modules (integrated inductor)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-55 to 125",
        "Package size: mm2:W x L (PKG)": "140 mm2: 13.77 x 10.16 (TO-PMOD|7)",
        "Package Group": "TO-PMOD|7",
        "\"Approx. price\n(USD)\"": "$10.120 | 1ku",
        "Status": "ACTIVE"
    },
    "LMZ10505EXT": {
        "Description": "5-A Power module with 5.5-V maximum input voltage for military and rugged applications",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck modules (integrated inductor)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-55 to 125",
        "Package size: mm2:W x L (PKG)": "140 mm2: 13.77 x 10.16 (TO-PMOD|7)",
        "Package Group": "TO-PMOD|7",
        "\"Approx. price\n(USD)\"": "$11.770 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS40210-HT": {
        "Description": "High Temperature Wide Input Range Current Mode Boost Controller",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost controllers (external switch)",
        "Rating": "High Temp",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-55 to 210",
        "Package size: mm2:W x L (PKG)": "40 mm2: 6.35 x 6.35 (CFP|10)",
        "Package Group": "CFP|10",
        "\"Approx. price\n(USD)\"": "$79.980 | 100u",
        "Status": "ACTIVE"
    },
    "TPS54521": {
        "Description": "17V Input 5A Synchronous Step-Down Converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "12 mm2: 3.5 x 3.5 (VQFN|14)",
        "Package Group": "VQFN|14",
        "\"Approx. price\n(USD)\"": "$0.920 | 1ku",
        "Status": "ACTIVE"
    },
    "LM34919B-Q1": {
        "Description": "Automotive 2x1.75mm 6-40V Wide Vin 600mA 2.6MHz Constant On-Time Non-Synchronous Buck Regulator",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "See datasheet (DSBGA)",
        "Package Group": "DSBGA|10",
        "\"Approx. price\n(USD)\"": "$1.428 | 1ku",
        "Status": "ACTIVE"
    },
    "SM72442": {
        "Description": "Programmable Maximum Power Point Tracking Controller for Photovoltaic Solar Panels",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck-boost & inverting controllers (external switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "62 mm2: 6.4 x 9.7 (TSSOP|28)",
        "Package Group": "TSSOP|28",
        "\"Approx. price\n(USD)\"": "$4.498 | 1ku",
        "Status": "ACTIVE"
    },
    "SM72485": {
        "Description": "100V 150 mA Constant On-Time Buck Switching Regulator",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "15 mm2: 4.9 x 3 (VSSOP|8) 16 mm2: 4 x 4 (WSON|8)",
        "Package Group": "VSSOP|8 WSON|8",
        "\"Approx. price\n(USD)\"": "$1.150 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS53311": {
        "Description": "2.9V to 6V Input 3A Synchronous Step-Down Converter with Eco-Mode and Smooth PWM",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (VQFN|16)",
        "Package Group": "VQFN|16",
        "\"Approx. price\n(USD)\"": "$0.810 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS54319": {
        "Description": "2.95 V to 6 V input 3 A 2 MHz SWIFT™ synchronous step-down converter in a 3 mm x 3 mm QFN package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 150",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (WQFN|16)",
        "Package Group": "WQFN|16",
        "\"Approx. price\n(USD)\"": "$0.629 | 1ku",
        "Status": "ACTIVE"
    },
    "LM34919B": {
        "Description": "2x1.75mm 6-40V Wide Vin 600mA Constant On-Time Non-Synchronous Buck Regulator",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "See datasheet (DSBGA)",
        "Package Group": "DSBGA|10",
        "\"Approx. price\n(USD)\"": "$1.210 | 1ku",
        "Status": "ACTIVE"
    },
    "PTD08D210W": {
        "Description": "Dual 10A 4.75V to 14V Non-Isolated Digital PowerTrain Module",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck modules (integrated inductor)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "426 mm2: 27.94 x 15.24 (DIP MODULE|22)",
        "Package Group": "DIP MODULE|22",
        "\"Approx. price\n(USD)\"": "$12.642 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS59621": {
        "Description": "Dual Phase D-CAP+&trade;Mode Step Down Controller for IMVP6.5 CPU/GPU Vcore in Embedded Computing",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck controllers (external switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 105",
        "Package size: mm2:W x L (PKG)": "36 mm2: 6 x 6 (VQFN|40)",
        "Package Group": "VQFN|40",
        "\"Approx. price\n(USD)\"": "$1.742 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS40304A": {
        "Description": "3-V to 20-V 25-A 600 kHz synchronous buck controller with FSS and wide operating temp range",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck controllers (external switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 145",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (VSON|10)",
        "Package Group": "VSON|10",
        "\"Approx. price\n(USD)\"": "$0.411 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62404": {
        "Description": "Dual 400mA and 600mA 2.25MHz Step-Down Converter with 1-Wire Interface in QFN",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (VSON|10)",
        "Package Group": "VSON|10",
        "\"Approx. price\n(USD)\"": "$0.609 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62674": {
        "Description": "500-mA 6-MHz High-Efficiency Step-Down Converter in Low Profile Chip Scale Packaging Vout=1.26V",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "1 mm2: 1 x 1.4 (DSBGA|6)",
        "Package Group": "DSBGA|6",
        "\"Approx. price\n(USD)\"": "$0.418 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS54240": {
        "Description": "3.5V to 42V Input 2.5A Step-Down Converter with Eco-Mode",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (HVSSOP|10) 9 mm2: 3 x 3 (VSON|10)",
        "Package Group": "HVSSOP|10 VSON|10",
        "\"Approx. price\n(USD)\"": "$1.162 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS65251": {
        "Description": "4.5-V TO 18-V input 3A/2A/2A output synchronous triple buck converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "36 mm2: 6 x 6 (VQFN|40)",
        "Package Group": "VQFN|40",
        "\"Approx. price\n(USD)\"": "$1.719 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS59610": {
        "Description": "Single Phase D-CAP+&trade; Sync Buck Controller for IMVP6+ CPU and GPU in Embedded Computing",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck controllers (external switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 105",
        "Package size: mm2:W x L (PKG)": "25 mm2: 5 x 5 (VQFN|32)",
        "Package Group": "VQFN|32",
        "\"Approx. price\n(USD)\"": "$1.355 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62410-Q1": {
        "Description": "Automotive 2.5V to 6V 2.25MHz Fixed Frequency Dual (800mA/800mA) Buck Converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (VSON|10)",
        "Package Group": "VSON|10",
        "\"Approx. price\n(USD)\"": "$0.776 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS63020": {
        "Description": "High Efficiency Single Inductor Buck-Boost Converter with 4A Switch",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck-boost inverting & split-rail converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "12 mm2: 4 x 3 (VSON|14)",
        "Package Group": "VSON|14",
        "\"Approx. price\n(USD)\"": "$1.108 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS63021": {
        "Description": "High Efficiency Single Inductor Buck-Boost Converter with 4A Switch",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck-boost inverting & split-rail converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "12 mm2: 4 x 3 (VSON|14)",
        "Package Group": "VSON|14",
        "\"Approx. price\n(USD)\"": "$1.108 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS61071-Q1": {
        "Description": "Adjustable 600-mA switch 1200-kHz boost converter in ThinSOT-23 with forced PWM mode",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 105",
        "Package size: mm2:W x L (PKG)": "5 mm2: 1.6 x 2.9 (SOT-23-THIN|6)",
        "Package Group": "SOT-23-THIN|6",
        "\"Approx. price\n(USD)\"": "$0.412 | 1ku",
        "Status": "ACTIVE"
    },
    "LMZ12001": {
        "Description": "SIMPLE SWITCHER&reg; 4.5V to 20V 1A DC/DC Power Module",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck modules (integrated inductor)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "140 mm2: 13.77 x 10.16 (TO-PMOD|7)",
        "Package Group": "TO-PMOD|7",
        "\"Approx. price\n(USD)\"": "$3.795 | 1ku",
        "Status": "ACTIVE"
    },
    "LMZ12002": {
        "Description": "SIMPLE SWITCHER® 4.5V to 20V 2A Power Module in Leaded Surface Mount TO Package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck modules (integrated inductor)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "140 mm2: 13.77 x 10.16 (TO-PMOD|7)",
        "Package Group": "TO-PMOD|7",
        "\"Approx. price\n(USD)\"": "$3.850 | 1ku",
        "Status": "ACTIVE"
    },
    "LMZ14201": {
        "Description": "SIMPLE SWITCHER&reg; 6V to 42V 1A Power Module in Leaded Surface Mount TO Package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck modules (integrated inductor)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "140 mm2: 13.77 x 10.16 (TO-PMOD|7)",
        "Package Group": "TO-PMOD|7",
        "\"Approx. price\n(USD)\"": "$5.663 | 1ku",
        "Status": "ACTIVE"
    },
    "LMZ14202": {
        "Description": "SIMPLE SWITCHER&reg; 6V to 42V 2A Power Module in Leaded SMT-TO Package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck modules (integrated inductor)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "140 mm2: 13.77 x 10.16 (TO-PMOD|7)",
        "Package Group": "TO-PMOD|7",
        "\"Approx. price\n(USD)\"": "$6.534 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62612": {
        "Description": "350-mA 6-MHz 1.5Vout High Efficiency Step-Down Converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "1 mm2: 1 x 1.4 (DSBGA|6)",
        "Package Group": "DSBGA|6",
        "\"Approx. price\n(USD)\"": "$0.377 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62616": {
        "Description": "350-mA 6-MHz 2.15Vout High Efficiency Step-Down Converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "1 mm2: 1 x 1.4 (DSBGA|6)",
        "Package Group": "DSBGA|6",
        "\"Approx. price\n(USD)\"": "$0.377 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62619": {
        "Description": "350-mA 6-MHz 1.8Vout High Efficiency Step-Down Converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "1 mm2: 1 x 1.4 (DSBGA|6)",
        "Package Group": "DSBGA|6",
        "\"Approx. price\n(USD)\"": "$0.377 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62660": {
        "Description": "1000mA 6MHz Synchronous Step-Down Converter in Chip Scale Packaging",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "See datasheet (DSBGA)",
        "Package Group": "DSBGA|6",
        "\"Approx. price\n(USD)\"": "$0.571 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS53127": {
        "Description": "4.5-V to 24-V 700 kHz synchronous dual-D-CAP2 buck controller",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck controllers (external switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "34 mm2: 4.4 x 7.8 (TSSOP|24) 16 mm2: 4 x 4 (VQFN|24)",
        "Package Group": "TSSOP|24 VQFN|24",
        "\"Approx. price\n(USD)\"": "$0.914 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS54260": {
        "Description": "3.5V to 60V Input 2.5A Step-Down Converter with Eco-Mode",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (HVSSOP|10) 9 mm2: 3 x 3 (VSON|10)",
        "Package Group": "HVSSOP|10 VSON|10",
        "\"Approx. price\n(USD)\"": "$1.452 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62060": {
        "Description": "3MHz 1.6A Step-Down Converter in 2x2 SON Package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "4 mm2: 2 x 2 (WSON|8)",
        "Package Group": "WSON|8",
        "\"Approx. price\n(USD)\"": "$0.682 | 1ku",
        "Status": "ACTIVE"
    },
    "LMZ23610": {
        "Description": "10A SIMPLE SWITCHER&reg; Power Module with 36V Maximum Input Voltage and Current Sharing",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck modules (integrated inductor)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "267 mm2: 17.79 x 15 (PFM|11)",
        "Package Group": "PFM|11",
        "\"Approx. price\n(USD)\"": "$14.617 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62065": {
        "Description": "3MHz 2A Step-Down Converter in 2x2 SON Package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "4 mm2: 2 x 2 (WSON|8)",
        "Package Group": "WSON|8",
        "\"Approx. price\n(USD)\"": "$0.601 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62067": {
        "Description": "3MHz 2A Step-Down Converter in 2x2 SON Package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "4 mm2: 2 x 2 (WSON|8)",
        "Package Group": "WSON|8",
        "\"Approx. price\n(USD)\"": "$0.601 | 1ku",
        "Status": "ACTIVE"
    },
    "LMZ10503": {
        "Description": "5.5V 3A Power Module in Leaded Surface Mount TO Package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck modules (integrated inductor)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "140 mm2: 13.77 x 10.16 (TO-PMOD|7)",
        "Package Group": "TO-PMOD|7",
        "\"Approx. price\n(USD)\"": "$3.300 | 1ku",
        "Status": "ACTIVE"
    },
    "LMZ10505": {
        "Description": "5.5V 5A Power Module in Leaded Surface Mount TO Package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck modules (integrated inductor)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "140 mm2: 13.77 x 10.16 (TO-PMOD|7)",
        "Package Group": "TO-PMOD|7",
        "\"Approx. price\n(USD)\"": "$4.565 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62110-Q1": {
        "Description": "Automotive 3V to 17V 1.5A Buck Converter in QFN-16 package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "16 mm2: 4 x 4 (QFN|16)",
        "Package Group": "QFN|16",
        "\"Approx. price\n(USD)\"": "$1.025 | 1ku",
        "Status": "ACTIVE"
    },
    "LM3241": {
        "Description": "6MHz 750mA Miniature Adjustable Step-Down DC-DC Converter for RF Power Amplifiers",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "2 mm2: 1.3 x 1.5 (DSBGA|6)",
        "Package Group": "DSBGA|6",
        "\"Approx. price\n(USD)\"": "$0.517 | 1ku",
        "Status": "ACTIVE"
    },
    "LMZ10504": {
        "Description": "5.5V 4A Power Module in Leaded Surface Mount TO Package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck modules (integrated inductor)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "140 mm2: 13.77 x 10.16 (TO-PMOD|7)",
        "Package Group": "TO-PMOD|7",
        "\"Approx. price\n(USD)\"": "$4.180 | 1ku",
        "Status": "ACTIVE"
    },
    "LMZ12003": {
        "Description": "3A SIMPLE SWITCHER&reg; Power Module with 20V Maximum Input Voltage",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck modules (integrated inductor)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "140 mm2: 13.77 x 10.16 (TO-PMOD|7)",
        "Package Group": "TO-PMOD|7",
        "\"Approx. price\n(USD)\"": "$4.400 | 1ku",
        "Status": "ACTIVE"
    },
    "LMZ14203": {
        "Description": "SIMPLE SWITCHER&reg; 6V to 42V 3A Power Module in Leaded Surface Mount TO Package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck modules (integrated inductor)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "140 mm2: 13.77 x 10.16 (TO-PMOD|7)",
        "Package Group": "TO-PMOD|7",
        "\"Approx. price\n(USD)\"": "$8.228 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62261-Q1": {
        "Description": "Automotive 2V to 6V 2.25MHz Fixed Frequency 600mA Buck Converter with 1.8V Fixed Output Voltage",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 105",
        "Package size: mm2:W x L (PKG)": "4 mm2: 2 x 2 (WSON|6)",
        "Package Group": "WSON|6",
        "\"Approx. price\n(USD)\"": "$0.575 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62262-Q1": {
        "Description": "Automotive 2V to 6V 2.25MHz Fixed Frequency 600mA Buck Converter with 1.2V Fixed Output Voltage",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 105",
        "Package size: mm2:W x L (PKG)": "4 mm2: 2 x 2 (WSON|6)",
        "Package Group": "WSON|6",
        "\"Approx. price\n(USD)\"": "$0.575 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62263-Q1": {
        "Description": "Automotive 2V to 6V 2.25MHz Fixed Frequency 600mA Buck Converter with 2.5V Fixed Output Voltage",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 105",
        "Package size: mm2:W x L (PKG)": "4 mm2: 2 x 2 (WSON|6)",
        "Package Group": "WSON|6",
        "\"Approx. price\n(USD)\"": "$0.575 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62404-Q1": {
        "Description": "Automotive 2.5V to 6V 2.25MHz Fixed Frequency Dual (400mA/600mA) Buck Converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (VSON|10)",
        "Package Group": "VSON|10",
        "\"Approx. price\n(USD)\"": "$0.719 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62420-Q1": {
        "Description": "Automotive 2.5V to 6V 2.25MHz Fixed Frequency Dual (1A/600mA) Buck Converter with 1-Wire Interface",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (VSON|10)",
        "Package Group": "VSON|10",
        "\"Approx. price\n(USD)\"": "$0.776 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62615": {
        "Description": "350-mA 6-MHz 1.2Vout High Efficiency Step-Down Converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "1 mm2: 1 x 1.4 (DSBGA|6)",
        "Package Group": "DSBGA|6",
        "\"Approx. price\n(USD)\"": "$0.377 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS51125A": {
        "Description": "4.5-V to 28-V dual-synchronous buck controller with 100-mA LDOs and flexible external components",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck controllers (external switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "16 mm2: 4 x 4 (VQFN|24)",
        "Package Group": "VQFN|24",
        "\"Approx. price\n(USD)\"": "$1.213 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS61085T": {
        "Description": "18.5V 2A 650kHz 1.2MHz Step-Up DC-DC Converter with Forced PWM Mode (extended temp range)",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 105",
        "Package size: mm2:W x L (PKG)": "19 mm2: 6.4 x 3 (TSSOP|8) 15 mm2: 4.9 x 3 (VSSOP|8)",
        "Package Group": "TSSOP|8 VSSOP|8",
        "\"Approx. price\n(USD)\"": "$0.756 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS65232A0": {
        "Description": "Wide input voltage power management IC (PMIC) in a 6 mm x 6 mm QFN package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "0 to 85",
        "Package size: mm2:W x L (PKG)": "36 mm2: 6 x 6 (VQFN|40)",
        "Package Group": "VQFN|40",
        "\"Approx. price\n(USD)\"": "$3.137 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS65232A2": {
        "Description": "Wide input voltage power management IC (PMIC) in a HTSSOP package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "0 to 85",
        "Package size: mm2:W x L (PKG)": "76 mm2: 6.1 x 12.5 (HTSSOP|48)",
        "Package Group": "HTSSOP|48",
        "\"Approx. price\n(USD)\"": "$3.137 | 1ku",
        "Status": "ACTIVE"
    },
    "PTD08A015W": {
        "Description": "15A 4.75 V to 14 V Input Non-Isolated Digital PowerTrain Module",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck modules (integrated inductor)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "334 mm2: 16.76 x 19.94 (Through-Hole Module|12)",
        "Package Group": "Through-Hole Module|12",
        "\"Approx. price\n(USD)\"": "$11.689 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS40303": {
        "Description": "3-V to 20-V 25-A 300-kHz synchronous buck controller with FSS",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck controllers (external switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (VSON|10)",
        "Package Group": "VSON|10",
        "\"Approx. price\n(USD)\"": "$0.823 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS40304": {
        "Description": "3-V to 20-V 25-A 600-kHz synchronous buck controller with FSS",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck controllers (external switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (VSON|10)",
        "Package Group": "VSON|10",
        "\"Approx. price\n(USD)\"": "$0.913 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS40305": {
        "Description": "3-V to 20-V 25-A 1.2-MHz synchronous buck controller with FSS",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck controllers (external switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (VSON|10)",
        "Package Group": "VSON|10",
        "\"Approx. price\n(USD)\"": "$0.823 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS51611": {
        "Description": "Single Phase D-CAP+&trade; Mode Step-Down Controller for IMVP6.5&trade; CPU/GPU Vcore",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck controllers (external switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-10 to 105",
        "Package size: mm2:W x L (PKG)": "25 mm2: 5 x 5 (VQFN|32)",
        "Package Group": "VQFN|32",
        "\"Approx. price\n(USD)\"": "$1.210 | 1ku",
        "Status": "ACTIVE"
    },
    "LMZ23605": {
        "Description": "5A SIMPLE SWITCHER&reg; Power Module with 36V Maximum Input Voltage",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck modules (integrated inductor)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "140 mm2: 13.77 x 10.16 (TO-PMOD|7)",
        "Package Group": "TO-PMOD|7",
        "\"Approx. price\n(USD)\"": "$8.954 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS54290": {
        "Description": "4.5 V to 18 V input 300 kHz 1.5 / 2.5 A dual synchronous step-down converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 145",
        "Package size: mm2:W x L (PKG)": "32 mm2: 6.4 x 5 (HTSSOP|16)",
        "Package Group": "HTSSOP|16",
        "\"Approx. price\n(USD)\"": "$1.760 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS54291": {
        "Description": "4.5 V to 18 V input 600 kHz 1.5 / 2.5 A dual synchronous step-down converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 145",
        "Package size: mm2:W x L (PKG)": "32 mm2: 6.4 x 5 (HTSSOP|16)",
        "Package Group": "HTSSOP|16",
        "\"Approx. price\n(USD)\"": "$1.760 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS54292": {
        "Description": "4.5 V to 18 V input 1.2 MHz 1.5 / 2.5 A dual synchronous step-down converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 145",
        "Package size: mm2:W x L (PKG)": "32 mm2: 6.4 x 5 (HTSSOP|16)",
        "Package Group": "HTSSOP|16",
        "\"Approx. price\n(USD)\"": "$1.760 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS51621": {
        "Description": "Dual Phase D-CAP+&trade;Mode Step-Down Controller for IMVP6.5 CPU/GPU Vcore",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck controllers (external switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-10 to 105",
        "Package size: mm2:W x L (PKG)": "36 mm2: 6 x 6 (VQFN|40)",
        "Package Group": "VQFN|40",
        "\"Approx. price\n(USD)\"": "$1.597 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS54226": {
        "Description": "4.5V to 18V Input 2A Synchronous Step-Down Converter with Eco-Mode&trade;",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "22 mm2: 4.4 x 5 (HTSSOP|14) 9 mm2: 3 x 3 (VQFN|16)",
        "Package Group": "HTSSOP|14 VQFN|16",
        "\"Approx. price\n(USD)\"": "$0.655 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS54225": {
        "Description": "4.5 V to 18 V input 2 A synchronous step-down converter in HTSSOP package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "22 mm2: 4.4 x 5 (HTSSOP|14)",
        "Package Group": "HTSSOP|14",
        "\"Approx. price\n(USD)\"": "$0.635 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS53125": {
        "Description": "4.5-V to 24-V 350 kHz synchronous dual-D-CAP2 buck controller",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck controllers (external switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "34 mm2: 4.4 x 7.8 (TSSOP|24) 16 mm2: 4 x 4 (VQFN|24)",
        "Package Group": "TSSOP|24 VQFN|24",
        "\"Approx. price\n(USD)\"": "$1.549 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS54326": {
        "Description": "4.5V to 18V Input 3A Synchronous Step-Down Converter with Eco-Mode&trade;",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "22 mm2: 4.4 x 5 (HTSSOP|14) 9 mm2: 3 x 3 (VQFN|16)",
        "Package Group": "HTSSOP|14 VQFN|16",
        "\"Approx. price\n(USD)\"": "$0.697 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS54162-Q1": {
        "Description": "Automotive 3.6V to 48V 1A Buck Converter with Low Iq and Voltage Supervision",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "42 mm2: 6.4 x 6.5 (HTSSOP|20)",
        "Package Group": "HTSSOP|20",
        "\"Approx. price\n(USD)\"": "$1.597 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS40200-HT": {
        "Description": "High Temperature Wide Input Non-Synchronous Buck DC/DC Controller",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck controllers (external switch)",
        "Rating": "High Temp",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "\"-55 to 175\n-55 to 210\"",
        "Package size: mm2:W x L (PKG)": "39 mm2: 5.65 x 6.9 (CFP|8) 19 mm2: 3.91 x 4.9 (SOIC|8)",
        "Package Group": "CFP|8 SOIC|8",
        "\"Approx. price\n(USD)\"": "$79.980 | 100u",
        "Status": "ACTIVE"
    },
    "TPS60151": {
        "Description": "140mA 5V Charge Pump in 2x2 QFN",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Charge pumps (inductorless)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "4 mm2: 2 x 2 (WSON|6)",
        "Package Group": "WSON|6",
        "\"Approx. price\n(USD)\"": "$0.539 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS61029-Q1": {
        "Description": "0.9-V to 5.5-V input range 1.8-A boost converter AEC-Q100 qualified",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (VSON|10)",
        "Package Group": "VSON|10",
        "\"Approx. price\n(USD)\"": "$1.029 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS61093": {
        "Description": "Low Input 20V/1.1A Step-Up DC/DC Converter with Integrated Power Diode and Input/Output Isolation",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "6 mm2: 2.5 x 2.5 (SON|10)",
        "Package Group": "SON|10",
        "\"Approx. price\n(USD)\"": "$0.759 | 1ku",
        "Status": "ACTIVE"
    },
    "LM3209-G3": {
        "Description": "Seamless Transition Buck-Boost DC/DC regulator for RF Power Amplifiers",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-30 to 85",
        "Package size: mm2:W x L (PKG)": "4 mm2: 1.8 x 2 (DSBGA|12)",
        "Package Group": "DSBGA|12",
        "\"Approx. price\n(USD)\"": "$0.996 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS51513": {
        "Description": "3-V to 28-V synchronous D-CAP buck controller with integrated gate drivers",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck controllers (external switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-10 to 100",
        "Package size: mm2:W x L (PKG)": "25 mm2: 5 x 5 (VQFN|32)",
        "Package Group": "VQFN|32",
        "\"Approx. price\n(USD)\"": "$1.510 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS54262-Q1": {
        "Description": "Automotive 3.6V to 60V 2A Buck Converter with Low Iq and Voltage Supervision",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "42 mm2: 6.4 x 6.5 (HTSSOP|20)",
        "Package Group": "HTSSOP|20",
        "\"Approx. price\n(USD)\"": "$1.784 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS5410-Q1": {
        "Description": "Automotive 5.5V to 36V 500kHz Fixed Frequency 1A Buck Converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "19 mm2: 3.91 x 4.9 (SOIC|8)",
        "Package Group": "SOIC|8",
        "\"Approx. price\n(USD)\"": "$1.331 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62751": {
        "Description": "2.25MHz Step-Down Converter w/ Programmble Input Current Limits for USB powered Applications",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "6 mm2: 2.5 x 2.5 (SON|10)",
        "Package Group": "SON|10",
        "\"Approx. price\n(USD)\"": "$0.639 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS54318": {
        "Description": "2.95V to 6V Input 3A Synchronous Step-Down SWIFT&trade; Converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 150",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (WQFN|16)",
        "Package Group": "WQFN|16",
        "\"Approx. price\n(USD)\"": "$0.627 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS5410-EP": {
        "Description": "Enhanced Product 5.5V to 36V 1A 500kHz Step Down Converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "HiRel Enhanced Product",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-55 to 125",
        "Package size: mm2:W x L (PKG)": "19 mm2: 3.91 x 4.9 (SOIC|8)",
        "Package Group": "SOIC|8",
        "\"Approx. price\n(USD)\"": "$2.658 | 1ku",
        "Status": "ACTIVE"
    },
    "LM25085-Q1": {
        "Description": "Automotive Grade 4.5-42V Wide Vin Constant On-Time Non-Synchronous PFET Buck Controller",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck controllers (external switch)",
        "Rating": "Automotive",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (HVSSOP|8)",
        "Package Group": "HVSSOP|8",
        "\"Approx. price\n(USD)\"": "$0.800 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS54218": {
        "Description": "2.95V to 6V Input 2A Synchronous Step-Down SWIFT&trade; Converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 150",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (WQFN|16)",
        "Package Group": "WQFN|16",
        "\"Approx. price\n(USD)\"": "$0.572 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS61086": {
        "Description": "18.5-V 2-A 2-MHz step-up DC/DC converter with forced PWM mode",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (VSON|10)",
        "Package Group": "VSON|10",
        "\"Approx. price\n(USD)\"": "$0.726 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62650": {
        "Description": "800-mA 6-MHz Synchronous Step-Down Converter in Chip Scale Packaging",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "2 mm2: 1.4 x 1.4 (DSBGA|9)",
        "Package Group": "DSBGA|9",
        "\"Approx. price\n(USD)\"": "$0.572 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS5450-EP": {
        "Description": "Enhanced Product 5.5V to 36V Input 5A 500kHz Step-Down Converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "HiRel Enhanced Product",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-55 to 125",
        "Package size: mm2:W x L (PKG)": "19 mm2: 3.9 x 4.89 (SO PowerPAD|8)",
        "Package Group": "SO PowerPAD|8",
        "\"Approx. price\n(USD)\"": "$4.391 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62621": {
        "Description": "600-mA 6-MHz Vout 1.8V 90% Efficiency Step-Down Converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "See datasheet (DSBGA)",
        "Package Group": "DSBGA|6",
        "\"Approx. price\n(USD)\"": "$0.464 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62622": {
        "Description": "600-mA 6-MHz Vout 1.5V 90% Efficiency Step-Down Converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "See datasheet (DSBGA)",
        "Package Group": "DSBGA|6",
        "\"Approx. price\n(USD)\"": "$0.464 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62623": {
        "Description": "600-mA 6-MHz Vout 1.225V 90% Efficiency Step-Down Converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "See datasheet (DSBGA) 1 mm2: 1 x 1.4 (DSBGA|6)",
        "Package Group": "DSBGA|6 DSBGA|6",
        "\"Approx. price\n(USD)\"": "$0.464 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62624": {
        "Description": "600-mA 6-MHz Vout 1.2V 90% Efficiency Step-Down Converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "See datasheet (DSBGA)",
        "Package Group": "DSBGA|6",
        "\"Approx. price\n(USD)\"": "$0.464 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62625": {
        "Description": "600-mA 6-MHz Vout 1.2V with Active Output Cap Discharge Capability",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "See datasheet (DSBGA)",
        "Package Group": "DSBGA|6",
        "\"Approx. price\n(USD)\"": "$0.464 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62750": {
        "Description": "2.25MHz Step-Down Converter w/ Programmable Input Current Limits for USB powered Applications",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "6 mm2: 2.5 x 2.5 (SON|10)",
        "Package Group": "SON|10",
        "\"Approx. price\n(USD)\"": "$0.639 | 1ku",
        "Status": "ACTIVE"
    },
    "LM5118-Q1": {
        "Description": "3-V to 75-V wide VIN current mode non-synchronous buck-boost controller",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck-boost & inverting controllers (external switch)",
        "Rating": "Automotive",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "42 mm2: 6.4 x 6.5 (HTSSOP|20)",
        "Package Group": "HTSSOP|20",
        "\"Approx. price\n(USD)\"": "$2.718 | 1ku",
        "Status": "ACTIVE"
    },
    "REG71055-Q1": {
        "Description": "Automotive 3.5V to 5.5V 60mA Buck/Boost Charge Pump for 5.5V Systems in ThinSOT-23 Package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Charge pumps (inductorless)",
        "Rating": "Automotive",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "5 mm2: 1.6 x 2.9 (SOT-23-THIN|6)",
        "Package Group": "SOT-23-THIN|6",
        "\"Approx. price\n(USD)\"": "$0.520 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS63000-Q1": {
        "Description": "Automotive 1.8V to 5.5V Input Range 1.8A High Efficiency Buck/Boost Converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck-boost inverting & split-rail converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (VSON|10)",
        "Package Group": "VSON|10",
        "\"Approx. price\n(USD)\"": "$1.010 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS55332-Q1": {
        "Description": "1.5-V to 60-V wide input range 3-A boost converter with voltage supervisor AEC-Q100 qualified",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "42 mm2: 6.4 x 6.5 (HTSSOP|20)",
        "Package Group": "HTSSOP|20",
        "\"Approx. price\n(USD)\"": "$2.382 | 1ku",
        "Status": "ACTIVE"
    },
    "PTD08A006W": {
        "Description": "6A 4.75V to 14V Non-Isolated Digital PowerTrain Module",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck modules (integrated inductor)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "334 mm2: 16.76 x 19.94 (Through-Hole Module|12)",
        "Package Group": "Through-Hole Module|12",
        "\"Approx. price\n(USD)\"": "$8.488 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS51217": {
        "Description": "3-V to 28-V 20-A synchronous D-CAP buck controller for notebook power",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck controllers (external switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (WSON|10)",
        "Package Group": "WSON|10",
        "\"Approx. price\n(USD)\"": "$1.307 | 1ku",
        "Status": "ACTIVE"
    },
    "LM10500": {
        "Description": "5A Step-Down Energy Management Unit With PowerWise&reg; Adaptive Voltage Scaling",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "25 mm2: 5 x 5 (WQFN|28)",
        "Package Group": "WQFN|28",
        "\"Approx. price\n(USD)\"": "$3.997 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS53126": {
        "Description": "4.5-V to 24-V synchronous dual-D-CAP2 buck controller with selectable switching frequency",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck controllers (external switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "34 mm2: 4.4 x 7.8 (TSSOP|24) 16 mm2: 4 x 4 (VQFN|24)",
        "Package Group": "TSSOP|24 VQFN|24",
        "\"Approx. price\n(USD)\"": "$1.549 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS54325": {
        "Description": "4.5V to 18V Input 3A Synchronous Step-Down Converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "22 mm2: 4.4 x 5 (HTSSOP|14)",
        "Package Group": "HTSSOP|14",
        "\"Approx. price\n(USD)\"": "$0.677 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS54620": {
        "Description": "4.5-V to 17-V 6-A synchronous SWIFT™ buck converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 150",
        "Package size: mm2:W x L (PKG)": "12 mm2: 3.5 x 3.5 (VQFN|14)",
        "Package Group": "VQFN|14",
        "\"Approx. price\n(USD)\"": "$2.064 | 1ku",
        "Status": "ACTIVE"
    },
    "LM26420": {
        "Description": "Dual 2 A high-efficiency synchronous DC/DC converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "42 mm2: 6.4 x 6.5 (HTSSOP|20) 16 mm2: 4 x 4 (WQFN|16)",
        "Package Group": "HTSSOP|20 WQFN|16",
        "\"Approx. price\n(USD)\"": "$1.333 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS54418": {
        "Description": "2.95V to 6V Input 4A Synchronous Step-Down SWIFT&trade; Converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 150",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (WQFN|16)",
        "Package Group": "WQFN|16",
        "\"Approx. price\n(USD)\"": "$0.920 | 1ku",
        "Status": "ACTIVE"
    },
    "LM5008A": {
        "Description": "6-95V Wide Vin 350mA Constant On-Time Non-Synchronous Buck Regulator",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "15 mm2: 4.9 x 3 (VSSOP|8) 16 mm2: 4 x 4 (WSON|8)",
        "Package Group": "VSSOP|8 WSON|8",
        "\"Approx. price\n(USD)\"": "$1.162 | 1ku",
        "Status": "ACTIVE"
    },
    "LM5009A": {
        "Description": "6-95V Wide Vin 150mA Constant On-Time Non-Synchronous Buck Regulator",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "15 mm2: 4.9 x 3 (VSSOP|8) 16 mm2: 4 x 4 (WSON|8)",
        "Package Group": "VSSOP|8 WSON|8",
        "\"Approx. price\n(USD)\"": "$1.065 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS51163": {
        "Description": "4.5-V to 12-V 600-kHz synchronous buck controller with high current gate driver",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck controllers (external switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (VSON|10)",
        "Package Group": "VSON|10",
        "\"Approx. price\n(USD)\"": "$0.581 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS51218": {
        "Description": "3-V to 28-V 20-A synchronous D-CAP buck controller for notebook power",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck controllers (external switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (WSON|10)",
        "Package Group": "WSON|10",
        "\"Approx. price\n(USD)\"": "$1.258 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS61241": {
        "Description": "5V 500mA 4MHz Step-Up DC/DC Converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "See datasheet (DSBGA)",
        "Package Group": "DSBGA|6",
        "\"Approx. price\n(USD)\"": "$0.330 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS61240": {
        "Description": "2.3-V to 5.5-V input range 3.5-MHz fixed frequency 450-mA boost converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "See datasheet (DSBGA) 4 mm2: 2 x 2 (WSON|6)",
        "Package Group": "DSBGA|6 WSON|6",
        "\"Approx. price\n(USD)\"": "$0.387 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62230": {
        "Description": "2 MHz Ultra Small Step Down Converter with DCS-Control in 1x1.5 SON Package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "1 mm2: 1 x 1.45 (SON|6)",
        "Package Group": "SON|6",
        "\"Approx. price\n(USD)\"": "$0.428 | 1ku",
        "Status": "ACTIVE"
    },
    "LM3478Q-Q1": {
        "Description": "40-V wide VIN low-side N-channel controller for switching regulators with 10-µA shutdown current",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost controllers (external switch)",
        "Rating": "Automotive",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "15 mm2: 4.9 x 3 (VSSOP|8)",
        "Package Group": "VSSOP|8",
        "\"Approx. price\n(USD)\"": "$1.034 | 1ku",
        "Status": "ACTIVE"
    },
    "LM3488Q-Q1": {
        "Description": "40-V wide VIN low-side N-channel controller for switching regulators with 5-µA shutdown current",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost controllers (external switch)",
        "Rating": "Automotive",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "15 mm2: 4.9 x 3 (VSSOP|8)",
        "Package Group": "VSSOP|8",
        "\"Approx. price\n(USD)\"": "$1.011 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS53114": {
        "Description": "4.5-V to 24-V synchronous buck controller for low voltage rails",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck controllers (external switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "32 mm2: 6.4 x 5 (HTSSOP|16) 22 mm2: 4.4 x 5 (TSSOP|16)",
        "Package Group": "HTSSOP|16 TSSOP|16",
        "\"Approx. price\n(USD)\"": "$1.045 | 1ku",
        "Status": "ACTIVE"
    },
    "LM26001-Q1": {
        "Description": "1.5A Switching Regulator with High Efficiency Sleep Mode",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "32 mm2: 6.4 x 5 (HTSSOP|16)",
        "Package Group": "HTSSOP|16",
        "\"Approx. price\n(USD)\"": "$1.537 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62000-HT": {
        "Description": "High Temperature High-Efficiency Step-Down Low Power DC-DC Converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "High Temp",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-55 to 210",
        "Package size: mm2:W x L (PKG)": "40 mm2: 6.35 x 6.35 (CFP|10)",
        "Package Group": "CFP|10",
        "\"Approx. price\n(USD)\"": "$104.720 | 100u",
        "Status": "ACTIVE"
    },
    "TPS5130-Q1": {
        "Description": "4.5-V to 28-V triple automotive synchronous buck controller with LDO controller",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck controllers (external switch)",
        "Rating": "Automotive",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "49 mm2: 7 x 7 (LQFP|48)",
        "Package Group": "LQFP|48",
        "\"Approx. price\n(USD)\"": "$2.706 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS5430-EP": {
        "Description": "Enhanced Product 5.5V to 36V Input 3A 500kHz Step Down Converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "HiRel Enhanced Product",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-55 to 125",
        "Package size: mm2:W x L (PKG)": "19 mm2: 3.9 x 4.89 (SO PowerPAD|8)",
        "Package Group": "SO PowerPAD|8",
        "\"Approx. price\n(USD)\"": "$4.391 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS51113": {
        "Description": "4.5-V to 13.2-V 300 kHz synchronous buck controller with high current gate driver",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck controllers (external switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (VSON|10)",
        "Package Group": "VSON|10",
        "\"Approx. price\n(USD)\"": "$0.959 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS54040": {
        "Description": "3.5V to 42V Input 0.5A Step-Down Converter with Eco-Mode",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 150",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (HVSSOP|10)",
        "Package Group": "HVSSOP|10",
        "\"Approx. price\n(USD)\"": "$0.871 | 1ku",
        "Status": "ACTIVE"
    },
    "LM25011": {
        "Description": "6-42V Wide Vin 2A Constant-On Time Buck Regulator with Adjustable Current Limit",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (HVSSOP|10)",
        "Package Group": "HVSSOP|10",
        "\"Approx. price\n(USD)\"": "$1.045 | 1ku",
        "Status": "ACTIVE"
    },
    "LM25011-Q1": {
        "Description": "Automotive 6-42V Wide Vin 2A Constant-On Time Non-Synchronous Buck Regulator w/ Adj Current Limit",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (HVSSOP|10)",
        "Package Group": "HVSSOP|10",
        "\"Approx. price\n(USD)\"": "$1.355 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62620": {
        "Description": "600-mA 6-MHz Vout 1.82V 90% Efficiency Step-Down Converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "See datasheet (DSBGA) 1 mm2: 1 x 1.4 (DSBGA|6)",
        "Package Group": "DSBGA|6 DSBGA|6",
        "\"Approx. price\n(USD)\"": "$0.464 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62272": {
        "Description": "2.25MHz 400mA Step-Down Converter with Selectable VOUT",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "4 mm2: 2 x 2 (WSON|6)",
        "Package Group": "WSON|6",
        "\"Approx. price\n(USD)\"": "$0.436 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS54060": {
        "Description": "3.5V to 60V Input 0.5A Step-Down Converter with Eco-Mode",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 150",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (HVSSOP|10) 9 mm2: 3 x 3 (VSON|10)",
        "Package Group": "HVSSOP|10 VSON|10",
        "\"Approx. price\n(USD)\"": "$1.065 | 1ku",
        "Status": "ACTIVE"
    },
    "LM25576-Q1": {
        "Description": "42V 3A Step-Down Switching Regulator",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "42 mm2: 6.4 x 6.5 (HTSSOP|20)",
        "Package Group": "HTSSOP|20",
        "\"Approx. price\n(USD)\"": "$2.284 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62113": {
        "Description": "1.5-A 17-Vin Step-Down Converter with LBI function in QFN-16",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "16 mm2: 4 x 4 (QFN|16)",
        "Package Group": "QFN|16",
        "\"Approx. price\n(USD)\"": "$0.869 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62225": {
        "Description": "2.2-V Output 400-mA 95% Efficient Step-Down Converter 15uA ThinSOT-23",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "8 mm2: 2.8 x 2.9 (SOT-23-THIN|5)",
        "Package Group": "SOT-23-THIN|5",
        "\"Approx. price\n(USD)\"": "$0.436 | 1ku",
        "Status": "ACTIVE"
    },
    "LM20136": {
        "Description": "2.95-5.5V 6A Current Mode Synchronous Buck Regulator with  Input Synchronization",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "32 mm2: 6.4 x 5 (HTSSOP|16)",
        "Package Group": "HTSSOP|16",
        "\"Approx. price\n(USD)\"": "$1.360 | 1ku",
        "Status": "ACTIVE"
    },
    "LM20146": {
        "Description": "6A Adjustable Frequency Synchronous Buck  Regulator",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "32 mm2: 6.4 x 5 (HTSSOP|16)",
        "Package Group": "HTSSOP|16",
        "\"Approx. price\n(USD)\"": "$1.360 | 1ku",
        "Status": "ACTIVE"
    },
    "LM25574-Q1": {
        "Description": "42V 0.5A Step-Down Switching Regulator",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "22 mm2: 4.4 x 5 (TSSOP|16)",
        "Package Group": "TSSOP|16",
        "\"Approx. price\n(USD)\"": "$1.568 | 1ku",
        "Status": "ACTIVE"
    },
    "LM25575-Q1": {
        "Description": "42V 1.5A Step-Down Switching Regulator",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "32 mm2: 6.4 x 5 (HTSSOP|16)",
        "Package Group": "HTSSOP|16",
        "\"Approx. price\n(USD)\"": "$2.091 | 1ku",
        "Status": "ACTIVE"
    },
    "LM25085A": {
        "Description": "4.5-42V Wide Vin Constant On-Time Non-Synchronous PFET Buck Controller with 0.9V Reference",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck controllers (external switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (HVSSOP|8) 15 mm2: 4.9 x 3 (VSSOP|8) 9 mm2: 3 x 3 (WSON|8)",
        "Package Group": "HVSSOP|8 VSSOP|8 WSON|8",
        "\"Approx. price\n(USD)\"": "$0.726 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS61220": {
        "Description": "0.7-VIN adjustable output voltage boost converter with 5.5-μA quiescent current",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "4 mm2: 2.1 x 2 (SC70|6)",
        "Package Group": "SC70|6",
        "\"Approx. price\n(USD)\"": "$0.367 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS61221": {
        "Description": "0.7-VIN 3.3-V fixed output voltage boost converter with 5.5-μA quiescent current",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "4 mm2: 2.1 x 2 (SC70|6)",
        "Package Group": "SC70|6",
        "\"Approx. price\n(USD)\"": "$0.367 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS61222": {
        "Description": "0.7-VIN 5-V fixed output voltage boost converter with 5.5-μA quiescent current",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "4 mm2: 2.1 x 2 (SC70|6)",
        "Package Group": "SC70|6",
        "\"Approx. price\n(USD)\"": "$0.367 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62590": {
        "Description": "2.25MHz 1A Step-Down Converter in 2 x 2 SON Package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "4 mm2: 2 x 2 (WSON|6)",
        "Package Group": "WSON|6",
        "\"Approx. price\n(USD)\"": "$0.539 | 1ku",
        "Status": "ACTIVE"
    },
    "LM27402": {
        "Description": "3-V to 20-V voltage mode synchronous buck controller with DCR current sensing",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck controllers (external switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "32 mm2: 6.4 x 5 (HTSSOP|16) 16 mm2: 4 x 4 (WQFN|16)",
        "Package Group": "HTSSOP|16 WQFN|16",
        "\"Approx. price\n(USD)\"": "$1.016 | 1ku",
        "Status": "ACTIVE"
    },
    "PTH08T255W": {
        "Description": "40A 8V to 14V Input 3V to 5.25V Output Non-Isolated Power Module with TurboTrans",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck modules (integrated inductor)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "1067 mm2: 26.92 x 39.62 (Surface Mount Module|22) 1067 mm2: 26.92 x 39.62 (Through-Hole Module|22)",
        "Package Group": "Surface Mount Module|22 Through-Hole Module|22",
        "\"Approx. price\n(USD)\"": "$44.274 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS54332": {
        "Description": "3.5V to 28V Input 3.5A 1MHz Step-Down Converter with Eco-mode",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 150",
        "Package size: mm2:W x L (PKG)": "19 mm2: 3.9 x 4.89 (SO PowerPAD|8)",
        "Package Group": "SO PowerPAD|8",
        "\"Approx. price\n(USD)\"": "$0.699 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS51220A": {
        "Description": "3-V to 28-V synchronous peak current mode buck controller for notebook power in RSN/RTV package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck controllers (external switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "16 mm2: 4 x 4 (QFN|32) 25 mm2: 5 x 5 (WQFN|32)",
        "Package Group": "QFN|32 WQFN|32",
        "\"Approx. price\n(USD)\"": "$1.320 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS51123": {
        "Description": "4.5-V to 28-V dual-channel synch buck controller low standby current consumption Out-of-Audio™",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck controllers (external switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "16 mm2: 4 x 4 (VQFN|24)",
        "Package Group": "VQFN|24",
        "\"Approx. price\n(USD)\"": "$1.888 | 1ku",
        "Status": "ACTIVE"
    },
    "PTH04T240F": {
        "Description": "10A 2.2V to 5.5V Input Power Module for 3-GHz DSP Systems",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck modules (integrated inductor)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "387 mm2: 16.76 x 23.11 (Surface Mount Module|11) 387 mm2: 16.76 x 23.11 (Through-Hole Module|11)",
        "Package Group": "Surface Mount Module|11 Through-Hole Module|11",
        "\"Approx. price\n(USD)\"": "$10.780 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS60150": {
        "Description": "140mA 5V Charge Pump in 2x2 SON",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Charge pumps (inductorless)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "4 mm2: 2 x 2 (WSON|6)",
        "Package Group": "WSON|6",
        "\"Approx. price\n(USD)\"": "$0.539 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62562": {
        "Description": "2.25MHz 600mA Step-Down Converter in 2x2mm SON Package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "4 mm2: 2 x 2 (WSON|6)",
        "Package Group": "WSON|6",
        "\"Approx. price\n(USD)\"": "$0.349 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS54232": {
        "Description": "3.5V to 28V Input 2A 1MHz Step-Down Converter with Eco-mode",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 150",
        "Package size: mm2:W x L (PKG)": "19 mm2: 3.91 x 4.9 (SOIC|8)",
        "Package Group": "SOIC|8",
        "\"Approx. price\n(USD)\"": "$0.569 | 1ku",
        "Status": "ACTIVE"
    },
    "LM22680": {
        "Description": "SIMPLE SWITCHER&reg; 4.5V to 42V 2A Step-Down DC/DC Switching Regulator with Precision Enable",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "19 mm2: 3.9 x 4.89 (SO PowerPAD|8)",
        "Package Group": "SO PowerPAD|8",
        "\"Approx. price\n(USD)\"": "$1.646 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS61175": {
        "Description": "3-A 40V High Voltage Boost Converter with Soft-start and Programmable Switching Frequency",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "22 mm2: 4.4 x 5 (HTSSOP|14)",
        "Package Group": "HTSSOP|14",
        "\"Approx. price\n(USD)\"": "$1.258 | 1ku",
        "Status": "ACTIVE"
    },
    "LM25088": {
        "Description": "4.5-42V Wide Vin Current Mode Non-Synchronous Buck Controller",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck controllers (external switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "32 mm2: 6.4 x 5 (HTSSOP|16)",
        "Package Group": "HTSSOP|16",
        "\"Approx. price\n(USD)\"": "$1.210 | 1ku",
        "Status": "ACTIVE"
    },
    "LM5088": {
        "Description": "4.5-75V Wide Vin Current Mode Non-Synchronous Buck Controller",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck controllers (external switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "32 mm2: 6.4 x 5 (HTSSOP|16)",
        "Package Group": "HTSSOP|16",
        "\"Approx. price\n(USD)\"": "$1.423 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS54140": {
        "Description": "3.5V to 42V Input 1.5A Step-Down Converter with Eco-Mode",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 150",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (HVSSOP|10)",
        "Package Group": "HVSSOP|10",
        "\"Approx. price\n(USD)\"": "$0.920 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS40197": {
        "Description": "4.5-V to 14-V 6-A synchronous buck controller with 4-bit VID interface",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck controllers (external switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "14 mm2: 3.5 x 4 (VQFN|16)",
        "Package Group": "VQFN|16",
        "\"Approx. price\n(USD)\"": "$1.496 | 1ku",
        "Status": "ACTIVE"
    },
    "LM25010-Q1": {
        "Description": "Automotive Grade 6-42V Wide Vin 1A Constant On-Time Non-Synchronous Buck Regulator",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "\"-40 to 125\n-40 to 150\"",
        "Package size: mm2:W x L (PKG)": "22 mm2: 4.4 x 5 (HTSSOP|14)",
        "Package Group": "HTSSOP|14",
        "\"Approx. price\n(USD)\"": "$1.086 | 1ku",
        "Status": "ACTIVE"
    },
    "LM5010A-Q1": {
        "Description": "Automotive Grade 0 and 1 6-75V Wide Vin 1A Constant On-Time Non-Synchronous Buck Regulator",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "\"-40 to 125\n-40 to 150\"",
        "Package size: mm2:W x L (PKG)": "22 mm2: 4.4 x 5 (HTSSOP|14)",
        "Package Group": "HTSSOP|14",
        "\"Approx. price\n(USD)\"": "$1.693 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS54617": {
        "Description": "3V to 6V Input 6A Synchronous Step-Down Converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "25 mm2: 7 x 3.5 (VQFN|34)",
        "Package Group": "VQFN|34",
        "\"Approx. price\n(USD)\"": "$1.353 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS54917": {
        "Description": "3V to 4V Input 9A Synchronous Step-Down SWIFT&trade; Converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "25 mm2: 7 x 3.5 (VQFN|34)",
        "Package Group": "VQFN|34",
        "\"Approx. price\n(USD)\"": "$2.420 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62561": {
        "Description": "2.25MHz 600mA Step-Down Converter in TSOT23 Package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "8 mm2: 2.8 x 2.9 (SOT-23-THIN|5)",
        "Package Group": "SOT-23-THIN|5",
        "\"Approx. price\n(USD)\"": "$0.349 | 1ku",
        "Status": "ACTIVE"
    },
    "LM25085": {
        "Description": "4.5-42V Wide Vin Constant On-Time Non-Synchronous PFET Buck Controller",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck controllers (external switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (HVSSOP|8) 15 mm2: 4.9 x 3 (VSSOP|8) 9 mm2: 3 x 3 (WSON|8)",
        "Package Group": "HVSSOP|8 VSSOP|8 WSON|8",
        "\"Approx. price\n(USD)\"": "$0.678 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62250": {
        "Description": "2.25MHz 1A Peak Current Limited Step-Down Converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "4 mm2: 2 x 2 (WSON|6)",
        "Package Group": "WSON|6",
        "\"Approx. price\n(USD)\"": "$0.629 | 1ku",
        "Status": "ACTIVE"
    },
    "LM7705": {
        "Description": "Low Noise Negative Bias Generator",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Charge pumps (inductorless)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "15 mm2: 4.9 x 3 (VSSOP|8)",
        "Package Group": "VSSOP|8",
        "\"Approx. price\n(USD)\"": "$0.252 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS54233": {
        "Description": "3.5 to 28V Input 2A 300kHz Step-Down Converter with Eco-mode",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 150",
        "Package size: mm2:W x L (PKG)": "19 mm2: 3.91 x 4.9 (SOIC|8)",
        "Package Group": "SOIC|8",
        "\"Approx. price\n(USD)\"": "$0.569 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS63030": {
        "Description": "High Efficient Single Inductor Buck-Boost Converter with 1-A Switches",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck-boost inverting & split-rail converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "6 mm2: 2.5 x 2.5 (SON|10)",
        "Package Group": "SON|10",
        "\"Approx. price\n(USD)\"": "$0.725 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS63031": {
        "Description": "High Efficient Single Inductor Buck-Boost Converter with 1-A Switches",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck-boost inverting & split-rail converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "6 mm2: 2.5 x 2.5 (SON|10)",
        "Package Group": "SON|10",
        "\"Approx. price\n(USD)\"": "$0.725 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS54160": {
        "Description": "3.5V to 60V Input 1.5A Step-Down Converter with Eco-Mode",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 150",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (HVSSOP|10)",
        "Package Group": "HVSSOP|10",
        "\"Approx. price\n(USD)\"": "$1.307 | 1ku",
        "Status": "ACTIVE"
    },
    "LM5116WG": {
        "Description": "100V Wide Vin Synchronous Buck Controller",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck controllers (external switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "99 mm2: 7.239 x 13.716 (CFP|20)",
        "Package Group": "CFP|20",
        "\"Approx. price\n(USD)\"": "$250.000 | 1ku",
        "Status": "ACTIVE"
    },
    "LM22673": {
        "Description": "SIMPLE SWITCHER® 4.5V to 42V 3A Step-Down Voltage Reg. with Adjustable Soft-Start and Current Limit",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "19 mm2: 3.9 x 4.89 (SO PowerPAD|8) 100 mm2: 9.85 x 10.16 (TO-263|7)",
        "Package Group": "SO PowerPAD|8 TO-263|7",
        "\"Approx. price\n(USD)\"": "$1.791 | 1ku",
        "Status": "ACTIVE"
    },
    "LM22676": {
        "Description": "SIMPLE SWITCHER&reg; 4.5V to 42V 3A Step-Down Regulator with Precision Enable",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "19 mm2: 3.9 x 4.89 (SO PowerPAD|8) 100 mm2: 9.85 x 10.16 (TO-263|7)",
        "Package Group": "SO PowerPAD|8 TO-263|7",
        "\"Approx. price\n(USD)\"": "$1.742 | 1ku",
        "Status": "ACTIVE"
    },
    "LM22678": {
        "Description": "SIMPLE SWITCHER® 4.5V to 42V 5A Step-Down Voltage Regulator with Precision Enable",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "100 mm2: 9.85 x 10.16 (TO-263|7)",
        "Package Group": "TO-263|7",
        "\"Approx. price\n(USD)\"": "$2.372 | 1ku",
        "Status": "ACTIVE"
    },
    "LM22679": {
        "Description": "SIMPLE SWITCHER® 4.5V to 42V 5A Step-Down Voltage Regulator with Adjustable Soft-Start & Current Li",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "100 mm2: 9.85 x 10.16 (TO-263|7)",
        "Package Group": "TO-263|7",
        "\"Approx. price\n(USD)\"": "$2.323 | 1ku",
        "Status": "ACTIVE"
    },
    "LM5576-Q1": {
        "Description": "75V 3A Step-Down Switching Regulator",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "42 mm2: 6.4 x 6.5 (HTSSOP|20)",
        "Package Group": "HTSSOP|20",
        "\"Approx. price\n(USD)\"": "$3.071 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS54231": {
        "Description": "3.5 to 28V Input 2A 570kHz Step-Down Converter with Eco-mode&trade;",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 150",
        "Package size: mm2:W x L (PKG)": "19 mm2: 3.91 x 4.9 (SOIC|8)",
        "Package Group": "SOIC|8",
        "\"Approx. price\n(USD)\"": "$0.569 | 1ku",
        "Status": "ACTIVE"
    },
    "LM5574-Q1": {
        "Description": "75V 0.5A Step-Down Switching Regulator",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "22 mm2: 4.4 x 5 (TSSOP|16)",
        "Package Group": "TSSOP|16",
        "\"Approx. price\n(USD)\"": "$1.770 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS55065-Q1": {
        "Description": "1.5-V to 40-V 500-mA buck-boost converter with 5-V fixed output voltage AEC-Q100 qualified",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck-boost inverting & split-rail converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "42 mm2: 6.4 x 6.5 (HTSSOP|20)",
        "Package Group": "HTSSOP|20",
        "\"Approx. price\n(USD)\"": "$1.502 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS55383": {
        "Description": "4.5V to 28V Input Dual 3A Outputs 300kHz Step-Down Converter with External Compensation",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "32 mm2: 6.4 x 5 (HTSSOP|16)",
        "Package Group": "HTSSOP|16",
        "\"Approx. price\n(USD)\"": "$1.500 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS55386": {
        "Description": "4.5V to 28V Input Dual 3A Outputs 600kHz Step-Down Converter with External Compensation",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "32 mm2: 6.4 x 5 (HTSSOP|16)",
        "Package Group": "HTSSOP|16",
        "\"Approx. price\n(USD)\"": "$1.500 | 1ku",
        "Status": "ACTIVE"
    },
    "LM22670": {
        "Description": "4.5V to 42V 3A SIMPLE SWITCHER® buck converter with frequency synchronization",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "19 mm2: 3.9 x 4.89 (SO PowerPAD|8) 100 mm2: 9.85 x 10.16 (TO-263|7)",
        "Package Group": "SO PowerPAD|8 TO-263|7",
        "\"Approx. price\n(USD)\"": "$1.791 | 1ku",
        "Status": "ACTIVE"
    },
    "LM22670-Q1": {
        "Description": "3A SIMPLE SWITCHER Step-Down Voltage Regulator with Synchronization or Adjustable Switching Freq",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "19 mm2: 3.9 x 4.89 (SO PowerPAD|8) 100 mm2: 9.85 x 10.16 (TO-263|7)",
        "Package Group": "SO PowerPAD|8 TO-263|7",
        "\"Approx. price\n(USD)\"": "$2.113 | 1ku",
        "Status": "ACTIVE"
    },
    "LM22677": {
        "Description": "SIMPLE SWITCHER® 4.5V to 42V 5A Step-Down DC/DC Switching Reg. with Frequency Synchronization",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "100 mm2: 9.85 x 10.16 (TO-263|7)",
        "Package Group": "TO-263|7",
        "\"Approx. price\n(USD)\"": "$2.420 | 1ku",
        "Status": "ACTIVE"
    },
    "LM22677-Q1": {
        "Description": "5A SIMPLE SWITCHER Step-Down Voltage Reg. with Synchronization or Adjustable Switching Frequency",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "100 mm2: 9.85 x 10.16 (TO-263|7)",
        "Package Group": "TO-263|7",
        "\"Approx. price\n(USD)\"": "$2.856 | 1ku",
        "Status": "ACTIVE"
    },
    "LM3150": {
        "Description": "6V to 42V Synchronous Step-Down Controller with Adjustable Output Voltage",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck controllers (external switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "22 mm2: 4.4 x 5 (HTSSOP|14)",
        "Package Group": "HTSSOP|14",
        "\"Approx. price\n(USD)\"": "$1.307 | 1ku",
        "Status": "ACTIVE"
    },
    "LM5575-Q1": {
        "Description": "75V 1.5A Step-Down Switching Regulator",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "\"-40 to 125\n-40 to 150\"",
        "Package size: mm2:W x L (PKG)": "32 mm2: 6.4 x 5 (HTSSOP|16)",
        "Package Group": "HTSSOP|16",
        "\"Approx. price\n(USD)\"": "$2.341 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS40210-Q1": {
        "Description": "4.5-V to 52-V wide input range current mode boost controller with 700-mV reference voltage",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost controllers (external switch)",
        "Rating": "Automotive",
        "TI functional safety category": "Functional Safety-Capable",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (HVSSOP|10)",
        "Package Group": "HVSSOP|10",
        "\"Approx. price\n(USD)\"": "$0.857 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS40211-Q1": {
        "Description": "4.5-V to 52-V wide input range current mode boost controller with 260-mV reference voltage",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost controllers (external switch)",
        "Rating": "Automotive",
        "TI functional safety category": "Functional Safety-Capable",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (HVSSOP|10)",
        "Package Group": "HVSSOP|10",
        "\"Approx. price\n(USD)\"": "$0.773 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS51610": {
        "Description": "Single Phase D-CAP+&trade;Mode Step Down Controller for IMVP6+ CPU/GPU Vcore",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck controllers (external switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 105",
        "Package size: mm2:W x L (PKG)": "25 mm2: 5 x 5 (VQFN|32)",
        "Package Group": "VQFN|32",
        "\"Approx. price\n(USD)\"": "$1.210 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS5450-Q1": {
        "Description": "Automotive 5.5V to 36V 5A Buck Converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "19 mm2: 3.9 x 4.89 (SO PowerPAD|8)",
        "Package Group": "SO PowerPAD|8",
        "\"Approx. price\n(USD)\"": "$2.420 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62701": {
        "Description": "2MHz 650mA Step-Down Converter for RF Power Amplifiers with Built in Clock Dittering Circuit and Tin",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "3 mm2: 1.75 x 1.75 (DSBGA|8)",
        "Package Group": "DSBGA|8",
        "\"Approx. price\n(USD)\"": "$0.506 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS54331": {
        "Description": "3.5V to 28V Input 3A 570kHz Step-Down Converter with Eco-mode",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 150",
        "Package size: mm2:W x L (PKG)": "19 mm2: 3.9 x 4.89 (SO PowerPAD|8) 19 mm2: 3.91 x 4.9 (SOIC|8)",
        "Package Group": "SO PowerPAD|8 SOIC|8",
        "\"Approx. price\n(USD)\"": "$0.561 | 1ku",
        "Status": "ACTIVE"
    },
    "LM20343": {
        "Description": "4.5-36V 3A Current Mode Synchronous Buck Regulator with Adjustable Frequency",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "42 mm2: 6.4 x 6.5 (HTSSOP|20)",
        "Package Group": "HTSSOP|20",
        "\"Approx. price\n(USD)\"": "$1.791 | 1ku",
        "Status": "ACTIVE"
    },
    "LM5085": {
        "Description": "4.5-75V Wide Vin Constant On-Time Non-Synchronous PFET Buck Controller",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck controllers (external switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (HVSSOP|8) 15 mm2: 4.9 x 3 (VSSOP|8) 9 mm2: 3 x 3 (WSON|8)",
        "Package Group": "HVSSOP|8 VSSOP|8 WSON|8",
        "\"Approx. price\n(USD)\"": "$0.823 | 1ku",
        "Status": "ACTIVE"
    },
    "LM5085-Q1": {
        "Description": "Automotive Grade 4.5-75V Wide Vin Constant On-Time Non-Synchronous PFET Buck Controller",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck controllers (external switch)",
        "Rating": "Automotive",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (HVSSOP|8)",
        "Package Group": "HVSSOP|8",
        "\"Approx. price\n(USD)\"": "$0.971 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62273": {
        "Description": "2.25MHz 400mA Step-Down Converter with Selectable Vout",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "4 mm2: 2 x 2 (WSON|6)",
        "Package Group": "WSON|6",
        "\"Approx. price\n(USD)\"": "$0.436 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS40090-Q1": {
        "Description": "Automotive 4.5V to 15V Multiphase Synchronous Buck Controller",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck controllers (external switch)",
        "Rating": "Automotive",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "34 mm2: 4.4 x 7.8 (TSSOP|24)",
        "Package Group": "TSSOP|24",
        "\"Approx. price\n(USD)\"": "$1.973 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS54110-Q1": {
        "Description": "Automotive 3V to 6V 1.5A Synchronous Buck Converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "42 mm2: 6.4 x 6.5 (HTSSOP|20)",
        "Package Group": "HTSSOP|20",
        "\"Approx. price\n(USD)\"": "$2.113 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS61085": {
        "Description": "18.5V 2A 650kHz / 1.2MHz Step-Up DC-DC Converter w/ Forced PWM Mode",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "19 mm2: 6.4 x 3 (TSSOP|8) 15 mm2: 4.9 x 3 (VSSOP|8)",
        "Package Group": "TSSOP|8 VSSOP|8",
        "\"Approx. price\n(USD)\"": "$0.706 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS63010": {
        "Description": "High Efficient Single Inductor Buck-Boost Converter with 2-A Switches",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck-boost inverting & split-rail converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "See datasheet (DSBGA)",
        "Package Group": "DSBGA|20",
        "\"Approx. price\n(USD)\"": "$0.833 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS63011": {
        "Description": "High Efficient Single Inductor Buck-Boost Converter with 2-A Switches",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck-boost inverting & split-rail converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "See datasheet (DSBGA)",
        "Package Group": "DSBGA|20",
        "\"Approx. price\n(USD)\"": "$0.833 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS63012": {
        "Description": "High Efficient Single Inductor Buck-Boost Converter with 2-A Switches",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck-boost inverting & split-rail converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "See datasheet (DSBGA)",
        "Package Group": "DSBGA|20",
        "\"Approx. price\n(USD)\"": "$0.833 | 1ku",
        "Status": "ACTIVE"
    },
    "LM3489-Q1": {
        "Description": "Automotive Grade 4.5-35V Hysteretic Non-Synchronous PFET Buck Controller with Enable Pin",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck controllers (external switch)",
        "Rating": "Automotive",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "15 mm2: 4.9 x 3 (VSSOP|8)",
        "Package Group": "VSSOP|8",
        "\"Approx. price\n(USD)\"": "$0.617 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62601": {
        "Description": "500-mA 6-MHz Synchronous Step-Down Converter in Chip Scale Packaging",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "See datasheet (DSBGA)",
        "Package Group": "DSBGA|6",
        "\"Approx. price\n(USD)\"": "$1.164 | 1ku",
        "Status": "ACTIVE"
    },
    "LM20323": {
        "Description": "4.5-36V 3A Current Mode Synchronous Buck Regulator",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "42 mm2: 6.4 x 6.5 (HTSSOP|20)",
        "Package Group": "HTSSOP|20",
        "\"Approx. price\n(USD)\"": "$1.384 | 1ku",
        "Status": "ACTIVE"
    },
    "LM20333": {
        "Description": "4.5-36V 3A Current Mode Synchronous Buck Regulator with Frequency Synchronization",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "42 mm2: 6.4 x 6.5 (HTSSOP|20)",
        "Package Group": "HTSSOP|20",
        "\"Approx. price\n(USD)\"": "$1.791 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS61087": {
        "Description": "18.5V 3.2A 650kHz / 1.2MHz Step-Up DC-DC Converter with Forced PWM Mode",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (VSON|10) 9 mm2: 3 x 3 (WSON|10)",
        "Package Group": "VSON|10 WSON|10",
        "\"Approx. price\n(USD)\"": "$0.755 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS54310-EP": {
        "Description": "Enhanced Product 3V to 6V Input 3A Synchronous Buck PWM Switcher with Integrated FETs",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "HiRel Enhanced Product",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-55 to 125",
        "Package size: mm2:W x L (PKG)": "42 mm2: 6.4 x 6.5 (HTSSOP|20)",
        "Package Group": "HTSSOP|20",
        "\"Approx. price\n(USD)\"": "$4.158 | 1ku",
        "Status": "ACTIVE"
    },
    "LM5118": {
        "Description": "3-75V Wide Vin Current Mode Non-Synchronous Buck-Boost Controller",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck-boost & inverting controllers (external switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "42 mm2: 6.4 x 6.5 (HTSSOP|20)",
        "Package Group": "HTSSOP|20",
        "\"Approx. price\n(USD)\"": "$2.303 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS51427": {
        "Description": "Dual-output synchronous D-CAP synchronous buck controller for notebook power",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck controllers (external switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "25 mm2: 5 x 5 (VQFN|32)",
        "Package Group": "VQFN|32",
        "\"Approx. price\n(USD)\"": "$1.888 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS51727": {
        "Description": "Dual-Phase  D-CAP+&trade; Mode Step Down Power Management IC for 50A+ Applications",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck controllers (external switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-10 to 100",
        "Package size: mm2:W x L (PKG)": "36 mm2: 6 x 6 (VQFN|40)",
        "Package Group": "VQFN|40",
        "\"Approx. price\n(USD)\"": "$1.258 | 1ku",
        "Status": "ACTIVE"
    },
    "LM22671": {
        "Description": "SIMPLE SWITCHER® 4.5V to 42V 500mA Step-Down Voltage Regulator with Adjustable Frequency",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "19 mm2: 3.9 x 4.89 (SO PowerPAD|8)",
        "Package Group": "SO PowerPAD|8",
        "\"Approx. price\n(USD)\"": "$1.258 | 1ku",
        "Status": "ACTIVE"
    },
    "LM22671-Q1": {
        "Description": "500mA SIMPLE SWITCHER&reg; Step-Down Voltage Regulator with Adjustable Frequency",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "19 mm2: 3.9 x 4.89 (SO PowerPAD|8)",
        "Package Group": "SO PowerPAD|8",
        "\"Approx. price\n(USD)\"": "$1.484 | 1ku",
        "Status": "ACTIVE"
    },
    "LM22672": {
        "Description": "SIMPLE SWITCHER® 4.5V to 42V 1A Step-Down Voltage Regulator with Adjustable Frequency",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "19 mm2: 3.9 x 4.89 (SO PowerPAD|8)",
        "Package Group": "SO PowerPAD|8",
        "\"Approx. price\n(USD)\"": "$1.549 | 1ku",
        "Status": "ACTIVE"
    },
    "LM22672-Q1": {
        "Description": "1A SIMPLE SWITCHER&reg; Step-Down Voltage Regulator with Adjustable Frequency",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "19 mm2: 3.9 x 4.89 (SO PowerPAD|8)",
        "Package Group": "SO PowerPAD|8",
        "\"Approx. price\n(USD)\"": "$1.828 | 1ku",
        "Status": "ACTIVE"
    },
    "LM2738": {
        "Description": "550kHz/1.6MHz 1.5A Step-Down DC-DC Switching Regulator",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (HVSSOP|8) 9 mm2: 3 x 3 (WSON|8)",
        "Package Group": "HVSSOP|8 WSON|8",
        "\"Approx. price\n(USD)\"": "$1.162 | 1ku",
        "Status": "ACTIVE"
    },
    "LM2854": {
        "Description": "4A 500 kHz / 1 MHz  Synchronous Buck Regulator",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "32 mm2: 6.4 x 5 (HTSSOP|16)",
        "Package Group": "HTSSOP|16",
        "\"Approx. price\n(USD)\"": "$2.137 | 1ku",
        "Status": "ACTIVE"
    },
    "PTD08A020W": {
        "Description": "20A 4.75V to 14V Non-Isolated Digital PowerTrain Module",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck modules (integrated inductor)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "524 mm2: 19.94 x 26.29 (Through-Hole Module|12)",
        "Package Group": "Through-Hole Module|12",
        "\"Approx. price\n(USD)\"": "$19.151 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62291": {
        "Description": "2.25MHz 1A Step-Down Converter in 2x2mm SON Package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "4 mm2: 2 x 2 (WSON|6)",
        "Package Group": "WSON|6",
        "\"Approx. price\n(USD)\"": "$0.601 | 1ku",
        "Status": "ACTIVE"
    },
    "LM34917A": {
        "Description": "2.3x2mm 8-33V 1.25A Constant On-Time Non-Synchronous Buck Regulator w/ Intelligent Current Limit",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "4 mm2: 1.8 x 2 (DSBGA|12)",
        "Package Group": "DSBGA|12",
        "\"Approx. price\n(USD)\"": "$1.307 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS40210": {
        "Description": "4.5~52V Wide Input Range Boost/SEPIC/Flyback DC-DC Controller",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost controllers (external switch)",
        "Rating": "Catalog",
        "TI functional safety category": "Functional Safety-Capable",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (HVSSOP|10) 9 mm2: 3 x 3 (VSON|10)",
        "Package Group": "HVSSOP|10 VSON|10",
        "\"Approx. price\n(USD)\"": "$0.726 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS40211": {
        "Description": "4.5-V to 52-V wide input range current mode boost controller with 260-mV reference voltage",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost controllers (external switch)",
        "Rating": "Catalog",
        "TI functional safety category": "Functional Safety-Capable",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (HVSSOP|10) 9 mm2: 3 x 3 (VSON|10)",
        "Package Group": "HVSSOP|10 VSON|10",
        "\"Approx. price\n(USD)\"": "$0.585 | 1ku",
        "Status": "ACTIVE"
    },
    "LM2830-Q1": {
        "Description": "High frequency 1 A automotive step-down DC/DC converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "5 mm2: 1.6 x 2.9 (SOT-23|5)",
        "Package Group": "SOT-23|5",
        "\"Approx. price\n(USD)\"": "$0.742 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62263": {
        "Description": "2.25MHz 600mA Step-Down Converter in 2x2mm SON/TSOT23 Package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "4 mm2: 2 x 2 (WSON|6)",
        "Package Group": "WSON|6",
        "\"Approx. price\n(USD)\"": "$0.487 | 1ku",
        "Status": "ACTIVE"
    },
    "LM2734Z-Q1": {
        "Description": "3 to 20 V input 1 A high frequency automotive step-down converter with light load efficiency",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "5 mm2: 1.6 x 2.9 (SOT-23-THIN|6) 9 mm2: 3 x 3 (WSON|6)",
        "Package Group": "SOT-23-THIN|6 WSON|6",
        "\"Approx. price\n(USD)\"": "$1.895 | 1ku",
        "Status": "ACTIVE"
    },
    "PTD08A010W": {
        "Description": "10A 4.75V to 14V Non-Isolated Digital PowerTrain Module",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck modules (integrated inductor)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "334 mm2: 16.76 x 19.94 (Through-Hole Module|12)",
        "Package Group": "Through-Hole Module|12",
        "\"Approx. price\n(USD)\"": "$10.459 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS53124": {
        "Description": "4.5-V to 24-V synchronous dual-D-CAP buck controller",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck controllers (external switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "62 mm2: 6.4 x 9.7 (TSSOP|28) 16 mm2: 4 x 4 (VQFN|24)",
        "Package Group": "TSSOP|28 VQFN|24",
        "\"Approx. price\n(USD)\"": "$1.118 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62560": {
        "Description": "2.25MHz 600mA Step-Down Converter in 2x2mm SON Package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "4 mm2: 2 x 2 (WSON|6)",
        "Package Group": "WSON|6",
        "\"Approx. price\n(USD)\"": "$0.349 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62293": {
        "Description": "2.25MHz 1A Step-Down Converter in 2x2mm SON Package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "4 mm2: 2 x 2 (WSON|6)",
        "Package Group": "WSON|6",
        "\"Approx. price\n(USD)\"": "$0.601 | 1ku",
        "Status": "ACTIVE"
    },
    "LM2773": {
        "Description": "Low-Ripple 1.8V/1.6V Spread-Spectrum Switched Capacitor Step-Down Regulator",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Charge pumps (inductorless)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-30 to 85",
        "Package size: mm2:W x L (PKG)": "4 mm2: 1.8 x 2 (DSBGA|9)",
        "Package Group": "DSBGA|9",
        "\"Approx. price\n(USD)\"": "$0.352 | 1ku",
        "Status": "ACTIVE"
    },
    "LM22674": {
        "Description": "4.5V to 42V 500mA SIMPLE SWITCHER® buck converter with precision enable",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "19 mm2: 3.9 x 4.89 (SO PowerPAD|8)",
        "Package Group": "SO PowerPAD|8",
        "\"Approx. price\n(USD)\"": "$1.210 | 1ku",
        "Status": "ACTIVE"
    },
    "LM22674-Q1": {
        "Description": "500 mA SIMPLE SWITCHER&reg; Step-Down Voltage Regulator with Precision Enable",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "19 mm2: 3.9 x 4.89 (SO PowerPAD|8)",
        "Package Group": "SO PowerPAD|8",
        "\"Approx. price\n(USD)\"": "$1.428 | 1ku",
        "Status": "ACTIVE"
    },
    "LM22675": {
        "Description": "4.5V to 42V 1A SIMPLE SWITCHER® buck converter with precision enable",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "19 mm2: 3.9 x 4.89 (SO PowerPAD|8)",
        "Package Group": "SO PowerPAD|8",
        "\"Approx. price\n(USD)\"": "$1.500 | 1ku",
        "Status": "ACTIVE"
    },
    "LM22675-Q1": {
        "Description": "1A SIMPLE SWITCHER Step-Down Voltage Regulator with Precision Enable",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "19 mm2: 3.9 x 4.89 (SO PowerPAD|8)",
        "Package Group": "SO PowerPAD|8",
        "\"Approx. price\n(USD)\"": "$1.770 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS40200-Q1": {
        "Description": "Automotive 4.5V to 52V Non-Synchronous Voltage Mode Buck Controller with P-Channel FET Driver",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck controllers (external switch)",
        "Rating": "Automotive",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "19 mm2: 3.91 x 4.9 (SOIC|8)",
        "Package Group": "SOIC|8",
        "\"Approx. price\n(USD)\"": "$0.834 | 1ku",
        "Status": "ACTIVE"
    },
    "LM2841": {
        "Description": "4.5V to 42V 300mA SIMPLE SWITCHER® buck converter in thin SOT-23",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "5 mm2: 1.6 x 2.9 (SOT-23-THIN|6)",
        "Package Group": "SOT-23-THIN|6",
        "\"Approx. price\n(USD)\"": "$1.065 | 1ku",
        "Status": "ACTIVE"
    },
    "LM2841-Q1": {
        "Description": "SIMPLE SWITCHER&reg; 42V 300mA Step-Down DC/DC Regulator in Thin SOT-23",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "5 mm2: 1.6 x 2.9 (SOT-23-THIN|6)",
        "Package Group": "SOT-23-THIN|6",
        "\"Approx. price\n(USD)\"": "$1.257 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS40042": {
        "Description": "Low Pin Count Low Vin Synchronous Buck DCDC Controller with Tracking",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck controllers (external switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (VSON|10)",
        "Package Group": "VSON|10",
        "\"Approx. price\n(USD)\"": "$0.823 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS51620": {
        "Description": "Dual Phase D-CAP+&trade;Mode Step Down Controller for IMVP6+ CPU/GPU Vcore",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck controllers (external switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-10 to 100",
        "Package size: mm2:W x L (PKG)": "36 mm2: 6 x 6 (VQFN|40)",
        "Package Group": "VQFN|40",
        "\"Approx. price\n(USD)\"": "$1.936 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62700": {
        "Description": "2 MHz 650mA Step-Down Converter for RF Power Amplifiers in tiny 8-pin WCSP Package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "3 mm2: 1.75 x 1.75 (DSBGA|8)",
        "Package Group": "DSBGA|8",
        "\"Approx. price\n(USD)\"": "$0.506 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62356": {
        "Description": "1A 3MHz Buck Converter with I2C for Dynamic Voltage Scaling",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "See datasheet (DSBGA)",
        "Package Group": "DSBGA|12",
        "\"Approx. price\n(USD)\"": "$0.571 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS5420-Q1": {
        "Description": "Automotive 5.5V to 36V 500kHz Fixed Frequency 2A Buck Converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "19 mm2: 3.91 x 4.9 (SOIC|8)",
        "Package Group": "SOIC|8",
        "\"Approx. price\n(USD)\"": "$1.634 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62270": {
        "Description": "2.25MHz 400mA Step-Down Converter with Selectable VOUT",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "4 mm2: 2 x 2 (WSON|6)",
        "Package Group": "WSON|6",
        "\"Approx. price\n(USD)\"": "$0.436 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS5430-Q1": {
        "Description": "Automotive 5.5V to 36V 500kHz Fixed Frequency 3A Buck Converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "19 mm2: 3.9 x 4.89 (SO PowerPAD|8)",
        "Package Group": "SO PowerPAD|8",
        "\"Approx. price\n(USD)\"": "$1.996 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS51220": {
        "Description": "3-V to 28-V synchronous peak current mode buck controller for notebook power",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck controllers (external switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "25 mm2: 5 x 5 (VQFN|32)",
        "Package Group": "VQFN|32",
        "\"Approx. price\n(USD)\"": "$1.320 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62112-EP": {
        "Description": "Enhanced Product 17 V 1.5 A Synchronous Step-Down Converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "HiRel Enhanced Product",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-55 to 125",
        "Package size: mm2:W x L (PKG)": "16 mm2: 4 x 4 (QFN|16)",
        "Package Group": "QFN|16",
        "\"Approx. price\n(USD)\"": "$4.840 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS61170": {
        "Description": "1.2A Switch 38V High Voltage Boost Converter in 2x2mm QFN Package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "4 mm2: 2 x 2 (WSON|6)",
        "Package Group": "WSON|6",
        "\"Approx. price\n(USD)\"": "$0.774 | 1ku",
        "Status": "ACTIVE"
    },
    "LM3679": {
        "Description": "3MHz 350mA Miniature Step-Down DC-DC Converter for Ultra Low Profile Applications",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-30 to 85",
        "Package size: mm2:W x L (PKG)": "See datasheet (DSBGA)",
        "Package Group": "DSBGA|5",
        "\"Approx. price\n(USD)\"": "$0.377 | 1ku",
        "Status": "ACTIVE"
    },
    "LM20123": {
        "Description": "2.95-5.5V 3A Current Mode Synchronous Buck Regulator with Optional Automotive Grade",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "32 mm2: 6.4 x 5 (HTSSOP|16)",
        "Package Group": "HTSSOP|16",
        "\"Approx. price\n(USD)\"": "$1.210 | 1ku",
        "Status": "ACTIVE"
    },
    "LM20124": {
        "Description": "2.95-5.5V 4A Current Mode Synchronous Buck Regulator with Optional Automotive Grade",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "32 mm2: 6.4 x 5 (HTSSOP|16)",
        "Package Group": "HTSSOP|16",
        "\"Approx. price\n(USD)\"": "$1.113 | 1ku",
        "Status": "ACTIVE"
    },
    "LM20125": {
        "Description": "2.95-5.5V 5A Current Mode Synchronous Buck Regulator with Optional Automotive Grade",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "32 mm2: 6.4 x 5 (HTSSOP|16)",
        "Package Group": "HTSSOP|16",
        "\"Approx. price\n(USD)\"": "$1.162 | 1ku",
        "Status": "ACTIVE"
    },
    "LM20133": {
        "Description": "2.95-5.5V 3A Current Mode Synchronous Buck Regulator with Input Sync and Optional Automotive Grade",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "32 mm2: 6.4 x 5 (HTSSOP|16)",
        "Package Group": "HTSSOP|16",
        "\"Approx. price\n(USD)\"": "$1.210 | 1ku",
        "Status": "ACTIVE"
    },
    "LM20134": {
        "Description": "2.95-5.5V 4A Current Mode Synchronous Buck Regulator with Input Sync and Optional Automotive Grade",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "32 mm2: 6.4 x 5 (HTSSOP|16)",
        "Package Group": "HTSSOP|16",
        "\"Approx. price\n(USD)\"": "$1.162 | 1ku",
        "Status": "ACTIVE"
    },
    "LM20143": {
        "Description": "2.95-5.5V 3A Current Mode Synchronous Buck Regulator with Adjustable Frequency",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "32 mm2: 6.4 x 5 (HTSSOP|16)",
        "Package Group": "HTSSOP|16",
        "\"Approx. price\n(USD)\"": "$1.210 | 1ku",
        "Status": "ACTIVE"
    },
    "LM20144": {
        "Description": "2.95-5.5V 4A Current Mode Synchronous Buck Regulator with Adjustable Frequency",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "32 mm2: 6.4 x 5 (HTSSOP|16)",
        "Package Group": "HTSSOP|16",
        "\"Approx. price\n(USD)\"": "$1.113 | 1ku",
        "Status": "ACTIVE"
    },
    "LM20145": {
        "Description": "2.95-5.5V 5A Current Mode Synchronous Buck Regulator with Adjustable Frequency",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "32 mm2: 6.4 x 5 (HTSSOP|16)",
        "Package Group": "HTSSOP|16",
        "\"Approx. price\n(USD)\"": "$1.162 | 1ku",
        "Status": "ACTIVE"
    },
    "LM20154": {
        "Description": "4A 1MHz Synchronous Buck  Regulator with SYNCOUT",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "32 mm2: 6.4 x 5 (HTSSOP|16)",
        "Package Group": "HTSSOP|16",
        "\"Approx. price\n(USD)\"": "$1.452 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62242": {
        "Description": "1.2V / 300mA Step-Down Converter in 2x2mm SON/TSOT23 Package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "4 mm2: 2 x 2 (WSON|6)",
        "Package Group": "WSON|6",
        "\"Approx. price\n(USD)\"": "$0.396 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS51125": {
        "Description": "4.5-V to 28-V dual-channel synchronous buck controller with 100-mA LDOs and Out-of-Audio™",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck controllers (external switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "16 mm2: 4 x 4 (VQFN|24)",
        "Package Group": "VQFN|24",
        "\"Approx. price\n(USD)\"": "$1.213 | 1ku",
        "Status": "ACTIVE"
    },
    "LM2757": {
        "Description": "Switched Capacitor Boost Regulator with High Impedance Output in Shutdown",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Charge pumps (inductorless)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-30 to 85",
        "Package size: mm2:W x L (PKG)": "See datasheet (DSBGA)",
        "Package Group": "DSBGA|12",
        "\"Approx. price\n(USD)\"": "$0.585 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62355": {
        "Description": "1A 3MHz Buck Converter with I2C for Dynamic Voltage Scaling",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (VSON|10)",
        "Package Group": "VSON|10",
        "\"Approx. price\n(USD)\"": "$0.571 | 1ku",
        "Status": "ACTIVE"
    },
    "LM4510": {
        "Description": "Synchronous Step-Up DC/DC Converter with True Shutdown Isolation",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (WSON|10)",
        "Package Group": "WSON|10",
        "\"Approx. price\n(USD)\"": "$0.485 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62111-EP": {
        "Description": "Enhanced Product 17-V 1.5-A Synchronous Step-Down Converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "HiRel Enhanced Product",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-55 to 125",
        "Package size: mm2:W x L (PKG)": "16 mm2: 4 x 4 (QFN|16)",
        "Package Group": "QFN|16",
        "\"Approx. price\n(USD)\"": "$2.750 | 1ku",
        "Status": "ACTIVE"
    },
    "LM3102": {
        "Description": "Synchronous 1MHz 2.5A Step-Down Voltage  Regulator",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "See datasheet (DSBGA) 42 mm2: 6.4 x 6.5 (HTSSOP|20)",
        "Package Group": "DSBGA|28 HTSSOP|20",
        "\"Approx. price\n(USD)\"": "$2.033 | 1ku",
        "Status": "ACTIVE"
    },
    "LM3103": {
        "Description": "Synchronous 1MHz 0.75A Step-Down Voltage  Regulator",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "32 mm2: 6.4 x 5 (HTSSOP|16)",
        "Package Group": "HTSSOP|16",
        "\"Approx. price\n(USD)\"": "$1.500 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS54283": {
        "Description": "4.5V to 28V Input Dual 2A Output 300kHz Step-Down Converter with Internal Compensation",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "22 mm2: 4.4 x 5 (HTSSOP|14)",
        "Package Group": "HTSSOP|14",
        "\"Approx. price\n(USD)\"": "$0.944 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS54286": {
        "Description": "4.5V to 28V Input Dual 2A Output 600kHz Step-Down Converter with Internal Compensation",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "22 mm2: 4.4 x 5 (HTSSOP|14)",
        "Package Group": "HTSSOP|14",
        "\"Approx. price\n(USD)\"": "$0.944 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS54383": {
        "Description": "4.5V to 28V Input Dual 3A Outputs 300kHz Step-Down Converter with Internal Compensation",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "22 mm2: 4.4 x 5 (HTSSOP|14)",
        "Package Group": "HTSSOP|14",
        "\"Approx. price\n(USD)\"": "$0.944 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS54386": {
        "Description": "4.5V to 28V Input Dual 3A Outputs 600kHz Step-Down Converter with Internal Compensation",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "22 mm2: 4.4 x 5 (HTSSOP|14)",
        "Package Group": "HTSSOP|14",
        "\"Approx. price\n(USD)\"": "$0.944 | 1ku",
        "Status": "ACTIVE"
    },
    "PTH08T250W": {
        "Description": "50A 4.5V to 14V Input Non-Isolated Wide Output Adjustable Power Module with TurboTrans",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck modules (integrated inductor)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "1067 mm2: 26.92 x 39.62 (Surface Mount Module|22) 1067 mm2: 26.92 x 39.62 (Through-Hole Module|22)",
        "Package Group": "Surface Mount Module|22 Through-Hole Module|22",
        "\"Approx. price\n(USD)\"": "$44.274 | 1ku",
        "Status": "ACTIVE"
    },
    "LM3153": {
        "Description": "SIMPLE SWITCHER® CONTROLLER 42V Synchronous Step-Down",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck controllers (external switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "22 mm2: 4.4 x 5 (HTSSOP|14)",
        "Package Group": "HTSSOP|14",
        "\"Approx. price\n(USD)\"": "$1.307 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62240": {
        "Description": "2.25MHz 300mA Step-Down Converter in 2x2mm SON/TSOT23 Package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "8 mm2: 2.8 x 2.9 (SOT-23-THIN|5) 4 mm2: 2 x 2 (WSON|6)",
        "Package Group": "SOT-23-THIN|5 WSON|6",
        "\"Approx. price\n(USD)\"": "$0.396 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62243": {
        "Description": "1.8V / 300mA Step-Down Converter in 2x2mm SON/TSOT23 Package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "4 mm2: 2 x 2 (WSON|6)",
        "Package Group": "WSON|6",
        "\"Approx. price\n(USD)\"": "$0.396 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62260": {
        "Description": "2.25MHz 600mA Step-Down Converter in 2x2mm SON/TSOT23 Package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "8 mm2: 2.8 x 2.9 (SOT-23-THIN|5) 4 mm2: 2 x 2 (WSON|6)",
        "Package Group": "SOT-23-THIN|5 WSON|6",
        "\"Approx. price\n(USD)\"": "$0.487 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62261": {
        "Description": "2.25MHz 600mA Step-Down Converter in 2x2mm SON/TSOT23 Package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "4 mm2: 2 x 2 (WSON|6)",
        "Package Group": "WSON|6",
        "\"Approx. price\n(USD)\"": "$0.487 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62262": {
        "Description": "2.25MHz 600mA Step-Down Converter in 2x2mm SON/TSOT23 Package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "8 mm2: 2.8 x 2.9 (SOT-23-THIN|5) 4 mm2: 2 x 2 (WSON|6)",
        "Package Group": "SOT-23-THIN|5 WSON|6",
        "\"Approx. price\n(USD)\"": "$0.487 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62290": {
        "Description": "2.25MHz 1A Step-Down Converter in 2x2mm SON Package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "4 mm2: 2 x 2 (WSON|6)",
        "Package Group": "WSON|6",
        "\"Approx. price\n(USD)\"": "$0.601 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62351": {
        "Description": "1A 3MHz Buck Converter with I2C for Dynamic Voltage Scaling",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (VSON|10)",
        "Package Group": "VSON|10",
        "\"Approx. price\n(USD)\"": "$0.571 | 1ku",
        "Status": "ACTIVE"
    },
    "LM34910C": {
        "Description": "8-50V 1.25A Constant On-Time Non-Synchronous Buck Regulator",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "16 mm2: 4 x 4 (WSON|10)",
        "Package Group": "WSON|10",
        "\"Approx. price\n(USD)\"": "$1.249 | 1ku",
        "Status": "ACTIVE"
    },
    "LM34919": {
        "Description": "2x1.5mm 8-40V Wide Vin 600mA Constant On-Time Non-Synchronous Buck Regulator",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "See datasheet (DSBGA)",
        "Package Group": "DSBGA|10",
        "\"Approx. price\n(USD)\"": "$1.162 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS61073": {
        "Description": "Adjustable 600-mA switch 1200-kHz boost converter in ThinSOT-23 with power-saving mode",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "5 mm2: 1.6 x 2.9 (SOT-23-THIN|6)",
        "Package Group": "SOT-23-THIN|6",
        "\"Approx. price\n(USD)\"": "$0.349 | 1ku",
        "Status": "ACTIVE"
    },
    "LM26001B": {
        "Description": "1.5A Switching Regulator with High Efficiency Sleep Mode",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "32 mm2: 6.4 x 5 (HTSSOP|16)",
        "Package Group": "HTSSOP|16",
        "\"Approx. price\n(USD)\"": "$0.660 | 1ku",
        "Status": "ACTIVE"
    },
    "PTH04T221W": {
        "Description": "16-A 2.2-V to 5.5-V Input Ceramic Cap Version Non-Isolated Wide-Output Power Module w/ TurboTra",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck modules (integrated inductor)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "524 mm2: 19.94 x 26.29 (Surface Mount Module|11) 524 mm2: 19.94 x 26.29 (Through-Hole Module|11)",
        "Package Group": "Surface Mount Module|11 Through-Hole Module|11",
        "\"Approx. price\n(USD)\"": "$12.650 | 1ku",
        "Status": "ACTIVE"
    },
    "PTH04T241W": {
        "Description": "10-A 2.2-V to 5.5-V Input Ceramic Cap Version Non-Iso Wide-Output Adj Power Module w/TurboTrans",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck modules (integrated inductor)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "387 mm2: 16.76 x 23.11 (Surface Mount Module|11) 387 mm2: 16.76 x 23.11 (Through-Hole Module|11)",
        "Package Group": "Surface Mount Module|11 Through-Hole Module|11",
        "\"Approx. price\n(USD)\"": "$10.780 | 1ku",
        "Status": "ACTIVE"
    },
    "LM25116": {
        "Description": "6-42V Wide Vin Current Mode Synchronous Buck Controller",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck controllers (external switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "42 mm2: 6.4 x 6.5 (HTSSOP|20)",
        "Package Group": "HTSSOP|20",
        "\"Approx. price\n(USD)\"": "$1.646 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS5450": {
        "Description": "5.5V to 36V Input 5A 500kHz Step Down Converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "19 mm2: 3.9 x 4.89 (SO PowerPAD|8)",
        "Package Group": "SO PowerPAD|8",
        "\"Approx. price\n(USD)\"": "$1.936 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS40192": {
        "Description": "4.5-V to 18-V 20-A 600-kHz synchronous buck controller with power good",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck controllers (external switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (VSON|10)",
        "Package Group": "VSON|10",
        "\"Approx. price\n(USD)\"": "$0.823 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS40193": {
        "Description": "4.5-V to 18-V 20-A 300-kHz synchronous buck controller with power good",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck controllers (external switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (VSON|10)",
        "Package Group": "VSON|10",
        "\"Approx. price\n(USD)\"": "$0.823 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS61200": {
        "Description": "0.3-V input voltage adjustable ouput voltage boost converter with 1.3-A switches 3-mm x 3-mm QFN",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (VSON|10)",
        "Package Group": "VSON|10",
        "\"Approx. price\n(USD)\"": "$0.871 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS61201": {
        "Description": "0.3-V input voltage 3.3-V fixed output voltage boost converter with 1.3-A switches 3-mm x 3-mm QFN",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (VSON|10)",
        "Package Group": "VSON|10",
        "\"Approx. price\n(USD)\"": "$0.871 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS61202": {
        "Description": "0.3-V input voltage 5-V fixed output voltage boost converter with 1.3-A switches 3-mm x 3-mm QF",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (VSON|10) 9 mm2: 3 x 3 (WSON|10)",
        "Package Group": "VSON|10 WSON|10",
        "\"Approx. price\n(USD)\"": "$0.871 | 1ku",
        "Status": "ACTIVE"
    },
    "LM5015": {
        "Description": "4.25-75V Monolithic Two-Switch Forward DC-DC Regulator",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "22 mm2: 4.4 x 5 (HTSSOP|14)",
        "Package Group": "HTSSOP|14",
        "\"Approx. price\n(USD)\"": "$2.037 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS40131": {
        "Description": "Two-Phase Synchronous Buck Controller w/Integrated Mosfet Drivers",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck controllers (external switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "25 mm2: 5 x 5 (VQFN|32)",
        "Package Group": "VQFN|32",
        "\"Approx. price\n(USD)\"": "$1.320 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS54311-EP": {
        "Description": "Enhanced Product 3-V To 6-V 3-A Output Synchronous-Buck Pwm Switcher W/Integrated Fets",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "HiRel Enhanced Product",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-55 to 125",
        "Package size: mm2:W x L (PKG)": "42 mm2: 6.4 x 6.5 (HTSSOP|20)",
        "Package Group": "HTSSOP|20",
        "\"Approx. price\n(USD)\"": "$4.673 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS54313-EP": {
        "Description": "Enhanced Product 3-V To 6-V 3-A Output Synchronous-Buck Pwm Switcher W/Integrated Fets",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "HiRel Enhanced Product",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-55 to 125",
        "Package size: mm2:W x L (PKG)": "42 mm2: 6.4 x 6.5 (HTSSOP|20)",
        "Package Group": "HTSSOP|20",
        "\"Approx. price\n(USD)\"": "$4.907 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS54314-EP": {
        "Description": "Enhanced Product 3-V To 6-V 3-A Output Synchronous-Buck Pwm Switcher W/Integrated Fets",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "HiRel Enhanced Product",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-55 to 125",
        "Package size: mm2:W x L (PKG)": "42 mm2: 6.4 x 6.5 (HTSSOP|20)",
        "Package Group": "HTSSOP|20",
        "\"Approx. price\n(USD)\"": "$4.673 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS54315-EP": {
        "Description": "Enhanced Product 3-V To 6-V 3-A Output Synchronous-Buck Pwm Switcher W/Integrated Fets",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "HiRel Enhanced Product",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-55 to 125",
        "Package size: mm2:W x L (PKG)": "42 mm2: 6.4 x 6.5 (HTSSOP|20)",
        "Package Group": "HTSSOP|20",
        "\"Approx. price\n(USD)\"": "$4.673 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS54316-EP": {
        "Description": "Enhanced Product 3-V To 6-V 3-A Output Synchronous-Buck Pwm Switcher W/Integrated Fets",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "HiRel Enhanced Product",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-55 to 125",
        "Package size: mm2:W x L (PKG)": "42 mm2: 6.4 x 6.5 (HTSSOP|20)",
        "Package Group": "HTSSOP|20",
        "\"Approx. price\n(USD)\"": "$4.673 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62354": {
        "Description": "1A 3MHz Buck Converter with I2C for Dynamic Voltage Scaling",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "See datasheet (DSBGA)",
        "Package Group": "DSBGA|12",
        "\"Approx. price\n(USD)\"": "$0.571 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62353": {
        "Description": "1A 3MHz Buck Converter with I2C for Dynamic Voltage Scaling",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "See datasheet (DSBGA)",
        "Package Group": "DSBGA|12",
        "\"Approx. price\n(USD)\"": "$0.571 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62402": {
        "Description": "Dual 400mA and 600mA 2.25MHz Step-Down Converter with 1-Wire Interface in QFN",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (VSON|10)",
        "Package Group": "VSON|10",
        "\"Approx. price\n(USD)\"": "$0.609 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62410": {
        "Description": "2.25MHZ 2x800mA Dual Step-Down Converter with 1-Wire Interface in QFN",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (VSON|10)",
        "Package Group": "VSON|10",
        "\"Approx. price\n(USD)\"": "$0.658 | 1ku",
        "Status": "ACTIVE"
    },
    "LM27342": {
        "Description": "2A - Wide Input Range Buck Regulator with Frequency Synchronization",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (HVSSOP|10) 9 mm2: 3 x 3 (WSON|10)",
        "Package Group": "HVSSOP|10 WSON|10",
        "\"Approx. price\n(USD)\"": "$1.162 | 1ku",
        "Status": "ACTIVE"
    },
    "LM27342-Q1": {
        "Description": "2A - Wide Input Range Buck Regulator with Frequency Synchronization",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (HVSSOP|10)",
        "Package Group": "HVSSOP|10",
        "\"Approx. price\n(USD)\"": "$1.371 | 1ku",
        "Status": "ACTIVE"
    },
    "TPIC74100-Q1": {
        "Description": "550kHz 1.5V to 40V 1A buck-boost converter with 5V fixed output voltage AEC-Q100 qualified",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck-boost inverting & split-rail converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "42 mm2: 6.4 x 6.5 (HTSSOP|20)",
        "Package Group": "HTSSOP|20",
        "\"Approx. price\n(USD)\"": "$1.646 | 1ku",
        "Status": "ACTIVE"
    },
    "LM3691": {
        "Description": "High Accuracy Miniature 1A Step-Down DC-DC Converter for Portable Applications",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-30 to 85",
        "Package size: mm2:W x L (PKG)": "2 mm2: 1.3 x 1.5 (DSBGA|6)",
        "Package Group": "DSBGA|6",
        "\"Approx. price\n(USD)\"": "$0.571 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS40195": {
        "Description": "4.5-V to 20-V 20-A synchronous buck controller with power good and synchronization",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck controllers (external switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "22 mm2: 4.4 x 5 (TSSOP|16) 14 mm2: 3.5 x 4 (VQFN|16)",
        "Package Group": "TSSOP|16 VQFN|16",
        "\"Approx. price\n(USD)\"": "$0.958 | 1ku",
        "Status": "ACTIVE"
    },
    "LM26400Y": {
        "Description": "Dual 2A 500kHz Wide Input Range Buck Regulator",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "32 mm2: 6.4 x 5 (HTSSOP|16) 25 mm2: 5 x 5 (WSON|16)",
        "Package Group": "HTSSOP|16 WSON|16",
        "\"Approx. price\n(USD)\"": "$2.033 | 1ku",
        "Status": "ACTIVE"
    },
    "LM25115A": {
        "Description": "42V Secondary Side Post Regulator/Synchronous Buck Controller with Power-Up/Power-Down Tracking",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck controllers (external switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "22 mm2: 4.4 x 5 (TSSOP|16)",
        "Package Group": "TSSOP|16",
        "\"Approx. price\n(USD)\"": "$1.065 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS54312-EP": {
        "Description": "Enhanced Product 3-V To 6-V In 3-A Out Synchronous-Buck Pwm Switchers W/ Integrated Fets",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "HiRel Enhanced Product",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-55 to 125",
        "Package size: mm2:W x L (PKG)": "42 mm2: 6.4 x 6.5 (HTSSOP|20)",
        "Package Group": "HTSSOP|20",
        "\"Approx. price\n(USD)\"": "$5.374 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62110-EP": {
        "Description": "Enhanced Product 17 V 1.5 A Synchronous Step-Down Converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "HiRel Enhanced Product",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-55 to 125",
        "Package size: mm2:W x L (PKG)": "16 mm2: 4 x 4 (QFN|16)",
        "Package Group": "QFN|16",
        "\"Approx. price\n(USD)\"": "$4.114 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS40077": {
        "Description": "4.5-V to 28-V synchronous buck controller with voltage feed forward in HTSSOP package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck controllers (external switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "32 mm2: 6.4 x 5 (HTSSOP|16)",
        "Package Group": "HTSSOP|16",
        "\"Approx. price\n(USD)\"": "$1.045 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS61080": {
        "Description": "27V 500mA switch 1.2MHz boost converter with integrated power diode",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (VSON|10)",
        "Package Group": "VSON|10",
        "\"Approx. price\n(USD)\"": "$0.920 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS61081": {
        "Description": "27V 1.2A switch 1.2MHz boost converter with integrated power diode",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (VSON|10)",
        "Package Group": "VSON|10",
        "\"Approx. price\n(USD)\"": "$1.113 | 1ku",
        "Status": "ACTIVE"
    },
    "LM25574": {
        "Description": "42V 0.5A Step-Down Switching Regulator",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "22 mm2: 4.4 x 5 (TSSOP|16)",
        "Package Group": "TSSOP|16",
        "\"Approx. price\n(USD)\"": "$1.188 | 1ku",
        "Status": "ACTIVE"
    },
    "LM25575": {
        "Description": "6V to 42V 1.5A Step-Down DC/DC Switching Regulator",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "32 mm2: 6.4 x 5 (HTSSOP|16)",
        "Package Group": "HTSSOP|16",
        "\"Approx. price\n(USD)\"": "$1.408 | 1ku",
        "Status": "ACTIVE"
    },
    "LM25576": {
        "Description": "4.5V to 42V 3A Step-Down DC/DC Switching Regulator",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "42 mm2: 6.4 x 6.5 (HTSSOP|20)",
        "Package Group": "HTSSOP|20",
        "\"Approx. price\n(USD)\"": "$1.936 | 1ku",
        "Status": "ACTIVE"
    },
    "LM5001": {
        "Description": "3.1-75V Wide Vin 1A Current Mode Non-Synchronous Switch Mode Regulator",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "19 mm2: 3.91 x 4.9 (SOIC|8) 16 mm2: 4 x 4 (WSON|8)",
        "Package Group": "SOIC|8 WSON|8",
        "\"Approx. price\n(USD)\"": "$1.761 | 1ku",
        "Status": "ACTIVE"
    },
    "LM5002": {
        "Description": "3.1-75V Wide Vin 0.5A Current Mode Boost Flyback Sepic Converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "19 mm2: 3.91 x 4.9 (SOIC|8) 16 mm2: 4 x 4 (WSON|8)",
        "Package Group": "SOIC|8 WSON|8",
        "\"Approx. price\n(USD)\"": "$1.544 | 1ku",
        "Status": "ACTIVE"
    },
    "LM5574": {
        "Description": "75V 0.5A Step-Down Switching Regulator",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "22 mm2: 4.4 x 5 (TSSOP|16)",
        "Package Group": "TSSOP|16",
        "\"Approx. price\n(USD)\"": "$1.500 | 1ku",
        "Status": "ACTIVE"
    },
    "LM5575": {
        "Description": "6V to 75V 1.5A Wide Vin Step-Down Regulator",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "32 mm2: 6.4 x 5 (HTSSOP|16)",
        "Package Group": "HTSSOP|16",
        "\"Approx. price\n(USD)\"": "$1.984 | 1ku",
        "Status": "ACTIVE"
    },
    "LM5576": {
        "Description": "6V to 75V 3A Wide Vin Step-Down Regulator",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "42 mm2: 6.4 x 6.5 (HTSSOP|20)",
        "Package Group": "HTSSOP|20",
        "\"Approx. price\n(USD)\"": "$2.517 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS61072": {
        "Description": "Adjustable 600-mA switch 600-kHz boost converter in ThinSOT-23 with forced PWM mode",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "5 mm2: 1.6 x 2.9 (SOT-23-THIN|6)",
        "Package Group": "SOT-23-THIN|6",
        "\"Approx. price\n(USD)\"": "$0.349 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS40200-EP": {
        "Description": "Enhanced Product Wide-Input-Range Non-Synchronous Voltage-Mode Controller",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck controllers (external switch)",
        "Rating": "HiRel Enhanced Product",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-55 to 125",
        "Package size: mm2:W x L (PKG)": "19 mm2: 3.91 x 4.9 (SOIC|8)",
        "Package Group": "SOIC|8",
        "\"Approx. price\n(USD)\"": "$1.954 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS54354-EP": {
        "Description": "Enhanced Product 4.5-V To 20-V Input 3-A Output Synchronous Pwm Switches W/ Integrated Fet",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "HiRel Enhanced Product",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-55 to 125",
        "Package size: mm2:W x L (PKG)": "32 mm2: 6.4 x 5 (HTSSOP|16)",
        "Package Group": "HTSSOP|16",
        "\"Approx. price\n(USD)\"": "$3.230 | 1ku",
        "Status": "ACTIVE"
    },
    "LM5022": {
        "Description": "6-60V Wide Vin current mode boost SEPIC and Flyback controller",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost controllers (external switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (VSSOP|10)",
        "Package Group": "VSSOP|10",
        "\"Approx. price\n(USD)\"": "$0.958 | 1ku",
        "Status": "ACTIVE"
    },
    "PTH04T220W": {
        "Description": "16-A 2.2-V to 5.5-V Input Non-Isolated Wide-Output Adjustable Power Module with TurboTrans",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck modules (integrated inductor)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "524 mm2: 19.94 x 26.29 (Surface Mount Module|11) 524 mm2: 19.94 x 26.29 (Through-Hole Module|11)",
        "Package Group": "Surface Mount Module|11 Through-Hole Module|11",
        "\"Approx. price\n(USD)\"": "$12.650 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS5420-EP": {
        "Description": "Enhanced Product 5.5V to 36V Input 2A 500kHz Step Down Converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "HiRel Enhanced Product",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-55 to 125",
        "Package size: mm2:W x L (PKG)": "19 mm2: 3.91 x 4.9 (SOIC|8)",
        "Package Group": "SOIC|8",
        "\"Approx. price\n(USD)\"": "$3.133 | 1ku",
        "Status": "ACTIVE"
    },
    "LM27313": {
        "Description": "1.6 MHz boost converter with 30V Internal FET switch in SOT-23",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "5 mm2: 1.6 x 2.9 (SOT-23|5)",
        "Package Group": "SOT-23|5",
        "\"Approx. price\n(USD)\"": "$0.581 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62352": {
        "Description": "1A 3MHz Buck Converter with I2C for Dynamic Voltage Scaling",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "See datasheet (DSBGA)",
        "Package Group": "DSBGA|12",
        "\"Approx. price\n(USD)\"": "$0.571 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62403": {
        "Description": "Dual 400mA and 600mA 2.25MHz Step-Down Converter with 1-Wire Interface in QFN",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (VSON|10)",
        "Package Group": "VSON|10",
        "\"Approx. price\n(USD)\"": "$0.609 | 1ku",
        "Status": "ACTIVE"
    },
    "TL2575HV-05": {
        "Description": "1-A Simple Step-Down Switching Voltage Regulators",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "155 mm2: 15.24 x 10.16 (DDPAK/TO-263|5) 181 mm2: 9.4 x 19.3 (PDIP|16) 83 mm2: 8.2 x 10.16 (TO-220|5)",
        "Package Group": "DDPAK/TO-263|5 PDIP|16 TO-220|5",
        "\"Approx. price\n(USD)\"": "$1.310 | 1ku",
        "Status": "ACTIVE"
    },
    "TL2575HV-12": {
        "Description": "1-A Simple Step-Down Switching Voltage Regulators",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "155 mm2: 15.24 x 10.16 (DDPAK/TO-263|5) 181 mm2: 9.4 x 19.3 (PDIP|16) 83 mm2: 8.2 x 10.16 (TO-220|5)",
        "Package Group": "DDPAK/TO-263|5 PDIP|16 TO-220|5",
        "\"Approx. price\n(USD)\"": "$1.310 | 1ku",
        "Status": "ACTIVE"
    },
    "TL2575HV-15": {
        "Description": "1-A Simple Step-Down Switching Voltage Regulators",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "155 mm2: 15.24 x 10.16 (DDPAK/TO-263|5) 181 mm2: 9.4 x 19.3 (PDIP|16) 83 mm2: 8.2 x 10.16 (TO-220|5)",
        "Package Group": "DDPAK/TO-263|5 PDIP|16 TO-220|5",
        "\"Approx. price\n(USD)\"": "$1.310 | 1ku",
        "Status": "ACTIVE"
    },
    "TL2575HV-33": {
        "Description": "1-A Simple Step-Down Switching Voltage Regulators",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "155 mm2: 15.24 x 10.16 (DDPAK/TO-263|5) 181 mm2: 9.4 x 19.3 (PDIP|16) 83 mm2: 8.2 x 10.16 (TO-220|5)",
        "Package Group": "DDPAK/TO-263|5 PDIP|16 TO-220|5",
        "\"Approx. price\n(USD)\"": "$1.310 | 1ku",
        "Status": "ACTIVE"
    },
    "TL2575HV-ADJ": {
        "Description": "1-A Simple Step-Down Switching Voltage Regulators",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "155 mm2: 15.24 x 10.16 (DDPAK/TO-263|5) 181 mm2: 9.4 x 19.3 (PDIP|16) 83 mm2: 8.2 x 10.16 (TO-220|5)",
        "Package Group": "DDPAK/TO-263|5 PDIP|16 TO-220|5",
        "\"Approx. price\n(USD)\"": "$1.310 | 1ku",
        "Status": "ACTIVE"
    },
    "LM3676": {
        "Description": "2MHz 600mA Step-Down DC-DC Converter with Mode Control",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-30 to 85",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (WSON|8)",
        "Package Group": "WSON|8",
        "\"Approx. price\n(USD)\"": "$0.464 | 1ku",
        "Status": "ACTIVE"
    },
    "LM3151": {
        "Description": "42V Synchronous Step-Down Controller with 3.3V Output and Adjustable Switching Frequency",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck controllers (external switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "22 mm2: 4.4 x 5 (HTSSOP|14)",
        "Package Group": "HTSSOP|14",
        "\"Approx. price\n(USD)\"": "$1.307 | 1ku",
        "Status": "ACTIVE"
    },
    "LM3152": {
        "Description": "42V Synchronous Step-Down Controller with 3.3V Output and 500kHz Switching Frequency",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck controllers (external switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "22 mm2: 4.4 x 5 (HTSSOP|14)",
        "Package Group": "HTSSOP|14",
        "\"Approx. price\n(USD)\"": "$1.307 | 1ku",
        "Status": "ACTIVE"
    },
    "PTH08T241W": {
        "Description": "10-A 4.5V to 14V Input Ceramic Cap Version Non-Iso Wide Output Adj Power Module with TurboTrans",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck modules (integrated inductor)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "387 mm2: 16.76 x 23.11 (Surface Mount Module|11) 348 mm2: 15.75 x 22.1 (Through-Hole Module|11)",
        "Package Group": "Surface Mount Module|11 Through-Hole Module|11",
        "\"Approx. price\n(USD)\"": "$12.075 | 1ku",
        "Status": "ACTIVE"
    },
    "LM2772": {
        "Description": "Low-Ripple Switched Capacitor Step-Down Regulator",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Charge pumps (inductorless)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-30 to 85",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (WSON|10)",
        "Package Group": "WSON|10",
        "\"Approx. price\n(USD)\"": "$0.319 | 1ku",
        "Status": "ACTIVE"
    },
    "LM34914": {
        "Description": "Ultra Small 1.25A Step-Down Switching Regulator with Intelligent Current Limit",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (WSON|10)",
        "Package Group": "WSON|10",
        "\"Approx. price\n(USD)\"": "$1.307 | 1ku",
        "Status": "ACTIVE"
    },
    "LM2853": {
        "Description": "3A 550 kHz Synchronous Buck Regulator",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "22 mm2: 4.4 x 5 (HTSSOP|14)",
        "Package Group": "HTSSOP|14",
        "\"Approx. price\n(USD)\"": "$1.781 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS40101": {
        "Description": "4.5-V to 18-V synchronous buck controller with advanced sequencing and output margining",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck controllers (external switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "16 mm2: 4 x 4 (VQFN|24)",
        "Package Group": "VQFN|24",
        "\"Approx. price\n(USD)\"": "$1.597 | 1ku",
        "Status": "ACTIVE"
    },
    "PTH04T240W": {
        "Description": "10-A 2.2V to 5.5V Input Non-Isolated Wide Output Adjustable Power Module with TurboTrans",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck modules (integrated inductor)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "387 mm2: 16.76 x 23.11 (Surface Mount Module|11) 387 mm2: 16.76 x 23.11 (Through-Hole Module|11)",
        "Package Group": "Surface Mount Module|11 Through-Hole Module|11",
        "\"Approx. price\n(USD)\"": "$10.780 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS5410": {
        "Description": "5.5V to 36V Input 1A 500kHz Step Down Converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "19 mm2: 3.91 x 4.9 (SOIC|8)",
        "Package Group": "SOIC|8",
        "\"Approx. price\n(USD)\"": "$1.065 | 1ku",
        "Status": "ACTIVE"
    },
    "LM3677": {
        "Description": "3MHz 600mA Miniature Step-Down DC-DC Converter for Ultra Low Voltage Circuits",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-30 to 85",
        "Package size: mm2:W x L (PKG)": "2 mm2: 1.2 x 1.5 (DSBGA|5) 3 mm2: 1.5 x 2 (USON|6)",
        "Package Group": "DSBGA|5 USON|6",
        "\"Approx. price\n(USD)\"": "$0.535 | 1ku",
        "Status": "ACTIVE"
    },
    "TL7660": {
        "Description": "CMOS Voltage Converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Charge pumps (inductorless)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "\"-40 to 125\n-40 to 85\"",
        "Package size: mm2:W x L (PKG)": "93 mm2: 9.43 x 9.81 (PDIP|8) 19 mm2: 3.91 x 4.9 (SOIC|8) 15 mm2: 4.9 x 3 (VSSOP|8)",
        "Package Group": "PDIP|8 SOIC|8 VSSOP|8",
        "\"Approx. price\n(USD)\"": "$0.320 | 1ku",
        "Status": "ACTIVE"
    },
    "LM2830": {
        "Description": "High frequency 1 A step-down DC/DC converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "5 mm2: 1.6 x 2.9 (SOT-23|5) 9 mm2: 3 x 3 (WSON|6)",
        "Package Group": "SOT-23|5 WSON|6",
        "\"Approx. price\n(USD)\"": "$0.629 | 1ku",
        "Status": "ACTIVE"
    },
    "LM2831": {
        "Description": "High Frequency 1.5A Load - Step-Down DC-DC Regulator",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "5 mm2: 1.6 x 2.9 (SOT-23|5) 9 mm2: 3 x 3 (WSON|6)",
        "Package Group": "SOT-23|5 WSON|6",
        "\"Approx. price\n(USD)\"": "$0.732 | 1ku",
        "Status": "ACTIVE"
    },
    "LM2840": {
        "Description": "SIMPLE SWITCHER&reg; 42V 100mA Step-Down DC/DC Regulator in Thin SOT-23",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "5 mm2: 1.6 x 2.9 (SOT-23-THIN|6)",
        "Package Group": "SOT-23-THIN|6",
        "\"Approx. price\n(USD)\"": "$0.958 | 1ku",
        "Status": "ACTIVE"
    },
    "LM2840-Q1": {
        "Description": "SIMPLE SWITCHER&reg; 42V 100mA Step-Down DC/DC Regulator in Thin SOT-23",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "5 mm2: 1.6 x 2.9 (SOT-23-THIN|6)",
        "Package Group": "SOT-23-THIN|6",
        "\"Approx. price\n(USD)\"": "$1.130 | 1ku",
        "Status": "ACTIVE"
    },
    "LM2842": {
        "Description": "SIMPLE SWITCHER&reg; 4.5V to 42V 0.6A Step-Down DC/DC Switching Regulator in Thin SOT-23",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "5 mm2: 1.6 x 2.9 (SOT-23-THIN|6)",
        "Package Group": "SOT-23-THIN|6",
        "\"Approx. price\n(USD)\"": "$1.210 | 1ku",
        "Status": "ACTIVE"
    },
    "LM2842-Q1": {
        "Description": "SIMPLE SWITCHER&reg; 4.5V to 42V 0.6A Step-Down Regulator in Thin SOT-23",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "5 mm2: 1.6 x 2.9 (SOT-23-THIN|6)",
        "Package Group": "SOT-23-THIN|6",
        "\"Approx. price\n(USD)\"": "$1.428 | 1ku",
        "Status": "ACTIVE"
    },
    "TL2575-12": {
        "Description": "1-A Simple Step-Down Switching Voltage Regulators",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "155 mm2: 15.24 x 10.16 (DDPAK/TO-263|5) 181 mm2: 9.4 x 19.3 (PDIP|16) 83 mm2: 8.2 x 10.16 (TO-220|5)",
        "Package Group": "DDPAK/TO-263|5 PDIP|16 TO-220|5",
        "\"Approx. price\n(USD)\"": "$0.784 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62400": {
        "Description": "Dual Adjustable 400mA and 600mA 2.25MHz Step-Down Converter with 1-Wire Interface in QFN",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (VSON|10)",
        "Package Group": "VSON|10",
        "\"Approx. price\n(USD)\"": "$0.609 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62401": {
        "Description": "Dual 400mA and 600mA 2.25MHz Step-Down Converter with 1-Wire Interface in QFN",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (VSON|10)",
        "Package Group": "VSON|10",
        "\"Approx. price\n(USD)\"": "$0.609 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62420": {
        "Description": "Dual Adjustable 600mA and 1000mA 2.25MHz Step-Down Converter with 1-Wire Interface in QFN",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (VSON|10)",
        "Package Group": "VSON|10",
        "\"Approx. price\n(USD)\"": "$0.658 | 1ku",
        "Status": "ACTIVE"
    },
    "LM3678": {
        "Description": "High-Performance Miniature 1.5A Step-Down DC-DC Converter for Handheld Applications",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-30 to 85",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (WSON|10)",
        "Package Group": "WSON|10",
        "\"Approx. price\n(USD)\"": "$0.668 | 1ku",
        "Status": "ACTIVE"
    },
    "LM2833": {
        "Description": "1.5MHz/3MHz 3.0A  Step-Down DC-DC  Switching Regulator",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (HVSSOP|10) 9 mm2: 3 x 3 (WSON|10)",
        "Package Group": "HVSSOP|10 WSON|10",
        "\"Approx. price\n(USD)\"": "$0.941 | 1ku",
        "Status": "ACTIVE"
    },
    "TL2575-15": {
        "Description": "1-A Simple Step-Down Switching Voltage Regulators",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "155 mm2: 15.24 x 10.16 (DDPAK/TO-263|5) 181 mm2: 9.4 x 19.3 (PDIP|16) 83 mm2: 8.2 x 10.16 (TO-220|5)",
        "Package Group": "DDPAK/TO-263|5 PDIP|16 TO-220|5",
        "\"Approx. price\n(USD)\"": "$0.784 | 1ku",
        "Status": "ACTIVE"
    },
    "TL2575-ADJ": {
        "Description": "1-A Simple Step-Down Switching Voltage Regulators",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "155 mm2: 15.24 x 10.16 (DDPAK/TO-263|5) 181 mm2: 9.4 x 19.3 (PDIP|16) 83 mm2: 8.2 x 10.16 (TO-220|5)",
        "Package Group": "DDPAK/TO-263|5 PDIP|16 TO-220|5",
        "\"Approx. price\n(USD)\"": "$0.683 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62350": {
        "Description": "1A 3MHz Buck Converter with I2C for Dynamic Voltage Scaling",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "See datasheet (DSBGA)",
        "Package Group": "DSBGA|12",
        "\"Approx. price\n(USD)\"": "$0.571 | 1ku",
        "Status": "ACTIVE"
    },
    "LM1771": {
        "Description": "Low-Voltage Synchronous Buck Controller with Precision Enable and No External Compensation",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck controllers (external switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "15 mm2: 4.9 x 3 (VSSOP|8) 9 mm2: 3 x 3 (WSON|6)",
        "Package Group": "VSSOP|8 WSON|6",
        "\"Approx. price\n(USD)\"": "$0.726 | 1ku",
        "Status": "ACTIVE"
    },
    "PTH08T230W": {
        "Description": "6-A 4.5V to 14V Input Non-Isolated Wide Output Adjustable Power Module with TurboTrans",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck modules (integrated inductor)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "334 mm2: 16.76 x 19.94 (Surface Mount Module|10) 334 mm2: 16.76 x 19.94 (Through-Hole Module|10)",
        "Package Group": "Surface Mount Module|10 Through-Hole Module|10",
        "\"Approx. price\n(USD)\"": "$9.637 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS40075": {
        "Description": "4.5-V to 28-V synchronous buck controller with voltage feed forward",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck controllers (external switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "16 mm2: 3.5 x 4.5 (VQFN|20)",
        "Package Group": "VQFN|20",
        "\"Approx. price\n(USD)\"": "$1.307 | 1ku",
        "Status": "ACTIVE"
    },
    "LM2832": {
        "Description": "High Frequency 2.0A Load - Step-Down DC-DC Regulator",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (HVSSOP|8) 9 mm2: 3 x 3 (WSON|6)",
        "Package Group": "HVSSOP|8 WSON|6",
        "\"Approx. price\n(USD)\"": "$0.726 | 1ku",
        "Status": "ACTIVE"
    },
    "LM26001": {
        "Description": "1.5A Switching Regulator with High Efficiency Sleep Mode",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "32 mm2: 6.4 x 5 (HTSSOP|16)",
        "Package Group": "HTSSOP|16",
        "\"Approx. price\n(USD)\"": "$1.210 | 1ku",
        "Status": "ACTIVE"
    },
    "LM3489": {
        "Description": "Hysteretic PFET Buck Controller with Enable Pin",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck controllers (external switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "15 mm2: 4.9 x 3 (VSSOP|8)",
        "Package Group": "VSSOP|8",
        "\"Approx. price\n(USD)\"": "$0.523 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62510": {
        "Description": "Adjustable 96% Efficiency 1.5A Buck Converter for low input voltages",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (VSON|10)",
        "Package Group": "VSON|10",
        "\"Approx. price\n(USD)\"": "$0.668 | 1ku",
        "Status": "ACTIVE"
    },
    "LM2694": {
        "Description": "30V 600 mA Step Down Switching Regulator",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "32 mm2: 6.4 x 5 (TSSOP|14) 9 mm2: 3 x 3 (WSON|10)",
        "Package Group": "TSSOP|14 WSON|10",
        "\"Approx. price\n(USD)\"": "$0.968 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS40056": {
        "Description": "Wide Vin (10V-40V) Synchronous Buck DC/DC Controller with Tracking",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck controllers (external switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "32 mm2: 6.4 x 5 (HTSSOP|16)",
        "Package Group": "HTSSOP|16",
        "\"Approx. price\n(USD)\"": "$1.559 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS5420": {
        "Description": "5.5V to 36V Input 2A 500kHz Step-Down Converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "19 mm2: 3.91 x 4.9 (SOIC|8)",
        "Package Group": "SOIC|8",
        "\"Approx. price\n(USD)\"": "$1.307 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS5431": {
        "Description": "5.5V to 23V Input 3A 500kHz Step-Down Converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "19 mm2: 3.9 x 4.89 (SO PowerPAD|8)",
        "Package Group": "SO PowerPAD|8",
        "\"Approx. price\n(USD)\"": "$1.549 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS63000": {
        "Description": "High efficiency Buck-Boost Converter with 1.8A Current Switches in 3x3 QFN",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck-boost inverting & split-rail converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (VSON|10)",
        "Package Group": "VSON|10",
        "\"Approx. price\n(USD)\"": "$0.856 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS63001": {
        "Description": "96% Buck-Boost Converter with 1.7A Current Switches 3.3V fixed Output voltage in 3x3 QFN",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck-boost inverting & split-rail converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (VSON|10)",
        "Package Group": "VSON|10",
        "\"Approx. price\n(USD)\"": "$0.856 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS63002": {
        "Description": "96% Buck-Boost Converter with 1.7A Current Switches 5V fixed Output voltage in 3x3 QFN",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck-boost inverting & split-rail converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (VSON|10)",
        "Package Group": "VSON|10",
        "\"Approx. price\n(USD)\"": "$0.856 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS40040": {
        "Description": "2.25 to 5.5 V input 300 kHz synchronous buck controller with low pin count",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck controllers (external switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (SON|8)",
        "Package Group": "SON|8",
        "\"Approx. price\n(USD)\"": "$0.561 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS40041": {
        "Description": "2.25 to 5.5 V input 600 kHz synchronous buck controller with low pin count",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck controllers (external switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (SON|8)",
        "Package Group": "SON|8",
        "\"Approx. price\n(USD)\"": "$0.561 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62227": {
        "Description": "1.2-V Output 400-mA 95% Efficient Step-Down Converter 15uA ThinSOT-23",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "8 mm2: 2.8 x 2.9 (SOT-23-THIN|5)",
        "Package Group": "SOT-23-THIN|5",
        "\"Approx. price\n(USD)\"": "$0.436 | 1ku",
        "Status": "ACTIVE"
    },
    "LM2771": {
        "Description": "Low-Ripple 250mA Switched Capacitor Step-Down DC/DC Converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Charge pumps (inductorless)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-30 to 110",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (WSON|10)",
        "Package Group": "WSON|10",
        "\"Approx. price\n(USD)\"": "$0.341 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS61026": {
        "Description": "5.0-V Output 1.8-A Switch 96% Efficient Boost Converter w/ LDO Down-Mode QFN-10",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (VSON|10)",
        "Package Group": "VSON|10",
        "\"Approx. price\n(USD)\"": "$0.823 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS61029": {
        "Description": "Adjustable 1.8-A Switch 96% Efficient Boost Converter with Down-Mode QFN-10",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (VSON|10)",
        "Package Group": "VSON|10",
        "\"Approx. price\n(USD)\"": "$0.823 | 1ku",
        "Status": "ACTIVE"
    },
    "LM5009": {
        "Description": "9.5-95V Wide Vin 150mA Constant On-Time Non-Synchronous Buck Regulator",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "15 mm2: 4.9 x 3 (VSSOP|8) 16 mm2: 4 x 4 (WSON|8)",
        "Package Group": "VSSOP|8 WSON|8",
        "\"Approx. price\n(USD)\"": "$1.065 | 1ku",
        "Status": "ACTIVE"
    },
    "LM27341": {
        "Description": "1.5A - Wide Input Range Buck Regulator with Frequency Synchronization",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (HVSSOP|10) 9 mm2: 3 x 3 (WSON|10)",
        "Package Group": "HVSSOP|10 WSON|10",
        "\"Approx. price\n(USD)\"": "$1.065 | 1ku",
        "Status": "ACTIVE"
    },
    "LM27341-Q1": {
        "Description": "1.5A - Wide Input Range Buck Regulator with Frequency Synchronization",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (HVSSOP|10)",
        "Package Group": "HVSSOP|10",
        "\"Approx. price\n(USD)\"": "$1.257 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS40200": {
        "Description": "Wide Input Non-Synchronous Buck DC/DC Controller",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck controllers (external switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "19 mm2: 3.91 x 4.9 (SOIC|8) 9 mm2: 3 x 3 (SON|8)",
        "Package Group": "SOIC|8 SON|8",
        "\"Approx. price\n(USD)\"": "$0.712 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS5430": {
        "Description": "5.5V to 36V Input 3A 500kHz Step-Down Converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "19 mm2: 3.9 x 4.89 (SO PowerPAD|8)",
        "Package Group": "SO PowerPAD|8",
        "\"Approx. price\n(USD)\"": "$1.597 | 1ku",
        "Status": "ACTIVE"
    },
    "TL2575-05": {
        "Description": "1-A Simple Step-Down Switching Voltage Regulators",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "155 mm2: 15.24 x 10.16 (DDPAK/TO-263|5) 181 mm2: 9.4 x 19.3 (PDIP|16) 83 mm2: 8.2 x 10.16 (TO-220|5)",
        "Package Group": "DDPAK/TO-263|5 PDIP|16 TO-220|5",
        "\"Approx. price\n(USD)\"": "$0.784 | 1ku",
        "Status": "ACTIVE"
    },
    "TL2575-33": {
        "Description": "1-A Simple Step-Down Switching Voltage Regulators",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "155 mm2: 15.24 x 10.16 (DDPAK/TO-263|5) 181 mm2: 9.4 x 19.3 (PDIP|16) 83 mm2: 8.2 x 10.16 (TO-220|5)",
        "Package Group": "DDPAK/TO-263|5 PDIP|16 TO-220|5",
        "\"Approx. price\n(USD)\"": "$0.784 | 1ku",
        "Status": "ACTIVE"
    },
    "LM3100": {
        "Description": "Synchronous 1MHz 1.5A Step-Down Voltage Regulator",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "42 mm2: 6.4 x 6.5 (HTSSOP|20)",
        "Package Group": "HTSSOP|20",
        "\"Approx. price\n(USD)\"": "$1.791 | 1ku",
        "Status": "ACTIVE"
    },
    "LM25007": {
        "Description": "9-42V Wide Vin 0.5A Constant On-Time Non-Synchronous Buck Regulator",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "15 mm2: 4.9 x 3 (VSSOP|8) 16 mm2: 4 x 4 (WSON|8)",
        "Package Group": "VSSOP|8 WSON|8",
        "\"Approx. price\n(USD)\"": "$1.016 | 1ku",
        "Status": "ACTIVE"
    },
    "LM25005": {
        "Description": "7-42V Wide Vin 2.5A Current Mode Non-Synchronous Buck Regulator",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "42 mm2: 6.4 x 6.5 (HTSSOP|20)",
        "Package Group": "HTSSOP|20",
        "\"Approx. price\n(USD)\"": "$1.355 | 1ku",
        "Status": "ACTIVE"
    },
    "LM2717-ADJ": {
        "Description": "Dual step-down DC/DC converter with adjustable output",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "34 mm2: 4.4 x 7.8 (TSSOP|24)",
        "Package Group": "TSSOP|24",
        "\"Approx. price\n(USD)\"": "$2.565 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS54317": {
        "Description": "3V to 6V Input 3A Synchronous Step-Down SWIFT&trade; Converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "20 mm2: 4 x 5 (VQFN|24)",
        "Package Group": "VQFN|24",
        "\"Approx. price\n(USD)\"": "$1.951 | 1ku",
        "Status": "ACTIVE"
    },
    "LM3674": {
        "Description": "2MHz 600mA Step-Down DC-DC Converter in SOT 23-5",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-30 to 85",
        "Package size: mm2:W x L (PKG)": "5 mm2: 1.6 x 2.9 (SOT-23|5)",
        "Package Group": "SOT-23|5",
        "\"Approx. price\n(USD)\"": "$0.464 | 1ku",
        "Status": "ACTIVE"
    },
    "PTH05T210W": {
        "Description": "30-A 4.5V to 5.5V Input Non-Isolated Wide Output Adjustable Power Module with TurboTrans",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck modules (integrated inductor)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "600 mm2: 16.76 x 35.81 (Surface Mount Module|14) 600 mm2: 16.76 x 35.81 (Through-Hole Module|14)",
        "Package Group": "Surface Mount Module|14 Through-Hole Module|14",
        "\"Approx. price\n(USD)\"": "$24.970 | 1ku",
        "Status": "ACTIVE"
    },
    "PTH08T240W": {
        "Description": "10-A 4.5V to 14V Input Non-Isolated Wide Output Adjustable Power Module with TurboTrans",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck modules (integrated inductor)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "387 mm2: 16.76 x 23.11 (Surface Mount Module|11) 348 mm2: 15.75 x 22.1 (Through-Hole Module|11)",
        "Package Group": "Surface Mount Module|11 Through-Hole Module|11",
        "\"Approx. price\n(USD)\"": "$13.285 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS51117": {
        "Description": "1.8-V to 28-V synchronous D-CAP buck contoller with light load efficiency",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck controllers (external switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "32 mm2: 6.4 x 5 (TSSOP|14) 12 mm2: 3.5 x 3.5 (VQFN|14)",
        "Package Group": "TSSOP|14 VQFN|14",
        "\"Approx. price\n(USD)\"": "$0.569 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS51124": {
        "Description": "4.5-V to 28-V dual-synchronous buck controller for low output voltage rails",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck controllers (external switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "16 mm2: 4 x 4 (VQFN|24)",
        "Package Group": "VQFN|24",
        "\"Approx. price\n(USD)\"": "$1.881 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62304": {
        "Description": "1.2V 500-mA 3-MHz Step-Down Converter in QFN or Chip-Scale",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (VSON|10)",
        "Package Group": "VSON|10",
        "\"Approx. price\n(USD)\"": "$0.591 | 1ku",
        "Status": "ACTIVE"
    },
    "LM25010": {
        "Description": "6-42V Wide Vin 1A Constant On-Time Non-Synchronous Buck Regulator",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "22 mm2: 4.4 x 5 (HTSSOP|14) 16 mm2: 4 x 4 (WSON|10)",
        "Package Group": "HTSSOP|14 WSON|10",
        "\"Approx. price\n(USD)\"": "$0.920 | 1ku",
        "Status": "ACTIVE"
    },
    "TL1451A-EP": {
        "Description": "Enhanced Product Dual Pulse-Width-Modulation Control Circuits",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost controllers (external switch)",
        "Rating": "HiRel Enhanced Product",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-55 to 125",
        "Package size: mm2:W x L (PKG)": "59 mm2: 6 x 9.9 (SOIC|16)",
        "Package Group": "SOIC|16",
        "\"Approx. price\n(USD)\"": "$1.994 | 1ku",
        "Status": "ACTIVE"
    },
    "LM5116": {
        "Description": "6-100V Wide Vin Current Mode Synchronous Buck Controller",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck controllers (external switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 150",
        "Package size: mm2:W x L (PKG)": "42 mm2: 6.4 x 6.5 (HTSSOP|20)",
        "Package Group": "HTSSOP|20",
        "\"Approx. price\n(USD)\"": "$2.343 | 1ku",
        "Status": "ACTIVE"
    },
    "LM5642X": {
        "Description": "High Voltage Dual Synchronous Buck Converter with Oscillator Synchronization",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck controllers (external switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "43 mm2: 4.4 x 9.7 (HTSSOP|28) 62 mm2: 6.4 x 9.7 (TSSOP|28)",
        "Package Group": "HTSSOP|28 TSSOP|28",
        "\"Approx. price\n(USD)\"": "$1.694 | 1ku",
        "Status": "ACTIVE"
    },
    "LM25115": {
        "Description": "42V Secondary Side Post Regulator/Synchronous Buck Controller",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck controllers (external switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "22 mm2: 4.4 x 5 (TSSOP|16) 25 mm2: 5 x 5 (WSON|16)",
        "Package Group": "TSSOP|16 WSON|16",
        "\"Approx. price\n(USD)\"": "$0.825 | 1ku",
        "Status": "ACTIVE"
    },
    "PTH08T210W": {
        "Description": "30-A 5.5-V to 14-V Input Non-Isolated Wide Output Adjust Power Module w/ TurboTrans",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck modules (integrated inductor)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "600 mm2: 16.76 x 35.81 (Surface Mount Module|14) 600 mm2: 16.76 x 35.81 (Through-Hole Module|14)",
        "Package Group": "Surface Mount Module|14 Through-Hole Module|14",
        "\"Approx. price\n(USD)\"": "$22.138 | 1ku",
        "Status": "ACTIVE"
    },
    "PTV08T250W": {
        "Description": "50-A 8-V to 14-V Input Non-Isolated Wide Output Adjust Vertical Power Module w/ TurboTrans Techn",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck modules (integrated inductor)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "555 mm2: 9.39 x 59.13 (SIP MODULE|21)",
        "Package Group": "SIP MODULE|21",
        "\"Approx. price\n(USD)\"": "$50.312 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS40222": {
        "Description": "1.6A 1.25-MHz Buck Converter in a 3 mm SON Package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (VSON|6)",
        "Package Group": "VSON|6",
        "\"Approx. price\n(USD)\"": "$0.780 | 1ku",
        "Status": "ACTIVE"
    },
    "LM5010A": {
        "Description": "6-75V Wide Vin 1A Constant On-Time Non-Synchronous Buck Regulator",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 150",
        "Package size: mm2:W x L (PKG)": "22 mm2: 4.4 x 5 (HTSSOP|14) 16 mm2: 4 x 4 (WSON|10)",
        "Package Group": "HTSSOP|14 WSON|10",
        "\"Approx. price\n(USD)\"": "$1.423 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS54350-EP": {
        "Description": "Enhanced Product 4.5-V To 20-V Input 3-A Output Synchronous Pwm Switcher W/Integrated Fet",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "HiRel Enhanced Product",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-55 to 125",
        "Package size: mm2:W x L (PKG)": "32 mm2: 6.4 x 5 (HTSSOP|16)",
        "Package Group": "HTSSOP|16",
        "\"Approx. price\n(USD)\"": "$3.392 | 1ku",
        "Status": "ACTIVE"
    },
    "LM2696": {
        "Description": "3A Constant On Time Buck Regulator",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "32 mm2: 6.4 x 5 (HTSSOP|16)",
        "Package Group": "HTSSOP|16",
        "\"Approx. price\n(USD)\"": "$1.646 | 1ku",
        "Status": "ACTIVE"
    },
    "PTV08040W": {
        "Description": "50-A 8-V to 14-V Input Non-Isolated Wide-Output Adjust Vertical Power Module",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck modules (integrated inductor)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "555 mm2: 9.39 x 59.13 (SIP MODULE|21)",
        "Package Group": "SIP MODULE|21",
        "\"Approx. price\n(USD)\"": "$48.920 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS63700": {
        "Description": "Adjustable -15V Output Inverting DC/DC Converter in 3x3 QFN",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck-boost inverting & split-rail converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (VSON|10)",
        "Package Group": "VSON|10",
        "\"Approx. price\n(USD)\"": "$0.796 | 1ku",
        "Status": "ACTIVE"
    },
    "PTN04050C": {
        "Description": "12-W 3.3/5-V Input Wide Adjust Output Boost Converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost modules (integrated inductor)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "314 mm2: 13.59 x 23.12 (Surface Mount Module|4) 314 mm2: 13.59 x 23.12 (Through-Hole Module|4)",
        "Package Group": "Surface Mount Module|4 Through-Hole Module|4",
        "\"Approx. price\n(USD)\"": "$11.000 | 1ku",
        "Status": "ACTIVE"
    },
    "LM5005": {
        "Description": "7-75V Wide Vin 2.5A Current Mode Non-Synchronous Buck Regulator",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "42 mm2: 6.4 x 6.5 (HTSSOP|20)",
        "Package Group": "HTSSOP|20",
        "\"Approx. price\n(USD)\"": "$1.694 | 1ku",
        "Status": "ACTIVE"
    },
    "TL5001A-Q1": {
        "Description": "PWM Controller with wide input range with ±3% tolerance on reference operation –20°C to 85°C",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost controllers (external switch)",
        "Rating": "Automotive",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "19 mm2: 3.91 x 4.9 (SOIC|8)",
        "Package Group": "SOIC|8",
        "\"Approx. price\n(USD)\"": "$0.980 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS54610-EP": {
        "Description": "Enhanced Product 3-V To 6-V Input 6-A Output Synchronous Buck Pwm Switcher W/ Integr. Fets",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "HiRel Enhanced Product",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-55 to 125",
        "Package size: mm2:W x L (PKG)": "43 mm2: 4.4 x 9.7 (HTSSOP|28)",
        "Package Group": "HTSSOP|28",
        "\"Approx. price\n(USD)\"": "$6.776 | 1ku",
        "Status": "ACTIVE"
    },
    "LM20242": {
        "Description": "4.5-36V 2A Current Mode Synchronous Buck Regulator with Adjustable Frequency",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "42 mm2: 6.4 x 6.5 (HTSSOP|20)",
        "Package Group": "HTSSOP|20",
        "\"Approx. price\n(USD)\"": "$1.452 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS54615-EP": {
        "Description": "Enhanced Product 3-V To 6-V Input 6-A Output Synchronous Buck Pwm Switcher W/Integr. Fets",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "HiRel Enhanced Product",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-55 to 125",
        "Package size: mm2:W x L (PKG)": "43 mm2: 4.4 x 9.7 (HTSSOP|28)",
        "Package Group": "HTSSOP|28",
        "\"Approx. price\n(USD)\"": "$6.776 | 1ku",
        "Status": "ACTIVE"
    },
    "LM3743": {
        "Description": "High-Performance Synchronous Buck Controller with Comprehensive Fault Protection Features",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck controllers (external switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (VSSOP|10)",
        "Package Group": "VSSOP|10",
        "\"Approx. price\n(USD)\"": "$0.748 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS51120": {
        "Description": "4.5-V to 28-V dual-channel synchronous buck controller with low standby current consumption",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck controllers (external switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "25 mm2: 5 x 5 (VQFN|32)",
        "Package Group": "VQFN|32",
        "\"Approx. price\n(USD)\"": "$1.413 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS40190": {
        "Description": "4.5-V to 15-V 20-A synchronous buck controller",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck controllers (external switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (VSON|10)",
        "Package Group": "VSON|10",
        "\"Approx. price\n(USD)\"": "$0.871 | 1ku",
        "Status": "ACTIVE"
    },
    "LM3310": {
        "Description": "Step-Up PWM DC/DC Converter with Integrated Op-Amp and Gate Pulse Modulation Switch",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "16 mm2: 4 x 4 (WQFN|24)",
        "Package Group": "WQFN|24",
        "\"Approx. price\n(USD)\"": "$1.800 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62111": {
        "Description": "3.3-V 1.5-A 17-V Vin Step-Down Converter in QFN-16",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "16 mm2: 4 x 4 (QFN|16)",
        "Package Group": "QFN|16",
        "\"Approx. price\n(USD)\"": "$0.869 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62112": {
        "Description": "5-V 1.5-A 17-V Vin Step-Down Converter in QFN-16",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "16 mm2: 4 x 4 (QFN|16)",
        "Package Group": "QFN|16",
        "\"Approx. price\n(USD)\"": "$0.869 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS40055-EP": {
        "Description": "Enhanced Product Wide Input Synchronous Buck Controller",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck controllers (external switch)",
        "Rating": "HiRel Enhanced Product",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-55 to 125",
        "Package size: mm2:W x L (PKG)": "32 mm2: 6.4 x 5 (HTSSOP|16)",
        "Package Group": "HTSSOP|16",
        "\"Approx. price\n(USD)\"": "$4.158 | 1ku",
        "Status": "ACTIVE"
    },
    "MC33063A-Q1": {
        "Description": "1.5-A peak boost/buck/inverting switching regulator AEC-Q100 qualified",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "19 mm2: 3.91 x 4.9 (SOIC|8)",
        "Package Group": "SOIC|8",
        "\"Approx. price\n(USD)\"": "$0.536 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62110": {
        "Description": "Adjustable 1.5-A 17-V Vin Step-Down Converter in QFN-16",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "16 mm2: 4 x 4 (QFN|16)",
        "Package Group": "QFN|16",
        "\"Approx. price\n(USD)\"": "$0.869 | 1ku",
        "Status": "ACTIVE"
    },
    "LM3000": {
        "Description": "3.3-V to 18.5-V dual-ouptut current mode synchronous buck controller",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck controllers (external switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "25 mm2: 5 x 5 (WQFN|32)",
        "Package Group": "WQFN|32",
        "\"Approx. price\n(USD)\"": "$2.662 | 1ku",
        "Status": "ACTIVE"
    },
    "TL1451A-Q1": {
        "Description": "3.6-V to 50-V dual-channel PWM controller AEC-Q100 qualified",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost controllers (external switch)",
        "Rating": "Automotive",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "22 mm2: 4.4 x 5 (TSSOP|16)",
        "Package Group": "TSSOP|16",
        "\"Approx. price\n(USD)\"": "$0.750 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS61028": {
        "Description": "Adjustable 800mA Switch 96% Efficient Boost Converter w/LDO Down-Mode QFN-10",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (VSON|10)",
        "Package Group": "VSON|10",
        "\"Approx. price\n(USD)\"": "$0.726 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS40100": {
        "Description": "4.5-V to 18-V synchronous buck controller with advanced sequencing and output margining",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck controllers (external switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "16 mm2: 4 x 4 (VQFN|24)",
        "Package Group": "VQFN|24",
        "\"Approx. price\n(USD)\"": "$1.549 | 1ku",
        "Status": "ACTIVE"
    },
    "LM3481": {
        "Description": "2.97V to 48V High-Efficiency Controller for Boost SEPIC and Flyback",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost controllers (external switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (VSSOP|10)",
        "Package Group": "VSSOP|10",
        "\"Approx. price\n(USD)\"": "$0.902 | 1ku",
        "Status": "ACTIVE"
    },
    "LM3481-Q1": {
        "Description": "2.97-V to 48-V high-efficiency controller for boost SEPIC and flyback AEC-Q100 qualified",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost controllers (external switch)",
        "Rating": "Automotive",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (VSSOP|10)",
        "Package Group": "VSSOP|10",
        "\"Approx. price\n(USD)\"": "$0.710 | 1ku",
        "Status": "ACTIVE"
    },
    "LM2717": {
        "Description": "Dual step-down DC/DC converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "34 mm2: 4.4 x 7.8 (TSSOP|24)",
        "Package Group": "TSSOP|24",
        "\"Approx. price\n(USD)\"": "$2.565 | 1ku",
        "Status": "ACTIVE"
    },
    "PTN78000H": {
        "Description": "1.5 A Wide Input Wide Output Adjust Module",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck modules (integrated inductor)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "271 mm2: 13.59 x 19.94 (Surface Mount Module|5) 271 mm2: 13.59 x 19.94 (Through-Hole Module|5)",
        "Package Group": "Surface Mount Module|5 Through-Hole Module|5",
        "\"Approx. price\n(USD)\"": "$8.390 | 1ku",
        "Status": "ACTIVE"
    },
    "PTN78020A": {
        "Description": "4 A Wide Input Non-Isolated Wide Negative Output Adjust Module",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck-boost & inverting modules (integrated inductor)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "901 mm2: 23.11 x 38.99 (Surface Mount Module|7) 901 mm2: 23.11 x 38.99 (Through-Hole Module|7)",
        "Package Group": "Surface Mount Module|7 Through-Hole Module|7",
        "\"Approx. price\n(USD)\"": "$18.112 | 1ku",
        "Status": "ACTIVE"
    },
    "LM2745": {
        "Description": "1-V to 14-V voltage mode synchronous buck controller with pre-bias startup and optional clock sync",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck controllers (external switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "32 mm2: 6.4 x 5 (TSSOP|14)",
        "Package Group": "TSSOP|14",
        "\"Approx. price\n(USD)\"": "$0.823 | 1ku",
        "Status": "ACTIVE"
    },
    "PTN78000A": {
        "Description": "1.5 A Wide Input Non-Isolated Wide Negative Output Adjust Module",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck-boost & inverting modules (integrated inductor)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "271 mm2: 13.59 x 19.94 (Surface Mount Module|5) 271 mm2: 13.59 x 19.94 (Through-Hole Module|5)",
        "Package Group": "Surface Mount Module|5 Through-Hole Module|5",
        "\"Approx. price\n(USD)\"": "$10.177 | 1ku",
        "Status": "ACTIVE"
    },
    "PTN78060A": {
        "Description": "3 A Wide Input Non-Isolated Wide Negative Output Adjust Module",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck-boost & inverting modules (integrated inductor)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "441 mm2: 16.76 x 26.29 (Surface Mount Module|7) 441 mm2: 16.76 x 26.29 (Through-Hole Module|7)",
        "Package Group": "Surface Mount Module|7 Through-Hole Module|7",
        "\"Approx. price\n(USD)\"": "$16.913 | 1ku",
        "Status": "ACTIVE"
    },
    "PTH04040W": {
        "Description": "60 A 3.3/5-V Input Non-Isolated Wide-Output Adjust Power Module",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck modules (integrated inductor)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "1460 mm2: 27.56 x 52.96 (Surface Mount Module|20) 1460 mm2: 27.56 x 52.96 (Through-Hole Module|20)",
        "Package Group": "Surface Mount Module|20 Through-Hole Module|20",
        "\"Approx. price\n(USD)\"": "$38.500 | 1ku",
        "Status": "ACTIVE"
    },
    "LM5115A": {
        "Description": "75V Secondary Side Post Regulator/ Synchronous Buck Controller with Power-Up/Power-Down Tracking",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck controllers (external switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "22 mm2: 4.4 x 5 (TSSOP|16)",
        "Package Group": "TSSOP|16",
        "\"Approx. price\n(USD)\"": "$1.650 | 1ku",
        "Status": "ACTIVE"
    },
    "LM3673": {
        "Description": "2MHz 350mA Step-Down DC-DC Converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-30 to 85",
        "Package size: mm2:W x L (PKG)": "2 mm2: 1.2 x 1.5 (DSBGA|5)",
        "Package Group": "DSBGA|5",
        "\"Approx. price\n(USD)\"": "$0.397 | 1ku",
        "Status": "ACTIVE"
    },
    "LM3370": {
        "Description": "Dual Synchronous Step-Down DC-DC Converter with Dynamic Voltage Scaling Function",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-30 to 85",
        "Package size: mm2:W x L (PKG)": "6 mm2: 2.3 x 2.5 (DSBGA|20) 20 mm2: 4 x 5 (WSON|16)",
        "Package Group": "DSBGA|20 WSON|16",
        "\"Approx. price\n(USD)\"": "$0.581 | 1ku",
        "Status": "ACTIVE"
    },
    "PTV03010W": {
        "Description": "8 A 3.3-V Input Non-Isolated Wide-Output Adjust w/Auto-Track",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck modules (integrated inductor)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "186 mm2: 8.13 x 22.86 (SIP MODULE|8)",
        "Package Group": "SIP MODULE|8",
        "\"Approx. price\n(USD)\"": "$9.790 | 1ku",
        "Status": "ACTIVE"
    },
    "PTV03020W": {
        "Description": "18 A 3.3-V Input Non-Isolated Wide-Output Adjust SIP Module w/ AutoTrack",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck modules (integrated inductor)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "384 mm2: 8.64 x 44.45 (SIP MODULE|12)",
        "Package Group": "SIP MODULE|12",
        "\"Approx. price\n(USD)\"": "$14.245 | 1ku",
        "Status": "ACTIVE"
    },
    "PTV05010W": {
        "Description": "8 A 5-V Input Non-Isolated Wide-Output Adjust SIP Module w/Auto-Track",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck modules (integrated inductor)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "186 mm2: 8.13 x 22.86 (SIP MODULE|8)",
        "Package Group": "SIP MODULE|8",
        "\"Approx. price\n(USD)\"": "$9.790 | 1ku",
        "Status": "ACTIVE"
    },
    "PTH08080W": {
        "Description": "2.25 A 4.5-V to 18-V Input Wide Adjust Miniature Power Module",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck modules (integrated inductor)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "223 mm2: 13.72 x 16.25 (Surface Mount Module|5) 223 mm2: 13.72 x 16.25 (Through-Hole Module|5)",
        "Package Group": "Surface Mount Module|5 Through-Hole Module|5",
        "\"Approx. price\n(USD)\"": "$4.787 | 1ku",
        "Status": "ACTIVE"
    },
    "PTV05020W": {
        "Description": "18-A 5-V Input Non-Isolated Wide-Adjust SIP Module",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck modules (integrated inductor)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "384 mm2: 8.64 x 44.45 (SIP MODULE|12)",
        "Package Group": "SIP MODULE|12",
        "\"Approx. price\n(USD)\"": "$14.245 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS54073": {
        "Description": "3V to 4V Input 14A Synchronous Step-Down Converter for Pre-biased Outputs",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "43 mm2: 4.4 x 9.7 (HTSSOP|28)",
        "Package Group": "HTSSOP|28",
        "\"Approx. price\n(USD)\"": "$3.564 | 1ku",
        "Status": "ACTIVE"
    },
    "MC33063A": {
        "Description": "1.5-A boost buck inverting switching regulator operation from -40°C to 85°C",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "93 mm2: 9.43 x 9.81 (PDIP|8) 19 mm2: 3.91 x 4.9 (SOIC|8) 16 mm2: 4 x 4 (SON|8)",
        "Package Group": "PDIP|8 SOIC|8 SON|8",
        "\"Approx. price\n(USD)\"": "$0.180 | 1ku",
        "Status": "ACTIVE"
    },
    "MC34063A": {
        "Description": "1.5-A boost buck inverting switching regulator operation from 0°C to 70°C",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "0 to 70",
        "Package size: mm2:W x L (PKG)": "93 mm2: 9.43 x 9.81 (PDIP|8) 19 mm2: 3.91 x 4.9 (SOIC|8) 16 mm2: 4 x 4 (SON|8)",
        "Package Group": "PDIP|8 SOIC|8 SON|8",
        "\"Approx. price\n(USD)\"": "$0.185 | 1ku",
        "Status": "ACTIVE"
    },
    "LM2852": {
        "Description": "2A 500/1500kHz Synchronous Buck Regulator",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "22 mm2: 4.4 x 5 (HTSSOP|14)",
        "Package Group": "HTSSOP|14",
        "\"Approx. price\n(USD)\"": "$1.526 | 1ku",
        "Status": "ACTIVE"
    },
    "LM2734Z": {
        "Description": "3 to 20 V input 1 A high frequency step-down converter with light load efficiency",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "5 mm2: 1.6 x 2.9 (SOT-23-THIN|6) 9 mm2: 3 x 3 (WSON|6)",
        "Package Group": "SOT-23-THIN|6 WSON|6",
        "\"Approx. price\n(USD)\"": "$1.307 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS61040-Q1": {
        "Description": "1.8-V to 6-V input range 400-mA boost converter AEC-Q100 qualified",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "5 mm2: 1.6 x 2.9 (SOT-23|5)",
        "Package Group": "SOT-23|5",
        "\"Approx. price\n(USD)\"": "$0.571 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS61041-Q1": {
        "Description": "1.8-V to 6-V input range 250-mA boost converter AEC-Q100 qualified",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "5 mm2: 1.6 x 2.9 (SOT-23|5)",
        "Package Group": "SOT-23|5",
        "\"Approx. price\n(USD)\"": "$0.571 | 1ku",
        "Status": "ACTIVE"
    },
    "PTV12010L": {
        "Description": "0.8 to 1.8-V 8-A 12-V Input Non-Isolated Wide-Adjust SIP Module",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck modules (integrated inductor)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "186 mm2: 8.13 x 22.86 (SIP MODULE|8)",
        "Package Group": "SIP MODULE|8",
        "\"Approx. price\n(USD)\"": "$10.612 | 1ku",
        "Status": "ACTIVE"
    },
    "PTV12010W": {
        "Description": "1.2 to 5.5-V 8-A 12-V Input Non-Isolated Wide-Adjust SIP Module",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck modules (integrated inductor)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "186 mm2: 8.13 x 22.86 (SIP MODULE|8)",
        "Package Group": "SIP MODULE|8",
        "\"Approx. price\n(USD)\"": "$10.612 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62026": {
        "Description": "3.3-V Output 600-mA 95% Efficient Step-Down Converter 18uA MSOP/QFN-10",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (HVSSOP|10) 9 mm2: 3 x 3 (VSON|10)",
        "Package Group": "HVSSOP|10 VSON|10",
        "\"Approx. price\n(USD)\"": "$0.629 | 1ku",
        "Status": "ACTIVE"
    },
    "PTN78020W": {
        "Description": "6-A Wide-Input Voltage Adjustable Switching Regulator",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck modules (integrated inductor)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "901 mm2: 23.11 x 38.99 (Surface Mount Module|7) 901 mm2: 23.11 x 38.99 (Through-Hole Module|7)",
        "Package Group": "Surface Mount Module|7 Through-Hole Module|7",
        "\"Approx. price\n(USD)\"": "$15.653 | 1ku",
        "Status": "ACTIVE"
    },
    "PTH12040W": {
        "Description": "50-A 8 to 14-V Input Wide-Output Adjust Power Module",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck modules (integrated inductor)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "1460 mm2: 27.56 x 52.96 (Surface Mount Module|20) 1460 mm2: 27.56 x 52.96 (Through-Hole Module|20)",
        "Package Group": "Surface Mount Module|20 Through-Hole Module|20",
        "\"Approx. price\n(USD)\"": "$46.629 | 1ku",
        "Status": "ACTIVE"
    },
    "PTN78060W": {
        "Description": "3-A Wide-Input Adjustable Switching Regulator Module",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck modules (integrated inductor)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "441 mm2: 16.76 x 26.29 (Surface Mount Module|7) 441 mm2: 16.76 x 26.29 (Through-Hole Module|7)",
        "Package Group": "Surface Mount Module|7 Through-Hole Module|7",
        "\"Approx. price\n(USD)\"": "$12.299 | 1ku",
        "Status": "ACTIVE"
    },
    "LM3224": {
        "Description": "615kHz/1.25MHz Step-up PWM DC/DC Converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "15 mm2: 4.9 x 3 (VSSOP|8)",
        "Package Group": "VSSOP|8",
        "\"Approx. price\n(USD)\"": "$1.118 | 1ku",
        "Status": "ACTIVE"
    },
    "LM3671": {
        "Description": "2MHz 600mA Step-Down DC-DC Converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "2 mm2: 1.2 x 1.5 (DSBGA|5) 5 mm2: 1.6 x 2.9 (SOT-23|5) 4 mm2: 2 x 2 (USON|6)",
        "Package Group": "DSBGA|5 SOT-23|5 USON|6",
        "\"Approx. price\n(USD)\"": "$0.464 | 1ku",
        "Status": "ACTIVE"
    },
    "LM5010": {
        "Description": "8-75V Wide Vin 1A Constant On-Time Non-Synchronous Buck Regulator",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "22 mm2: 4.4 x 5 (HTSSOP|14) 16 mm2: 4 x 4 (WSON|10)",
        "Package Group": "HTSSOP|14 WSON|10",
        "\"Approx. price\n(USD)\"": "$1.384 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62228": {
        "Description": "1.875-V Output 400-mA 95% Efficient Step-Down Converter 15uA ThinSOT-23",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "8 mm2: 2.8 x 2.9 (SOT-23-THIN|5)",
        "Package Group": "SOT-23-THIN|5",
        "\"Approx. price\n(USD)\"": "$0.436 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62229": {
        "Description": "1.7-V Output 400-mA 95% Efficient Step-Down Converter 15uA ThinSOT-23",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "8 mm2: 2.8 x 2.9 (SOT-23-THIN|5)",
        "Package Group": "SOT-23-THIN|5",
        "\"Approx. price\n(USD)\"": "$0.436 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS65131": {
        "Description": "Split-Rail Converter with Dual Positive and Negative Outputs (750mA typ)",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck-boost inverting & split-rail converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "16 mm2: 4 x 4 (VQFN|24)",
        "Package Group": "VQFN|24",
        "\"Approx. price\n(USD)\"": "$1.068 | 1ku",
        "Status": "ACTIVE"
    },
    "LM34910": {
        "Description": "8-36V 1.25A Constant On-Time Non-Synchronous Buck Regulator",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "16 mm2: 4 x 4 (WSON|10)",
        "Package Group": "WSON|10",
        "\"Approx. price\n(USD)\"": "$1.249 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62300": {
        "Description": "Adjustable 500-mA 3-MHz Step-Down Converter in QFN",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (VSON|10)",
        "Package Group": "VSON|10",
        "\"Approx. price\n(USD)\"": "$0.591 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62301": {
        "Description": "1.5V 500-mA 3-MHz Step-Down Converter in QFN or Chip-Scale",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (VSON|10)",
        "Package Group": "VSON|10",
        "\"Approx. price\n(USD)\"": "$0.591 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62302": {
        "Description": "1.6V 500-mA 3-MHz Step-Down Converter in QFN or Chip-Scale",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (VSON|10)",
        "Package Group": "VSON|10",
        "\"Approx. price\n(USD)\"": "$0.591 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62303": {
        "Description": "1.8V 500-mA 3-MHz Step-Down Converter in QFN or Chip-Scale",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (VSON|10)",
        "Package Group": "VSON|10",
        "\"Approx. price\n(USD)\"": "$0.591 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62305": {
        "Description": "1.875V 500-mA 3-MHz Step-Down Converter in QFN or Chip-Scale",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (VSON|10)",
        "Package Group": "VSON|10",
        "\"Approx. price\n(USD)\"": "$0.591 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62320": {
        "Description": "Adjustable 500-mA 3-MHz Step-Down Converter in QFN or Chip-Scale",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (VSON|10)",
        "Package Group": "VSON|10",
        "\"Approx. price\n(USD)\"": "$0.591 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62321": {
        "Description": "1.5V 500-mA 3-MHz Step-Down Converter in QFN or Chip-Scale",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (VSON|10)",
        "Package Group": "VSON|10",
        "\"Approx. price\n(USD)\"": "$0.591 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS54010": {
        "Description": "3V to 4V Input 14A Synchronous Step-Down Converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "43 mm2: 4.4 x 9.7 (HTSSOP|28)",
        "Package Group": "HTSSOP|28",
        "\"Approx. price\n(USD)\"": "$2.970 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS40091": {
        "Description": "4 Channel Multiphase Buck DC/DC Controller with Tri-state",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck controllers (external switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "34 mm2: 4.4 x 7.8 (TSSOP|24)",
        "Package Group": "TSSOP|24",
        "\"Approx. price\n(USD)\"": "$1.672 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS60400-Q1": {
        "Description": "Automotive Unregulated 60mA Charge Pump Voltage Inverter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Charge pumps (inductorless)",
        "Rating": "Automotive",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "5 mm2: 1.6 x 2.9 (SOT-23|5)",
        "Package Group": "SOT-23|5",
        "\"Approx. price\n(USD)\"": "$0.385 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS60401-Q1": {
        "Description": "Automotive Unregulated 60mA Charge Pump Voltage Inverter with 20kHz Fixed Frequency",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Charge pumps (inductorless)",
        "Rating": "Automotive",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "5 mm2: 1.6 x 2.9 (SOT-23|5)",
        "Package Group": "SOT-23|5",
        "\"Approx. price\n(USD)\"": "$0.385 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS60402-Q1": {
        "Description": "Automotive Unregulated 60mA Charge Pump Voltage Inverter with 50kHz Fixed Frequency",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Charge pumps (inductorless)",
        "Rating": "Automotive",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "5 mm2: 1.6 x 2.9 (SOT-23|5)",
        "Package Group": "SOT-23|5",
        "\"Approx. price\n(USD)\"": "$0.385 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS60403-Q1": {
        "Description": "Automotive Unregulated 60mA Charge Pump Voltage Inverter with 250kHz Fixed Frequency",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Charge pumps (inductorless)",
        "Rating": "Automotive",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "5 mm2: 1.6 x 2.9 (SOT-23|5)",
        "Package Group": "SOT-23|5",
        "\"Approx. price\n(USD)\"": "$0.385 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62207": {
        "Description": "1.2-V Output 300-mA 95% Efficient Step-Down Converter in SOT-23",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "5 mm2: 1.6 x 2.9 (SOT-23|5)",
        "Package Group": "SOT-23|5",
        "\"Approx. price\n(USD)\"": "$0.416 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62021": {
        "Description": "Adjustable 600-mA 95% Efficient Step-Down Converter 18uA Active-Low Mode in QFN-10",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (VSON|10)",
        "Package Group": "VSON|10",
        "\"Approx. price\n(USD)\"": "$0.629 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS61070": {
        "Description": "Adjustable 600-mA switch 1200-kHz boost converter in ThinSOT-23 with power-saving mode",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "5 mm2: 1.6 x 2.9 (SOT-23-THIN|6)",
        "Package Group": "SOT-23-THIN|6",
        "\"Approx. price\n(USD)\"": "$0.349 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS61071": {
        "Description": "Adjustable 600-mA switch 1200-kHz boost converter in ThinSOT-23 with forced PWM mode",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "5 mm2: 1.6 x 2.9 (SOT-23-THIN|6)",
        "Package Group": "SOT-23-THIN|6",
        "\"Approx. price\n(USD)\"": "$0.349 | 1ku",
        "Status": "ACTIVE"
    },
    "PTH03010Y": {
        "Description": "15 A 3.3-V Input Bus Termination Power Module for DDR/QDR Memory",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck modules (integrated inductor)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "600 mm2: 16.76 x 35.81 (Through-Hole Module|10)",
        "Package Group": "Through-Hole Module|10",
        "\"Approx. price\n(USD)\"": "$13.860 | 1ku",
        "Status": "ACTIVE"
    },
    "PTH03050Y": {
        "Description": "6 A 3.3-V Input Bus Termination Power Module for DDR/QDR Memory",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck modules (integrated inductor)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "314 mm2: 13.59 x 23.12 (Surface Mount Module|6) 314 mm2: 13.59 x 23.12 (Through-Hole Module|6)",
        "Package Group": "Surface Mount Module|6 Through-Hole Module|6",
        "\"Approx. price\n(USD)\"": "$8.470 | 1ku",
        "Status": "ACTIVE"
    },
    "PTH03060Y": {
        "Description": "10 A 3.3-V Input Bus Termination Power Module for DDR/QDR Memory",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck modules (integrated inductor)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "441 mm2: 16.76 x 26.29 (Surface Mount Module|10) 441 mm2: 16.76 x 26.29 (Through-Hole Module|10)",
        "Package Group": "Surface Mount Module|10 Through-Hole Module|10",
        "\"Approx. price\n(USD)\"": "$10.230 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS40007": {
        "Description": "2.25V-5.5V 300 kHz Synchronous Buck Controller Source/ Sink Prebias Operation",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck controllers (external switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (HVSSOP|10)",
        "Package Group": "HVSSOP|10",
        "\"Approx. price\n(USD)\"": "$0.682 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS40009": {
        "Description": "2.25V-5.5V 600 kHz Synchronous Buck Controller Source/ Sink Prebias Operation",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck controllers (external switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (HVSSOP|10)",
        "Package Group": "HVSSOP|10",
        "\"Approx. price\n(USD)\"": "$0.682 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62223": {
        "Description": "2.3-V Output 400-mA 95% Efficient Step-Down Converter 15uA ThinSOT-23",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "8 mm2: 2.8 x 2.9 (SOT-23-THIN|5)",
        "Package Group": "SOT-23-THIN|5",
        "\"Approx. price\n(USD)\"": "$0.436 | 1ku",
        "Status": "ACTIVE"
    },
    "LM26003": {
        "Description": "3A Switching Regulator with High Efficiency Sleep Mode",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "42 mm2: 6.4 x 6.5 (HTSSOP|20)",
        "Package Group": "HTSSOP|20",
        "\"Approx. price\n(USD)\"": "$1.404 | 1ku",
        "Status": "ACTIVE"
    },
    "LM26003-Q1": {
        "Description": "3A Switching Regulator with High Efficiency Sleep Mode",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "42 mm2: 6.4 x 6.5 (HTSSOP|20)",
        "Package Group": "HTSSOP|20",
        "\"Approx. price\n(USD)\"": "$1.783 | 1ku",
        "Status": "ACTIVE"
    },
    "LM2735": {
        "Description": "520kHz/1.6MHz space efficient boost and SEPIC DC-DC regulator",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (HVSSOP|8) 5 mm2: 1.6 x 2.9 (SOT-23|5) 9 mm2: 3 x 3 (WSON|6)",
        "Package Group": "HVSSOP|8 SOT-23|5 WSON|6",
        "\"Approx. price\n(USD)\"": "$0.799 | 1ku",
        "Status": "ACTIVE"
    },
    "LM2735-Q1": {
        "Description": "520-kHz 1.6-MHz space efficient boost and SEPIC DC/DC regulator AEC-Q100 qualified",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "5 mm2: 1.6 x 2.9 (SOT-23|5) 9 mm2: 3 x 3 (WSON|6)",
        "Package Group": "SOT-23|5 WSON|6",
        "\"Approx. price\n(USD)\"": "$0.943 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62208": {
        "Description": "1.875-V Output 300-mA 95% Efficient Step-Down Converter in SOT-23",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "5 mm2: 1.6 x 2.9 (SOT-23|5)",
        "Package Group": "SOT-23|5",
        "\"Approx. price\n(USD)\"": "$0.416 | 1ku",
        "Status": "ACTIVE"
    },
    "PTH05010Y": {
        "Description": "15 A 5-V Input Bus Termination Power Module for DDR/QDR Memory",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck modules (integrated inductor)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "601 mm2: 16.76 x 35.85 (Surface Mount Module|10)",
        "Package Group": "Surface Mount Module|10",
        "\"Approx. price\n(USD)\"": "$13.860 | 1ku",
        "Status": "ACTIVE"
    },
    "PTH05050Y": {
        "Description": "6 A 5-V Input Bus Termination Power Module for DDR/QDR Memory",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck modules (integrated inductor)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "314 mm2: 13.59 x 23.12 (Surface Mount Module|6) 314 mm2: 13.59 x 23.12 (Through-Hole Module|6)",
        "Package Group": "Surface Mount Module|6 Through-Hole Module|6",
        "\"Approx. price\n(USD)\"": "$8.470 | 1ku",
        "Status": "ACTIVE"
    },
    "PTH05060Y": {
        "Description": "10 A 5-V Input Bus Termination Power Module for DDR/QDR Memory",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck modules (integrated inductor)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "441 mm2: 16.76 x 26.29 (Surface Mount Module|10) 441 mm2: 16.76 x 26.29 (Through-Hole Module|10)",
        "Package Group": "Surface Mount Module|10 Through-Hole Module|10",
        "\"Approx. price\n(USD)\"": "$12.792 | 1ku",
        "Status": "ACTIVE"
    },
    "PTH12010Y": {
        "Description": "15 A 12-V Input Bus Termination Power Module for DDR/QDR Memory",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck modules (integrated inductor)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "601 mm2: 16.76 x 35.85 (Surface Mount Module|10) 600 mm2: 16.76 x 35.81 (Through-Hole Module|10)",
        "Package Group": "Surface Mount Module|10 Through-Hole Module|10",
        "\"Approx. price\n(USD)\"": "$17.839 | 1ku",
        "Status": "ACTIVE"
    },
    "PTH12050Y": {
        "Description": "6 A 12-V Input Non-Isolated DDR/QDR Memory Bus Termination Module",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck modules (integrated inductor)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "314 mm2: 13.59 x 23.12 (Surface Mount Module|6) 314 mm2: 13.59 x 23.12 (Through-Hole Module|6)",
        "Package Group": "Surface Mount Module|6 Through-Hole Module|6",
        "\"Approx. price\n(USD)\"": "$10.612 | 1ku",
        "Status": "ACTIVE"
    },
    "PTH12060Y": {
        "Description": "10-A 12-V Input bus termination power module for DDR/QDR memory",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck modules (integrated inductor)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "441 mm2: 16.76 x 26.29 (Surface Mount Module|10) 441 mm2: 16.76 x 26.29 (Through-Hole Module|10)",
        "Package Group": "Surface Mount Module|10 Through-Hole Module|10",
        "\"Approx. price\n(USD)\"": "$15.073 | 1ku",
        "Status": "ACTIVE"
    },
    "PTH03030W": {
        "Description": "30 A 3.3-V Input Wide-Output Adjust Plug-in Power Module",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck modules (integrated inductor)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "1055 mm2: 29.45 x 35.81 (Surface Mount Module|13) 1055 mm2: 29.45 x 35.81 (Through-Hole Module|13)",
        "Package Group": "Surface Mount Module|13 Through-Hole Module|13",
        "\"Approx. price\n(USD)\"": "$17.600 | 1ku",
        "Status": "ACTIVE"
    },
    "LM2742": {
        "Description": "2.2-V to 16-V voltage mode synchronous buck controller with adjustable soft start",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck controllers (external switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "32 mm2: 6.4 x 5 (TSSOP|14)",
        "Package Group": "TSSOP|14",
        "\"Approx. price\n(USD)\"": "$0.774 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS65130": {
        "Description": "Split-Rail Converter with Dual Positive and Negative Outputs (300mA typ)",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck-boost inverting & split-rail converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "16 mm2: 4 x 4 (VQFN|24)",
        "Package Group": "VQFN|24",
        "\"Approx. price\n(USD)\"": "$0.968 | 1ku",
        "Status": "ACTIVE"
    },
    "LM2770": {
        "Description": "High Efficiency Switched Capacitor Step-Down DC/DC Regulator with Sleep Mode",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Charge pumps (inductorless)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-30 to 105",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (WSON|10)",
        "Package Group": "WSON|10",
        "\"Approx. price\n(USD)\"": "$0.359 | 1ku",
        "Status": "ACTIVE"
    },
    "LM5008": {
        "Description": "9.5-95V Wide Vin 350mA Constant On-Time Non-Synchronous Buck Regulator",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "15 mm2: 4.9 x 3 (VSSOP|8) 16 mm2: 4 x 4 (WSON|8)",
        "Package Group": "VSSOP|8 WSON|8",
        "\"Approx. price\n(USD)\"": "$1.113 | 1ku",
        "Status": "ACTIVE"
    },
    "LM5115": {
        "Description": "75V Secondary Side Post Regulator/ Synchronous Buck Controller",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck controllers (external switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "22 mm2: 4.4 x 5 (TSSOP|16) 25 mm2: 5 x 5 (WSON|16)",
        "Package Group": "TSSOP|16 WSON|16",
        "\"Approx. price\n(USD)\"": "$1.595 | 1ku",
        "Status": "ACTIVE"
    },
    "PTH05030W": {
        "Description": "30 A 5-V Input Wide-Output Adjust Plug-in Power Module",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck modules (integrated inductor)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "1055 mm2: 29.45 x 35.81 (Surface Mount Module|13) 1055 mm2: 29.45 x 35.81 (Through-Hole Module|13)",
        "Package Group": "Surface Mount Module|13 Through-Hole Module|13",
        "\"Approx. price\n(USD)\"": "$17.600 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS40055": {
        "Description": "Wide Input (8V-40V) up to 1MHz Frequency Synchronous Buck Controller source/sink",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck controllers (external switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "32 mm2: 6.4 x 5 (HTSSOP|16)",
        "Package Group": "HTSSOP|16",
        "\"Approx. price\n(USD)\"": "$1.742 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS40057": {
        "Description": "Wide Input (8V-40V) up to 1MHz Frequency Synchronous Buck Controller source/sink with prebias",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck controllers (external switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "32 mm2: 6.4 x 5 (HTSSOP|16)",
        "Package Group": "HTSSOP|16",
        "\"Approx. price\n(USD)\"": "$1.742 | 1ku",
        "Status": "ACTIVE"
    },
    "LM1770": {
        "Description": "Low-Voltage SOT23 Synchronous Buck Controller With No External Compensation",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck controllers (external switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "5 mm2: 1.6 x 2.9 (SOT-23|5)",
        "Package Group": "SOT-23|5",
        "\"Approx. price\n(USD)\"": "$0.678 | 1ku",
        "Status": "ACTIVE"
    },
    "LM3670": {
        "Description": "Miniature Step-Down DC-DC Converter for Ultra Low Voltage Circuits",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "5 mm2: 1.6 x 2.9 (SOT-23|5)",
        "Package Group": "SOT-23|5",
        "\"Approx. price\n(USD)\"": "$0.377 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS5120-Q1": {
        "Description": "Automotive 4.5V to 28V Dual Two-Phase Synchronous Buck Controller",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck controllers (external switch)",
        "Rating": "Automotive",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "34 mm2: 4.4 x 7.8 (TSSOP|30)",
        "Package Group": "TSSOP|30",
        "\"Approx. price\n(USD)\"": "$3.322 | 1ku",
        "Status": "ACTIVE"
    },
    "PTH03050W": {
        "Description": "6 A 3.3-V Input Non-Isolated Wide Adjust Module w/ Auto-Track",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck modules (integrated inductor)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "314 mm2: 13.59 x 23.12 (Surface Mount Module|6) 314 mm2: 13.59 x 23.12 (Through-Hole Module|6)",
        "Package Group": "Surface Mount Module|6 Through-Hole Module|6",
        "\"Approx. price\n(USD)\"": "$8.470 | 1ku",
        "Status": "ACTIVE"
    },
    "PTH03060W": {
        "Description": "10 A 3.3-V Input Non-Isolated Wide Adjust Module",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck modules (integrated inductor)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "441 mm2: 16.76 x 26.29 (Surface Mount Module|10) 441 mm2: 16.76 x 26.29 (Through-Hole Module|10)",
        "Package Group": "Surface Mount Module|10 Through-Hole Module|10",
        "\"Approx. price\n(USD)\"": "$10.230 | 1ku",
        "Status": "ACTIVE"
    },
    "PTH05060W": {
        "Description": "10 A 5-V Input Non-Isolated Wide Adjust Module",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck modules (integrated inductor)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "441 mm2: 16.76 x 26.29 (Surface Mount Module|10) 441 mm2: 16.76 x 26.29 (Through-Hole Module|10)",
        "Package Group": "Surface Mount Module|10 Through-Hole Module|10",
        "\"Approx. price\n(USD)\"": "$10.230 | 1ku",
        "Status": "ACTIVE"
    },
    "PTH12050W": {
        "Description": "1.2 to 5.5 V 6-A 12-V Input Non-Isolated Wide-Adjust Module",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck modules (integrated inductor)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "314 mm2: 13.59 x 23.12 (Surface Mount Module|6) 314 mm2: 13.59 x 23.12 (Through-Hole Module|6)",
        "Package Group": "Surface Mount Module|6 Through-Hole Module|6",
        "\"Approx. price\n(USD)\"": "$8.633 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS54110": {
        "Description": "3V to 6V Input 1.5A Synchronous Step-Down Converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "42 mm2: 6.4 x 6.5 (HTSSOP|20)",
        "Package Group": "HTSSOP|20",
        "\"Approx. price\n(USD)\"": "$1.162 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS5120-EP": {
        "Description": "Enhanced Product Dual Output Two-Phase Synchronous Buck Dc/Dc Controller",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck controllers (external switch)",
        "Rating": "HiRel Enhanced Product",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "\"-40 to 125\n-55 to 125\"",
        "Package size: mm2:W x L (PKG)": "34 mm2: 4.4 x 7.8 (TSSOP|30)",
        "Package Group": "TSSOP|30",
        "\"Approx. price\n(USD)\"": "$5.896 | 1ku",
        "Status": "ACTIVE"
    },
    "REG71050": {
        "Description": "60-mA 5.0-V Buck/Boost Charge Pump in ThinSOT-23",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Charge pumps (inductorless)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "5 mm2: 1.6 x 2.9 (SOT-23-THIN|6) 4 mm2: 2 x 2 (WSON|6)",
        "Package Group": "SOT-23-THIN|6 WSON|6",
        "\"Approx. price\n(USD)\"": "$0.458 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS40050-Q1": {
        "Description": "Automotive 8V to 40V Synchronous Buck Controller",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck controllers (external switch)",
        "Rating": "Automotive",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "32 mm2: 6.4 x 5 (HTSSOP|16)",
        "Package Group": "HTSSOP|16",
        "\"Approx. price\n(USD)\"": "$1.888 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS40051-Q1": {
        "Description": "Automotive 8V to 40V Synchronous Buck Controller",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck controllers (external switch)",
        "Rating": "Automotive",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "32 mm2: 6.4 x 5 (HTSSOP|16)",
        "Package Group": "HTSSOP|16",
        "\"Approx. price\n(USD)\"": "$1.888 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS40090": {
        "Description": "4 Channel Multiphase Buck DC/DC Controller",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck controllers (external switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "34 mm2: 4.4 x 7.8 (TSSOP|24) 25 mm2: 5 x 5 (VQFN|28)",
        "Package Group": "TSSOP|24 VQFN|28",
        "\"Approx. price\n(USD)\"": "$1.672 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS54350": {
        "Description": "4.5V to 20V Input 3A Synchronous Step-Down Converter with Low-Side Gate Driver",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 150",
        "Package size: mm2:W x L (PKG)": "32 mm2: 6.4 x 5 (HTSSOP|16)",
        "Package Group": "HTSSOP|16",
        "\"Approx. price\n(USD)\"": "$1.355 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS54680-EP": {
        "Description": "Enhanced Product 3V to 6V Input Tracking Synchronous Buck Pwm Switcher",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "HiRel Enhanced Product",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "\"-40 to 125\n-55 to 125\"",
        "Package size: mm2:W x L (PKG)": "43 mm2: 4.4 x 9.7 (HTSSOP|28)",
        "Package Group": "HTSSOP|28",
        "\"Approx. price\n(USD)\"": "$6.634 | 1ku",
        "Status": "ACTIVE"
    },
    "PTH03010W": {
        "Description": "15 A 3.3-V Input Non-Isolated Wide-Output Adjust Power Module",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck modules (integrated inductor)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "601 mm2: 16.76 x 35.85 (Surface Mount Module|10) 600 mm2: 16.76 x 35.81 (Through-Hole Module|10)",
        "Package Group": "Surface Mount Module|10 Through-Hole Module|10",
        "\"Approx. price\n(USD)\"": "$11.550 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62220": {
        "Description": "Adjustable 400-mA 95% Efficient Step-Down Converter 15uA ThinSOT-23",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "8 mm2: 2.8 x 2.9 (SOT-23-THIN|5)",
        "Package Group": "SOT-23-THIN|5",
        "\"Approx. price\n(USD)\"": "$0.436 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62221": {
        "Description": "1.5-V Output 400-mA 95% Efficient Step-Down Converter 15uA ThinSOT-23",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "8 mm2: 2.8 x 2.9 (SOT-23-THIN|5)",
        "Package Group": "SOT-23-THIN|5",
        "\"Approx. price\n(USD)\"": "$0.436 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62222": {
        "Description": "1.8-V Output 400-mA 95% Efficient Step-Down Converter 15uA ThinSOT-23",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "8 mm2: 2.8 x 2.9 (SOT-23-THIN|5)",
        "Package Group": "SOT-23-THIN|5",
        "\"Approx. price\n(USD)\"": "$0.436 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62224": {
        "Description": "1.6-V Output 400-mA 95% Efficient Step-Down Converter 15uA ThinSOT-23",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "8 mm2: 2.8 x 2.9 (SOT-23-THIN|5)",
        "Package Group": "SOT-23-THIN|5",
        "\"Approx. price\n(USD)\"": "$0.436 | 1ku",
        "Status": "ACTIVE"
    },
    "PTH03020W": {
        "Description": "22 A 3.3-V Input Wide-Output Adjust Plug-in Power Module",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck modules (integrated inductor)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "901 mm2: 23.11 x 38.99 (Surface Mount Module|10) 901 mm2: 23.11 x 38.99 (Through-Hole Module|10)",
        "Package Group": "Surface Mount Module|10 Through-Hole Module|10",
        "\"Approx. price\n(USD)\"": "$17.160 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS61020": {
        "Description": "Adjustable 1.5-A Switch 96% Efficient Boost Converter with Down-Mode QFN-10",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (VSON|10)",
        "Package Group": "VSON|10",
        "\"Approx. price\n(USD)\"": "$0.755 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS61024": {
        "Description": "3.0-V Output 1.5-A Switch 96% Efficient Boost Converter w/ LDO Down-Mode QFN-10",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (VSON|10)",
        "Package Group": "VSON|10",
        "\"Approx. price\n(USD)\"": "$0.774 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS61025": {
        "Description": "3.3-V Output 1.5-A Switch 96% Efficient Boost Converter w/ LDO Down-Mode QFN-10",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (VSON|10)",
        "Package Group": "VSON|10",
        "\"Approx. price\n(USD)\"": "$0.774 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS61027": {
        "Description": "5-V Output 1.5-A Switch 96% Efficient Boost Converter w/ LDO Down-Mode QFN-10",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (VSON|10)",
        "Package Group": "VSON|10",
        "\"Approx. price\n(USD)\"": "$0.774 | 1ku",
        "Status": "ACTIVE"
    },
    "PTH12010W": {
        "Description": "1.2 to 5.5 V 12-A 12-V Input Non-Isolated Wide-Adjust Module",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck modules (integrated inductor)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "601 mm2: 16.76 x 35.85 (Surface Mount Module|10) 600 mm2: 16.76 x 35.81 (Through-Hole Module|10)",
        "Package Group": "Surface Mount Module|10 Through-Hole Module|10",
        "\"Approx. price\n(USD)\"": "$14.270 | 1ku",
        "Status": "ACTIVE"
    },
    "LM5020": {
        "Description": "13-100V Wide Vin Current Mode PWM Boost Flyback Sepic Controller",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost controllers (external switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (VSSOP|10) 16 mm2: 4 x 4 (WSON|10)",
        "Package Group": "VSSOP|10 WSON|10",
        "\"Approx. price\n(USD)\"": "$0.823 | 1ku",
        "Status": "ACTIVE"
    },
    "LM2736": {
        "Description": "3V to 18V Input 0.75A Step-Down Converter with Light Load Efficiency",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "5 mm2: 1.6 x 2.9 (SOT-23-THIN|6)",
        "Package Group": "SOT-23-THIN|6",
        "\"Approx. price\n(USD)\"": "$0.678 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS64200": {
        "Description": "1.8 to 6.5 V input 350 kHz 95% efficient step-down controller 20 uA SOT-23",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck controllers (external switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "5 mm2: 1.6 x 2.9 (SOT-23|6)",
        "Package Group": "SOT-23|6",
        "\"Approx. price\n(USD)\"": "$0.484 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS64201": {
        "Description": "1.8 to 6.5 V input 450 kHz 95% efficient step-down controller 20 uA SOT-23",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck controllers (external switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "5 mm2: 1.6 x 2.9 (SOT-23|6)",
        "Package Group": "SOT-23|6",
        "\"Approx. price\n(USD)\"": "$0.484 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS64202": {
        "Description": "1.8 to 6.5 V input 550 kHz 95% efficient step-down controller 20 uA SOT-23",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck controllers (external switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "5 mm2: 1.6 x 2.9 (SOT-23|6)",
        "Package Group": "SOT-23|6",
        "\"Approx. price\n(USD)\"": "$0.484 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS64203": {
        "Description": "1.8 to 6.5 V input 800 kHz 95% efficient step-down controller 20 uA SOT-23",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck controllers (external switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "5 mm2: 1.6 x 2.9 (SOT-23|6)",
        "Package Group": "SOT-23|6",
        "\"Approx. price\n(USD)\"": "$0.484 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS61090": {
        "Description": "1.8Vin 2A Switch 96% Efficient Boost Converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "16 mm2: 4 x 4 (QFN|16)",
        "Package Group": "QFN|16",
        "\"Approx. price\n(USD)\"": "$0.871 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS61091": {
        "Description": "3.3-V Output 500-mA 96% Efficient Boost Converter 20uA QFN-16",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "16 mm2: 4 x 4 (QFN|16)",
        "Package Group": "QFN|16",
        "\"Approx. price\n(USD)\"": "$0.871 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS61092": {
        "Description": "5-V Output 500-mA 96% Efficient Boost Converter 20uA QFN-16",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "16 mm2: 4 x 4 (QFN|16)",
        "Package Group": "QFN|16",
        "\"Approx. price\n(USD)\"": "$0.871 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62020": {
        "Description": "Adjustable 600-mA 95% Efficient Step-Down Converter 18uA MSOP-10",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (HVSSOP|10) 9 mm2: 3 x 3 (VSON|10)",
        "Package Group": "HVSSOP|10 VSON|10",
        "\"Approx. price\n(USD)\"": "$0.629 | 1ku",
        "Status": "ACTIVE"
    },
    "PTH05010W": {
        "Description": "15 A 5-V Input Wide-Output Adjust Plug-in Power Module",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck modules (integrated inductor)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "601 mm2: 16.76 x 35.85 (Surface Mount Module|10) 600 mm2: 16.76 x 35.81 (Through-Hole Module|10)",
        "Package Group": "Surface Mount Module|10 Through-Hole Module|10",
        "\"Approx. price\n(USD)\"": "$11.550 | 1ku",
        "Status": "ACTIVE"
    },
    "PTH05020W": {
        "Description": "22 A 5-V Input Wide-Output Adjust Plug-in Power Module",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck modules (integrated inductor)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "901 mm2: 23.11 x 38.99 (Surface Mount Module|10) 901 mm2: 23.11 x 38.99 (Through-Hole Module|10)",
        "Package Group": "Surface Mount Module|10 Through-Hole Module|10",
        "\"Approx. price\n(USD)\"": "$17.160 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62040": {
        "Description": "Adjustable 1.2-A 95% efficient step-down converter 18 uA MSOP-10 and QFN",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (HVSSOP|10) 9 mm2: 3 x 3 (VSON|10)",
        "Package Group": "HVSSOP|10 VSON|10",
        "\"Approx. price\n(USD)\"": "$0.763 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62042": {
        "Description": "1.5-V Output 1.2-A 95% Efficient Step-Down Converter 18uA MSOP-10",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (HVSSOP|10) 9 mm2: 3 x 3 (VSON|10)",
        "Package Group": "HVSSOP|10 VSON|10",
        "\"Approx. price\n(USD)\"": "$0.763 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62043": {
        "Description": "1.6-V Output 1.2-A 95% efficient step-down converter 18 uA MSOP-10 or QFN",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (HVSSOP|10) 9 mm2: 3 x 3 (VSON|10)",
        "Package Group": "HVSSOP|10 VSON|10",
        "\"Approx. price\n(USD)\"": "$0.763 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62044": {
        "Description": "1.8-V Output 1.2-A 95% Efficient Step-Down Converter 18uA MSOP-10",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (HVSSOP|10) 9 mm2: 3 x 3 (VSON|10)",
        "Package Group": "HVSSOP|10 VSON|10",
        "\"Approx. price\n(USD)\"": "$0.763 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62046": {
        "Description": "3.3-V Output 1.2-A 95% Efficient Step-Down Converter 18uA MSOP-10 QFN-10",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (HVSSOP|10) 9 mm2: 3 x 3 (VSON|10)",
        "Package Group": "HVSSOP|10 VSON|10",
        "\"Approx. price\n(USD)\"": "$0.763 | 1ku",
        "Status": "ACTIVE"
    },
    "LM5642": {
        "Description": "4.5-36V Current Mode Dual Synchronous Buck Controller with Oscillator Synchronization",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck controllers (external switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "43 mm2: 4.4 x 9.7 (HTSSOP|28) 62 mm2: 6.4 x 9.7 (TSSOP|28)",
        "Package Group": "HTSSOP|28 TSSOP|28",
        "\"Approx. price\n(USD)\"": "$1.694 | 1ku",
        "Status": "ACTIVE"
    },
    "REG71055": {
        "Description": "60-mA 5.5V Buck/boost Charge Pump in ThinSOT-23",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Charge pumps (inductorless)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "5 mm2: 1.6 x 2.9 (SOT-23-THIN|6)",
        "Package Group": "SOT-23-THIN|6",
        "\"Approx. price\n(USD)\"": "$0.416 | 1ku",
        "Status": "ACTIVE"
    },
    "LM2731": {
        "Description": "0.6/1.6 MHz Boost Converters With 22V Internal FET Switch in SOT-23",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "5 mm2: 1.6 x 2.9 (SOT-23|5)",
        "Package Group": "SOT-23|5",
        "\"Approx. price\n(USD)\"": "$0.807 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS54973": {
        "Description": "3.3V Input 9A Synchronous Step-Down Converter for Prebiased Outputs",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "43 mm2: 4.4 x 9.7 (HTSSOP|28)",
        "Package Group": "HTSSOP|28",
        "\"Approx. price\n(USD)\"": "$2.420 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS54980": {
        "Description": "3.3V Input 9A Synchronous Step-Down Converter for Sequencing",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "0 to 70",
        "Package size: mm2:W x L (PKG)": "43 mm2: 4.4 x 9.7 (HTSSOP|28)",
        "Package Group": "HTSSOP|28",
        "\"Approx. price\n(USD)\"": "$2.420 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS61045": {
        "Description": "28-V 85% Efficient Boost Converter in QFN-8 Digitally Adjustable",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (SON|8)",
        "Package Group": "SON|8",
        "\"Approx. price\n(USD)\"": "$0.550 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS61030": {
        "Description": "1.8Vin 4-A Switch 96% Efficient Boost Converter w/20µA Iq in TSSOP-16",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "32 mm2: 6.4 x 5 (HTSSOP|16) 16 mm2: 4 x 4 (QFN|16)",
        "Package Group": "HTSSOP|16 QFN|16",
        "\"Approx. price\n(USD)\"": "$1.113 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS61031": {
        "Description": "3.3-V Output 1-A 96% Efficient Boost Converter w/20uA Iq in TSSOP-16",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "32 mm2: 6.4 x 5 (HTSSOP|16) 16 mm2: 4 x 4 (QFN|16)",
        "Package Group": "HTSSOP|16 QFN|16",
        "\"Approx. price\n(USD)\"": "$1.113 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS61032": {
        "Description": "5-V Output 1-A 96% Efficient Boost Converter w/20uA Iq in TSSOP-16",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "32 mm2: 6.4 x 5 (HTSSOP|16) 16 mm2: 4 x 4 (QFN|16)",
        "Package Group": "HTSSOP|16 QFN|16",
        "\"Approx. price\n(USD)\"": "$1.113 | 1ku",
        "Status": "ACTIVE"
    },
    "LM5007": {
        "Description": "9-75V Wide Vin 500mA Constant On-Time Non-Synchronous Buck Regulator",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "15 mm2: 4.9 x 3 (VSSOP|8) 16 mm2: 4 x 4 (WSON|8)",
        "Package Group": "VSSOP|8 WSON|8",
        "\"Approx. price\n(USD)\"": "$1.258 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS40060": {
        "Description": "Wide Input (10V-55V) up to 1 MHz Frequency Synchronous Buck Controller source only",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck controllers (external switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "32 mm2: 6.4 x 5 (HTSSOP|16)",
        "Package Group": "HTSSOP|16",
        "\"Approx. price\n(USD)\"": "$1.549 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS40061": {
        "Description": "Wide Input (10V-55V) up to 1 MHz Frequency Synchronous Buck Controller source/sink",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck controllers (external switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "32 mm2: 6.4 x 5 (HTSSOP|16)",
        "Package Group": "HTSSOP|16",
        "\"Approx. price\n(USD)\"": "$1.549 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62050": {
        "Description": "Adjustable 800-mA 10V Vin 95% Efficient Step-Down Converter in MSOP-10",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (VSSOP|10)",
        "Package Group": "VSSOP|10",
        "\"Approx. price\n(USD)\"": "$0.697 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62051": {
        "Description": "Adjustable 800-mA 10V Vin Enhanced LBI Step-Down Converter in MSOP-10",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (VSSOP|10)",
        "Package Group": "VSSOP|10",
        "\"Approx. price\n(USD)\"": "$0.697 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62052": {
        "Description": "1.5-V Output 800-mA 10V Vin 95% Efficient Step-Down Converter in MSOP-10",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (VSSOP|10)",
        "Package Group": "VSSOP|10",
        "\"Approx. price\n(USD)\"": "$0.697 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62054": {
        "Description": "1.8-V Output 800-mA 10V Vin 95% Efficient Step-Down Converter in MSOP-10",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (VSSOP|10)",
        "Package Group": "VSSOP|10",
        "\"Approx. price\n(USD)\"": "$0.697 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62056": {
        "Description": "3.3-V Output 800-mA 10V Vin 95% Efficient Step-Down Converter in MSOP-10",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (VSSOP|10)",
        "Package Group": "VSSOP|10",
        "\"Approx. price\n(USD)\"": "$0.697 | 1ku",
        "Status": "ACTIVE"
    },
    "LM2734": {
        "Description": "3V to 20V Input 1A Step-Down Converter with Light Load Efficiency",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "5 mm2: 1.6 x 2.9 (SOT-23-THIN|6)",
        "Package Group": "SOT-23-THIN|6",
        "\"Approx. price\n(USD)\"": "$1.297 | 1ku",
        "Status": "ACTIVE"
    },
    "LM2734-Q1": {
        "Description": "3 to 20 V input 1 A automotive step-down converter with light load efficiency",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Automotive",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "5 mm2: 1.6 x 2.9 (SOT-23-THIN|6)",
        "Package Group": "SOT-23-THIN|6",
        "\"Approx. price\n(USD)\"": "$1.530 | 1ku",
        "Status": "ACTIVE"
    },
    "LM2724A": {
        "Description": "High Speed 3A Synchronous MOSFET Driver",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "19 mm2: 3.91 x 4.9 (SOIC|8)",
        "Package Group": "SOIC|8",
        "\"Approx. price\n(USD)\"": "$1.085 | 1ku",
        "Status": "ACTIVE"
    },
    "LM2733": {
        "Description": "0.6/1.6 MHz Boost Converters With 40V Internal FET Switch in SOT-23",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "5 mm2: 1.6 x 2.9 (SOT-23|5)",
        "Package Group": "SOT-23|5",
        "\"Approx. price\n(USD)\"": "$0.768 | 1ku",
        "Status": "ACTIVE"
    },
    "LM2705": {
        "Description": "Micropower step-up DC/DC converter with 150mA peak current limit",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "5 mm2: 1.6 x 2.9 (SOT-23|5)",
        "Package Group": "SOT-23|5",
        "\"Approx. price\n(USD)\"": "$0.746 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS54880": {
        "Description": "4.5 to 5.5V Input 8A Synchronous Step-Down Converter for Sequencing",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "43 mm2: 4.4 x 9.7 (HTSSOP|28)",
        "Package Group": "HTSSOP|28",
        "\"Approx. price\n(USD)\"": "$2.365 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS61107": {
        "Description": "Dual output converter (boost DC/DC + LDO) for single/dual cell apps with 1.8V fixed output voltage",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "29 mm2: 4.4 x 6.5 (TSSOP|20) 16 mm2: 4 x 4 (VQFN|24)",
        "Package Group": "TSSOP|20 VQFN|24",
        "\"Approx. price\n(USD)\"": "$2.114 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS61120": {
        "Description": "Adjustable 95% Efficient Boost Converter with 200-mA LDO for 1-Cell LiIon or Dual-Cell Applications",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "16 mm2: 4 x 4 (QFN|16) 22 mm2: 4.4 x 5 (TSSOP|16)",
        "Package Group": "QFN|16 TSSOP|16",
        "\"Approx. price\n(USD)\"": "$1.278 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS61121": {
        "Description": "3.3-V 95% Efficient Boost Converter with 1.5-V 200-mA LDO for 1-Cell LiIon or Dual-Cell Applications",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "22 mm2: 4.4 x 5 (TSSOP|16)",
        "Package Group": "TSSOP|16",
        "\"Approx. price\n(USD)\"": "$1.278 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS61122": {
        "Description": "3.6-V 95% Efficient Boost Converter with 3.3-V 200-mA LDO for 1-Cell LiIon or Dual-Cell Applications",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "22 mm2: 4.4 x 5 (TSSOP|16)",
        "Package Group": "TSSOP|16",
        "\"Approx. price\n(USD)\"": "$1.278 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS61130": {
        "Description": "Adjustable 90% Efficient SEPIC Converter with 200-mA LDO for 1-Cell LiIon or Dual-Cell Applications",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "16 mm2: 4 x 4 (QFN|16) 22 mm2: 4.4 x 5 (TSSOP|16)",
        "Package Group": "QFN|16 TSSOP|16",
        "\"Approx. price\n(USD)\"": "$1.456 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS61131": {
        "Description": "3.3V 90% Efficient SEPIC Converter with 3.3V 200-mA LDO for 1-Cell LiIon or Dual-Cell Applications",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "22 mm2: 4.4 x 5 (TSSOP|16)",
        "Package Group": "TSSOP|16",
        "\"Approx. price\n(USD)\"": "$1.456 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS61100": {
        "Description": "Dual output converter (boost DC/DC + LDO) for single/dual cell applications",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "29 mm2: 4.4 x 6.5 (TSSOP|20) 16 mm2: 4 x 4 (VQFN|24)",
        "Package Group": "TSSOP|20 VQFN|24",
        "\"Approx. price\n(USD)\"": "$2.114 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62008": {
        "Description": "1.9-V Output 600-mA 95% Efficient Step-Down Converter in MSOP-10",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (VSSOP|10)",
        "Package Group": "VSSOP|10",
        "\"Approx. price\n(USD)\"": "$0.741 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS40000": {
        "Description": "Low Input  (2.25V-5.5V) 300 kHz Frequency Synchronous Buck Controller Source Only",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck controllers (external switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (HVSSOP|10)",
        "Package Group": "HVSSOP|10",
        "\"Approx. price\n(USD)\"": "$0.682 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS5130": {
        "Description": "4.5-V to 28-V triple synchronous buck controller with LDO controller",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck controllers (external switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "49 mm2: 7 x 7 (LQFP|48)",
        "Package Group": "LQFP|48",
        "\"Approx. price\n(USD)\"": "$2.310 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS54910": {
        "Description": "3V to 4V Input 9A Synchronous Step-Down Converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "43 mm2: 4.4 x 9.7 (HTSSOP|28)",
        "Package Group": "HTSSOP|28",
        "\"Approx. price\n(USD)\"": "$2.420 | 1ku",
        "Status": "ACTIVE"
    },
    "LM2642": {
        "Description": "4.5-V to 30-V two-phase peak current mode synchronous buck controller",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck controllers (external switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "62 mm2: 6.4 x 9.7 (TSSOP|28)",
        "Package Group": "TSSOP|28",
        "\"Approx. price\n(USD)\"": "$1.432 | 1ku",
        "Status": "ACTIVE"
    },
    "LM2623": {
        "Description": "0.8V to 14V input voltage 2A load current step-up DC-DC",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "15 mm2: 4.9 x 3 (VSSOP|8) 16 mm2: 4 x 4 (WSON|14)",
        "Package Group": "VSSOP|8 WSON|14",
        "\"Approx. price\n(USD)\"": "$0.532 | 1ku",
        "Status": "ACTIVE"
    },
    "LM3475": {
        "Description": "10-V hysteretic PFET buck controller",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck controllers (external switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "5 mm2: 1.6 x 2.9 (SOT-23|5)",
        "Package Group": "SOT-23|5",
        "\"Approx. price\n(USD)\"": "$0.464 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62200": {
        "Description": "Adjustable 300-mA 95% Efficient Step-Down Converter in SOT-23",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "5 mm2: 1.6 x 2.9 (SOT-23|5)",
        "Package Group": "SOT-23|5",
        "\"Approx. price\n(USD)\"": "$0.416 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62201": {
        "Description": "1.5-V Output 300-mA 95% Efficient Step-Down Converter in SOT-23",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "5 mm2: 1.6 x 2.9 (SOT-23|5)",
        "Package Group": "SOT-23|5",
        "\"Approx. price\n(USD)\"": "$0.416 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62202": {
        "Description": "1.8-V Output 300-mA 95% Efficient Step-Down Converter in SOT-23",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "5 mm2: 1.6 x 2.9 (SOT-23|5)",
        "Package Group": "SOT-23|5",
        "\"Approx. price\n(USD)\"": "$0.416 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62203": {
        "Description": "3.3-V Output 300-mA 95% Efficient Step-Down Converter in SOT-23",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "5 mm2: 1.6 x 2.9 (SOT-23|5)",
        "Package Group": "SOT-23|5",
        "\"Approx. price\n(USD)\"": "$0.416 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62204": {
        "Description": "1.6-V Output 300-mA 95% Efficient Step-Down Converter in SOT-23",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "5 mm2: 1.6 x 2.9 (SOT-23|5)",
        "Package Group": "SOT-23|5",
        "\"Approx. price\n(USD)\"": "$0.416 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62205": {
        "Description": "2.5-V Output 300-mA 95% Efficient Step-Down Converter in SOT-23",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "5 mm2: 1.6 x 2.9 (SOT-23|5)",
        "Package Group": "SOT-23|5",
        "\"Approx. price\n(USD)\"": "$0.416 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS54810": {
        "Description": "4.5 to 5.5V Input  8A Synchronous Step-Down Converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "43 mm2: 4.4 x 9.7 (HTSSOP|28)",
        "Package Group": "HTSSOP|28",
        "\"Approx. price\n(USD)\"": "$2.483 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS61040": {
        "Description": "28-V 400-mA Switch Boost Converter in SOT-23 for LCD and White LED Applications",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "5 mm2: 1.6 x 2.9 (SOT-23|5) 8 mm2: 2.8 x 2.9 (SOT-23-THIN|5) 4 mm2: 2 x 2 (WSON|6)",
        "Package Group": "SOT-23-THIN|5 SOT-23|5 WSON|6",
        "\"Approx. price\n(USD)\"": "$0.484 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS61041": {
        "Description": "28-V 250-mA Switch Boost Converter in SOT-23 for LCD and White LED Applications",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "5 mm2: 1.6 x 2.9 (SOT-23|5) 4 mm2: 2 x 2 (WSON|6)",
        "Package Group": "SOT-23|5 WSON|6",
        "\"Approx. price\n(USD)\"": "$0.484 | 1ku",
        "Status": "ACTIVE"
    },
    "LM5000": {
        "Description": "3.1-40V Wide Vin 2A Current Mode Non-Synchronous Boost Regulator",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "22 mm2: 4.4 x 5 (TSSOP|16) 25 mm2: 5 x 5 (WSON|16)",
        "Package Group": "TSSOP|16 WSON|16",
        "\"Approx. price\n(USD)\"": "$1.916 | 1ku",
        "Status": "ACTIVE"
    },
    "LM2704": {
        "Description": "Micropower Step-up DC/DC Converter with 550mA Peak Current Limit",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "5 mm2: 1.6 x 2.9 (SOT-23|5)",
        "Package Group": "SOT-23|5",
        "\"Approx. price\n(USD)\"": "$0.778 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS60240": {
        "Description": "170 uVrms Zero-Ripple Switched Cap Boost Converter With Fixed 3.3V Output For VCO Supply",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Charge pumps (inductorless)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "15 mm2: 4.9 x 3 (VSSOP|8)",
        "Package Group": "VSSOP|8",
        "\"Approx. price\n(USD)\"": "$0.532 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS60242": {
        "Description": "170 uVrms Zero-Ripple Switched Cap Boost Converter With Fixed 2.7V Output For VCO Supply",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Charge pumps (inductorless)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "15 mm2: 4.9 x 3 (VSSOP|8)",
        "Package Group": "VSSOP|8",
        "\"Approx. price\n(USD)\"": "$0.532 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS60243": {
        "Description": "170 uVrms Zero-Ripple Switched Cap Boost Converter With Fixed 3V Output For VCO Supply",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Charge pumps (inductorless)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "15 mm2: 4.9 x 3 (VSSOP|8)",
        "Package Group": "VSSOP|8",
        "\"Approx. price\n(USD)\"": "$0.532 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS54310": {
        "Description": "3V to 6V Input 3A Synchronous Step-Down Converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "42 mm2: 6.4 x 6.5 (HTSSOP|20)",
        "Package Group": "HTSSOP|20",
        "\"Approx. price\n(USD)\"": "$1.300 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS60500": {
        "Description": "250-mA Adjustable (0.8V-3.3V) High-Efficiency Step-Down Charge Pump",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Charge pumps (inductorless)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (VSSOP|10)",
        "Package Group": "VSSOP|10",
        "\"Approx. price\n(USD)\"": "$0.427 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS60501": {
        "Description": "250-mA 3.3-V High-Efficiency Step-Down Charge Pump",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Charge pumps (inductorless)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (VSSOP|10)",
        "Package Group": "VSSOP|10",
        "\"Approx. price\n(USD)\"": "$0.427 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS60503": {
        "Description": "250-mA 1.5-V High-Efficiency Step-Down Charge Pump",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Charge pumps (inductorless)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (VSSOP|10)",
        "Package Group": "VSSOP|10",
        "\"Approx. price\n(USD)\"": "$0.427 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS43000": {
        "Description": "Multi-Topology (buck boost sepic) High Frequency DC/DC Controller",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost controllers (external switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "22 mm2: 4.4 x 5 (TSSOP|16)",
        "Package Group": "TSSOP|16",
        "\"Approx. price\n(USD)\"": "$1.517 | 1ku",
        "Status": "ACTIVE"
    },
    "LM2750": {
        "Description": "2.7-V to 5.6-VIN low-noise switched-capacitor boost doubler",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Charge pumps (inductorless)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (WSON|10)",
        "Package Group": "WSON|10",
        "\"Approx. price\n(USD)\"": "$0.639 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS60241": {
        "Description": "170 uVrms Zero-Ripple Switched Cap Boost Converter With Fixed 5.0V Output For VCO Supply",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Charge pumps (inductorless)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "15 mm2: 4.9 x 3 (VSSOP|8)",
        "Package Group": "VSSOP|8",
        "\"Approx. price\n(USD)\"": "$0.532 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS60300": {
        "Description": "Single cell to 3.3V 20mA dual output high efficiency charge pump with open-drain power-good output",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Charge pumps (inductorless)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (VSSOP|10)",
        "Package Group": "VSSOP|10",
        "\"Approx. price\n(USD)\"": "$0.746 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS60301": {
        "Description": "Single cell to 3.0V 20mA dual output high efficiency charge pump with open-drain power-good output",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Charge pumps (inductorless)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (VSSOP|10)",
        "Package Group": "VSSOP|10",
        "\"Approx. price\n(USD)\"": "$0.746 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS60302": {
        "Description": "Single cell to 3.3V 20mA dual output high efficiency charge pump with push-pull power-good output",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Charge pumps (inductorless)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (VSSOP|10)",
        "Package Group": "VSSOP|10",
        "\"Approx. price\n(USD)\"": "$0.746 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS60303": {
        "Description": "Single cell to 3.0V 20mA dual output high efficiency charge pump with Push-Pull power-good output",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Charge pumps (inductorless)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (VSSOP|10)",
        "Package Group": "VSSOP|10",
        "\"Approx. price\n(USD)\"": "$0.746 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS60310": {
        "Description": "Single-cell to 3.3-V 20-mA ultra-low quiescent current charge pump and open-drain power-good output",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Charge pumps (inductorless)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (VSSOP|10)",
        "Package Group": "VSSOP|10",
        "\"Approx. price\n(USD)\"": "$0.692 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS60311": {
        "Description": "Single-cell to 3-V 20-mA ultra-low quiescent current charge pump with open-drain power-good output",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Charge pumps (inductorless)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (VSSOP|10)",
        "Package Group": "VSSOP|10",
        "\"Approx. price\n(USD)\"": "$0.692 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS60312": {
        "Description": "Single-cell to 3.3-V 20-mA ultra-low quiescent current charge pump and push-pull power-good output",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Charge pumps (inductorless)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (VSSOP|10)",
        "Package Group": "VSSOP|10",
        "\"Approx. price\n(USD)\"": "$0.692 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS60313": {
        "Description": "Single-cell to 3-V 20-mA ultra-low quiescent current charge pump and push-pull power-good output",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Charge pumps (inductorless)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (VSSOP|10)",
        "Package Group": "VSSOP|10",
        "\"Approx. price\n(USD)\"": "$0.692 | 1ku",
        "Status": "ACTIVE"
    },
    "REG710-27": {
        "Description": "30-mA Switched-Cap DC-DC Converter with fixed 2.7-V Output",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Charge pumps (inductorless)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "5 mm2: 1.6 x 2.9 (SOT-23|6)",
        "Package Group": "SOT-23|6",
        "\"Approx. price\n(USD)\"": "$0.458 | 1ku",
        "Status": "ACTIVE"
    },
    "REG710-3": {
        "Description": "30-mA Switched-Cap DC-DC Converter with fixed 3-V Output",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Charge pumps (inductorless)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "5 mm2: 1.6 x 2.9 (SOT-23|6)",
        "Package Group": "SOT-23|6",
        "\"Approx. price\n(USD)\"": "$0.458 | 1ku",
        "Status": "ACTIVE"
    },
    "REG710-33": {
        "Description": "30-mA Switched-Cap DC-DC Converter with fixed 3.3-V Output",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Charge pumps (inductorless)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "5 mm2: 1.6 x 2.9 (SOT-23|6)",
        "Package Group": "SOT-23|6",
        "\"Approx. price\n(USD)\"": "$0.458 | 1ku",
        "Status": "ACTIVE"
    },
    "REG710-5": {
        "Description": "30-mA Switched-Cap DC-DC Converter with fixed 5-V Output",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Charge pumps (inductorless)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "5 mm2: 1.6 x 2.9 (SOT-23|6)",
        "Package Group": "SOT-23|6",
        "\"Approx. price\n(USD)\"": "$0.458 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS54616": {
        "Description": "3V to 6V Input 6A Synchronous Step-Down SWIFT&trade; Converter with 3.3V Output",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "43 mm2: 4.4 x 9.7 (HTSSOP|28)",
        "Package Group": "HTSSOP|28",
        "\"Approx. price\n(USD)\"": "$1.355 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS60400": {
        "Description": "60mA Charge Pump Voltage Inverter with Variable Switching Frequency",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Charge pumps (inductorless)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "5 mm2: 1.6 x 2.9 (SOT-23|5)",
        "Package Group": "SOT-23|5",
        "\"Approx. price\n(USD)\"": "$0.326 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS60401": {
        "Description": "60mA Charge Pump Voltage Inverter with Fixed 20kHz Operation",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Charge pumps (inductorless)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "5 mm2: 1.6 x 2.9 (SOT-23|5)",
        "Package Group": "SOT-23|5",
        "\"Approx. price\n(USD)\"": "$0.326 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS60402": {
        "Description": "60mA Charge Pump Voltage Inverter with Fixed 50kHz Operation",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Charge pumps (inductorless)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "5 mm2: 1.6 x 2.9 (SOT-23|5)",
        "Package Group": "SOT-23|5",
        "\"Approx. price\n(USD)\"": "$0.326 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS60403": {
        "Description": "60mA Charge Pump Voltage Inverter with Fixed 250kHz Operation",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Charge pumps (inductorless)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "5 mm2: 1.6 x 2.9 (SOT-23|5)",
        "Package Group": "SOT-23|5",
        "\"Approx. price\n(USD)\"": "$0.326 | 1ku",
        "Status": "ACTIVE"
    },
    "LM3485": {
        "Description": "4.5-35V Hysteretic Non-Synchronous PFET Buck Controller",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck controllers (external switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "15 mm2: 4.9 x 3 (VSSOP|8)",
        "Package Group": "VSSOP|8",
        "\"Approx. price\n(USD)\"": "$0.510 | 1ku",
        "Status": "ACTIVE"
    },
    "LM3485-Q1": {
        "Description": "Automotive Grade 4.5-35V Hysteretic Non-Synchronous PFET Buck Controller",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck controllers (external switch)",
        "Rating": "Automotive",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "15 mm2: 4.9 x 3 (VSSOP|8)",
        "Package Group": "VSSOP|8",
        "\"Approx. price\n(USD)\"": "$0.602 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS54610": {
        "Description": "3V to 6V Input 6A Synchronous Step-Down Converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "43 mm2: 4.4 x 9.7 (HTSSOP|28)",
        "Package Group": "HTSSOP|28",
        "\"Approx. price\n(USD)\"": "$1.491 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS60204": {
        "Description": "Regulated 3.3V low ripple charge pump with low battery indicator",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Charge pumps (inductorless)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (VSSOP|10)",
        "Package Group": "VSSOP|10",
        "\"Approx. price\n(USD)\"": "$0.629 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS60205": {
        "Description": "Regulated 3.3V low ripple charge pump with power good indicator",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Charge pumps (inductorless)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (VSSOP|10)",
        "Package Group": "VSSOP|10",
        "\"Approx. price\n(USD)\"": "$0.629 | 1ku",
        "Status": "ACTIVE"
    },
    "REG710-25": {
        "Description": "30-mA Switched-Cap DC-DC Converter with fixed 2.5-V Output",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Charge pumps (inductorless)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "5 mm2: 1.6 x 2.9 (SOT-23|6)",
        "Package Group": "SOT-23|6",
        "\"Approx. price\n(USD)\"": "$0.458 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS60502": {
        "Description": "250-mA 1.8-V High-Efficiency Step-Down Charge Pump",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Charge pumps (inductorless)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (VSSOP|10)",
        "Package Group": "VSSOP|10",
        "\"Approx. price\n(USD)\"": "$0.427 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62000": {
        "Description": "Adjustable 600-mA 95% Efficient Step-Down Converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (VSSOP|10)",
        "Package Group": "VSSOP|10",
        "\"Approx. price\n(USD)\"": "$0.741 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62002": {
        "Description": "1.0-V Output 600-mA 95% Efficient Step-Down Converter in MSOP-10",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (VSSOP|10)",
        "Package Group": "VSSOP|10",
        "\"Approx. price\n(USD)\"": "$0.741 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62003": {
        "Description": "1.2-V Output 600-mA 95% Efficient Step-Down Converter in MSOP-10",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (VSSOP|10)",
        "Package Group": "VSSOP|10",
        "\"Approx. price\n(USD)\"": "$0.741 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62004": {
        "Description": "1.5-V Output 600-mA 95% Efficient Step-Down Converter in MSOP-10",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (VSSOP|10)",
        "Package Group": "VSSOP|10",
        "\"Approx. price\n(USD)\"": "$0.741 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62005": {
        "Description": "1.8-V Output 600-mA 95% Efficient Step-Down Converter in MSOP-10",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (VSSOP|10)",
        "Package Group": "VSSOP|10",
        "\"Approx. price\n(USD)\"": "$0.741 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62006": {
        "Description": "2.5-V Output 600-mA 95% Efficient Step-Down Converter in MSOP-10",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (VSSOP|10)",
        "Package Group": "VSSOP|10",
        "\"Approx. price\n(USD)\"": "$0.741 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62007": {
        "Description": "3.3-V Output 600-mA 95% Efficient Step-Down Converter in MSOP-10",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (VSSOP|10)",
        "Package Group": "VSSOP|10",
        "\"Approx. price\n(USD)\"": "$0.741 | 1ku",
        "Status": "ACTIVE"
    },
    "LM2590HV": {
        "Description": "SIMPLE SWITCHER Power Converter 150 KHz 1A Step-Down Voltage Regulator with Features",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "154 mm2: 15.24 x 10.1 (DDPAK/TO-263|7) 83 mm2: 8.13 x 10.16 (TO-220|7)",
        "Package Group": "DDPAK/TO-263|7 TO-220|7",
        "\"Approx. price\n(USD)\"": "$2.150 | 1ku",
        "Status": "ACTIVE"
    },
    "LM2591HV": {
        "Description": "SIMPLE SWITCHER Power Converter 150 kHz 1A Step-Down Voltage Regulator",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "155 mm2: 15.24 x 10.16 (DDPAK/TO-263|5) 86 mm2: 8.47 x 10.16 (TO-220|5)",
        "Package Group": "DDPAK/TO-263|5 TO-220|5",
        "\"Approx. price\n(USD)\"": "$2.200 | 1ku",
        "Status": "ACTIVE"
    },
    "LM2592HV": {
        "Description": "SIMPLE SWITCHER Power Converter 150 KHz 2A Step-Down Voltage Regulator",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "155 mm2: 15.24 x 10.16 (DDPAK/TO-263|5) 86 mm2: 8.47 x 10.16 (TO-220|5)",
        "Package Group": "DDPAK/TO-263|5 TO-220|5",
        "\"Approx. price\n(USD)\"": "$2.640 | 1ku",
        "Status": "ACTIVE"
    },
    "LM2700": {
        "Description": "600kHz/1.25MHz 2.5A step-up PWM DC/DC converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "32 mm2: 6.4 x 5 (TSSOP|14) 16 mm2: 4 x 4 (WSON|14)",
        "Package Group": "TSSOP|14 WSON|14",
        "\"Approx. price\n(USD)\"": "$1.650 | 1ku",
        "Status": "ACTIVE"
    },
    "LM2593HV": {
        "Description": "SIMPLE SWITCHER Power Converter 150 KHz 2A Step-Down Voltage Regulator with Features",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "154 mm2: 15.24 x 10.1 (DDPAK/TO-263|7) 83 mm2: 8.13 x 10.16 (TO-220|7)",
        "Package Group": "DDPAK/TO-263|7 TO-220|7",
        "\"Approx. price\n(USD)\"": "$2.805 | 1ku",
        "Status": "ACTIVE"
    },
    "LM2703": {
        "Description": "Micropower Step-Up DC/DC Converter with 350mA Peak Current Limit",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "5 mm2: 1.6 x 2.9 (SOT-23|5)",
        "Package Group": "SOT-23|5",
        "\"Approx. price\n(USD)\"": "$0.605 | 1ku",
        "Status": "ACTIVE"
    },
    "REG711-25": {
        "Description": "50mA Switched-Cap DC/DC Converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Charge pumps (inductorless)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "15 mm2: 4.9 x 3 (VSSOP|8)",
        "Package Group": "VSSOP|8",
        "\"Approx. price\n(USD)\"": "$0.377 | 1ku",
        "Status": "ACTIVE"
    },
    "REG711-3": {
        "Description": "50mA Switched-Cap DC/DC Converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Charge pumps (inductorless)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "15 mm2: 4.9 x 3 (VSSOP|8)",
        "Package Group": "VSSOP|8",
        "\"Approx. price\n(USD)\"": "$0.377 | 1ku",
        "Status": "ACTIVE"
    },
    "REG711-33": {
        "Description": "50mA Switched-Cap DC/DC Converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Charge pumps (inductorless)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "15 mm2: 4.9 x 3 (VSSOP|8)",
        "Package Group": "VSSOP|8",
        "\"Approx. price\n(USD)\"": "$0.377 | 1ku",
        "Status": "ACTIVE"
    },
    "REG711-5": {
        "Description": "50mA Switched-Cap DC/DC Converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Charge pumps (inductorless)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "15 mm2: 4.9 x 3 (VSSOP|8)",
        "Package Group": "VSSOP|8",
        "\"Approx. price\n(USD)\"": "$0.377 | 1ku",
        "Status": "ACTIVE"
    },
    "LM2611": {
        "Description": "1.4MHz Cuk Converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck-boost inverting & split-rail converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "5 mm2: 1.6 x 2.9 (SOT-23|5)",
        "Package Group": "SOT-23|5",
        "\"Approx. price\n(USD)\"": "$1.259 | 1ku",
        "Status": "ACTIVE"
    },
    "LM2698": {
        "Description": "SIMPLE SWITCHER&reg; 1.35A Boost Regulator",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "15 mm2: 4.9 x 3 (VSSOP|8)",
        "Package Group": "VSSOP|8",
        "\"Approx. price\n(USD)\"": "$1.646 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS5140": {
        "Description": "4.5-V to 28-V quad output buck controller for notebook power",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck controllers (external switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-20 to 85",
        "Package size: mm2:W x L (PKG)": "144 mm2: 12 x 12 (TQFP|64)",
        "Package Group": "TQFP|64",
        "\"Approx. price\n(USD)\"": "$3.659 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62100": {
        "Description": "Multimode 300kHz Synchronous Buck Converter with Adjustable Output",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "19 mm2: 3.91 x 4.9 (SOIC|8)",
        "Package Group": "SOIC|8",
        "\"Approx. price\n(USD)\"": "$1.045 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62101": {
        "Description": "Multimode 600kHz Synchronous Buck Converter with Adjustable Output",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "19 mm2: 3.91 x 4.9 (SOIC|8)",
        "Package Group": "SOIC|8",
        "\"Approx. price\n(USD)\"": "$1.045 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62102": {
        "Description": "Multimode 1MHz Synchronous Buck Converter with Adjustable Output",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "19 mm2: 3.91 x 4.9 (SOIC|8)",
        "Package Group": "SOIC|8",
        "\"Approx. price\n(USD)\"": "$1.045 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS62103": {
        "Description": "Multimode 2MHz Synchronous Buck Converter with Adjustable Output",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "19 mm2: 3.91 x 4.9 (SOIC|8)",
        "Package Group": "SOIC|8",
        "\"Approx. price\n(USD)\"": "$1.045 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS61010": {
        "Description": "Low Input Voltage Synchronous Boost Converter with Adjustable Output",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (VSSOP|10)",
        "Package Group": "VSSOP|10",
        "\"Approx. price\n(USD)\"": "$1.142 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS61012": {
        "Description": "Low Input Voltage Synchronous Boost Converter with Fixed 1.8V Output",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (VSSOP|10)",
        "Package Group": "VSSOP|10",
        "\"Approx. price\n(USD)\"": "$1.350 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS61013": {
        "Description": "Low Input Voltage Synchronous Boost Converter with Fixed 2.5V Output",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (VSSOP|10)",
        "Package Group": "VSSOP|10",
        "\"Approx. price\n(USD)\"": "$1.142 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS61014": {
        "Description": "Low Input Voltage Synchronous Boost Converter with Fixed 2.8V Output",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (VSSOP|10)",
        "Package Group": "VSSOP|10",
        "\"Approx. price\n(USD)\"": "$1.464 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS61015": {
        "Description": "Low Input Voltage Synchronous Boost Converter with Fixed 3.0V Output",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (VSSOP|10)",
        "Package Group": "VSSOP|10",
        "\"Approx. price\n(USD)\"": "$1.239 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS61016": {
        "Description": "Low Input Voltage Synchronous Boost Converter with Fixed 3.3V Output",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (VSSOP|10)",
        "Package Group": "VSSOP|10",
        "\"Approx. price\n(USD)\"": "$1.239 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS5120": {
        "Description": "4.5-V to 28-V dual-ouptut two-phase synchronous buck controller",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck controllers (external switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "34 mm2: 4.4 x 7.8 (TSSOP|30)",
        "Package Group": "TSSOP|30",
        "\"Approx. price\n(USD)\"": "$2.836 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS60124": {
        "Description": "Regulated 3.0-V High Efficiency Charge Pump With Low Battery Indicator",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Charge pumps (inductorless)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "42 mm2: 6.4 x 6.5 (HTSSOP|20)",
        "Package Group": "HTSSOP|20",
        "\"Approx. price\n(USD)\"": "$0.851 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS60125": {
        "Description": "Regulated 3.0-V High Efficiency Charge Pump With Power Good Indicator",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Charge pumps (inductorless)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "42 mm2: 6.4 x 6.5 (HTSSOP|20)",
        "Package Group": "HTSSOP|20",
        "\"Approx. price\n(USD)\"": "$0.774 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS61000": {
        "Description": "Low input voltage non-synchronous boost converter with adjustable output",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (VSSOP|10)",
        "Package Group": "VSSOP|10",
        "\"Approx. price\n(USD)\"": "$1.348 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS61002": {
        "Description": "Low input voltage non-synchronous boost converter with fixed 1.8-V output",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (VSSOP|10)",
        "Package Group": "VSSOP|10",
        "\"Approx. price\n(USD)\"": "$1.141 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS61005": {
        "Description": "Low input voltage non-synchronous boost converter with fixed 3.0-V output",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (VSSOP|10)",
        "Package Group": "VSSOP|10",
        "\"Approx. price\n(USD)\"": "$1.141 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS61006": {
        "Description": "Low input voltage non-synchronous boost converter with fixed 3.3-V output",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (VSSOP|10)",
        "Package Group": "VSSOP|10",
        "\"Approx. price\n(USD)\"": "$1.141 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS61007": {
        "Description": "Low input voltage boost converter with adjustable output with DGS package",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (VSSOP|10)",
        "Package Group": "VSSOP|10",
        "\"Approx. price\n(USD)\"": "$1.141 | 1ku",
        "Status": "ACTIVE"
    },
    "LM3488": {
        "Description": "2.97V to 40V Wide Vin Low-Side N-Channel Controller for Switching Regulators",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost controllers (external switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "15 mm2: 4.9 x 3 (VSSOP|8)",
        "Package Group": "VSSOP|8",
        "\"Approx. price\n(USD)\"": "$0.857 | 1ku",
        "Status": "ACTIVE"
    },
    "UCC39411": {
        "Description": "1.125V threshold low power synchronous boost converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "0 to 70",
        "Package size: mm2:W x L (PKG)": "19 mm2: 3.91 x 4.9 (SOIC|8) 19 mm2: 6.4 x 3 (TSSOP|8)",
        "Package Group": "SOIC|8 TSSOP|8",
        "\"Approx. price\n(USD)\"": "$2.225 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS60210": {
        "Description": "Regulated 3.3V 100mA low-battery detector low-ripple charge pump with Ultra low operating current",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Charge pumps (inductorless)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (VSSOP|10)",
        "Package Group": "VSSOP|10",
        "\"Approx. price\n(USD)\"": "$0.629 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS60211": {
        "Description": "Regulated 3.3V 100mA low-ripple charge pump with ultra low operating current",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Charge pumps (inductorless)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (VSSOP|10)",
        "Package Group": "VSSOP|10",
        "\"Approx. price\n(USD)\"": "$0.629 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS60212": {
        "Description": "Regulated 3.3V 50mA low battery detector low-ripple charge pump with ultra low operating current",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Charge pumps (inductorless)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (VSSOP|10)",
        "Package Group": "VSSOP|10",
        "\"Approx. price\n(USD)\"": "$0.629 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS60213": {
        "Description": "Regulated 3.3V 50mA low-ripple charge pump with ultra low operating current",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Charge pumps (inductorless)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (VSSOP|10)",
        "Package Group": "VSSOP|10",
        "\"Approx. price\n(USD)\"": "$0.629 | 1ku",
        "Status": "ACTIVE"
    },
    "LM2765": {
        "Description": "50-kHz switched capacitor voltage doubler",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Charge pumps (inductorless)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "5 mm2: 1.6 x 2.9 (SOT-23|6)",
        "Package Group": "SOT-23|6",
        "\"Approx. price\n(USD)\"": "$0.330 | 1ku",
        "Status": "ACTIVE"
    },
    "LM2766": {
        "Description": "200-kHz switched capacitor voltage doubler",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Charge pumps (inductorless)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "5 mm2: 1.6 x 2.9 (SOT-23|6)",
        "Package Group": "SOT-23|6",
        "\"Approx. price\n(USD)\"": "$0.330 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS60200": {
        "Description": "Regulated 3.3V 100mA low ripple charge pump with low battery indicator",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Charge pumps (inductorless)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (VSSOP|10)",
        "Package Group": "VSSOP|10",
        "\"Approx. price\n(USD)\"": "$0.629 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS60201": {
        "Description": "Regulated 3.3V 100mA low ripple charge pump with power good indicator",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Charge pumps (inductorless)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (VSSOP|10)",
        "Package Group": "VSSOP|10",
        "\"Approx. price\n(USD)\"": "$0.629 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS60202": {
        "Description": "Regulated 3.3V 50mA low ripple charge pump with low battery indicator",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Charge pumps (inductorless)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (VSSOP|10)",
        "Package Group": "VSSOP|10",
        "\"Approx. price\n(USD)\"": "$0.629 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS60203": {
        "Description": "Regulated 3.3V 50mA low ripple charge pump with power good indicator",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Charge pumps (inductorless)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "9 mm2: 3 x 3 (VSSOP|10)",
        "Package Group": "VSSOP|10",
        "\"Approx. price\n(USD)\"": "$0.629 | 1ku",
        "Status": "ACTIVE"
    },
    "LM3477": {
        "Description": "High Efficiency High-Side N-Channel Controller for Switching Regulator",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck controllers (external switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "15 mm2: 4.9 x 3 (VSSOP|8)",
        "Package Group": "VSSOP|8",
        "\"Approx. price\n(USD)\"": "$0.823 | 1ku",
        "Status": "ACTIVE"
    },
    "LM3478": {
        "Description": "2.97~40V Wide Input Range Boost/SEPIC/Flyback DC-DC Controller",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost controllers (external switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "19 mm2: 3.91 x 4.9 (SOIC|8) 15 mm2: 4.9 x 3 (VSSOP|8)",
        "Package Group": "SOIC|8 VSSOP|8",
        "\"Approx. price\n(USD)\"": "$0.876 | 1ku",
        "Status": "ACTIVE"
    },
    "LM2622": {
        "Description": "600kHz/1.3MHz Step-up PWM DC/DC Converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "15 mm2: 4.9 x 3 (VSSOP|8)",
        "Package Group": "VSSOP|8",
        "\"Approx. price\n(USD)\"": "$0.755 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS60140": {
        "Description": "Regulated 5-V Charge Pump Voltage Tripler With Low Battery Indicator",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Charge pumps (inductorless)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "42 mm2: 6.4 x 6.5 (HTSSOP|20)",
        "Package Group": "HTSSOP|20",
        "\"Approx. price\n(USD)\"": "$0.692 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS60141": {
        "Description": "Regulated 5-V Charge Pump Voltage Tripler With Power Good Indicator",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Charge pumps (inductorless)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "42 mm2: 6.4 x 6.5 (HTSSOP|20)",
        "Package Group": "HTSSOP|20",
        "\"Approx. price\n(USD)\"": "$0.692 | 1ku",
        "Status": "ACTIVE"
    },
    "LM2655": {
        "Description": "2.5A High Efficiency Synchronous Switching Regulator",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "22 mm2: 4.4 x 5 (TSSOP|16)",
        "Package Group": "TSSOP|16",
        "\"Approx. price\n(USD)\"": "$1.577 | 1ku",
        "Status": "ACTIVE"
    },
    "LM2767": {
        "Description": "11-kHz switched capacitor voltage doubler",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Charge pumps (inductorless)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "5 mm2: 1.6 x 2.9 (SOT-23|5)",
        "Package Group": "SOT-23|5",
        "\"Approx. price\n(USD)\"": "$0.287 | 1ku",
        "Status": "ACTIVE"
    },
    "LM2677": {
        "Description": "SIMPLE SWITCHER High Efficiency 5A Step-Down Voltage Regulator with Sync",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "154 mm2: 15.24 x 10.1 (DDPAK/TO-263|7) 83 mm2: 8.13 x 10.16 (TO-220|7) 30 mm2: 5 x 6 (VSON|14)",
        "Package Group": "DDPAK/TO-263|7 TO-220|7 VSON|14",
        "\"Approx. price\n(USD)\"": "$2.475 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS60120": {
        "Description": "Regulated 3.3V high efficiency charge pump DC/DC converter with low-battery detector",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Charge pumps (inductorless)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "42 mm2: 6.4 x 6.5 (HTSSOP|20)",
        "Package Group": "HTSSOP|20",
        "\"Approx. price\n(USD)\"": "$0.851 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS60121": {
        "Description": "Regulated 3.3V high efficiency charge pump DC/DC converter with power-good detector",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Charge pumps (inductorless)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "42 mm2: 6.4 x 6.5 (HTSSOP|20)",
        "Package Group": "HTSSOP|20",
        "\"Approx. price\n(USD)\"": "$1.022 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS60122": {
        "Description": "Regulated 100mA 3.3V high efficiency charge pump DC/DC converter with low-battery detector",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Charge pumps (inductorless)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "42 mm2: 6.4 x 6.5 (HTSSOP|20)",
        "Package Group": "HTSSOP|20",
        "\"Approx. price\n(USD)\"": "$0.692 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS60123": {
        "Description": "Regulated 100 mA 3.3V high efficiency charge pump DC/DC converter with power-good detector",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Charge pumps (inductorless)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "42 mm2: 6.4 x 6.5 (HTSSOP|20)",
        "Package Group": "HTSSOP|20",
        "\"Approx. price\n(USD)\"": "$0.692 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS60130": {
        "Description": "3 cell to regulated 5V 300mA high efficiency charge pump with low battery comparator",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Charge pumps (inductorless)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "42 mm2: 6.4 x 6.5 (HTSSOP|20)",
        "Package Group": "HTSSOP|20",
        "\"Approx. price\n(USD)\"": "$0.851 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS60131": {
        "Description": "3 cell to regulated 5V 300mA high efficiency charge pump with power-good comparator",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Charge pumps (inductorless)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "42 mm2: 6.4 x 6.5 (HTSSOP|20)",
        "Package Group": "HTSSOP|20",
        "\"Approx. price\n(USD)\"": "$0.851 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS60132": {
        "Description": "3 cell to regulated 5V 150mA high efficiency charge pump with low battery comparator",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Charge pumps (inductorless)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "42 mm2: 6.4 x 6.5 (HTSSOP|20)",
        "Package Group": "HTSSOP|20",
        "\"Approx. price\n(USD)\"": "$0.746 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS60133": {
        "Description": "3 cell to regulated 5V 150mA high efficiency charge pump with power-good comparator",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Charge pumps (inductorless)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "42 mm2: 6.4 x 6.5 (HTSSOP|20)",
        "Package Group": "HTSSOP|20",
        "\"Approx. price\n(USD)\"": "$0.746 | 1ku",
        "Status": "ACTIVE"
    },
    "LM2695": {
        "Description": "High Voltage (30V 1.25A) Step Down Switching Regulator",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "22 mm2: 4.4 x 5 (HTSSOP|14) 16 mm2: 4 x 4 (WSON|10)",
        "Package Group": "HTSSOP|14 WSON|10",
        "\"Approx. price\n(USD)\"": "$1.355 | 1ku",
        "Status": "ACTIVE"
    },
    "LM2682": {
        "Description": "Switched Capacitor Voltage Doubling Inverter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Charge pumps (inductorless)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "15 mm2: 4.9 x 3 (VSSOP|8)",
        "Package Group": "VSSOP|8",
        "\"Approx. price\n(USD)\"": "$0.585 | 1ku",
        "Status": "ACTIVE"
    },
    "TL5001AM": {
        "Description": "PWM Controller with wide input range with ±3% tolerance on reference operation –55°C to 125°C",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost controllers (external switch)",
        "Rating": "Military",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-55 to 125",
        "Package size: mm2:W x L (PKG)": "64 mm2: 6.67 x 9.6 (CDIP|8) 79 mm2: 8.89 x 8.89 (LCCC|20)",
        "Package Group": "CDIP|8 LCCC|20",
        "\"Approx. price\n(USD)\"": "$12.489 | 100u",
        "Status": "ACTIVE"
    },
    "TL5001M": {
        "Description": "PWM Controller with wide input range with ±5% tolerance on reference operation –55°C to 125°C",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost controllers (external switch)",
        "Rating": "Military",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-55 to 125",
        "Package size: mm2:W x L (PKG)": "64 mm2: 6.67 x 9.6 (CDIP|8)",
        "Package Group": "CDIP|8",
        "\"Approx. price\n(USD)\"": "$8.910 | 100u",
        "Status": "ACTIVE"
    },
    "TPS60100": {
        "Description": "Regulated 200mA 3.3V high power low noise charge pump DC/DC converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Charge pumps (inductorless)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "42 mm2: 6.4 x 6.5 (HTSSOP|20)",
        "Package Group": "HTSSOP|20",
        "\"Approx. price\n(USD)\"": "$0.851 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS60101": {
        "Description": "Regulated 100mA 3.3V high power low noise charge pump DC/DC converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Charge pumps (inductorless)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "42 mm2: 6.4 x 6.5 (HTSSOP|20)",
        "Package Group": "HTSSOP|20",
        "\"Approx. price\n(USD)\"": "$0.692 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS60110": {
        "Description": "3 cell to regulated 5V 300-mA low noise charge pump",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Charge pumps (inductorless)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "42 mm2: 6.4 x 6.5 (HTSSOP|20)",
        "Package Group": "HTSSOP|20",
        "\"Approx. price\n(USD)\"": "$0.851 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS60111": {
        "Description": "3 cell to regulated 5V 150-mA low noise charge pump",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Charge pumps (inductorless)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "42 mm2: 6.4 x 6.5 (HTSSOP|20)",
        "Package Group": "HTSSOP|20",
        "\"Approx. price\n(USD)\"": "$0.746 | 1ku",
        "Status": "ACTIVE"
    },
    "LM2653": {
        "Description": "1.5A High Efficiency Synchronous Switching Regulator",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "22 mm2: 4.4 x 5 (TSSOP|16)",
        "Package Group": "TSSOP|16",
        "\"Approx. price\n(USD)\"": "$1.526 | 1ku",
        "Status": "ACTIVE"
    },
    "LM828": {
        "Description": "Switched Capacitor Voltage Converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Charge pumps (inductorless)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "5 mm2: 1.6 x 2.9 (SOT-23|5)",
        "Package Group": "SOT-23|5",
        "\"Approx. price\n(USD)\"": "$0.280 | 1ku",
        "Status": "ACTIVE"
    },
    "MAX660": {
        "Description": "10 kHz/80 kHz switched capacitor voltage converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Charge pumps (inductorless)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "19 mm2: 3.91 x 4.9 (SOIC|8)",
        "Package Group": "SOIC|8",
        "\"Approx. price\n(USD)\"": "$0.495 | 1ku",
        "Status": "ACTIVE"
    },
    "LM2681": {
        "Description": "20-mA switched capacitor voltage doubler",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Charge pumps (inductorless)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "5 mm2: 1.6 x 2.9 (SOT-23|6)",
        "Package Group": "SOT-23|6",
        "\"Approx. price\n(USD)\"": "$0.330 | 1ku",
        "Status": "ACTIVE"
    },
    "UCC29421": {
        "Description": "High frequency multimode synchronous controller",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost controllers (external switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "22 mm2: 4.4 x 5 (TSSOP|16)",
        "Package Group": "TSSOP|16",
        "\"Approx. price\n(USD)\"": "$3.747 | 1ku",
        "Status": "ACTIVE"
    },
    "LM2670": {
        "Description": "SIMPLE SWITCHER High Efficiency 3A Step-Down Voltage Regulator with Sync",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "154 mm2: 15.24 x 10.1 (DDPAK/TO-263|7) 83 mm2: 8.13 x 10.16 (TO-220|7) 30 mm2: 5 x 6 (VSON|14)",
        "Package Group": "DDPAK/TO-263|7 TO-220|7 VSON|14",
        "\"Approx. price\n(USD)\"": "$2.035 | 1ku",
        "Status": "ACTIVE"
    },
    "LM2594HV": {
        "Description": "SIMPLE SWITCHER Power Converter 150 kHz 0.5A Step-Down Voltage Regulator",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "93 mm2: 9.43 x 9.81 (PDIP|8) 19 mm2: 3.91 x 4.9 (SOIC|8)",
        "Package Group": "PDIP|8 SOIC|8",
        "\"Approx. price\n(USD)\"": "$1.943 | 1ku",
        "Status": "ACTIVE"
    },
    "LM2678": {
        "Description": "8V to 40V 5A SIMPLE SWITCHER® buck converter with high efficiency",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "154 mm2: 15.24 x 10.1 (DDPAK/TO-263|7) 83 mm2: 8.13 x 10.16 (TO-220|7) 30 mm2: 5 x 6 (VSON|14)",
        "Package Group": "DDPAK/TO-263|7 TO-220|7 VSON|14",
        "\"Approx. price\n(USD)\"": "$2.310 | 1ku",
        "Status": "ACTIVE"
    },
    "LM2679": {
        "Description": "SIMPLE SWITCHER® 8V to 40V 5A Step-Down DC/DC Switching Regulator with Adjustable Current Limit",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "154 mm2: 15.24 x 10.1 (DDPAK/TO-263|7) 83 mm2: 8.13 x 10.16 (TO-220|7) 30 mm2: 5 x 6 (VSON|14)",
        "Package Group": "DDPAK/TO-263|7 TO-220|7 VSON|14",
        "\"Approx. price\n(USD)\"": "$2.481 | 1ku",
        "Status": "ACTIVE"
    },
    "LM2621": {
        "Description": "1.2V to 14V input voltage 1A load current step-up DC-DC",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "15 mm2: 4.9 x 3 (VSSOP|8)",
        "Package Group": "VSSOP|8",
        "\"Approx. price\n(USD)\"": "$0.783 | 1ku",
        "Status": "ACTIVE"
    },
    "LM2664": {
        "Description": "1.8-V to 5.5-VIN switched capacitor voltage inverter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Charge pumps (inductorless)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "5 mm2: 1.6 x 2.9 (SOT-23|6)",
        "Package Group": "SOT-23|6",
        "\"Approx. price\n(USD)\"": "$0.264 | 1ku",
        "Status": "ACTIVE"
    },
    "LM2665": {
        "Description": "1.8-V to 5.5-VIN switched capacitor voltage doubler",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Charge pumps (inductorless)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "5 mm2: 1.6 x 2.9 (SOT-23|6)",
        "Package Group": "SOT-23|6",
        "\"Approx. price\n(USD)\"": "$0.165 | 1ku",
        "Status": "ACTIVE"
    },
    "LM2597HV": {
        "Description": "SIMPLE SWITCHER Power Converter 150 kHz 0.5A Step-Down Voltage Regulator with Features",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "93 mm2: 9.43 x 9.81 (PDIP|8) 19 mm2: 3.91 x 4.9 (SOIC|8)",
        "Package Group": "PDIP|8 SOIC|8",
        "\"Approx. price\n(USD)\"": "$2.090 | 1ku",
        "Status": "ACTIVE"
    },
    "LM2671": {
        "Description": "8V to 40V 500mA SIMPLE SWITCHER® buck converter with 5 external components",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "93 mm2: 9.43 x 9.81 (PDIP|8) 19 mm2: 3.91 x 4.9 (SOIC|8) 25 mm2: 5 x 5 (WSON|16)",
        "Package Group": "PDIP|8 SOIC|8 WSON|16",
        "\"Approx. price\n(USD)\"": "$1.430 | 1ku",
        "Status": "ACTIVE"
    },
    "LM2674": {
        "Description": "SIMPLE SWITCHER&reg; 40V 500mA Low Component Count Step-Down Regulator",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "93 mm2: 9.43 x 9.81 (PDIP|8) 19 mm2: 3.91 x 4.9 (SOIC|8) 25 mm2: 5 x 5 (WSON|16)",
        "Package Group": "PDIP|8 SOIC|8 WSON|16",
        "\"Approx. price\n(USD)\"": "$1.320 | 1ku",
        "Status": "ACTIVE"
    },
    "LM2663": {
        "Description": "200mA switched capacitor voltage converter with low current shutdown mode",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Charge pumps (inductorless)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "19 mm2: 3.91 x 4.9 (SOIC|8)",
        "Package Group": "SOIC|8",
        "\"Approx. price\n(USD)\"": "$0.730 | 1ku",
        "Status": "ACTIVE"
    },
    "LM2662": {
        "Description": "200mA switched capacitor voltage converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Charge pumps (inductorless)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "19 mm2: 3.91 x 4.9 (SOIC|8)",
        "Package Group": "SOIC|8",
        "\"Approx. price\n(USD)\"": "$0.605 | 1ku",
        "Status": "ACTIVE"
    },
    "LM2675": {
        "Description": "SIMPLE SWITCHER&reg; 6.5V to 40V 1A Low Component Count Step-Down Regulator",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "93 mm2: 9.43 x 9.81 (PDIP|8) 19 mm2: 3.91 x 4.9 (SOIC|8) 25 mm2: 5 x 5 (WSON|16)",
        "Package Group": "PDIP|8 SOIC|8 WSON|16",
        "\"Approx. price\n(USD)\"": "$1.760 | 1ku",
        "Status": "ACTIVE"
    },
    "LM2660": {
        "Description": "100mA switched capacitor voltage converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Charge pumps (inductorless)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "19 mm2: 3.91 x 4.9 (SOIC|8) 15 mm2: 4.9 x 3 (VSSOP|8)",
        "Package Group": "SOIC|8 VSSOP|8",
        "\"Approx. price\n(USD)\"": "$0.490 | 1ku",
        "Status": "ACTIVE"
    },
    "LM2650": {
        "Description": "Synchronous Step-Down DC/DC Converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "160 mm2: 10.3 x 15.5 (SOIC|24)",
        "Package Group": "SOIC|24",
        "\"Approx. price\n(USD)\"": "$3.677 | 1ku",
        "Status": "ACTIVE"
    },
    "LM2651": {
        "Description": "1.5A High Efficiency Switching Regulator",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "22 mm2: 4.4 x 5 (TSSOP|16)",
        "Package Group": "TSSOP|16",
        "\"Approx. price\n(USD)\"": "$1.424 | 1ku",
        "Status": "ACTIVE"
    },
    "LM2673": {
        "Description": "8V to 40V 3A SIMPLE SWITCHER® buck converter with adjustable current limit",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "154 mm2: 15.24 x 10.1 (DDPAK/TO-263|7) 83 mm2: 8.13 x 10.16 (TO-220|7) 30 mm2: 5 x 6 (VSON|14)",
        "Package Group": "DDPAK/TO-263|7 TO-220|7 VSON|14",
        "\"Approx. price\n(USD)\"": "$1.943 | 1ku",
        "Status": "ACTIVE"
    },
    "LM2672": {
        "Description": "SIMPLE SWITCHER&reg; 6.5V to 40V 1A Low Component Count Step-Down Regulator",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "93 mm2: 9.43 x 9.81 (PDIP|8) 19 mm2: 3.91 x 4.9 (SOIC|8) 25 mm2: 5 x 5 (WSON|16)",
        "Package Group": "PDIP|8 SOIC|8 WSON|16",
        "\"Approx. price\n(USD)\"": "$1.733 | 1ku",
        "Status": "ACTIVE"
    },
    "TPS6735": {
        "Description": "Fixed Negative 5-V 200-MA Inverting DC/DC Converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck-boost inverting & split-rail converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "93 mm2: 9.43 x 9.81 (PDIP|8) 19 mm2: 3.91 x 4.9 (SOIC|8)",
        "Package Group": "PDIP|8 SOIC|8",
        "\"Approx. price\n(USD)\"": "$1.638 | 1ku",
        "Status": "ACTIVE"
    },
    "LM2586": {
        "Description": "4-V to 40-V 3-A step-up wide VIN flyback regulator with frequency synchronization",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "154 mm2: 15.24 x 10.1 (DDPAK/TO-263|7) 83 mm2: 8.13 x 10.16 (TO-220|7)",
        "Package Group": "DDPAK/TO-263|7 TO-220|7",
        "\"Approx. price\n(USD)\"": "$3.301 | 1ku",
        "Status": "ACTIVE"
    },
    "LM2585": {
        "Description": "4-V to 40-V 3-A step-up wide VIN flyback regulator",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "155 mm2: 15.24 x 10.16 (DDPAK/TO-263|5) 86 mm2: 8.47 x 10.16 (TO-220|5)",
        "Package Group": "DDPAK/TO-263|5 TO-220|5",
        "\"Approx. price\n(USD)\"": "$3.438 | 1ku",
        "Status": "ACTIVE"
    },
    "LM2598": {
        "Description": "4.5V to 40V 1A SIMPLE SWITCHER® buck converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "154 mm2: 15.24 x 10.1 (DDPAK/TO-263|7) 83 mm2: 8.13 x 10.16 (TO-220|7)",
        "Package Group": "DDPAK/TO-263|7 TO-220|7",
        "\"Approx. price\n(USD)\"": "$1.377 | 1ku",
        "Status": "ACTIVE"
    },
    "LM2595": {
        "Description": "SIMPLE SWITCHER Power Converter 150 KHz 1A Step-Down Voltage Regulator",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "155 mm2: 15.24 x 10.16 (DDPAK/TO-263|5) 86 mm2: 8.47 x 10.16 (TO-220|5)",
        "Package Group": "DDPAK/TO-263|5 TO-220|5",
        "\"Approx. price\n(USD)\"": "$1.760 | 1ku",
        "Status": "ACTIVE"
    },
    "LM2676": {
        "Description": "SIMPLE SWITCHER&reg; 8V to 40V 3A Low Component Count Step-Down Regulator",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "154 mm2: 15.24 x 10.1 (DDPAK/TO-263|7) 83 mm2: 8.13 x 10.16 (TO-220|7) 30 mm2: 5 x 6 (VSON|14)",
        "Package Group": "DDPAK/TO-263|7 TO-220|7 VSON|14",
        "\"Approx. price\n(USD)\"": "$1.980 | 1ku",
        "Status": "ACTIVE"
    },
    "LM2596": {
        "Description": "SIMPLE SWITCHER&reg; 4.5V to 40V 3A Low Component Count Step-Down Regulator",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "155 mm2: 15.24 x 10.16 (DDPAK/TO-263|5) 86 mm2: 8.47 x 10.16 (TO-220|5)",
        "Package Group": "DDPAK/TO-263|5 TO-220|5",
        "\"Approx. price\n(USD)\"": "$2.178 | 1ku",
        "Status": "ACTIVE"
    },
    "LM2599": {
        "Description": "SIMPLE SWITCHER Power Converter 150 KHz 3A Step-Down Voltage Regulator with Features",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "154 mm2: 15.24 x 10.1 (DDPAK/TO-263|7) 83 mm2: 8.13 x 10.16 (TO-220|7)",
        "Package Group": "DDPAK/TO-263|7 TO-220|7",
        "\"Approx. price\n(USD)\"": "$2.255 | 1ku",
        "Status": "ACTIVE"
    },
    "UC2572": {
        "Description": "Negative output Flyback pulse width modulator",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost controllers (external switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "19 mm2: 3.91 x 4.9 (SOIC|8)",
        "Package Group": "SOIC|8",
        "\"Approx. price\n(USD)\"": "$1.343 | 1ku",
        "Status": "ACTIVE"
    },
    "UC2573": {
        "Description": "Buck Pulse Width Modulator Stepdown Voltage Regulator",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck controllers (external switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "19 mm2: 3.91 x 4.9 (SOIC|8)",
        "Package Group": "SOIC|8",
        "\"Approx. price\n(USD)\"": "$1.166 | 1ku",
        "Status": "ACTIVE"
    },
    "LM2597": {
        "Description": "SIMPLE SWITCHER Power Converter 150 kHz 0.5A Step-Down Voltage Regulator",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "93 mm2: 9.43 x 9.81 (PDIP|8) 19 mm2: 3.91 x 4.9 (SOIC|8)",
        "Package Group": "PDIP|8 SOIC|8",
        "\"Approx. price\n(USD)\"": "$1.650 | 1ku",
        "Status": "ACTIVE"
    },
    "LM2594": {
        "Description": "SIMPLE SWITCHER&reg; 40V 500mA Low Component Count Step-Down Regulator",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "93 mm2: 9.43 x 9.81 (PDIP|8) 19 mm2: 3.91 x 4.9 (SOIC|8)",
        "Package Group": "PDIP|8 SOIC|8",
        "\"Approx. price\n(USD)\"": "$1.320 | 1ku",
        "Status": "ACTIVE"
    },
    "LM2588": {
        "Description": "4-V to 40-V 5-A step-up wide VIN flyback regulator with frequency synchronization",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "154 mm2: 15.24 x 10.1 (DDPAK/TO-263|7) 83 mm2: 8.13 x 10.16 (TO-220|7)",
        "Package Group": "DDPAK/TO-263|7 TO-220|7",
        "\"Approx. price\n(USD)\"": "$4.525 | 1ku",
        "Status": "ACTIVE"
    },
    "LM2587": {
        "Description": "4V to 40V 5A Step-Up Wide Vin Flyback Regulator",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "155 mm2: 15.24 x 10.16 (DDPAK/TO-263|5) 86 mm2: 8.47 x 10.16 (TO-220|5)",
        "Package Group": "DDPAK/TO-263|5 TO-220|5",
        "\"Approx. price\n(USD)\"": "$4.946 | 1ku",
        "Status": "ACTIVE"
    },
    "TL5001": {
        "Description": "PWM Controller with wide input range with ±5% tolerance on reference operation –20°C to 85°C",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost controllers (external switch)",
        "Rating": "\"Automotive\nCatalog\"",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "\"-25 to 85\n-40 to 125\n-40 to 85\"",
        "Package size: mm2:W x L (PKG)": "93 mm2: 9.43 x 9.81 (PDIP|8) 48 mm2: 7.8 x 6.2 (SO|8) 19 mm2: 3.91 x 4.9 (SOIC|8)",
        "Package Group": "PDIP|8 SOIC|8 SO|8",
        "\"Approx. price\n(USD)\"": "$0.585 | 1ku",
        "Status": "ACTIVE"
    },
    "TL5001A": {
        "Description": "PWM Controller with wide input range with ±3% tolerance on reference operation –20°C to 85°C",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost controllers (external switch)",
        "Rating": "\"Automotive\nCatalog\"",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "\"-20 to 85\n-40 to 125\n-40 to 85\"",
        "Package size: mm2:W x L (PKG)": "93 mm2: 9.43 x 9.81 (PDIP|8) 19 mm2: 3.91 x 4.9 (SOIC|8)",
        "Package Group": "PDIP|8 SOIC|8",
        "\"Approx. price\n(USD)\"": "$0.754 | 1ku",
        "Status": "ACTIVE"
    },
    "LM2574": {
        "Description": "8V to 40V 500mA SIMPLE SWITCHER® buck converter with 4 external components",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "93 mm2: 9.43 x 9.81 (PDIP|8) 93 mm2: 10.325 x 8.9915 (SOIC|14)",
        "Package Group": "PDIP|8 SOIC|14",
        "\"Approx. price\n(USD)\"": "$1.007 | 1ku",
        "Status": "ACTIVE"
    },
    "LM2574HV": {
        "Description": "SIMPLE SWITCHER 0.5A Step-Down Voltage Regulator",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "93 mm2: 9.43 x 9.81 (PDIP|8) 93 mm2: 10.325 x 8.9915 (SOIC|14)",
        "Package Group": "PDIP|8 SOIC|14",
        "\"Approx. price\n(USD)\"": "$1.595 | 1ku",
        "Status": "ACTIVE"
    },
    "LM2575": {
        "Description": "1-A Simple Step-Down Adjustable Voltage Switching Regulator with Output Enable",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "181 mm2: 9.4 x 19.3 (PDIP|16)",
        "Package Group": "PDIP|16",
        "\"Approx. price\n(USD)\"": "$0.751 | 1ku",
        "Status": "ACTIVE"
    },
    "LM2576": {
        "Description": "SIMPLE SWITCHER&reg; 40V 3A Low Component Count Step-Down Regulator",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "155 mm2: 15.24 x 10.16 (DDPAK/TO-263|5) 86 mm2: 8.47 x 10.16 (TO-220|5) 86 mm2: 8.51 x 10.16 (TO-220|5)",
        "Package Group": "DDPAK/TO-263|5 TO-220|5 TO-220|5",
        "\"Approx. price\n(USD)\"": "$1.313 | 1ku",
        "Status": "ACTIVE"
    },
    "LM2576HV": {
        "Description": "SIMPLE SWITCHER&reg; 4V to 60V 3A Low Component Count Step-Down Regulator",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "155 mm2: 15.24 x 10.16 (DDPAK/TO-263|5) 86 mm2: 8.47 x 10.16 (TO-220|5) 86 mm2: 8.51 x 10.16 (TO-220|5)",
        "Package Group": "DDPAK/TO-263|5 TO-220|5 TO-220|5",
        "\"Approx. price\n(USD)\"": "$2.816 | 1ku",
        "Status": "ACTIVE"
    },
    "LM2577": {
        "Description": "3.5-V to 40-V 3-A low component count step-up regulator",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "155 mm2: 15.24 x 10.16 (DDPAK/TO-263|5) 86 mm2: 8.47 x 10.16 (TO-220|5) 86 mm2: 8.51 x 10.16 (TO-220|5)",
        "Package Group": "DDPAK/TO-263|5 TO-220|5 TO-220|5",
        "\"Approx. price\n(USD)\"": "$3.161 | 1ku",
        "Status": "ACTIVE"
    },
    "LT1054": {
        "Description": "3.5 V to 15 VIN 100-mA output current switched-capacitor voltage converters with regulator",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Charge pumps (inductorless)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "\"-40 to 85\n0 to 70\"",
        "Package size: mm2:W x L (PKG)": "93 mm2: 9.43 x 9.81 (PDIP|8) 77 mm2: 7.5 x 10.3 (SOIC|16)",
        "Package Group": "PDIP|8 SOIC|16",
        "\"Approx. price\n(USD)\"": "$0.726 | 1ku",
        "Status": "ACTIVE"
    },
    "TL497A": {
        "Description": "500-mA Peak Step-Up Step-Down Inverting Switching Voltage Regulator",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "\"-40 to 85\n0 to 70\"",
        "Package size: mm2:W x L (PKG)": "181 mm2: 9.4 x 19.3 (PDIP|14) 80 mm2: 7.8 x 10.2 (SO|14) 52 mm2: 6 x 8.65 (SOIC|14) 32 mm2: 6.4 x 5 (TSSOP|14)",
        "Package Group": "PDIP|14 SOIC|14 SO|14 TSSOP|14",
        "\"Approx. price\n(USD)\"": "$0.606 | 1ku",
        "Status": "ACTIVE"
    },
    "TL499A": {
        "Description": "Wide-Range Power-Supply Controller",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-20 to 85",
        "Package size: mm2:W x L (PKG)": "93 mm2: 9.43 x 9.81 (PDIP|8) 48 mm2: 7.8 x 6.2 (SO|8)",
        "Package Group": "PDIP|8 SO|8",
        "\"Approx. price\n(USD)\"": "$0.877 | 1ku",
        "Status": "ACTIVE"
    },
    "LM2575-N": {
        "Description": "SIMPLE SWITCHER 1A Step-Down Voltage Regulator",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "155 mm2: 15.24 x 10.16 (DDPAK/TO-263|5) 160 mm2: 10.3 x 15.5 (SOIC|24) 86 mm2: 8.47 x 10.16 (TO-220|5) 86 mm2: 8.51 x 10.16 (TO-220|5)",
        "Package Group": "DDPAK/TO-263|5 SOIC|24 TO-220|5 TO-220|5",
        "\"Approx. price\n(USD)\"": "$1.116 | 1ku",
        "Status": "ACTIVE"
    },
    "LM2575HV": {
        "Description": "SIMPLE SWITCHER 1A Step-Down Voltage Regulator",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "155 mm2: 15.24 x 10.16 (DDPAK/TO-263|5) 86 mm2: 8.47 x 10.16 (TO-220|5) 86 mm2: 8.51 x 10.16 (TO-220|5)",
        "Package Group": "DDPAK/TO-263|5 TO-220|5 TO-220|5",
        "\"Approx. price\n(USD)\"": "$1.890 | 1ku",
        "Status": "ACTIVE"
    },
    "TL1451": {
        "Description": "Dual Pulse-Width-Modulation Control Circuit",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost controllers (external switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-20 to 85",
        "Package size: mm2:W x L (PKG)": "181 mm2: 9.4 x 19.3 (PDIP|16) 55 mm2: 5.3 x 10.3 (SO|16) 80 mm2: 7.8 x 10.2 (SO|16)",
        "Package Group": "PDIP|16 SO|16 SO|16",
        "\"Approx. price\n(USD)\"": "$0.703 | 1ku",
        "Status": "ACTIVE"
    },
    "TL1451A": {
        "Description": "3.6V to 50V dual channel  controller with Wide input voltage range",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost controllers (external switch)",
        "Rating": "\"Automotive\nCatalog\"",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "\"-20 to 85\n-40 to 125\"",
        "Package size: mm2:W x L (PKG)": "181 mm2: 9.4 x 19.3 (PDIP|16) 55 mm2: 5.3 x 10.3 (SO|16) 80 mm2: 7.8 x 10.2 (SO|16) 59 mm2: 6 x 9.9 (SOIC|16) 33 mm2: 5.3 x 6.2 (SSOP|16) 22 mm2: 4.4 x 5 (TSSOP|16)",
        "Package Group": "PDIP|16 SOIC|16 SO|16 SO|16 SSOP|16 TSSOP|16",
        "\"Approx. price\n(USD)\"": "$0.645 | 1ku",
        "Status": "ACTIVE"
    },
    "LMC7660": {
        "Description": "1.5-V to 10-V switched capacitor voltage converter",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Charge pumps (inductorless)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 85",
        "Package size: mm2:W x L (PKG)": "93 mm2: 9.43 x 9.81 (PDIP|8) 19 mm2: 3.91 x 4.9 (SOIC|8)",
        "Package Group": "PDIP|8 SOIC|8",
        "\"Approx. price\n(USD)\"": "$0.410 | 1ku",
        "Status": "ACTIVE"
    },
    "LM2578A": {
        "Description": "Switching Regulator",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Buck converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "-40 to 125",
        "Package size: mm2:W x L (PKG)": "93 mm2: 9.43 x 9.81 (PDIP|8) 19 mm2: 3.91 x 4.9 (SOIC|8)",
        "Package Group": "PDIP|8 SOIC|8",
        "\"Approx. price\n(USD)\"": "$1.375 | 1ku",
        "Status": "ACTIVE"
    },
    "LM3578A": {
        "Description": "2-V to 40-VIN switching regulators in buck boost terminal depending upon the application",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "0 to 125",
        "Package size: mm2:W x L (PKG)": "93 mm2: 9.43 x 9.81 (PDIP|8) 19 mm2: 3.91 x 4.9 (SOIC|8)",
        "Package Group": "PDIP|8 SOIC|8",
        "\"Approx. price\n(USD)\"": "$0.627 | 1ku",
        "Status": "ACTIVE"
    },
    "LM78S40": {
        "Description": "1.5A Adjustable Step Up Step Down or Inverting Regulator",
        "Ordering & quality": "Ordering & quality",
        "SubFamily": "Boost converters (integrated switch)",
        "Rating": "Catalog",
        "TI functional safety category": " --- ",
        "\"Operating temperature range\n(C)\"": "0 to 70",
        "Package size: mm2:W x L (PKG)": "52 mm2: 8.26 x 6.35 (PDIP|16)",
        "Package Group": "PDIP|16",
        "\"Approx. price\n(USD)\"": "$0.751 | 1ku",
        "Status": "ACTIVE"
    }
};

export const defaultPartOptions = ["TPS61033",
                                    "TPS568231",
                                    "TPS62992-Q1",
                                    "TPS62993-Q1",
                                    "LM5149-Q1",
                                    "TPSM365R6",
                                    "LM5012",
                                    "LM5012-Q1",
                                    "LM5013",
                                    "LM5169",
                                    "TPS51383",
                                    "TPS61376",
                                    "TPS563252",
                                    "TPS563257",
                                    "TLV61070A",
                                    "TPS62873-Q1",
                                    "TPS544C26",
                                    "TPS55289",
                                    "LM5168-Q1",
                                    "LM5169-Q1",
                                    "TPS543B22",
                                    "TPSM8D6B24",
                                    "TPS56C231",
                                    "TPS62872-Q1",
                                    "TPS62933O",
                                    "TPS62A02A",
                                    "TPS628513",
                                    "LMR51420",
                                    "TPS62A02",
                                    "TPS62870-Q1",
                                    "TPS563300",
                                    "TPS62933F",
                                    "TPS62933P",
                                    "TPS63901",
                                    "TPS62441-Q1",
                                    "TPS62442-Q1",
                                    "LMR51430",
                                    "TPS628503",
                                    "LM25143-Q1",
                                    "LM5143A-Q1",
                                    "LM5177",
                                    "TLVM13620",
                                    "TPSM63602",
                                    "TPSM63603E",
                                    "TPS62A01A",
                                    "TPS564242",
                                    "TPS565242",
                                    "TPS565247",
                                    "TPS566242",
                                    "TPS566247",
                                    "TPS62903-Q1",
                                    "TPS62871-Q1",
                                    "TLVM13640",
                                    "TLVM13660",
                                    "TPSM63604",
                                    "TPSM63606E",
                                    "LM5152-Q1",
                                    "LM51521-Q1",
                                    "TPS629203-Q1",
                                    "LM5013-Q1",
                                    "LMR43610-Q1",
                                    "TPS62A01",
                                    "TPS629203",
                                    "TPS629206",
                                    "TPS629206-Q1",
                                    "TPS629210E",
                                    "TPS629211-Q1",
                                    "LM25143",
                                    "LM5143",
                                    "TPSM82903",
                                    "TPS62442",
                                    "TPS62932",
                                    "LMQ66430",
                                    "LMQ66430-Q1",
                                    "TPS62824",
                                    "TLVM13630",
                                    "TPS7H4003-SEP",
                                    "LMR38010",
                                    "TPS629210",
                                    "TPSM5D1806E",
                                    "TPS62843",
                                    "TPS631000",
                                    "LMR54406",
                                    "LM63460-Q1",
                                    "TPS62810M",
                                    "TPS62812M",
                                    "TPSM8D6C24",
                                    "TPS62816-Q1",
                                    "LM5123-Q1",
                                    "TPSM82864A",
                                    "TPSM82866A",
                                    "TPS536C9",
                                    "LM25148",
                                    "LM25149",
                                    "LMR43620-Q1",
                                    "TPSM63606",
                                    "TPSM8A28",
                                    "TPSM8A29",
                                    "TPS62933",
                                    "LM5168",
                                    "LM61480",
                                    "LM61495",
                                    "LM62460",
                                    "TPS62089A",
                                    "TPS629210-Q1",
                                    "TPSM63603",
                                    "LMR54410",
                                    "TPSM82821A",
                                    "TPSM82822A",
                                    "TPSM82823A",
                                    "LMR38020",
                                    "TPS62088A",
                                    "LM61430-Q1",
                                    "TPS562212",
                                    "TPS61094",
                                    "TPS563212",
                                    "LM5158",
                                    "LM5158-Q1",
                                    "LM51581",
                                    "LM51581-Q1",
                                    "TPS63807",
                                    "TPS628503-Q1",
                                    "TPS53689",
                                    "TPSM5601R5",
                                    "TPSM560R6",
                                    "TPSM560R6H",
                                    "TPS62811M",
                                    "TPS62813M",
                                    "TPS562211",
                                    "TPS563211",
                                    "TPS7H4002-SP",
                                    "TPS628510",
                                    "TPS628511",
                                    "TPS628512",
                                    "LM61480-Q1",
                                    "TPS628501",
                                    "TPS628502",
                                    "TPSM831D31",
                                    "TPS548B27",
                                    "LM5157",
                                    "LMR33620AP-Q1",
                                    "LMR33630AP-Q1",
                                    "LM25148-Q1",
                                    "LM5157-Q1",
                                    "LM5145-Q1",
                                    "LM5146",
                                    "LM62460-Q1",
                                    "TPSM82823",
                                    "TPS61379-Q1",
                                    "TPS62865",
                                    "TPS62867",
                                    "LM61495-Q1",
                                    "TPS541620",
                                    "TPS62901",
                                    "TPS62902",
                                    "TPS62903",
                                    "TPS62912",
                                    "TPS62913",
                                    "TPSM5D1806",
                                    "TPSM13604H",
                                    "TPSM5601R5H",
                                    "TPSM5601R5HE",
                                    "LM51571-Q1",
                                    "TPS62824A",
                                    "TPS62827A",
                                    "LM5156",
                                    "LM51561",
                                    "TPS566231",
                                    "TPS566238",
                                    "TPS62868",
                                    "LMR36015S",
                                    "LMR36503",
                                    "LMR36506",
                                    "TLV62595",
                                    "TPS543820E",
                                    "TPS53676",
                                    "TPS543820",
                                    "TPS628501-Q1",
                                    "TPS55288-Q1",
                                    "TPS552882-Q1",
                                    "LM25149-Q1",
                                    "TPS536C7",
                                    "TPS543320",
                                    "TPS61288",
                                    "TPS54622-EP",
                                    "TPS548B28",
                                    "LMQ62440-Q1",
                                    "TPS62869",
                                    "TPSM265R1",
                                    "TPSM41615",
                                    "TPSM41625",
                                    "TPSM82810",
                                    "TPSM82813",
                                    "TPS62825A",
                                    "TPS62826A",
                                    "LMQ61460",
                                    "TPS552882",
                                    "TPSM82821",
                                    "TPSM82822",
                                    "TPS7H4010-SEP",
                                    "TPS542A52",
                                    "TPS543620",
                                    "TPS628502-Q1",
                                    "TPS562207S",
                                    "LMR50410",
                                    "TPS542A50",
                                    "TPS546A24A",
                                    "TPS54J061",
                                    "TPS562202S",
                                    "TPS563202S",
                                    "TPS563207S",
                                    "LMQ61460-Q1",
                                    "TPS63900",
                                    "TPS51397A",
                                    "TPS562202",
                                    "TPS563207",
                                    "LM34966-Q1",
                                    "TPS61378-Q1",
                                    "LM51561H",
                                    "LM51561H-Q1",
                                    "LM5156H",
                                    "LM5156H-Q1",
                                    "TPS62860",
                                    "TPS53688",
                                    "TPS546B24A",
                                    "LMR36503-Q1",
                                    "TPS562207",
                                    "TPS54618C-Q1",
                                    "TPS55288",
                                    "LM60430",
                                    "LM60440",
                                    "TPS563202",
                                    "TPS62861",
                                    "TPS54JB20",
                                    "LMR50410-Q1",
                                    "LM76005",
                                    "LM76005-Q1",
                                    "LM63610-Q1",
                                    "TPS53820",
                                    "TPS548A28",
                                    "TPS548A29",
                                    "LMR36506-Q1",
                                    "LM60430-Q1",
                                    "LM60440-Q1",
                                    "LM5156-Q1",
                                    "LM51561-Q1",
                                    "TPS51215A",
                                    "LM62435-Q1",
                                    "LM62440-Q1",
                                    "TPS62864",
                                    "TPS62866",
                                    "TPS7H4001-SP",
                                    "TPS54J060",
                                    "LM61440",
                                    "TPS54JA20",
                                    "LM61440-Q1",
                                    "TPS59632-Q1",
                                    "LM61435-Q1",
                                    "LM61460",
                                    "LMR36510",
                                    "LMR36520",
                                    "LM63635-Q1",
                                    "LM5163H-Q1",
                                    "TPS652353",
                                    "LM61460-Q1",
                                    "TPS546D24A",
                                    "LM5170",
                                    "TPSM53602",
                                    "TPSM53603",
                                    "TPSM53604",
                                    "TPS61023",
                                    "TPS61391",
                                    "LMR33640",
                                    "LMR33610",
                                    "LM5163",
                                    "TPS63810",
                                    "TPS63811",
                                    "TPS543C20A",
                                    "LM63615-Q1",
                                    "LM63625-Q1",
                                    "TPS63802",
                                    "LM5143-Q1",
                                    "TPS56C230",
                                    "TPS56637",
                                    "TPS560430-Q1",
                                    "TPS63806",
                                    "TPS62811-Q1",
                                    "TPS62812-Q1",
                                    "TPS62840",
                                    "TPS62152A-Q1",
                                    "LM51551-Q1",
                                    "LM5155-Q1",
                                    "TLV61048",
                                    "TPS61390",
                                    "TPS62810-Q1",
                                    "TPS62813-Q1",
                                    "LM5163-Q1",
                                    "TPS54A24",
                                    "TPS56339",
                                    "LMR34215-Q1",
                                    "LMR34206-Q1",
                                    "TPS566235",
                                    "TPS562231",
                                    "TPS568230",
                                    "TPS61022",
                                    "TPS62827",
                                    "LM5164-Q1",
                                    "TPS51396A",
                                    "TPS563231",
                                    "TPS62807",
                                    "TPS62808",
                                    "TPS54340B",
                                    "TPS54540B",
                                    "TPS54560B",
                                    "TPS563249",
                                    "TPS563240",
                                    "LM5164",
                                    "TPS6283810",
                                    "LM51551",
                                    "LM34936-Q1",
                                    "LM5155",
                                    "LMR36006",
                                    "TPS54360B",
                                    "TPS61372",
                                    "TPS61088-Q1",
                                    "LM5146-Q1",
                                    "LMR36015",
                                    "LMR36015-Q1",
                                    "LM5122ZA",
                                    "LMR33620-Q1",
                                    "LMR33630-Q1",
                                    "LMR36006-Q1",
                                    "LMZM33604",
                                    "LMZM33606",
                                    "TPS63805",
                                    "LM2775-Q1",
                                    "LM5176-Q1",
                                    "TPS61281D",
                                    "TPS61282D",
                                    "LM34936",
                                    "TPS62422-Q1",
                                    "TPS62423-Q1",
                                    "TPS62424-Q1",
                                    "TPS62800",
                                    "TPS62802",
                                    "TPS62823",
                                    "TPS62825",
                                    "TPS62826",
                                    "LM51501-Q1",
                                    "TLV62568A",
                                    "TLV62569A",
                                    "TPS560430",
                                    "TPS62806",
                                    "TPS62822",
                                    "TPSM84209",
                                    "LMZM23600",
                                    "LMZM23601",
                                    "TPS62147",
                                    "TPS62148",
                                    "TPSM84624",
                                    "LMR14010A",
                                    "TPSM82480",
                                    "LMR23615",
                                    "LMR23615-Q1",
                                    "TPS62243-Q1",
                                    "TPS62244-Q1",
                                    "LMZM33602",
                                    "LMZM33603",
                                    "TPS62801",
                                    "LMR33620",
                                    "LMR33630",
                                    "TPS62821",
                                    "TPSM84424",
                                    "TPSM84824",
                                    "TPS65268-Q1",
                                    "TPSM846C24",
                                    "TPSM846C23",
                                    "TPS61322",
                                    "TPS61280D",
                                    "TPS62097-Q1",
                                    "LM73605-Q1",
                                    "LM73606-Q1",
                                    "LM76002-Q1",
                                    "LM76003-Q1",
                                    "TPS40345",
                                    "TPS53119",
                                    "TPS62088",
                                    "TPS55160-Q1",
                                    "TPS55162-Q1",
                                    "TPS55165-Q1",
                                    "TPS61085A-Q1",
                                    "LM2623-Q1",
                                    "LM76002",
                                    "LM76003",
                                    "LM5150-Q1",
                                    "TPS63710",
                                    "LM73605",
                                    "LM73606",
                                    "TPS565208",
                                    "LMS3655-Q1",
                                    "LMS3635-Q1",
                                    "TPS565201",
                                    "TLV62585",
                                    "LV14360",
                                    "LMS3655",
                                    "TPS54424",
                                    "TPSM84203",
                                    "TPSM84205",
                                    "TPSM84212",
                                    "TPS543B20",
                                    "TPS82140",
                                    "TPS82150",
                                    "TPS53681",
                                    "LM25145",
                                    "TPS549B22",
                                    "LM5176",
                                    "TPS54308",
                                    "LM5145",
                                    "TPS65263-1Q1",
                                    "TPS561201",
                                    "TPS561208",
                                    "TLV61046A",
                                    "TPS61096A",
                                    "TPS57112C-Q1",
                                    "TPS61253A",
                                    "TPS62136",
                                    "TPS53627",
                                    "LM25141",
                                    "LM5141",
                                    "TPS54560B-Q1",
                                    "TPS61178",
                                    "LM25141-Q1",
                                    "TPS6213013A-Q1",
                                    "TPS54340B-Q1",
                                    "TPS54360B-Q1",
                                    "TPS54540B-Q1",
                                    "TPS61256C",
                                    "TPS568215OA",
                                    "TPS62672",
                                    "TPS548B22",
                                    "TPS65235-1",
                                    "TPS54260-EP",
                                    "TPS54262-EP",
                                    "TPSM84A21",
                                    "TPSM84A22",
                                    "LMR23625-Q1",
                                    "TPS63027",
                                    "LM5166",
                                    "LMR23610-Q1",
                                    "LMR23630-Q1",
                                    "TLV62568",
                                    "TLV62569",
                                    "LM53603",
                                    "TPS62162-Q1",
                                    "TPS562210A",
                                    "TPS562219A",
                                    "TPS563210A",
                                    "TPS563219A",
                                    "TPS54824",
                                    "LM5170-Q1",
                                    "TPS53622",
                                    "TPS53659",
                                    "TPS53679",
                                    "TPS568215",
                                    "TPS65266-1",
                                    "LM53602",
                                    "LM27762",
                                    "TPS62171-Q1",
                                    "TLV62084A",
                                    "TPS53667",
                                    "TPS62135",
                                    "TPS546C23",
                                    "LM5141-Q1",
                                    "TPS61099",
                                    "LM5161-Q1",
                                    "TPS546C20A",
                                    "TPS548D21",
                                    "TPS549D22",
                                    "TPS61230A",
                                    "TPS63070",
                                    "TPS54335-2A",
                                    "TPS54388C-Q1",
                                    "TPS57114C-Q1",
                                    "LMR23610",
                                    "LMR23625",
                                    "LMR23630",
                                    "TPS61235P",
                                    "TPS61236P",
                                    "TPS53626",
                                    "TPS54302",
                                    "TPS61021A",
                                    "TLV627432",
                                    "TPS560200-Q1",
                                    "TPS612592",
                                    "LMR16010",
                                    "LMR16020",
                                    "LMR16030",
                                    "LM53635-Q1",
                                    "LM53625-Q1",
                                    "TPS564201",
                                    "TPS54202H",
                                    "TPS548D22",
                                    "LMZ34202",
                                    "TPS610987",
                                    "TPS61089",
                                    "TPS54A20",
                                    "LM5175-Q1",
                                    "TPS54202",
                                    "TPS564208",
                                    "TLV62095",
                                    "TPS62770",
                                    "LM5165",
                                    "LM5165-Q1",
                                    "TPS56C215",
                                    "LM5022-Q1",
                                    "TPS82130",
                                    "TPS62480",
                                    "LM27761",
                                    "TPS562208",
                                    "LM5140-Q1",
                                    "TPS563208",
                                    "TPS610985",
                                    "TPS610986",
                                    "LMR14020-Q1",
                                    "LMR14030-Q1",
                                    "LMR14050-Q1",
                                    "LM53600-Q1",
                                    "LM53601-Q1",
                                    "TPS562201",
                                    "LM25122-Q1",
                                    "TPS563201",
                                    "TPS548A20",
                                    "TPS549A20",
                                    "TPS62097",
                                    "TPS65265",
                                    "TPS63020-Q1",
                                    "TPS65235",
                                    "TLV62085",
                                    "TPS40210-EP",
                                    "TPS54335-1A",
                                    "LMZ36002",
                                    "TPS62748",
                                    "TPS65400-Q1",
                                    "TPS57140-EP",
                                    "TPS82084",
                                    "LM46002-Q1",
                                    "LM43601-Q1",
                                    "LM46001-Q1",
                                    "LM43600-Q1",
                                    "LM46000-Q1",
                                    "TPS610982",
                                    "LMR16006Y-Q1",
                                    "LM53602-Q1",
                                    "LM53603-Q1",
                                    "LM5160-Q1",
                                    "TPS50601A-SP",
                                    "TPS61098",
                                    "TPS62745",
                                    "TPS627451",
                                    "LM2776",
                                    "TPS62746",
                                    "TPS8268120",
                                    "TPS8268180",
                                    "TPS610981",
                                    "TPS62743",
                                    "TPS53647",
                                    "TPS51275B-1",
                                    "TPS54334",
                                    "LM2775",
                                    "TPS544B25",
                                    "TPS544C25",
                                    "TPS61088",
                                    "LM43602-Q1",
                                    "LM43603-Q1",
                                    "TPS82085",
                                    "TPS61046",
                                    "TPS566250",
                                    "TPS826716",
                                    "LM5175",
                                    "LMR14020",
                                    "LMR14030",
                                    "LMR14050",
                                    "TPS62184",
                                    "TPS61093-Q1",
                                    "LM5160A",
                                    "TPS62134D",
                                    "TPS62067-Q1",
                                    "TPS65263-Q1",
                                    "TPS62160-Q1",
                                    "TPS62170-Q1",
                                    "TPS62172-Q1",
                                    "TPS54335A",
                                    "TPS54336A",
                                    "TPS61175-Q1",
                                    "TPS62406-Q1",
                                    "TPS62407-Q1",
                                    "LMZ20501",
                                    "LMZ20502",
                                    "TPS53625",
                                    "TPS63024",
                                    "TPS630241",
                                    "TPS630242",
                                    "LM3281",
                                    "TPS65400",
                                    "TPS8268090",
                                    "TPS8268105",
                                    "TPS8268150",
                                    "LMZ21700",
                                    "LMZ21701",
                                    "LMR16006",
                                    "LV2862",
                                    "TPS826721",
                                    "TPS563209",
                                    "TPS51623",
                                    "TPS51633",
                                    "TPS61291",
                                    "TPS563200",
                                    "TPS53632",
                                    "TPS54561-Q1",
                                    "TPS62180",
                                    "TPS62182",
                                    "LM43600",
                                    "LM43601",
                                    "TPS51632-Q1",
                                    "TPS62134A",
                                    "TPS62742",
                                    "TPS57114-EP",
                                    "LM46000",
                                    "LM46001",
                                    "TPS65263",
                                    "TPS54060-EP",
                                    "TPS55340-EP",
                                    "TPS53631",
                                    "TPS53641",
                                    "TPS53661",
                                    "TPS53640",
                                    "TPS53640A",
                                    "TPS62133A-Q1",
                                    "TPS62153A-Q1",
                                    "TPS82740A",
                                    "TPS82740B",
                                    "TPS55340-Q1",
                                    "TPS626765",
                                    "TPS62130A-Q1",
                                    "TPS62150A-Q1",
                                    "TPS40428",
                                    "TPS544B20",
                                    "TPS544C20",
                                    "TPS630250",
                                    "TPS630251",
                                    "TPS630252",
                                    "TPS62095",
                                    "LM5001-Q1",
                                    "TPS54361-Q1",
                                    "TPS62684",
                                    "LM43602",
                                    "LM43603",
                                    "LM46002",
                                    "TPS61230",
                                    "TPS82692",
                                    "TPS826951",
                                    "TPS40425",
                                    "TLV62084",
                                    "TPS63050",
                                    "TPS562200",
                                    "TPS562209",
                                    "TPS61097A-33",
                                    "LMZ10500",
                                    "LMZ10501",
                                    "TPS65279",
                                    "TPS63060-EP",
                                    "TPS626751",
                                    "LMZ31520",
                                    "LMZ31530",
                                    "TPS65261",
                                    "TPS65261-1",
                                    "TPS54341",
                                    "TPS54361",
                                    "TPS54561",
                                    "TPS54541",
                                    "LMR14006",
                                    "TPS82697",
                                    "TPS563900",
                                    "TPS53915",
                                    "TPS53513",
                                    "TPS53515",
                                    "TPS54418A",
                                    "TPS56520",
                                    "TPS56628",
                                    "TPS56C20",
                                    "TPS62740",
                                    "TPS51678",
                                    "LMZ31704",
                                    "LMZ31707",
                                    "TPS40007-DIE",
                                    "TLV62565",
                                    "TLV62566",
                                    "TPS62085",
                                    "TPS62086",
                                    "TPS62087",
                                    "LM5116-HT",
                                    "LM3248",
                                    "TPS51624",
                                    "TPS65581",
                                    "LM5121",
                                    "LM5121-Q1",
                                    "TPS560200",
                                    "TPS65580",
                                    "LMZ30604",
                                    "LMZ30606",
                                    "LMZ31503",
                                    "LMZ31506",
                                    "LMZ31506H",
                                    "LMZ31710",
                                    "LMZ35003",
                                    "LMZ30602",
                                    "LMZ34002",
                                    "TPS51622A",
                                    "TPS51631A",
                                    "LM27403",
                                    "LM34919C-Q1",
                                    "LMR12007",
                                    "TPS61232",
                                    "TPS54625",
                                    "TPS54626",
                                    "TPS62090-Q1",
                                    "TPS62065-Q1",
                                    "TPS63051",
                                    "TPS82698",
                                    "TPS62130A",
                                    "TPS62737",
                                    "LM3017",
                                    "TLV62150A",
                                    "TPS62150A",
                                    "TPS62140A",
                                    "LM3263",
                                    "TLV62130A",
                                    "TPS65133",
                                    "LM5122",
                                    "LM5122-Q1",
                                    "TPS65132",
                                    "TPS54540",
                                    "TPS55330",
                                    "TPS62402-Q1",
                                    "TPS62405-Q1",
                                    "TPS54531",
                                    "TPS54627",
                                    "TPS54628",
                                    "TPS65251-1",
                                    "TPS65251-2",
                                    "TPS65251-3",
                                    "TPS56428",
                                    "TPS56528",
                                    "TPS51285A",
                                    "TPS51285B",
                                    "TPS40170-EP",
                                    "TPS51632",
                                    "TPS62400-Q1",
                                    "TPS53511",
                                    "TPS84A20",
                                    "LM3279",
                                    "TPS51622",
                                    "TPS54061-Q1",
                                    "TPS62736",
                                    "TPS51275B",
                                    "TPS51362",
                                    "TPS51363",
                                    "TPS51367",
                                    "TPS65273V",
                                    "TPS65276V",
                                    "TPS65279V",
                                    "TPS82693",
                                    "TPS43060",
                                    "TPS54020",
                                    "TPS54560",
                                    "TPS53624",
                                    "TPS65131-Q1",
                                    "LM25119Q",
                                    "LM5119Q",
                                    "TPS54239",
                                    "TPS54239E",
                                    "TPS54339",
                                    "TPS54010-EP",
                                    "LM25017",
                                    "LM25018",
                                    "LM25019",
                                    "TPS50601-SP",
                                    "TPS826745",
                                    "TPS51631",
                                    "TPS54339E",
                                    "TPS62698",
                                    "TPS62693",
                                    "TPS50301-HT",
                                    "TPS62732",
                                    "TPS43061",
                                    "TPS62733",
                                    "TPS53819A",
                                    "TPS54340",
                                    "TPS62175",
                                    "TPS62177",
                                    "TPS826765",
                                    "LM22673-Q1",
                                    "LM22679-Q1",
                                    "TPS40021-EP",
                                    "TPS51312",
                                    "TPS51313",
                                    "TPS61222-EP",
                                    "TPS54360",
                                    "TPS5402",
                                    "TPS5403",
                                    "TPS53015",
                                    "TPS54362-HT",
                                    "LM3262",
                                    "TPS84259",
                                    "TPS63036",
                                    "TPS61259",
                                    "TPS84250",
                                    "LMR10530",
                                    "LMR12015",
                                    "LMR12020",
                                    "LMR61428",
                                    "LM5018",
                                    "LM5019",
                                    "TPS62203-DIE",
                                    "TPS62366A",
                                    "TPS62366B",
                                    "TPS542951",
                                    "TPS542941",
                                    "LM3269",
                                    "LMR70503",
                                    "TPS54678",
                                    "TPS5405",
                                    "TPS51275",
                                    "TPS51275C",
                                    "TPS53318",
                                    "TPS54394",
                                    "TPS54395",
                                    "TPS54494",
                                    "TPS54495",
                                    "TPS826711",
                                    "TPS54525",
                                    "TPS54526",
                                    "TPS53319",
                                    "TPS54719",
                                    "TPS81256",
                                    "TLV61220",
                                    "TPS59641",
                                    "TPS53014",
                                    "TPS54061",
                                    "TPS54140A",
                                    "TPS54160A",
                                    "TPS55340",
                                    "TPS61253",
                                    "TPS61258",
                                    "TPS62125",
                                    "LM2700Q-Q1",
                                    "TPS82670",
                                    "TPS82673",
                                    "LM25117-Q1",
                                    "TPS40170-Q1",
                                    "TPS54386-Q1",
                                    "TPS62242-Q1",
                                    "TLV62090",
                                    "TPS54233-Q1",
                                    "TPS62090",
                                    "TPS62091",
                                    "TPS62092",
                                    "TPS62093",
                                    "TPS62650-Q1",
                                    "TPS62080A",
                                    "TPS54040A",
                                    "TPS54060A",
                                    "TPS62363",
                                    "TPS54120",
                                    "TPS5432",
                                    "LM26420-Q1",
                                    "TPS51463",
                                    "TPS59650",
                                    "TLV62080",
                                    "SM72445",
                                    "TLV62130",
                                    "TLV62150",
                                    "TPS51225",
                                    "TPS51225B",
                                    "LM5017",
                                    "TPS82695",
                                    "TPS82672",
                                    "TPS51650",
                                    "TPS51640A",
                                    "TPS59640",
                                    "TPS82674",
                                    "LM3253-C",
                                    "TPS51225C",
                                    "TPS40422",
                                    "LM3102-Q1",
                                    "LM3243",
                                    "TPS53219A",
                                    "TPS51462",
                                    "TPS61087-Q1",
                                    "TPS62231-Q1",
                                    "TPS622314-Q1",
                                    "TPS63060",
                                    "TPS63061",
                                    "TPIC74101-Q1",
                                    "TPS53316",
                                    "LM25118",
                                    "TPS51518",
                                    "TPS84621",
                                    "LM3671-Q1",
                                    "TPS54294",
                                    "TPS54428",
                                    "TPS84610",
                                    "TPS62150",
                                    "TPS62151",
                                    "TPS62152",
                                    "TPS62153",
                                    "TPS54295",
                                    "TPS54427",
                                    "TPS62130",
                                    "TPS62131",
                                    "TPS62132",
                                    "TPS62133",
                                    "TPS62140",
                                    "TPS62141",
                                    "TPS62142",
                                    "TPS62143",
                                    "TPS65135",
                                    "TPS62160",
                                    "TPS62161",
                                    "TPS62162",
                                    "TPS62163",
                                    "TPS62171",
                                    "TPS62172",
                                    "LM20144-Q1",
                                    "LM20145-Q1",
                                    "TPS62170",
                                    "TPS62173",
                                    "TPS54329E",
                                    "TPS54229E",
                                    "TPS61256",
                                    "LM25118-Q1",
                                    "LMR14203",
                                    "LMR14206",
                                    "LMR62421",
                                    "LMR10510",
                                    "LMR10515",
                                    "LMR10520",
                                    "TPS54362-Q1",
                                    "TPS54821",
                                    "TPS53211",
                                    "LMR24210",
                                    "LMR24220",
                                    "LMR62014",
                                    "TPS54229",
                                    "TPS652510",
                                    "TPS84320",
                                    "TPS54519",
                                    "TPS54623",
                                    "TPS61170-Q1",
                                    "TPS54329",
                                    "TPS62080",
                                    "TPS62081",
                                    "TPS62082",
                                    "TPS61254",
                                    "LMR12010",
                                    "LMR64010",
                                    "TPS65270",
                                    "TPS82676",
                                    "TPS53353",
                                    "TPS54527",
                                    "TPS54528",
                                    "TPS62362",
                                    "LM27313-Q1",
                                    "TPS40400",
                                    "TPS61256A",
                                    "LM25117",
                                    "TPS51123A",
                                    "LM3242",
                                    "TPS54225-Q1",
                                    "TPS54325-Q1",
                                    "TPS54478",
                                    "TPS65253",
                                    "LM20143-Q1",
                                    "TPS40322",
                                    "TPS54429",
                                    "TPS54429E",
                                    "LM21305",
                                    "TPS62360",
                                    "TPS62361B",
                                    "TPS62730",
                                    "TPS82677",
                                    "TPS61261",
                                    "TPS53314",
                                    "TPS54062",
                                    "TPS61260",
                                    "TPS54227",
                                    "TPS54228",
                                    "LM5117",
                                    "LM5117-Q1",
                                    "LMZ13608",
                                    "LMZ13610",
                                    "LMZ23608",
                                    "TPS62061",
                                    "TPS62063",
                                    "TPS62671",
                                    "TPS62675",
                                    "LM21215A",
                                    "LMZ12008",
                                    "LMZ12010",
                                    "LMZ22008",
                                    "LMZ22010",
                                    "LM5006",
                                    "TPS51220A-Q1",
                                    "TPS51317",
                                    "TPS54622",
                                    "TPS40170",
                                    "LM34922",
                                    "TPS62690",
                                    "LMZ22003",
                                    "LMZ22005",
                                    "LMZ23603",
                                    "TLV61224",
                                    "TPS56121",
                                    "TPS56221",
                                    "LM34923",
                                    "TPS53355",
                                    "LM25088-Q1",
                                    "LM5088-Q1",
                                    "LM22680-Q1",
                                    "LM22676-Q1",
                                    "LM22678-Q1",
                                    "LM21212-1",
                                    "LM21212-2",
                                    "LM21215",
                                    "TPS62260-Q1",
                                    "TPS51219",
                                    "TPS62651",
                                    "TPS62679",
                                    "LMZ14201H",
                                    "LMZ14202H",
                                    "LMZ14203H",
                                    "TLV61225",
                                    "TPS53315",
                                    "TPS54260-Q1",
                                    "TPS54240-Q1",
                                    "TPS57140-Q1",
                                    "TPS57160-Q1",
                                    "TPS57040-Q1",
                                    "TPS57060-Q1",
                                    "TPS61240-Q1",
                                    "TPS62590-Q1",
                                    "TPS51461",
                                    "TPS53310",
                                    "TPS53321",
                                    "LM8850",
                                    "TPS5401",
                                    "TLV62065",
                                    "TPS51211",
                                    "TPS54328",
                                    "TPS54327",
                                    "TPS54618",
                                    "TPS54331-Q1",
                                    "TPS82671",
                                    "TPS82675",
                                    "LM8801",
                                    "TPS59620",
                                    "TPS61251",
                                    "TPS61252",
                                    "PTD08A210W",
                                    "TL2575HV-05-Q1",
                                    "TL2575HV-33-Q1",
                                    "TPS62290-Q1",
                                    "TPS62293-Q1",
                                    "TPS62665",
                                    "LM25119",
                                    "LM5119",
                                    "TPS54320",
                                    "TPS62120",
                                    "TPS53128",
                                    "TPS53129",
                                    "TPS54425",
                                    "TPS54426",
                                    "TPS62421",
                                    "LMZ12001EXT",
                                    "LMZ12002EXT",
                                    "LMZ12003EXT",
                                    "LMZ14201EXT",
                                    "LMZ14202EXT",
                                    "LMZ14203EXT",
                                    "TPS62122",
                                    "LMZ10503EXT",
                                    "LMZ10504EXT",
                                    "LMZ10505EXT",
                                    "TPS40210-HT",
                                    "TPS54521",
                                    "LM34919B-Q1",
                                    "SM72442",
                                    "SM72485",
                                    "TPS53311",
                                    "TPS54319",
                                    "LM34919B",
                                    "PTD08D210W",
                                    "TPS59621",
                                    "TPS40304A",
                                    "TPS62404",
                                    "TPS62674",
                                    "TPS54240",
                                    "TPS65251",
                                    "TPS59610",
                                    "TPS62410-Q1",
                                    "TPS63020",
                                    "TPS63021",
                                    "TPS61071-Q1",
                                    "LMZ12001",
                                    "LMZ12002",
                                    "LMZ14201",
                                    "LMZ14202",
                                    "TPS62612",
                                    "TPS62616",
                                    "TPS62619",
                                    "TPS62660",
                                    "TPS53127",
                                    "TPS54260",
                                    "TPS62060",
                                    "LMZ23610",
                                    "TPS62065",
                                    "TPS62067",
                                    "LMZ10503",
                                    "LMZ10505",
                                    "TPS62110-Q1",
                                    "LM3241",
                                    "LMZ10504",
                                    "LMZ12003",
                                    "LMZ14203",
                                    "TPS62261-Q1",
                                    "TPS62262-Q1",
                                    "TPS62263-Q1",
                                    "TPS62404-Q1",
                                    "TPS62420-Q1",
                                    "TPS62615",
                                    "TPS51125A",
                                    "TPS61085T",
                                    "TPS65232A0",
                                    "TPS65232A2",
                                    "PTD08A015W",
                                    "TPS40303",
                                    "TPS40304",
                                    "TPS40305",
                                    "TPS51611",
                                    "LMZ23605",
                                    "TPS54290",
                                    "TPS54291",
                                    "TPS54292",
                                    "TPS51621",
                                    "TPS54226",
                                    "TPS54225",
                                    "TPS53125",
                                    "TPS54326",
                                    "TPS54162-Q1",
                                    "TPS40200-HT",
                                    "TPS60151",
                                    "TPS61029-Q1",
                                    "TPS61093",
                                    "LM3209-G3",
                                    "TPS51513",
                                    "TPS54262-Q1",
                                    "TPS5410-Q1",
                                    "TPS62751",
                                    "TPS54318",
                                    "TPS5410-EP",
                                    "LM25085-Q1",
                                    "TPS54218",
                                    "TPS61086",
                                    "TPS62650",
                                    "TPS5450-EP",
                                    "TPS62621",
                                    "TPS62622",
                                    "TPS62623",
                                    "TPS62624",
                                    "TPS62625",
                                    "TPS62750",
                                    "LM5118-Q1",
                                    "REG71055-Q1",
                                    "TPS63000-Q1",
                                    "TPS55332-Q1",
                                    "PTD08A006W",
                                    "TPS51217",
                                    "LM10500",
                                    "TPS53126",
                                    "TPS54325",
                                    "TPS54620",
                                    "LM26420",
                                    "TPS54418",
                                    "LM5008A",
                                    "LM5009A",
                                    "TPS51163",
                                    "TPS51218",
                                    "TPS61241",
                                    "TPS61240",
                                    "TPS62230",
                                    "LM3478Q-Q1",
                                    "LM3488Q-Q1",
                                    "TPS53114",
                                    "LM26001-Q1",
                                    "TPS62000-HT",
                                    "TPS5130-Q1",
                                    "TPS5430-EP",
                                    "TPS51113",
                                    "TPS54040",
                                    "LM25011",
                                    "LM25011-Q1",
                                    "TPS62620",
                                    "TPS62272",
                                    "TPS54060",
                                    "LM25576-Q1",
                                    "TPS62113",
                                    "TPS62225",
                                    "LM20136",
                                    "LM20146",
                                    "LM25574-Q1",
                                    "LM25575-Q1",
                                    "LM25085A",
                                    "TPS61220",
                                    "TPS61221",
                                    "TPS61222",
                                    "TPS62590",
                                    "LM27402",
                                    "PTH08T255W",
                                    "TPS54332",
                                    "TPS51220A",
                                    "TPS51123",
                                    "PTH04T240F",
                                    "TPS60150",
                                    "TPS62562",
                                    "TPS54232",
                                    "LM22680",
                                    "TPS61175",
                                    "LM25088",
                                    "LM5088",
                                    "TPS54140",
                                    "TPS40197",
                                    "LM25010-Q1",
                                    "LM5010A-Q1",
                                    "TPS54617",
                                    "TPS54917",
                                    "TPS62561",
                                    "LM25085",
                                    "TPS62250",
                                    "LM7705",
                                    "TPS54233",
                                    "TPS63030",
                                    "TPS63031",
                                    "TPS54160",
                                    "LM5116WG",
                                    "LM22673",
                                    "LM22676",
                                    "LM22678",
                                    "LM22679",
                                    "LM5576-Q1",
                                    "TPS54231",
                                    "LM5574-Q1",
                                    "TPS55065-Q1",
                                    "TPS55383",
                                    "TPS55386",
                                    "LM22670",
                                    "LM22670-Q1",
                                    "LM22677",
                                    "LM22677-Q1",
                                    "LM3150",
                                    "LM5575-Q1",
                                    "TPS40210-Q1",
                                    "TPS40211-Q1",
                                    "TPS51610",
                                    "TPS5450-Q1",
                                    "TPS62701",
                                    "TPS54331",
                                    "LM20343",
                                    "LM5085",
                                    "LM5085-Q1",
                                    "TPS62273",
                                    "TPS40090-Q1",
                                    "TPS54110-Q1",
                                    "TPS61085",
                                    "TPS63010",
                                    "TPS63011",
                                    "TPS63012",
                                    "LM3489-Q1",
                                    "TPS62601",
                                    "LM20323",
                                    "LM20333",
                                    "TPS61087",
                                    "TPS54310-EP",
                                    "LM5118",
                                    "TPS51427",
                                    "TPS51727",
                                    "LM22671",
                                    "LM22671-Q1",
                                    "LM22672",
                                    "LM22672-Q1",
                                    "LM2738",
                                    "LM2854",
                                    "PTD08A020W",
                                    "TPS62291",
                                    "LM34917A",
                                    "TPS40210",
                                    "TPS40211",
                                    "LM2830-Q1",
                                    "TPS62263",
                                    "LM2734Z-Q1",
                                    "PTD08A010W",
                                    "TPS53124",
                                    "TPS62560",
                                    "TPS62293",
                                    "LM2773",
                                    "LM22674",
                                    "LM22674-Q1",
                                    "LM22675",
                                    "LM22675-Q1",
                                    "TPS40200-Q1",
                                    "LM2841",
                                    "LM2841-Q1",
                                    "TPS40042",
                                    "TPS51620",
                                    "TPS62700",
                                    "TPS62356",
                                    "TPS5420-Q1",
                                    "TPS62270",
                                    "TPS5430-Q1",
                                    "TPS51220",
                                    "TPS62112-EP",
                                    "TPS61170",
                                    "LM3679",
                                    "LM20123",
                                    "LM20124",
                                    "LM20125",
                                    "LM20133",
                                    "LM20134",
                                    "LM20143",
                                    "LM20144",
                                    "LM20145",
                                    "LM20154",
                                    "TPS62242",
                                    "TPS51125",
                                    "LM2757",
                                    "TPS62355",
                                    "LM4510",
                                    "TPS62111-EP",
                                    "LM3102",
                                    "LM3103",
                                    "TPS54283",
                                    "TPS54286",
                                    "TPS54383",
                                    "TPS54386",
                                    "PTH08T250W",
                                    "LM3153",
                                    "TPS62240",
                                    "TPS62243",
                                    "TPS62260",
                                    "TPS62261",
                                    "TPS62262",
                                    "TPS62290",
                                    "TPS62351",
                                    "LM34910C",
                                    "LM34919",
                                    "TPS61073",
                                    "LM26001B",
                                    "PTH04T221W",
                                    "PTH04T241W",
                                    "LM25116",
                                    "TPS5450",
                                    "TPS40192",
                                    "TPS40193",
                                    "TPS61200",
                                    "TPS61201",
                                    "TPS61202",
                                    "LM5015",
                                    "TPS40131",
                                    "TPS54311-EP",
                                    "TPS54313-EP",
                                    "TPS54314-EP",
                                    "TPS54315-EP",
                                    "TPS54316-EP",
                                    "TPS62354",
                                    "TPS62353",
                                    "TPS62402",
                                    "TPS62410",
                                    "LM27342",
                                    "LM27342-Q1",
                                    "TPIC74100-Q1",
                                    "LM3691",
                                    "TPS40195",
                                    "LM26400Y",
                                    "LM25115A",
                                    "TPS54312-EP",
                                    "TPS62110-EP",
                                    "TPS40077",
                                    "TPS61080",
                                    "TPS61081",
                                    "LM25574",
                                    "LM25575",
                                    "LM25576",
                                    "LM5001",
                                    "LM5002",
                                    "LM5574",
                                    "LM5575",
                                    "LM5576",
                                    "TPS61072",
                                    "TPS40200-EP",
                                    "TPS54354-EP",
                                    "LM5022",
                                    "PTH04T220W",
                                    "TPS5420-EP",
                                    "LM27313",
                                    "TPS62352",
                                    "TPS62403",
                                    "TL2575HV-05",
                                    "TL2575HV-12",
                                    "TL2575HV-15",
                                    "TL2575HV-33",
                                    "TL2575HV-ADJ",
                                    "LM3676",
                                    "LM3151",
                                    "LM3152",
                                    "PTH08T241W",
                                    "LM2772",
                                    "LM34914",
                                    "LM2853",
                                    "TPS40101",
                                    "PTH04T240W",
                                    "TPS5410",
                                    "LM3677",
                                    "TL7660",
                                    "LM2830",
                                    "LM2831",
                                    "LM2840",
                                    "LM2840-Q1",
                                    "LM2842",
                                    "LM2842-Q1",
                                    "TL2575-12",
                                    "TPS62400",
                                    "TPS62401",
                                    "TPS62420",
                                    "LM3678",
                                    "LM2833",
                                    "TL2575-15",
                                    "TL2575-ADJ",
                                    "TPS62350",
                                    "LM1771",
                                    "PTH08T230W",
                                    "TPS40075",
                                    "LM2832",
                                    "LM26001",
                                    "LM3489",
                                    "TPS62510",
                                    "LM2694",
                                    "TPS40056",
                                    "TPS5420",
                                    "TPS5431",
                                    "TPS63000",
                                    "TPS63001",
                                    "TPS63002",
                                    "TPS40040",
                                    "TPS40041",
                                    "TPS62227",
                                    "LM2771",
                                    "TPS61026",
                                    "TPS61029",
                                    "LM5009",
                                    "LM27341",
                                    "LM27341-Q1",
                                    "TPS40200",
                                    "TPS5430",
                                    "TL2575-05",
                                    "TL2575-33",
                                    "LM3100",
                                    "LM25007",
                                    "LM25005",
                                    "LM2717-ADJ",
                                    "TPS54317",
                                    "LM3674",
                                    "PTH05T210W",
                                    "PTH08T240W",
                                    "TPS51117",
                                    "TPS51124",
                                    "TPS62304",
                                    "LM25010",
                                    "TL1451A-EP",
                                    "LM5116",
                                    "LM5642X",
                                    "LM25115",
                                    "PTH08T210W",
                                    "PTV08T250W",
                                    "TPS40222",
                                    "LM5010A",
                                    "TPS54350-EP",
                                    "LM2696",
                                    "PTV08040W",
                                    "TPS63700",
                                    "PTN04050C",
                                    "LM5005",
                                    "TL5001A-Q1",
                                    "TPS54610-EP",
                                    "LM20242",
                                    "TPS54615-EP",
                                    "LM3743",
                                    "TPS51120",
                                    "TPS40190",
                                    "LM3310",
                                    "TPS62111",
                                    "TPS62112",
                                    "TPS40055-EP",
                                    "MC33063A-Q1",
                                    "TPS62110",
                                    "LM3000",
                                    "TL1451A-Q1",
                                    "TPS61028",
                                    "TPS40100",
                                    "LM3481",
                                    "LM3481-Q1",
                                    "LM2717",
                                    "PTN78000H",
                                    "PTN78020A",
                                    "LM2745",
                                    "PTN78000A",
                                    "PTN78060A",
                                    "PTH04040W",
                                    "LM5115A",
                                    "LM3673",
                                    "LM3370",
                                    "PTV03010W",
                                    "PTV03020W",
                                    "PTV05010W",
                                    "PTH08080W",
                                    "PTV05020W",
                                    "TPS54073",
                                    "MC33063A",
                                    "MC34063A",
                                    "LM2852",
                                    "LM2734Z",
                                    "TPS61040-Q1",
                                    "TPS61041-Q1",
                                    "PTV12010L",
                                    "PTV12010W",
                                    "TPS62026",
                                    "PTN78020W",
                                    "PTH12040W",
                                    "PTN78060W",
                                    "LM3224",
                                    "LM3671",
                                    "LM5010",
                                    "TPS62228",
                                    "TPS62229",
                                    "TPS65131",
                                    "LM34910",
                                    "TPS62300",
                                    "TPS62301",
                                    "TPS62302",
                                    "TPS62303",
                                    "TPS62305",
                                    "TPS62320",
                                    "TPS62321",
                                    "TPS54010",
                                    "TPS40091",
                                    "TPS60400-Q1",
                                    "TPS60401-Q1",
                                    "TPS60402-Q1",
                                    "TPS60403-Q1",
                                    "TPS62207",
                                    "TPS62021",
                                    "TPS61070",
                                    "TPS61071",
                                    "PTH03010Y",
                                    "PTH03050Y",
                                    "PTH03060Y",
                                    "TPS40007",
                                    "TPS40009",
                                    "TPS62223",
                                    "LM26003",
                                    "LM26003-Q1",
                                    "LM2735",
                                    "LM2735-Q1",
                                    "TPS62208",
                                    "PTH05010Y",
                                    "PTH05050Y",
                                    "PTH05060Y",
                                    "PTH12010Y",
                                    "PTH12050Y",
                                    "PTH12060Y",
                                    "PTH03030W",
                                    "LM2742",
                                    "TPS65130",
                                    "LM2770",
                                    "LM5008",
                                    "LM5115",
                                    "PTH05030W",
                                    "TPS40055",
                                    "TPS40057",
                                    "LM1770",
                                    "LM3670",
                                    "TPS5120-Q1",
                                    "PTH03050W",
                                    "PTH03060W",
                                    "PTH05060W",
                                    "PTH12050W",
                                    "TPS54110",
                                    "TPS5120-EP",
                                    "REG71050",
                                    "TPS40050-Q1",
                                    "TPS40051-Q1",
                                    "TPS40090",
                                    "TPS54350",
                                    "TPS54680-EP",
                                    "PTH03010W",
                                    "TPS62220",
                                    "TPS62221",
                                    "TPS62222",
                                    "TPS62224",
                                    "PTH03020W",
                                    "TPS61020",
                                    "TPS61024",
                                    "TPS61025",
                                    "TPS61027",
                                    "PTH12010W",
                                    "LM5020",
                                    "LM2736",
                                    "TPS64200",
                                    "TPS64201",
                                    "TPS64202",
                                    "TPS64203",
                                    "TPS61090",
                                    "TPS61091",
                                    "TPS61092",
                                    "TPS62020",
                                    "PTH05010W",
                                    "PTH05020W",
                                    "TPS62040",
                                    "TPS62042",
                                    "TPS62043",
                                    "TPS62044",
                                    "TPS62046",
                                    "LM5642",
                                    "REG71055",
                                    "LM2731",
                                    "TPS54973",
                                    "TPS54980",
                                    "TPS61045",
                                    "TPS61030",
                                    "TPS61031",
                                    "TPS61032",
                                    "LM5007",
                                    "TPS40060",
                                    "TPS40061",
                                    "TPS62050",
                                    "TPS62051",
                                    "TPS62052",
                                    "TPS62054",
                                    "TPS62056",
                                    "LM2734",
                                    "LM2734-Q1",
                                    "LM2724A",
                                    "LM2733",
                                    "LM2705",
                                    "TPS54880",
                                    "TPS61107",
                                    "TPS61120",
                                    "TPS61121",
                                    "TPS61122",
                                    "TPS61130",
                                    "TPS61131",
                                    "TPS61100",
                                    "TPS62008",
                                    "TPS40000",
                                    "TPS5130",
                                    "TPS54910",
                                    "LM2642",
                                    "LM2623",
                                    "LM3475",
                                    "TPS62200",
                                    "TPS62201",
                                    "TPS62202",
                                    "TPS62203",
                                    "TPS62204",
                                    "TPS62205",
                                    "TPS54810",
                                    "TPS61040",
                                    "TPS61041",
                                    "LM5000",
                                    "LM2704",
                                    "TPS60240",
                                    "TPS60242",
                                    "TPS60243",
                                    "TPS54310",
                                    "TPS60500",
                                    "TPS60501",
                                    "TPS60503",
                                    "TPS43000",
                                    "LM2750",
                                    "TPS60241",
                                    "TPS60300",
                                    "TPS60301",
                                    "TPS60302",
                                    "TPS60303",
                                    "TPS60310",
                                    "TPS60311",
                                    "TPS60312",
                                    "TPS60313",
                                    "REG710-27",
                                    "REG710-3",
                                    "REG710-33",
                                    "REG710-5",
                                    "TPS54616",
                                    "TPS60400",
                                    "TPS60401",
                                    "TPS60402",
                                    "TPS60403",
                                    "LM3485",
                                    "LM3485-Q1",
                                    "TPS54610",
                                    "TPS60204",
                                    "TPS60205",
                                    "REG710-25",
                                    "TPS60502",
                                    "TPS62000",
                                    "TPS62002",
                                    "TPS62003",
                                    "TPS62004",
                                    "TPS62005",
                                    "TPS62006",
                                    "TPS62007",
                                    "LM2590HV",
                                    "LM2591HV",
                                    "LM2592HV",
                                    "LM2700",
                                    "LM2593HV",
                                    "LM2703",
                                    "REG711-25",
                                    "REG711-3",
                                    "REG711-33",
                                    "REG711-5",
                                    "LM2611",
                                    "LM2698",
                                    "TPS5140",
                                    "TPS62100",
                                    "TPS62101",
                                    "TPS62102",
                                    "TPS62103",
                                    "TPS61010",
                                    "TPS61012",
                                    "TPS61013",
                                    "TPS61014",
                                    "TPS61015",
                                    "TPS61016",
                                    "TPS5120",
                                    "TPS60124",
                                    "TPS60125",
                                    "TPS61000",
                                    "TPS61002",
                                    "TPS61005",
                                    "TPS61006",
                                    "TPS61007",
                                    "LM3488",
                                    "UCC39411",
                                    "TPS60210",
                                    "TPS60211",
                                    "TPS60212",
                                    "TPS60213",
                                    "LM2765",
                                    "LM2766",
                                    "TPS60200",
                                    "TPS60201",
                                    "TPS60202",
                                    "TPS60203",
                                    "LM3477",
                                    "LM3478",
                                    "LM2622",
                                    "TPS60140",
                                    "TPS60141",
                                    "LM2655",
                                    "LM2767",
                                    "LM2677",
                                    "TPS60120",
                                    "TPS60121",
                                    "TPS60122",
                                    "TPS60123",
                                    "TPS60130",
                                    "TPS60131",
                                    "TPS60132",
                                    "TPS60133",
                                    "LM2695",
                                    "LM2682",
                                    "TL5001AM",
                                    "TL5001M",
                                    "TPS60100",
                                    "TPS60101",
                                    "TPS60110",
                                    "TPS60111",
                                    "LM2653",
                                    "LM828",
                                    "MAX660",
                                    "LM2681",
                                    "UCC29421",
                                    "LM2670",
                                    "LM2594HV",
                                    "LM2678",
                                    "LM2679",
                                    "LM2621",
                                    "LM2664",
                                    "LM2665",
                                    "LM2597HV",
                                    "LM2671",
                                    "LM2674",
                                    "LM2663",
                                    "LM2662",
                                    "LM2675",
                                    "LM2660",
                                    "LM2650",
                                    "LM2651",
                                    "LM2673",
                                    "LM2672",
                                    "TPS6735",
                                    "LM2586",
                                    "LM2585",
                                    "LM2598",
                                    "LM2595",
                                    "LM2676",
                                    "LM2596",
                                    "LM2599",
                                    "UC2572",
                                    "UC2573",
                                    "LM2597",
                                    "LM2594",
                                    "LM2588",
                                    "LM2587",
                                    "TL5001",
                                    "TL5001A",
                                    "LM2574",
                                    "LM2574HV",
                                    "LM2575",
                                    "LM2576",
                                    "LM2576HV",
                                    "LM2577",
                                    "LT1054",
                                    "TL497A",
                                    "TL499A",
                                    "LM2575-N",
                                    "LM2575HV",
                                    "TL1451",
                                    "TL1451A",
                                    "LMC7660",
                                    "LM2578A",
                                    "LM3578A",
                                    "LM78S40"];